import * as Y from "react";
import zt, { useContext as Yt, useRef as ee, useCallback as ve, useDebugValue as Oo, createContext as dn, useLayoutEffect as Sr, useEffect as te, useState as Re, useMemo as Oe, createElement as Z, forwardRef as Te, Children as st, isValidElement as lt, cloneElement as Rr, Fragment as Os, useReducer as Ou, PureComponent as Iu } from "react";
import { jsx as C, jsxs as j, Fragment as Is } from "react/jsx-runtime";
import * as pu from "react-dom";
import hu, { unstable_batchedUpdates as ps, flushSync as hs } from "react-dom";
function ct(e) {
  "@babel/helpers - typeof";
  return ct = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ct(e);
}
function As(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ie(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && r.push.apply(r, Object.getOwnPropertySymbols(n).filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), r.forEach(function(o) {
      As(e, o, n[o]);
    });
  }
  return e;
}
function Me(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Di(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function we(e, t, n) {
  return t && Di(e.prototype, t), n && Di(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Lt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Tn(e, t) {
  if (t && (ct(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lt(e);
}
function Gt(e) {
  return Gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gt(e);
}
function Io(e, t) {
  return Io = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Io(e, t);
}
function Nr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Io(e, t);
}
var Au = {
  type: "logger",
  log: function(t) {
    this.output("log", t);
  },
  warn: function(t) {
    this.output("warn", t);
  },
  error: function(t) {
    this.output("error", t);
  },
  output: function(t, n) {
    console && console[t] && console[t].apply(console, n);
  }
}, gu = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Me(this, e), this.init(t, n);
  }
  return we(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = r.prefix || "i18next:", this.logger = n || Au, this.options = r, this.debug = r.debug;
    }
  }, {
    key: "setDebug",
    value: function(n) {
      this.debug = n;
    }
  }, {
    key: "log",
    value: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return this.forward(r, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return this.forward(r, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return this.forward(r, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(n, r, o, i) {
      return i && !this.debug ? null : (typeof n[0] == "string" && (n[0] = "".concat(o).concat(this.prefix, " ").concat(n[0])), this.logger[r](n));
    }
  }, {
    key: "create",
    value: function(n) {
      return new e(this.logger, Ie({}, {
        prefix: "".concat(this.prefix, ":").concat(n, ":")
      }, this.options));
    }
  }]), e;
}(), Ze = new gu(), _t = function() {
  function e() {
    Me(this, e), this.observers = {};
  }
  return we(e, [{
    key: "on",
    value: function(n, r) {
      var o = this;
      return n.split(" ").forEach(function(i) {
        o.observers[i] = o.observers[i] || [], o.observers[i].push(r);
      }), this;
    }
  }, {
    key: "off",
    value: function(n, r) {
      if (this.observers[n]) {
        if (!r) {
          delete this.observers[n];
          return;
        }
        this.observers[n] = this.observers[n].filter(function(o) {
          return o !== r;
        });
      }
    }
  }, {
    key: "emit",
    value: function(n) {
      for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
        o[i - 1] = arguments[i];
      if (this.observers[n]) {
        var a = [].concat(this.observers[n]);
        a.forEach(function(c) {
          c.apply(void 0, o);
        });
      }
      if (this.observers["*"]) {
        var s = [].concat(this.observers["*"]);
        s.forEach(function(c) {
          c.apply(c, [n].concat(o));
        });
      }
    }
  }]), e;
}();
function en() {
  var e, t, n = new Promise(function(r, o) {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function mi(e) {
  return e == null ? "" : "" + e;
}
function vu(e, t, n) {
  e.forEach(function(r) {
    t[r] && (n[r] = t[r]);
  });
}
function Yo(e, t, n) {
  function r(s) {
    return s && s.indexOf("###") > -1 ? s.replace(/###/g, ".") : s;
  }
  function o() {
    return !e || typeof e == "string";
  }
  for (var i = typeof t != "string" ? [].concat(t) : t.split("."); i.length > 1; ) {
    if (o())
      return {};
    var a = r(i.shift());
    !e[a] && n && (e[a] = new n()), Object.prototype.hasOwnProperty.call(e, a) ? e = e[a] : e = {};
  }
  return o() ? {} : {
    obj: e,
    k: r(i.shift())
  };
}
function Li(e, t, n) {
  var r = Yo(e, t, Object), o = r.obj, i = r.k;
  o[i] = n;
}
function Du(e, t, n, r) {
  var o = Yo(e, t, Object), i = o.obj, a = o.k;
  i[a] = i[a] || [], r && (i[a] = i[a].concat(n)), r || i[a].push(n);
}
function jn(e, t) {
  var n = Yo(e, t), r = n.obj, o = n.k;
  if (r)
    return r[o];
}
function Ci(e, t, n) {
  var r = jn(e, n);
  return r !== void 0 ? r : jn(t, n);
}
function gs(e, t, n) {
  for (var r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : gs(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function Ut(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var mu = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Lu(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, function(t) {
    return mu[t];
  }) : e;
}
var Or = typeof window < "u" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, Cu = function(e) {
  Nr(t, e);
  function t(n) {
    var r, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return Me(this, t), r = Tn(this, Gt(t).call(this)), Or && _t.call(Lt(r)), r.data = n || {}, r.options = o, r.options.keySeparator === void 0 && (r.options.keySeparator = "."), r;
  }
  return we(t, [{
    key: "addNamespaces",
    value: function(r) {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }
  }, {
    key: "removeNamespaces",
    value: function(r) {
      var o = this.options.ns.indexOf(r);
      o > -1 && this.options.ns.splice(o, 1);
    }
  }, {
    key: "getResource",
    value: function(r, o, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, c = [r, o];
      return i && typeof i != "string" && (c = c.concat(i)), i && typeof i == "string" && (c = c.concat(s ? i.split(s) : i)), r.indexOf(".") > -1 && (c = r.split(".")), jn(this.data, c);
    }
  }, {
    key: "addResource",
    value: function(r, o, i, a) {
      var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, c = this.options.keySeparator;
      c === void 0 && (c = ".");
      var u = [r, o];
      i && (u = u.concat(c ? i.split(c) : i)), r.indexOf(".") > -1 && (u = r.split("."), a = o, o = u[1]), this.addNamespaces(o), Li(this.data, u, a), s.silent || this.emit("added", r, o, i, a);
    }
  }, {
    key: "addResources",
    value: function(r, o, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var s in i)
        (typeof i[s] == "string" || Object.prototype.toString.apply(i[s]) === "[object Array]") && this.addResource(r, o, s, i[s], {
          silent: !0
        });
      a.silent || this.emit("added", r, o, i);
    }
  }, {
    key: "addResourceBundle",
    value: function(r, o, i, a, s) {
      var c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, u = [r, o];
      r.indexOf(".") > -1 && (u = r.split("."), a = i, i = o, o = u[1]), this.addNamespaces(o);
      var E = jn(this.data, u) || {};
      a ? gs(E, i, s) : E = Ie({}, E, i), Li(this.data, u, E), c.silent || this.emit("added", r, o, i);
    }
  }, {
    key: "removeResourceBundle",
    value: function(r, o) {
      this.hasResourceBundle(r, o) && delete this.data[r][o], this.removeNamespaces(o), this.emit("removed", r, o);
    }
  }, {
    key: "hasResourceBundle",
    value: function(r, o) {
      return this.getResource(r, o) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(r, o) {
      return o || (o = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? Ie({}, {}, this.getResource(r, o)) : this.getResource(r, o);
    }
  }, {
    key: "getDataByLanguage",
    value: function(r) {
      return this.data[r];
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), t;
}(_t), vs = {
  processors: {},
  addPostProcessor: function(t) {
    this.processors[t.name] = t;
  },
  handle: function(t, n, r, o, i) {
    var a = this;
    return t.forEach(function(s) {
      a.processors[s] && (n = a.processors[s].process(n, r, o, i));
    }), n;
  }
}, Pi = {}, yi = function(e) {
  Nr(t, e);
  function t(n) {
    var r, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Me(this, t), r = Tn(this, Gt(t).call(this)), Or && _t.call(Lt(r)), vu(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, Lt(r)), r.options = o, r.options.keySeparator === void 0 && (r.options.keySeparator = "."), r.logger = Ze.create("translator"), r;
  }
  return we(t, [{
    key: "changeLanguage",
    value: function(r) {
      r && (this.language = r);
    }
  }, {
    key: "exists",
    value: function(r) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, i = this.resolve(r, o);
      return i && i.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(r, o) {
      var i = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
      i === void 0 && (i = ":");
      var a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, s = o.ns || this.options.defaultNS;
      if (i && r.indexOf(i) > -1) {
        var c = r.match(this.interpolator.nestingRegexp);
        if (c && c.length > 0)
          return {
            key: r,
            namespaces: s
          };
        var u = r.split(i);
        (i !== a || i === a && this.options.ns.indexOf(u[0]) > -1) && (s = u.shift()), r = u.join(a);
      }
      return typeof s == "string" && (s = [s]), {
        key: r,
        namespaces: s
      };
    }
  }, {
    key: "translate",
    value: function(r, o, i) {
      var a = this;
      if (ct(o) !== "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), o || (o = {}), r == null)
        return "";
      Array.isArray(r) || (r = [String(r)]);
      var s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, c = this.extractFromKey(r[r.length - 1], o), u = c.key, E = c.namespaces, l = E[E.length - 1], f = o.lng || this.language, _ = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (f && f.toLowerCase() === "cimode") {
        if (_) {
          var S = o.nsSeparator || this.options.nsSeparator;
          return l + S + u;
        }
        return u;
      }
      var d = this.resolve(r, o), T = d && d.res, O = d && d.usedKey || u, h = d && d.exactUsedKey || u, N = Object.prototype.toString.apply(T), I = ["[object Number]", "[object Function]", "[object RegExp]"], R = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, p = !this.i18nFormat || this.i18nFormat.handleAsObject, A = typeof T != "string" && typeof T != "boolean" && typeof T != "number";
      if (p && T && A && I.indexOf(N) < 0 && !(typeof R == "string" && N === "[object Array]")) {
        if (!o.returnObjects && !this.options.returnObjects)
          return this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(O, T, o) : "key '".concat(u, " (").concat(this.language, ")' returned an object instead of string.");
        if (s) {
          var g = N === "[object Array]", v = g ? [] : {}, D = g ? h : O;
          for (var m in T)
            if (Object.prototype.hasOwnProperty.call(T, m)) {
              var L = "".concat(D).concat(s).concat(m);
              v[m] = this.translate(L, Ie({}, o, {
                joinArrays: !1,
                ns: E
              })), v[m] === L && (v[m] = T[m]);
            }
          T = v;
        }
      } else if (p && typeof R == "string" && N === "[object Array]")
        T = T.join(R), T && (T = this.extendTranslation(T, r, o, i));
      else {
        var P = !1, U = !1, M = o.count !== void 0 && typeof o.count != "string", H = t.hasDefaultValue(o), x = M ? this.pluralResolver.getSuffix(f, o.count) : "", F = o["defaultValue".concat(x)] || o.defaultValue;
        !this.isValidLookup(T) && H && (P = !0, T = F), this.isValidLookup(T) || (U = !0, T = u);
        var z = H && F !== T && this.options.updateMissing;
        if (U || P || z) {
          if (this.logger.log(z ? "updateKey" : "missingKey", f, l, u, z ? F : T), s) {
            var y = this.resolve(u, Ie({}, o, {
              keySeparator: !1
            }));
            y && y.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var b = [], V = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && V && V[0])
            for (var w = 0; w < V.length; w++)
              b.push(V[w]);
          else
            this.options.saveMissingTo === "all" ? b = this.languageUtils.toResolveHierarchy(o.lng || this.language) : b.push(o.lng || this.language);
          var B = function(k, K, X) {
            a.options.missingKeyHandler ? a.options.missingKeyHandler(k, l, K, z ? X : T, z, o) : a.backendConnector && a.backendConnector.saveMissing && a.backendConnector.saveMissing(k, l, K, z ? X : T, z, o), a.emit("missingKey", k, l, K, T);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && M ? b.forEach(function(G) {
            a.pluralResolver.getSuffixes(G).forEach(function(k) {
              B([G], u + k, o["defaultValue".concat(k)] || F);
            });
          }) : B(b, u, F));
        }
        T = this.extendTranslation(T, r, o, d, i), U && T === u && this.options.appendNamespaceToMissingKey && (T = "".concat(l, ":").concat(u)), U && this.options.parseMissingKeyHandler && (T = this.options.parseMissingKeyHandler(T));
      }
      return T;
    }
  }, {
    key: "extendTranslation",
    value: function(r, o, i, a, s) {
      var c = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        r = this.i18nFormat.parse(r, i, a.usedLng, a.usedNS, a.usedKey, {
          resolved: a
        });
      else if (!i.skipInterpolation) {
        i.interpolation && this.interpolator.init(Ie({}, i, {
          interpolation: Ie({}, this.options.interpolation, i.interpolation)
        }));
        var u = i.interpolation && i.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables, E;
        if (u) {
          var l = r.match(this.interpolator.nestingRegexp);
          E = l && l.length;
        }
        var f = i.replace && typeof i.replace != "string" ? i.replace : i;
        if (this.options.interpolation.defaultVariables && (f = Ie({}, this.options.interpolation.defaultVariables, f)), r = this.interpolator.interpolate(r, f, i.lng || this.language, i), u) {
          var _ = r.match(this.interpolator.nestingRegexp), S = _ && _.length;
          E < S && (i.nest = !1);
        }
        i.nest !== !1 && (r = this.interpolator.nest(r, function() {
          for (var O = arguments.length, h = new Array(O), N = 0; N < O; N++)
            h[N] = arguments[N];
          return s && s[0] === h[0] && !i.context ? (c.logger.warn("It seems you are nesting recursively key: ".concat(h[0], " in key: ").concat(o[0])), null) : c.translate.apply(c, h.concat([o]));
        }, i)), i.interpolation && this.interpolator.reset();
      }
      var d = i.postProcess || this.options.postProcess, T = typeof d == "string" ? [d] : d;
      return r != null && T && T.length && i.applyPostProcessor !== !1 && (r = vs.handle(T, r, o, this.options && this.options.postProcessPassResolved ? Ie({
        i18nResolved: a
      }, i) : i, this)), r;
    }
  }, {
    key: "resolve",
    value: function(r) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a, s, c, u, E;
      return typeof r == "string" && (r = [r]), r.forEach(function(l) {
        if (!o.isValidLookup(a)) {
          var f = o.extractFromKey(l, i), _ = f.key;
          s = _;
          var S = f.namespaces;
          o.options.fallbackNS && (S = S.concat(o.options.fallbackNS));
          var d = i.count !== void 0 && typeof i.count != "string", T = i.context !== void 0 && typeof i.context == "string" && i.context !== "", O = i.lngs ? i.lngs : o.languageUtils.toResolveHierarchy(i.lng || o.language, i.fallbackLng);
          S.forEach(function(h) {
            o.isValidLookup(a) || (E = h, !Pi["".concat(O[0], "-").concat(h)] && o.utils && o.utils.hasLoadedNamespace && !o.utils.hasLoadedNamespace(E) && (Pi["".concat(O[0], "-").concat(h)] = !0, o.logger.warn('key "'.concat(s, '" for languages "').concat(O.join(", "), `" won't get resolved as namespace "`).concat(E, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), O.forEach(function(N) {
              if (!o.isValidLookup(a)) {
                u = N;
                var I = _, R = [I];
                if (o.i18nFormat && o.i18nFormat.addLookupKeys)
                  o.i18nFormat.addLookupKeys(R, _, N, h, i);
                else {
                  var p;
                  d && (p = o.pluralResolver.getSuffix(N, i.count)), d && T && R.push(I + p), T && R.push(I += "".concat(o.options.contextSeparator).concat(i.context)), d && R.push(I += p);
                }
                for (var A; A = R.pop(); )
                  o.isValidLookup(a) || (c = A, a = o.getResource(N, h, A, i));
              }
            }));
          });
        }
      }), {
        res: a,
        usedKey: s,
        exactUsedKey: c,
        usedLng: u,
        usedNS: E
      };
    }
  }, {
    key: "isValidLookup",
    value: function(r) {
      return r !== void 0 && !(!this.options.returnNull && r === null) && !(!this.options.returnEmptyString && r === "");
    }
  }, {
    key: "getResource",
    value: function(r, o, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(r, o, i, a) : this.resourceStore.getResource(r, o, i, a);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(r) {
      var o = "defaultValue";
      for (var i in r)
        if (Object.prototype.hasOwnProperty.call(r, i) && o === i.substring(0, o.length) && r[i] !== void 0)
          return !0;
      return !1;
    }
  }]), t;
}(_t);
function wr(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var Pu = function() {
  function e(t) {
    Me(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ze.create("languageUtils");
  }
  return we(e, [{
    key: "getScriptPartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0)
        return null;
      var r = n.split("-");
      return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0)
        return n;
      var r = n.split("-");
      return this.formatLanguageCode(r[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(n) {
      if (typeof n == "string" && n.indexOf("-") > -1) {
        var r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], o = n.split("-");
        return this.options.lowerCaseLng ? o = o.map(function(i) {
          return i.toLowerCase();
        }) : o.length === 2 ? (o[0] = o[0].toLowerCase(), o[1] = o[1].toUpperCase(), r.indexOf(o[1].toLowerCase()) > -1 && (o[1] = wr(o[1].toLowerCase()))) : o.length === 3 && (o[0] = o[0].toLowerCase(), o[1].length === 2 && (o[1] = o[1].toUpperCase()), o[0] !== "sgn" && o[2].length === 2 && (o[2] = o[2].toUpperCase()), r.indexOf(o[1].toLowerCase()) > -1 && (o[1] = wr(o[1].toLowerCase())), r.indexOf(o[2].toLowerCase()) > -1 && (o[2] = wr(o[2].toLowerCase()))), o.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
    }
  }, {
    key: "isWhitelisted",
    value: function(n) {
      return this.logger.deprecate("languageUtils.isWhitelisted", `function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it's usage asap.`), this.isSupportedCode(n);
    }
  }, {
    key: "isSupportedCode",
    value: function(n) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(n) {
      var r = this;
      if (!n)
        return null;
      var o;
      return n.forEach(function(i) {
        if (!o) {
          var a = r.formatLanguageCode(i);
          (!r.options.supportedLngs || r.isSupportedCode(a)) && (o = a);
        }
      }), !o && this.options.supportedLngs && n.forEach(function(i) {
        if (!o) {
          var a = r.getLanguagePartFromCode(i);
          if (r.isSupportedCode(a))
            return o = a;
          o = r.options.supportedLngs.find(function(s) {
            if (s.indexOf(a) === 0)
              return s;
          });
        }
      }), o || (o = this.getFallbackCodes(this.options.fallbackLng)[0]), o;
    }
  }, {
    key: "getFallbackCodes",
    value: function(n, r) {
      if (!n)
        return [];
      if (typeof n == "function" && (n = n(r)), typeof n == "string" && (n = [n]), Object.prototype.toString.apply(n) === "[object Array]")
        return n;
      if (!r)
        return n.default || [];
      var o = n[r];
      return o || (o = n[this.getScriptPartFromCode(r)]), o || (o = n[this.formatLanguageCode(r)]), o || (o = n[this.getLanguagePartFromCode(r)]), o || (o = n.default), o || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(n, r) {
      var o = this, i = this.getFallbackCodes(r || this.options.fallbackLng || [], n), a = [], s = function(u) {
        u && (o.isSupportedCode(u) ? a.push(u) : o.logger.warn("rejecting language code not found in supportedLngs: ".concat(u)));
      };
      return typeof n == "string" && n.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(n))) : typeof n == "string" && s(this.formatLanguageCode(n)), i.forEach(function(c) {
        a.indexOf(c) < 0 && s(o.formatLanguageCode(c));
      }), a;
    }
  }]), e;
}(), yu = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Uu = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
};
function bu() {
  var e = {};
  return yu.forEach(function(t) {
    t.lngs.forEach(function(n) {
      e[n] = {
        numbers: t.nr,
        plurals: Uu[t.fc]
      };
    });
  }), e;
}
var Mu = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Me(this, e), this.languageUtils = t, this.options = n, this.logger = Ze.create("pluralResolver"), this.rules = bu();
  }
  return we(e, [{
    key: "addRule",
    value: function(n, r) {
      this.rules[n] = r;
    }
  }, {
    key: "getRule",
    value: function(n) {
      return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
    }
  }, {
    key: "needsPlural",
    value: function(n) {
      var r = this.getRule(n);
      return r && r.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(n, r) {
      return this.getSuffixes(n).map(function(o) {
        return r + o;
      });
    }
  }, {
    key: "getSuffixes",
    value: function(n) {
      var r = this, o = this.getRule(n);
      return o ? o.numbers.map(function(i) {
        return r.getSuffix(n, i);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(n, r) {
      var o = this, i = this.getRule(n);
      if (i) {
        var a = i.noAbs ? i.plurals(r) : i.plurals(Math.abs(r)), s = i.numbers[a];
        this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
        var c = function() {
          return o.options.prepend && s.toString() ? o.options.prepend + s.toString() : s.toString();
        };
        return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? "_plural_".concat(s.toString()) : c() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 ? c() : this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
      }
      return this.logger.warn("no plural rule found for: ".concat(n)), "";
    }
  }]), e;
}(), wu = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Me(this, e), this.logger = Ze.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function(n) {
      return n;
    }, this.init(t);
  }
  return we(e, [{
    key: "init",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      n.interpolation || (n.interpolation = {
        escapeValue: !0
      });
      var r = n.interpolation;
      this.escape = r.escape !== void 0 ? r.escape : Lu, this.escapeValue = r.escapeValue !== void 0 ? r.escapeValue : !0, this.useRawValueToEscape = r.useRawValueToEscape !== void 0 ? r.useRawValueToEscape : !1, this.prefix = r.prefix ? Ut(r.prefix) : r.prefixEscaped || "{{", this.suffix = r.suffix ? Ut(r.suffix) : r.suffixEscaped || "}}", this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",", this.unescapePrefix = r.unescapeSuffix ? "" : r.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : r.unescapeSuffix || "", this.nestingPrefix = r.nestingPrefix ? Ut(r.nestingPrefix) : r.nestingPrefixEscaped || Ut("$t("), this.nestingSuffix = r.nestingSuffix ? Ut(r.nestingSuffix) : r.nestingSuffixEscaped || Ut(")"), this.nestingOptionsSeparator = r.nestingOptionsSeparator ? r.nestingOptionsSeparator : r.nestingOptionsSeparator || ",", this.maxReplaces = r.maxReplaces ? r.maxReplaces : 1e3, this.alwaysFormat = r.alwaysFormat !== void 0 ? r.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var n = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(n, "g");
      var r = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(r, "g");
      var o = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(o, "g");
    }
  }, {
    key: "interpolate",
    value: function(n, r, o, i) {
      var a = this, s, c, u, E = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function l(T) {
        return T.replace(/\$/g, "$$$$");
      }
      var f = function(O) {
        if (O.indexOf(a.formatSeparator) < 0) {
          var h = Ci(r, E, O);
          return a.alwaysFormat ? a.format(h, void 0, o) : h;
        }
        var N = O.split(a.formatSeparator), I = N.shift().trim(), R = N.join(a.formatSeparator).trim();
        return a.format(Ci(r, E, I), R, o, i);
      };
      this.resetRegExp();
      var _ = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, S = i && i.interpolation && i.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables, d = [{
        regex: this.regexpUnescape,
        safeValue: function(O) {
          return l(O);
        }
      }, {
        regex: this.regexp,
        safeValue: function(O) {
          return a.escapeValue ? l(a.escape(O)) : l(O);
        }
      }];
      return d.forEach(function(T) {
        for (u = 0; s = T.regex.exec(n); ) {
          if (c = f(s[1].trim()), c === void 0)
            if (typeof _ == "function") {
              var O = _(n, s, i);
              c = typeof O == "string" ? O : "";
            } else if (S) {
              c = s[0];
              continue;
            } else
              a.logger.warn("missed to pass in variable ".concat(s[1], " for interpolating ").concat(n)), c = "";
          else
            typeof c != "string" && !a.useRawValueToEscape && (c = mi(c));
          if (n = n.replace(s[0], T.safeValue(c)), T.regex.lastIndex = 0, u++, u >= a.maxReplaces)
            break;
        }
      }), n;
    }
  }, {
    key: "nest",
    value: function(n, r) {
      var o = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, s, c = Ie({}, i);
      c.applyPostProcessor = !1, delete c.defaultValue;
      function u(_, S) {
        var d = this.nestingOptionsSeparator;
        if (_.indexOf(d) < 0)
          return _;
        var T = _.split(new RegExp("".concat(d, "[ ]*{"))), O = "{".concat(T[1]);
        _ = T[0], O = this.interpolate(O, c), O = O.replace(/'/g, '"');
        try {
          c = JSON.parse(O), S && (c = Ie({}, S, c));
        } catch (h) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(_), h), "".concat(_).concat(d).concat(O);
        }
        return delete c.defaultValue, _;
      }
      for (; a = this.nestingRegexp.exec(n); ) {
        var E = [], l = !1;
        if (a[0].includes(this.formatSeparator) && !/{.*}/.test(a[1])) {
          var f = a[1].split(this.formatSeparator).map(function(_) {
            return _.trim();
          });
          a[1] = f.shift(), E = f, l = !0;
        }
        if (s = r(u.call(this, a[1].trim(), c), c), s && a[0] === n && typeof s != "string")
          return s;
        typeof s != "string" && (s = mi(s)), s || (this.logger.warn("missed to resolve ".concat(a[1], " for nesting ").concat(n)), s = ""), l && (s = E.reduce(function(_, S) {
          return o.format(_, S, i.lng, i);
        }, s.trim())), n = n.replace(a[0], s), this.regexp.lastIndex = 0;
      }
      return n;
    }
  }]), e;
}();
function $u(e, t) {
  for (var n = e.indexOf(t); n !== -1; )
    e.splice(n, 1), n = e.indexOf(t);
}
var Hu = function(e) {
  Nr(t, e);
  function t(n, r, o) {
    var i, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return Me(this, t), i = Tn(this, Gt(t).call(this)), Or && _t.call(Lt(i)), i.backend = n, i.store = r, i.services = o, i.languageUtils = o.languageUtils, i.options = a, i.logger = Ze.create("backendConnector"), i.state = {}, i.queue = [], i.backend && i.backend.init && i.backend.init(o, a.backend, a), i;
  }
  return we(t, [{
    key: "queueLoad",
    value: function(r, o, i, a) {
      var s = this, c = [], u = [], E = [], l = [];
      return r.forEach(function(f) {
        var _ = !0;
        o.forEach(function(S) {
          var d = "".concat(f, "|").concat(S);
          !i.reload && s.store.hasResourceBundle(f, S) ? s.state[d] = 2 : s.state[d] < 0 || (s.state[d] === 1 ? u.indexOf(d) < 0 && u.push(d) : (s.state[d] = 1, _ = !1, u.indexOf(d) < 0 && u.push(d), c.indexOf(d) < 0 && c.push(d), l.indexOf(S) < 0 && l.push(S)));
        }), _ || E.push(f);
      }), (c.length || u.length) && this.queue.push({
        pending: u,
        loaded: {},
        errors: [],
        callback: a
      }), {
        toLoad: c,
        pending: u,
        toLoadLanguages: E,
        toLoadNamespaces: l
      };
    }
  }, {
    key: "loaded",
    value: function(r, o, i) {
      var a = r.split("|"), s = a[0], c = a[1];
      o && this.emit("failedLoading", s, c, o), i && this.store.addResourceBundle(s, c, i), this.state[r] = o ? -1 : 2;
      var u = {};
      this.queue.forEach(function(E) {
        Du(E.loaded, [s], c), $u(E.pending, r), o && E.errors.push(o), E.pending.length === 0 && !E.done && (Object.keys(E.loaded).forEach(function(l) {
          u[l] || (u[l] = []), E.loaded[l].length && E.loaded[l].forEach(function(f) {
            u[l].indexOf(f) < 0 && u[l].push(f);
          });
        }), E.done = !0, E.errors.length ? E.callback(E.errors) : E.callback());
      }), this.emit("loaded", u), this.queue = this.queue.filter(function(E) {
        return !E.done;
      });
    }
  }, {
    key: "read",
    value: function(r, o, i) {
      var a = this, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 350, u = arguments.length > 5 ? arguments[5] : void 0;
      return r.length ? this.backend[i](r, o, function(E, l) {
        if (E && l && s < 5) {
          setTimeout(function() {
            a.read.call(a, r, o, i, s + 1, c * 2, u);
          }, c);
          return;
        }
        u(E, l);
      }) : u(null, {});
    }
  }, {
    key: "prepareLoading",
    value: function(r, o) {
      var i = this, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
      typeof r == "string" && (r = this.languageUtils.toResolveHierarchy(r)), typeof o == "string" && (o = [o]);
      var c = this.queueLoad(r, o, a, s);
      if (!c.toLoad.length)
        return c.pending.length || s(), null;
      c.toLoad.forEach(function(u) {
        i.loadOne(u);
      });
    }
  }, {
    key: "load",
    value: function(r, o, i) {
      this.prepareLoading(r, o, {}, i);
    }
  }, {
    key: "reload",
    value: function(r, o, i) {
      this.prepareLoading(r, o, {
        reload: !0
      }, i);
    }
  }, {
    key: "loadOne",
    value: function(r) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", a = r.split("|"), s = a[0], c = a[1];
      this.read(s, c, "read", void 0, void 0, function(u, E) {
        u && o.logger.warn("".concat(i, "loading namespace ").concat(c, " for language ").concat(s, " failed"), u), !u && E && o.logger.log("".concat(i, "loaded namespace ").concat(c, " for language ").concat(s), E), o.loaded(r, u, E);
      });
    }
  }, {
    key: "saveMissing",
    value: function(r, o, i, a, s) {
      var c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(o)) {
        this.logger.warn('did not save key "'.concat(i, '" as the namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      i == null || i === "" || (this.backend && this.backend.create && this.backend.create(r, o, i, a, null, Ie({}, c, {
        isUpdate: s
      })), !(!r || !r[0]) && this.store.addResource(r[0], o, i, a));
    }
  }]), t;
}(_t);
function Vu() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    whitelist: !1,
    nonExplicitWhitelist: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      var n = {};
      if (ct(t[1]) === "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), ct(t[2]) === "object" || ct(t[3]) === "object") {
        var r = t[3] || t[2];
        Object.keys(r).forEach(function(o) {
          n[o] = r[o];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: function(t, n, r, o) {
        return t;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !1
    }
  };
}
function Ui(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function vn() {
}
var Bu = function(e) {
  Nr(t, e);
  function t() {
    var n, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
    if (Me(this, t), n = Tn(this, Gt(t).call(this)), Or && _t.call(Lt(n)), n.options = Ui(r), n.services = {}, n.logger = Ze, n.modules = {
      external: []
    }, o && !n.isInitialized && !r.isClone) {
      if (!n.options.initImmediate)
        return n.init(r, o), Tn(n, Lt(n));
      setTimeout(function() {
        n.init(r, o);
      }, 0);
    }
    return n;
  }
  return we(t, [{
    key: "init",
    value: function() {
      var r = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
      typeof o == "function" && (i = o, o = {}), o.whitelist && !o.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), o.nonExplicitWhitelist && !o.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = Ie({}, Vu(), this.options, Ui(o)), this.format = this.options.interpolation.format, i || (i = vn);
      function a(S) {
        return S ? typeof S == "function" ? new S() : S : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? Ze.init(a(this.modules.logger), this.options) : Ze.init(null, this.options);
        var s = new Pu(this.options);
        this.store = new Cu(this.options.resources, this.options);
        var c = this.services;
        c.logger = Ze, c.resourceStore = this.store, c.languageUtils = s, c.pluralResolver = new Mu(s, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), c.interpolator = new wu(this.options), c.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, c.backendConnector = new Hu(a(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", function(S) {
          for (var d = arguments.length, T = new Array(d > 1 ? d - 1 : 0), O = 1; O < d; O++)
            T[O - 1] = arguments[O];
          r.emit.apply(r, [S].concat(T));
        }), this.modules.languageDetector && (c.languageDetector = a(this.modules.languageDetector), c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = a(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new yi(this.services, this.options), this.translator.on("*", function(S) {
          for (var d = arguments.length, T = new Array(d > 1 ? d - 1 : 0), O = 1; O < d; O++)
            T[O - 1] = arguments[O];
          r.emit.apply(r, [S].concat(T));
        }), this.modules.external.forEach(function(S) {
          S.init && S.init(r);
        });
      }
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var E = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      E.forEach(function(S) {
        r[S] = function() {
          var d;
          return (d = r.store)[S].apply(d, arguments);
        };
      });
      var l = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      l.forEach(function(S) {
        r[S] = function() {
          var d;
          return (d = r.store)[S].apply(d, arguments), r;
        };
      });
      var f = en(), _ = function() {
        var d = function(O, h) {
          r.isInitialized && r.logger.warn("init: i18next is already initialized. You should call init just once!"), r.isInitialized = !0, r.options.isClone || r.logger.log("initialized", r.options), r.emit("initialized", r.options), f.resolve(h), i(O, h);
        };
        if (r.languages && r.options.compatibilityAPI !== "v1" && !r.isInitialized)
          return d(null, r.t.bind(r));
        r.changeLanguage(r.options.lng, d);
      };
      return this.options.resources || !this.options.initImmediate ? _() : setTimeout(_, 0), f;
    }
  }, {
    key: "loadResources",
    value: function(r) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vn, a = i, s = typeof r == "string" ? r : this.language;
      if (typeof r == "function" && (a = r), !this.options.resources || this.options.partialBundledLanguages) {
        if (s && s.toLowerCase() === "cimode")
          return a();
        var c = [], u = function(f) {
          if (f) {
            var _ = o.services.languageUtils.toResolveHierarchy(f);
            _.forEach(function(S) {
              c.indexOf(S) < 0 && c.push(S);
            });
          }
        };
        if (s)
          u(s);
        else {
          var E = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          E.forEach(function(l) {
            return u(l);
          });
        }
        this.options.preload && this.options.preload.forEach(function(l) {
          return u(l);
        }), this.services.backendConnector.load(c, this.options.ns, a);
      } else
        a(null);
    }
  }, {
    key: "reloadResources",
    value: function(r, o, i) {
      var a = en();
      return r || (r = this.languages), o || (o = this.options.ns), i || (i = vn), this.services.backendConnector.reload(r, o, function(s) {
        a.resolve(), i(s);
      }), a;
    }
  }, {
    key: "use",
    value: function(r) {
      if (!r)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!r.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return r.type === "backend" && (this.modules.backend = r), (r.type === "logger" || r.log && r.warn && r.error) && (this.modules.logger = r), r.type === "languageDetector" && (this.modules.languageDetector = r), r.type === "i18nFormat" && (this.modules.i18nFormat = r), r.type === "postProcessor" && vs.addPostProcessor(r), r.type === "3rdParty" && this.modules.external.push(r), this;
    }
  }, {
    key: "changeLanguage",
    value: function(r, o) {
      var i = this;
      this.isLanguageChangingTo = r;
      var a = en();
      this.emit("languageChanging", r);
      var s = function(E, l) {
        l ? (i.language = l, i.languages = i.services.languageUtils.toResolveHierarchy(l), i.translator.changeLanguage(l), i.isLanguageChangingTo = void 0, i.emit("languageChanged", l), i.logger.log("languageChanged", l)) : i.isLanguageChangingTo = void 0, a.resolve(function() {
          return i.t.apply(i, arguments);
        }), o && o(E, function() {
          return i.t.apply(i, arguments);
        });
      }, c = function(E) {
        var l = typeof E == "string" ? E : i.services.languageUtils.getBestMatchFromCodes(E);
        l && (i.language || (i.language = l, i.languages = i.services.languageUtils.toResolveHierarchy(l)), i.translator.language || i.translator.changeLanguage(l), i.services.languageDetector && i.services.languageDetector.cacheUserLanguage(l)), i.loadResources(l, function(f) {
          s(f, l);
        });
      };
      return !r && this.services.languageDetector && !this.services.languageDetector.async ? c(this.services.languageDetector.detect()) : !r && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(c) : c(r), a;
    }
  }, {
    key: "getFixedT",
    value: function(r, o) {
      var i = this, a = function s(c, u) {
        var E;
        if (ct(u) !== "object") {
          for (var l = arguments.length, f = new Array(l > 2 ? l - 2 : 0), _ = 2; _ < l; _++)
            f[_ - 2] = arguments[_];
          E = i.options.overloadTranslationOptionHandler([c, u].concat(f));
        } else
          E = Ie({}, u);
        return E.lng = E.lng || s.lng, E.lngs = E.lngs || s.lngs, E.ns = E.ns || s.ns, i.t(c, E);
      };
      return typeof r == "string" ? a.lng = r : a.lngs = r, a.ns = o, a;
    }
  }, {
    key: "t",
    value: function() {
      var r;
      return this.translator && (r = this.translator).translate.apply(r, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var r;
      return this.translator && (r = this.translator).exists.apply(r, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(r) {
      this.options.defaultNS = r;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(r) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var a = this.languages[0], s = this.options ? this.options.fallbackLng : !1, c = this.languages[this.languages.length - 1];
      if (a.toLowerCase() === "cimode")
        return !0;
      var u = function(f, _) {
        var S = o.services.backendConnector.state["".concat(f, "|").concat(_)];
        return S === -1 || S === 2;
      };
      if (i.precheck) {
        var E = i.precheck(this, u);
        if (E !== void 0)
          return E;
      }
      return !!(this.hasResourceBundle(a, r) || !this.services.backendConnector.backend || u(a, r) && (!s || u(c, r)));
    }
  }, {
    key: "loadNamespaces",
    value: function(r, o) {
      var i = this, a = en();
      return this.options.ns ? (typeof r == "string" && (r = [r]), r.forEach(function(s) {
        i.options.ns.indexOf(s) < 0 && i.options.ns.push(s);
      }), this.loadResources(function(s) {
        a.resolve(), o && o(s);
      }), a) : (o && o(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(r, o) {
      var i = en();
      typeof r == "string" && (r = [r]);
      var a = this.options.preload || [], s = r.filter(function(c) {
        return a.indexOf(c) < 0;
      });
      return s.length ? (this.options.preload = a.concat(s), this.loadResources(function(c) {
        i.resolve(), o && o(c);
      }), i) : (o && o(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(r) {
      if (r || (r = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !r)
        return "rtl";
      var o = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"];
      return o.indexOf(this.services.languageUtils.getLanguagePartFromCode(r)) >= 0 ? "rtl" : "ltr";
    }
  }, {
    key: "createInstance",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
      return new t(r, o);
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var r = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vn, a = Ie({}, this.options, o, {
        isClone: !0
      }), s = new t(a), c = ["store", "services", "language"];
      return c.forEach(function(u) {
        s[u] = r[u];
      }), s.services = Ie({}, this.services), s.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s.translator = new yi(s.services, s.options), s.translator.on("*", function(u) {
        for (var E = arguments.length, l = new Array(E > 1 ? E - 1 : 0), f = 1; f < E; f++)
          l[f - 1] = arguments[f];
        s.emit.apply(s, [u].concat(l));
      }), s.init(a, i), s.translator.options = s.options, s.translator.backendConnector.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s;
    }
  }]), t;
}(_t), Gu = new Bu();
function ku(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function bi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bi(Object(n), !0).forEach(function(r) {
      As(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var wi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0
};
zt.createContext();
function xu() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  wi = Mi(Mi({}, wi), e);
}
(function() {
  function e() {
    Me(this, e), this.usedNamespaces = {};
  }
  return we(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var r = this;
      n.forEach(function(o) {
        r.usedNamespaces[o] || (r.usedNamespaces[o] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var Fu = {
  type: "3rdParty",
  init: function(t) {
    xu(t.options.react);
  }
}, Ds = [], Wu = Ds.forEach, Ku = Ds.slice;
function zu(e) {
  return Wu.call(Ku.call(arguments, 1), function(t) {
    if (t)
      for (var n in t)
        e[n] === void 0 && (e[n] = t[n]);
  }), e;
}
var $i = {
  create: function(t, n, r, o) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/"
    }, a;
    if (r) {
      var s = /* @__PURE__ */ new Date();
      s.setTime(s.getTime() + r * 60 * 1e3), a = "; expires=" + s.toUTCString();
    } else
      a = "";
    o = o ? "domain=" + o + ";" : "", i = Object.keys(i).reduce(function(c, u) {
      return c + ";" + u.replace(/([A-Z])/g, function(E) {
        return "-" + E.toLowerCase();
      }) + "=" + i[u];
    }, ""), document.cookie = t + "=" + encodeURIComponent(n) + a + ";" + o + i;
  },
  read: function(t) {
    for (var n = t + "=", r = document.cookie.split(";"), o = 0; o < r.length; o++) {
      for (var i = r[o]; i.charAt(0) === " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(n) === 0)
        return i.substring(n.length, i.length);
    }
    return null;
  },
  remove: function(t) {
    this.create(t, "", -1);
  }
}, Yu = {
  name: "cookie",
  lookup: function(t) {
    var n;
    if (t.lookupCookie && typeof document < "u") {
      var r = $i.read(t.lookupCookie);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupCookie && typeof document < "u" && $i.create(n.lookupCookie, t, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
  }
}, ju = {
  name: "querystring",
  lookup: function(t) {
    var n;
    if (typeof window < "u")
      for (var r = window.location.search.substring(1), o = r.split("&"), i = 0; i < o.length; i++) {
        var a = o[i].indexOf("=");
        if (a > 0) {
          var s = o[i].substring(0, a);
          s === t.lookupQuerystring && (n = o[i].substring(a + 1));
        }
      }
    return n;
  }
}, Zn;
try {
  Zn = window !== "undefined" && window.localStorage !== null;
  var Hi = "i18next.translate.boo";
  window.localStorage.setItem(Hi, "foo"), window.localStorage.removeItem(Hi);
} catch {
  Zn = !1;
}
var Zu = {
  name: "localStorage",
  lookup: function(t) {
    var n;
    if (t.lookupLocalStorage && Zn) {
      var r = window.localStorage.getItem(t.lookupLocalStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupLocalStorage && Zn && window.localStorage.setItem(n.lookupLocalStorage, t);
  }
}, Xn;
try {
  Xn = window !== "undefined" && window.sessionStorage !== null;
  var Vi = "i18next.translate.boo";
  window.sessionStorage.setItem(Vi, "foo"), window.sessionStorage.removeItem(Vi);
} catch {
  Xn = !1;
}
var Xu = {
  name: "sessionStorage",
  lookup: function(t) {
    var n;
    if (t.lookupsessionStorage && Xn) {
      var r = window.sessionStorage.getItem(t.lookupsessionStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupsessionStorage && Xn && window.sessionStorage.setItem(n.lookupsessionStorage, t);
  }
}, qu = {
  name: "navigator",
  lookup: function(t) {
    var n = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          n.push(navigator.languages[r]);
      navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
    }
    return n.length > 0 ? n : void 0;
  }
}, Qu = {
  name: "htmlTag",
  lookup: function(t) {
    var n, r = t.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
  }
}, Ju = {
  name: "path",
  lookup: function(t) {
    var n;
    if (typeof window < "u") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof t.lookupFromPathIndex == "number") {
          if (typeof r[t.lookupFromPathIndex] != "string")
            return;
          n = r[t.lookupFromPathIndex].replace("/", "");
        } else
          n = r[0].replace("/", "");
    }
    return n;
  }
}, eE = {
  name: "subdomain",
  lookup: function(t) {
    var n;
    if (typeof window < "u") {
      var r = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
      r instanceof Array && (typeof t.lookupFromSubdomainIndex == "number" ? n = r[t.lookupFromSubdomainIndex].replace("http://", "").replace("https://", "").replace(".", "") : n = r[0].replace("http://", "").replace("https://", "").replace(".", ""));
    }
    return n;
  }
};
function tE() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
    checkWhitelist: !0,
    checkForSimilarInWhitelist: !1
  };
}
var ms = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Me(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
  }
  return we(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n, this.options = zu(r, this.options || {}, tE()), this.options.checkForSimilarInWhitelist && (this.options.checkWhitelist = !0), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = o, this.addDetector(Yu), this.addDetector(ju), this.addDetector(Zu), this.addDetector(Xu), this.addDetector(qu), this.addDetector(Qu), this.addDetector(Ju), this.addDetector(eE);
    }
  }, {
    key: "addDetector",
    value: function(n) {
      this.detectors[n.name] = n;
    }
  }, {
    key: "detect",
    value: function(n) {
      var r = this;
      n || (n = this.options.order);
      var o = [];
      n.forEach(function(s) {
        if (r.detectors[s]) {
          var c = r.detectors[s].lookup(r.options);
          c && typeof c == "string" && (c = [c]), c && (o = o.concat(c));
        }
      });
      var i;
      if (o.forEach(function(s) {
        if (!i) {
          var c = r.services.languageUtils.formatLanguageCode(s);
          (!r.options.checkWhitelist || r.services.languageUtils.isWhitelisted(c)) && (i = c), !i && r.options.checkForSimilarInWhitelist && (i = r.getSimilarInWhitelist(c));
        }
      }), !i) {
        var a = this.i18nOptions.fallbackLng;
        typeof a == "string" && (a = [a]), a || (a = []), Object.prototype.toString.apply(a) === "[object Array]" ? i = a[0] : i = a[0] || a.default && a.default[0];
      }
      return i;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(n, r) {
      var o = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || r.forEach(function(i) {
        o.detectors[i] && o.detectors[i].cacheUserLanguage(n, o.options);
      }));
    }
  }, {
    key: "getSimilarInWhitelist",
    value: function(n) {
      var r = this;
      if (this.i18nOptions.whitelist) {
        if (n.includes("-")) {
          var o = n.split("-")[0], i = this.services.languageUtils.formatLanguageCode(o);
          if (this.services.languageUtils.isWhitelisted(i))
            return i;
          n = i;
        }
        var a = this.i18nOptions.whitelist.find(function(s) {
          var c = r.services.languageUtils.formatLanguageCode(s);
          if (c.startsWith(n))
            return c;
        });
        if (a)
          return a;
      }
    }
  }]), e;
}();
ms.type = "languageDetector";
const nE = "login", rE = "E-mail", oE = "Kennwort", iE = "fehlerhafte Daten", aE = "überprüfen Sie Ihre Daten", sE = "erhalten Pakete", cE = "aufladen", uE = "nächste", EE = "zurück", lE = "Geh zurück", _E = "Bevestig", dE = "stornieren", TE = "Vollbild", fE = "Route", SE = "Routen", RE = "Wir arbeiten für Sie", NE = "Das System versucht immer, den besten Weg zu finden", OE = "Aber du bist der Experte!", IE = "Fahrer", pE = "Anzahl der Pakete", hE = "wählen Farher", AE = "Speichern", gE = "naam", vE = "Lage", DE = "Postleitzahl", mE = "Adresse", LE = "Straße", CE = "Nummer", PE = "stadt", yE = "lat", UE = "lng", bE = "Land", ME = "Niederlande", wE = "Deutschland", $E = "Telefonnummer", HE = "Telefonnummer ist nicht registriert", VE = "Kommentare", BE = "Pakete", GE = "Paket", kE = "geocode error", xE = "-", FE = "Übergabe", WE = "bewegen auf eine andere Route", KE = "anfang", zE = "Optimieren", YE = "Erstellen sie neue touren", jE = "Optimierungsoptionen", ZE = "anpassen Optimierung", XE = "gehen", qE = "Fahrgeschwindigkeit", QE = "schneller", JE = "schnell", el = "normal", tl = "langsahm", nl = "sehr langsahm", rl = "am Ende offene Tour", ol = "alle wählen", il = "Übergabe fertig", al = "abmelden", sl = "Kennwort zurücksetzen", cl = "Route hinzufügen", ul = "filter Touren", El = "Route optimieren", ll = "export", _l = "schliessen", dl = "Position", Tl = "uhrzeit", fl = "unterschrift", Sl = "code", Rl = "Profil", Nl = "Profil bearbeiten", Ol = "Fahrer", Il = "Fahrer bearbeiten", pl = "Hinzufügen Fahrer", hl = "Passwort ändern", Al = "Aktuelles Kennwort", gl = "Neues Kennwort", vl = "bestätige neues Kennwort", Dl = "Kennwort ist falsch", ml = "Ihr aktuelles Kennwort ist falsch", Ll = "Kennwort zu kurz", Cl = "Das neue Kennwort muss mindestens 8 Zeichen enthalten", Pl = "Kennwort geändert", yl = "Ihr Kennwort wurde geändert. Sie können jetzt mit dem neuen Kennwort einloggen.", Ul = "Passwörter stimmen nicht überein", bl = "Neues Kennwort stimmt nicht mit dem bestätigen Kennwort überein", Ml = "Formular unvollständig", wl = "Bitte füllen Sie alle angeforderten Felder aus.", $l = "Die Änderungen wurden gespeichert", Hl = "Änderungen an Ihrem Profil wurden gespeichert.", Vl = "Fehlermeldung", Bl = "Es gab einen Fehler Einsparung. Aktualisieren Sie die Seite und versuchen Sie es erneut.", Gl = "Fehlermeldung", kl = "Irgendetwas ging schief, um die Touren zu retten. Bitte laden Sie die Seite neu und versuchen Sie es erneut", xl = "Fahrer hinzugefügt", Fl = "Neuer Fahrer wurde erfolgreich hinzugefügt.", Wl = "ungültige E-Mail-Adresse", Kl = "Die von Ihnen angegebene E-Mail-Adresse ist ungültig", zl = "Die von Ihnen angegebene E-Mail-Adresse ist nicht mit einem Konto verknüpft", Yl = "Sie haben nicht gespeicherte Änderungen. Möchten Sie jetzt Änderungen speichern?", jl = "Es gibt neue Pakete bereit, die noch nicht in der geplanten Route enthalten. Optimieren Sie wieder die Strecke.", Zl = "der Verkehr", Xl = "Mindestanzahl der Haltestellen", ql = "Routen gleichen Abstand", Ql = "Least Anzahl der Fahrer", Jl = "Dauer", e_ = "die Farbe wechseln", t_ = "Sind Sie sicher, dass Sie diese Sendung stornieren möchten?", n_ = "Ja", r_ = "Nein", o_ = "E-Mail senden", i_ = "Füllen Sie E-Mail-Adresse aus und wir senden Ihnen ein neues Passwort zu.", a_ = "Wir haben ein neues Passwort an Ihre E-Mail Adresse gesendet. Sobald Sie sich mit Ihrem neuen Passwort angemeldet haben, können Sie Ihr Passwort auf Ihrer Profilseite ändern.", s_ = "Bearbeiten Tour", c_ = "Schließen", u_ = "Neues Update!", E_ = "Nehmen Sie sich einen Moment Zeit, um herauszufinden, was neu ist", l_ = "Multicolli Anzeige", __ = "Multicolli Sendungen auf der Karte werden nun durch einen kleinen Stern auf der Markierung angezeigt. Durch Anklicken des Markers können Sie sehen, wie viele Sendungen. Um alle Sendungen sofort zu verschieben, kannst du jetzt mit der rechten Maustaste auf den Marker klicken, um alle Sendungen gleichzeitig zu verschieben.", d_ = "", T_ = "", f_ = "", S_ = "", R_ = "Feedback?", N_ = "Wir arbeiten kontinuierlich daran, die Planner App zu verbessern. Wenn Sie also Feedback, Anregungen oder Wünsche haben, würden wir sie gerne hören. Sie können uns eine E-Mail an wietse@trunkrs.nl schicken.", O_ = "Willkommen bei der Plannr App!", I_ = "Nehmen Sie sich einen Moment Zeit, um herauszufinden, was die Planner App machen kann und wie es Ihnen helfen kann, Ihre Produktivität zu maximieren", p_ = "Sendungsübersicht", h_ = "Sehen Sie alle heutigen Sendungen an und bearbeiten oder stornieren sie bei Bedarf.", A_ = "Tourenplaner", g_ = "Nutzen Sie unser anspruchsvolles System, um die besten Touren zu berechnen und zu modifizieren, wenn Sie möchten.", v_ = "Übergabe", D_ = "Führen Sie die Handover manuell durch oder verwenden Sie den Barcode-Scanner, um den Prozess zu automatisieren. Finalisieren Sie den Prozess, indem Sie eine Rollkarte für den Fahrer ausdrucken.", m_ = "Versuch es!", L_ = "Zeit, die App und all ihre Features zu erkunden! Wenn Sie irgendwelche Fragen haben, können Sie uns über die Schaltfläche in der unteren rechten Ecke kontaktieren.", C_ = "Die Annahmeschlusszeit ist noch nicht erreicht, so dass Sie immer noch neue Sendungen erhalten können.", P_ = "Keine pakete", y_ = "Die Übergabe ist bereits im Gange. Sie können die Touren nicht mehr ändern.", U_ = "Wenn Sie die Optimierung erneut ausführen, werden alle bisherigen Änderungen überschrieben. Sie können auch einzelne Routen optimieren auf dem Gang durch einen Klick. Sind Sie sicher, dass Sie fortfahren möchten?", b_ = "Warnung: Ihre Touren wurden gespeichert, aber nicht alle Touren haben noch einen zugewiesenen Treiber", M_ = "Verwenden Sie eine andere E-Mail-Adresse", w_ = "Diese E-Mail-Adresse wird bereits von einem anderen Treiber benutzt", $_ = "Zoomen durch Scrollen", H_ = "Cluster-Sendungen", V_ = "Anleitung", B_ = "Sehen Sie sich das Video unten an, um zu sehen, was die Planner App ausführen kann.", G_ = "Update", k_ = "Sehen Sie das Video unten an, um zu sehen, was neu ist.", x_ = "Letztes Update-Video ansehen (Englisch)", F_ = "Die Plannr App wurde aktualisiert. Klicken Sie hier um zu sehen, was neu ist!", W_ = "Karre", K_ = "Confirmation", z_ = "Reset handover", Y_ = "Do you want to reset handovers?", j_ = "Number of drivers in optimization", Z_ = "Aktiv", X_ = "Code schicken", q_ = "Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.", Q_ = "Tourfortschritt", J_ = "Tourübersicht abrufen", ed = "wird nicht am Hub gescannt", td = "auf dem weg", nd = "geliefert", rd = "an den nachbarn geliefert", od = "nicht zugestellt", id = "Falscher Bestätigungscode. Bitte versuche es erneut.", ad = `Hoppla, es sieht so aus, als hätten wir Probleme.
`, sd = "Das Trunkrs Team wurde benachrichtigt.", cd = "Wenn Sie helfen möchten, teilen Sie uns unten mit, was passiert ist.", ud = "Dein Name", Ed = "Deine E-Mail", ld = "Beschrieb, was kurz vor dem Absturz passierte.", _d = "Schließen", dd = "Einreichen", Td = "Ihr Feedback wurde gesendet. Vielen Dank, dass Sie uns geholfen haben, den Planer zu verbessern!", fd = "Tourfortschritt", Sd = "Pas op", Rd = "Je staat op het punt om de chauffeur voor deze route te wijzigen. Als de huidige chauffeur al onderweg is, zal zijn app hierna leeg zijn en kan hij niet verder. Deze tour zal na de wijziging (in de facturering en cijfers) toe worden gewezen aan de nieuwe chauffeur. Wij zijn niet in staat om dit op een later moment terug te draaien. Weet je zeker dat de chauffeur wilt veranderen? Zo ja kies hieronder dan de nieuwe chauffeur.", Nd = "Zuletzt aktualisiert", Od = "Er is hier niets te zien", Id = "Paket zurück nach Trunkrs", pd = "Paket nicht auf Depot", hd = "Paket wieder in Planung", Ad = "Lade Aufgabenliste...", gd = "Paket nicht auf Depot", vd = "Bitte geben Sie weitere Informationen über den Ort dieses Pakets und warum es sich nicht im Depot befindet.", Dd = "Schreiben Sie hier Ihre Erklärung...", md = "Gescanntes Paket", Ld = "Aufgabenliste", Cd = "Aufgabenliste", Pd = "Nicht geliefert", yd = "Kein Endstatus", Ud = "Verarbeitet", bd = "Scannen Sie den Barcode, um das Paket zu verarbeiten", Md = "Zeit übrig", wd = "Verarbeitet", $d = "Grund nicht geliefert", Hd = "Nicht zurück", Vd = "Paket zurück", Bd = "Paket nicht auf Depot", Gd = "Paket auf Depot", kd = "Letzter Status", xd = "Lieferadresse wurde geändert!", Fd = "Neue Adresse", Wd = "Alte Adresse", Kd = "Vom Fahrer akzeptiert", zd = "Adresse nicht gefunden", Yd = "Geschäft geschlossen", jd = "Falsche Adresse", Zd = "Paket beschädigt", Xd = "Keine Zeit mehr für die Tour", qd = "Empfänger nicht zu Hause", Qd = "Fahrer in Unfall", Jd = "Vom Kunden abgelehnt", eT = "Extremes Wetter", tT = "Paket fehlt", nT = "Adresse nicht erreichbar", rT = "Paket fehlt", oT = "Schwer beschädigt", iT = "Paket zu schwer", aT = "Paket zu groß", sT = "Sendungen sortiert nach regionalen Hubs", cT = "Von Fahrern angenommene Sendungen", uT = "Sendungen mit Endzustand", ET = "Nachbarzustellung gegen Nichtzustellung", lT = "Alle sendungen", _T = "Ergebnisse", dT = "Welche sendungen wurden am regionalen hub sortiert?", TT = "Welche sendungen wurden NICHT im regionalen hub sortiert?", fT = "Welche sendungen wurden von ihren fahrern angenommen?", ST = "Welche sendungen wurden von ihren fahrern NICHT angenommen?", RT = "Welche sendungen haben einen endzustand?", NT = "Welche sendungen haben KEINEN endzustand?", OT = "Welche sendungen werden an nachbarn geliefert?", IT = "Welche sendungen wurden nicht geliefert?", pT = "Filter löschen", hT = "Transfer nach", AT = "Not ready to handover yet", gT = "Before you can start the handover, the following steps must be complete:", vT = "Trunkrs", DT = "Planning", mT = "Planning is fixed", LT = "Choose your drivers below and go to the handover page.", CT = "Die Planung muss gespeichert werden, damit wir sicherstellen können, dass die von Ihnen erstellten Touren die Touren sind, die Ihre Fahrer heute Abend fahren.", PT = "Trunkrs", yT = "Central sorting", UT = "It is necessary for the central sorting to be done before making the tours permanent, so we know what you will deliver today.", bT = "Die Planung wurde gespeichert!", MT = "You", wT = "Assign drivers", $T = "Once you have assigned drivers to the tours and the central sorting is done, you can proceed to make the tours permanent.", HT = "Start assigning drivers", VT = "Make tours permanent and start handover", BT = "Fossil", GT = "Electric", kT = "Planung noch nicht fertig!", xT = "Geschätzte Anzahl der Sendungen und Fahrer verfügbar in", FT = "Information", WT = "Die geschätzte Anzahl der Sendungen und benötigten Fahrer ist unter verfügbar", KT = "Die Planung scheint noch nicht fertig zu sein. Für Ihre Bequemlichkeit finden Sie unten die geschätzte Versandmenge und die Treiber, die Sie benötigen.", zT = "Sie können auf die Planung zugreifen, wenn sie abgeschlossen ist", YT = "Geschätzte Anzahl der Sendungen", jT = "Treiber, die Sie wahrscheinlich benötigen", ZT = "Der zentrale Sortiervorgang ist nun abgeschlossen. Bitte neu laden, um mit der Planung zu beginnen.", XT = "WARNUNG", qT = "Der zentrale Sortiervorgang ist noch nicht abgeschlossen. Bis dahin kann keine Ihrer Änderungen gespeichert werden.", QT = "Fahrzeug", JT = "Volle tour zeigen", ef = "Verstecke deine", tf = "Optimieren sie ihre", nf = "Umgekehrte tour", rf = "Farbtour", of = "Wähle deine farbe", af = "Stornieren", sf = "Pakete", cf = "Zu einer anderen tour wechseln", uf = "Alle abwählen", Ef = "Wenn möglich, vorherige Optimierung verwenden?", lf = "Use the new (faster) optimalisation?", _f = "Verberg route op kaart", df = "Toon route op kaart", Tf = "Er is een fout opgetreden tijdens het optimaliseren", ff = "Opnieuw optimaliseren kan dit probleem oplossen", Sf = "Wil je opnieuw optimaliseren?", Rf = "Er is iets mis gegaan, we kunnen geen routes maken.", Nf = "Neem contact op met Trunkrs via jullie slack kanalen", Of = "", If = "Optimalisatie resultaten", pf = "Optimalisatie tijd:", hf = "Hoeveelheid chauffeurs geselecteerd:", Af = "Overflow routes gecreëerd:", gf = "Probeer opnieuw", vf = "Accepteren", Df = "Opnieuw optimaliseren", mf = "Overflow tours are the result of not having enough drivers assigned. You can solve this by re-optimising with more drivers.", Lf = "Hub-inventaris", Cf = "RETOUR AAN TRUNKRS", Pf = "OPZIJ ZETTEN!", yf = "Let op", Uf = "Deze zending is in de verkeerde regio, retourneer de zending zo snel mogelijk aan Trunkrs.", bf = "Deze zending hoort niet bij de tours voor vandaag", Mf = {
  TITLE: "Hub-inventaris",
  TRUNKRSNR: "TrunkrsNr",
  ADDRESS: "Adres",
  LAST_DRIVER: "Laatste Chauffeur",
  INTENDED_DELIVERY_DATE: "Originele afleverdatum",
  IN_SINCE: "Op depot sinds",
  STATUS: "Status",
  EMPTY_TITLE: "Niets te zien hier!",
  EMPTY_DESC: "Blijf relaxt, pak een kop koffie en herlaad deze pagina.",
  RELOAD_BUTTON: "Herlaad pagina"
}, wf = {
  TITLE: "Retour Scan",
  SCAN_INPUT_PLACEHOLDER: "Scan alle zendingen op de hub",
  AT_REGIONAL_HUB: "Momenteel op hub",
  KEEP_IN_REGION: "Blijft op hub",
  BACK_TO_TRUNKRS: "Retour naar Trunkrs",
  AT_REGIONAL_HUB_PLACEHOLDER: "Je bent klaar met scannen, zorg er voor dat de zendingen op de juiste bestemming aankomen.",
  KEEP_ON_HUB_PLACEHOLDER: "Scan eerst een van de zendingen op de hub",
  BACK_TO_TRUNKRS_PLACEHOLDER: "Scan eerst een van de zendingen op de hub",
  BUTTON_CONFIRM_RETURNS: "Bevestig retouren",
  LAST_DRIVER: "Laatste Chauffeur",
  ADDRESS: "Adres",
  SENDER: "Verzender",
  ERROR: "FOUT",
  SCAN_ERROR_TITLE: "Zending kan niet worden verwerkt.",
  SCAN_ERROR_DETAILS: "Neem contact op met Trunkrs voordat je doorgaat.",
  SCAN_UNSCANNABLE_TITLE: "Zending reeds gemarkeerd als 'niet scanbaar'.",
  RETURNED_SCAN_SUCCESS: "Deze zendingen zijn succesvol geretourneerd.",
  SUCCESS_CALLOUT: "You have successfully returned all these shipments to Trunkrs.",
  CONFIRMED_RETURNS: "Confirmed returns!",
  APOLOGIES: "Apologies!",
  ACKNOWLEDGEMENT: {
    TITLE: "Retouren Bevestigen",
    DESCRIPTION: "Hierbij bevestig ik dat deze zendingen geretourneerd worden aan Trunkrs en dat de chauffeur die deze zending retourneert vanaf nu verantwoordelijk is.",
    CONFIRM: "Bevestig",
    BACK: "Ga terug",
    WARNING: "Let op! Je hebt nog niet alle zendingen op je hub gescand, weet je zeker dat door wil gaan?"
  },
  OWNERSHIP: "Eigenaar",
  ACTIONS: "Acties",
  SHIPMENT_DETAILS: "Details van de verzending",
  REASON: "Reden",
  OTHER_REASON: "Andere reden",
  ADDITIONAL_REASON: "Aanvullende reden",
  NOT_AT_REGIONAL_HUB: "Niet op het regionale depot",
  TAG_AS_NOT_SCANNABLE: "Als 'niet scanbaar' gemarkeerd",
  UNSCANNABLE_DESC: "Selecteer hieronder de reden voor het ontbreken van de zending op de locatie waardoor het niet mogelijk is deze te scannen.",
  UNSCANNANBLE_REASON_CODES: {
    SHIPMENT_WITH_DRIVER_DELAYED: "Zending is nog bij chauffeur en komt vandaag niet terug op depot",
    SHIPMENT_WITH_DRIVER_NOT_DELAYED: "Zending is nog bij chauffeur en is nog voor 17:00 terug op depot",
    SHIPMENT_LOST: "Zending is zoekgeraakt",
    FALSELY_MARKED_NOT_DELIVERED: "Zending is toch geleverd",
    DAMAGED_LABEL: "De barcode/label van de zending is niet leesbaar/scanbaar",
    SHIPMENT_MISSING: "Zending is vermist"
  },
  CAUTION_PROCEED_NEXT: "U staat op het punt om naar de volgende stap van het planningsproces te gaan, alhoewel de 'Voorraadscan' nog niet is voltooid. U kunt nog steeds terug naar de Voorraadscan, maar wees attent dat vanaf [DATE] het onmogelijk is om het planningsproces te vervolgen zonder de voorraadscan compleet af te ronden.",
  CAUTION_PROCEED_TO_OTHER_STEP: "Vervolg naar andere stap",
  SUCCESS: "Succesvol",
  TOAST_DESC: "Zending {{ trunkrsNr }} verplaatst naar 'Niet op regionale depot'",
  SELECT_ONE: "Kies een",
  RETURN_TODAY_TO: "Sie können dies noch heute an uns zurücksenden",
  COLLECTION_OPT_ID: "Sammlungsoptimierungs-ID:",
  COLLECTION_TOUR_TAG: "Sammlungstour Schlagwort:",
  NO_COLLECTION_TODAY: "Heute erfolgt keine Inkasso für <b>{{merchantName}}</b>. Ihre nächste Inkasso ist am <b>{{day}}</b> mit Optimierungs-ID für die Inkassosammlung: <b>{{optimizationId}}</b> und Tour Tag : <b>{{tourTag}}</b>",
  FOR_RETURN_TO_SENDER: "Zur Rücksendung an den Absender",
  LOADING: `Scannen.
Bitte warten..`,
  DETAILS: {
    SHIPMENT_DETAILS: "Versanddetails",
    INTENDED_DELIVERY_DATE: "Geplanter Liefertermin"
  },
  TRUNKRS_NR: "TrunkrsNR"
}, $f = {
  DATA_RECEIVED: "Data ontvangen",
  DATA_PROCESSED: "Aangemeld voor verzending",
  SHIPMENT_SORTED: "Gesorteerd (centrale hub)",
  SHIPMENT_SORTED_AT_SUB_DEPOT: "Gesorteerd (regionaal depot)",
  SHIPMENT_ACCEPTED_BY_DRIVER: "Geaccepteerd door chauffeur",
  SHIPMENT_NOT_DELIVERED: "Niet afgeleverd",
  RETURN_SHIPMENT_TO_SENDER: "Retour naar webshop",
  RETURN_ACCEPTED_BY_DRIVER: "Retour geaccepteerd door chauffeur",
  RETURN_ASSIGNED_TO_PICKUP: "Retour toegewezen aan collectie",
  RETURN_ACCEPTED_BY_TRUNKRS: "Retour geaccepteerd door Trunkrs",
  RETURN_ACCEPTED_BY_PICKUP_DRIVER: "Retour geaccepteerd door collectie chauffeur",
  RETURN_ACCEPTED_BY_SENDER: "Retour geaccepteerd door verzender",
  EXCEPTION_SHIPMENT_NOT_ARRIVED: "Niet aangekomen",
  EXCEPTION_SHIPMENT_MIS_SORTED: "Verkeerd gesorteerd",
  EXCEPTION_SHIPMENT_MISS_SORTED: "Foutief gesorteerd",
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER: "Geweigerd door chauffeur",
  EXCEPTION_SHIPMENT_MISSING: "Zending vermist",
  EXCEPTION_SHIPMENT_LOST: "Zending kwijt",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER: "Retour geweigerd door verzender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER: "Geannuleerd door verzender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS: "Geannuleerd door Trunkrs",
  EXCEPTION_SHIPMENT_DESTROYED: "Zending vernietigd",
  EXCEPTION_SHIPMENT_INVESTIGATE: "Zending wordt onderzocht",
  CHANGE_SHIPMENT_ADDRESS_CHANGED: "Adres gewijzigd",
  CHANGE_SHIPMENT_NEIGHBOUR_CHANGE: "Buuradres gewijzigd",
  CHANGE_SHIPMENT_POST_PONED: "Zending gepostponed",
  CUSTOMER_SERVICE_OVERRULE: "Customer Service overrule",
  EXCEPTION_LINEHAUL_ARRIVED_LATE: "Linehaul laat gearriveerd",
  EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL: "Niet op linehaul",
  EXCEPTION_PICKUP_ARRIVED_LATE: "Collectie laat aangekomen",
  EXCEPTION_PICKUP_NOT_PICKED_UP: "Niet opgehaald",
  EXCEPTION_PICKUP_REFUSED_BY_DRIVER: "Collectie geweigerd door chauffeur",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL: "Retour geweigerd door linehaul",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP: "Retour geweigerd door collectie",
  LINEHAUL_ARRIVED_ON_TIME: "Linehaul op tijd aangekomen",
  LINEHAUL_IN_TRANSIT: "Linehaul onderweg",
  PICKUP_ACCEPTED_BY_DRIVER: "Collectie geaccepteerd door chauffeur",
  PICKUP_ARRIVED_ON_TIME: "Collectie op tijd aangekomen",
  PICKUP_DRIVER_ASSIGNED: "Collectie chauffeur toegewezen",
  PICKUP_PICKED_UP: "Gecollecteerd",
  RETURN_ASSIGNED_TO_LINEHAUL: "Retour toegewezen aan linehaul",
  SHIPMENT_DELIVERED: "Afgeleverd",
  SHIPMENT_DELIVERED_TO_NEIGHBOR: "Afgeleverd bij buur",
  PARTNER_OVERRULE: "The shipment has been overruled by the partner"
}, Hf = {
  TITLE: "Werknemers",
  ADD_USER_TITLE: "Werknemer toevoegen",
  ADD_USER_BUTTON: "Werknemer toevoegen",
  ADD_USER_CREATE_BUTTON: "Voeg toe",
  ADD_USER_CANCEL_BUTTON: "Sluiten",
  ADD_USER_CREATING_BUTTON: "Toevoegen",
  ADD_USER_NAME_REQUIRED: "Naam is vereist",
  ADD_USER_LANGUAGE_REQUIRED: "Taalvoorkeur is vereist",
  ADD_USER_PHONE_REQUIRED: "Telefoonnummer is vereist",
  USER_LIST_HEADER: "Werknemers",
  USER_LIST_TAB_ALL_EMPLOYEES: "Alle werknemers",
  USER_LIST_TAB_PLANNER: "Planners",
  USER_LIST_TAB_INACTIVE: "Inactief",
  USER_LIST_TAB_DELETED: "Verwijderd",
  USER_LIST_TABLE_EMPLOYEE_NAME: "Naam",
  USER_LIST_TABLE_ROLE: "Functie",
  USER_LIST_TABLE_PHONE_NUMBER: "Telefoonnummer",
  USER_LIST_TABLE_STATUS: "Status",
  USER_LIST_TABLE_MANAGE_EMPLOYEE: "Gegevens aanpassen",
  USER_LIST_TABLE_ROLE_PLANNER: "Planner, Chauffeur",
  USER_LIST_TABLE_ROLE_DRIVER: "Chauffeur",
  USER_LIST_TABLE_ROLE_DELETED: "Verwijderd",
  USER_LIST_TABLE_ACTIVE: "Actief",
  USER_LIST_TABLE_INACTIVE: "Inactief",
  USER_LIST_MENU_OPTIONS: "Opties",
  USER_LIST_MENU_EDIT_USER: "Gegevens aanpassen",
  USER_LIST_MENU_DELETE_USER: "Verwijder werknemer",
  NO_USERS_FOUND: "Niets gevonden",
  NO_USERS_FOUND_MSG: "Er zijn geen werknemers die voldoen aan deze categorie",
  DELETE_USER_SUBTEXT: "U kunt deze actie niet ongedaan maken.",
  DELETE_USER_TITLE: "Verwijder gebruiker?",
  LONGPRESS_DELETE_USER: "houden 3 secs to verwijderen",
  LONGPRESS_DONE: "Verwijderen...",
  DELETE_USER_SUCCESS_MSG_SUBTEXT: "{{EMP_NAME}}'s profiel is verwijderd",
  ADD_USER_SUCCESS_MSG: "BRAVO!",
  ADD_USER_SUCCESS_MSG_SUBTEXT: "We hebben de nieuwe werknemer aangemaakt.",
  EDIT_USER_SUCCESS_MSG_SUBTEXT: "Je hebt de medewerker succesvol geüpdatet.",
  IMPORT_DRIVER_MODAL_TITLE: "Importeer chauffeur naar deze regio",
  DRIVER_PHONE_NUMBER: "Telefoonnummer chauffeur",
  CURRENT_REGION: "Huidige regio:",
  NOTIF_CANNOT_FIND_DRIVER: "Er zijn geen chauffeurs gevonden met dit telefoonnummer.",
  AVAILABLE_ASSIGNED: "Deze chauffeur is al aan een route in {{region}} toegewezen en zal van deze route worden verwijderd als je doorgaat.",
  NOT_AVAILABLE_ASSIGNED: "Deze chauffeur is al onderdeel van deze regio.",
  NOTIF_DRIVER_CANNOT_BE_MOVED: "Deze chauffeur is al aan een route in ZOS toegewezen en zal van deze route worden verwijderd als je doorgaat.",
  TOAST_DRIVER_IMPORT_SUCCESS: "Chauffeur succesvol geïmporteerd!",
  TOAST_DRIVER_IMPORT_SUCCESS_SUBTEXT: "{{name}} is nu beschikbaar in deze regio.",
  BUTTON_IMPORT_DRIVER: "Importeer chauffeur",
  BUTTON_CANCEL: "Sluiten",
  EDIT_INFORMATION_TOOLTIP: "Informatie wijzigen",
  DELETE_TOOLTIP: "Verwijderen"
}, Vf = "Totale Afstand", Bf = "Tour(s) {{text}} bevatten stop(s) die niet volledig geoptimaliseerd konden worden.", Gf = "Voor sommige stops konden we geen routelijnen trekken, dit is geen probleem.", kf = "Deze route is niet volledig geoptimaliseerd. Voor de rode stops konden we geen routelijnen trekken. Deze stops kunnen handmatig worden aangepast of naar een andere route worden verplaatst.", xf = {
  BUSY_PEAK_DAYS: "Drukke dag. Er kan nog niet begonnen worden met de handover. Maak nieuwe tours zodra de centrale sortering is afgerond.",
  CENTRAL_SORTING_IS_DONE: "De centrale sortering is afgerond. Maak nieuwe tours voordat je start met de handover.",
  HANDOVER_CENTRAL_SORTING_DONE: "Drukke dag. Er kan nog niet begonnen worden met de handover. Maak nieuwe tours zodra de centrale sortering is afgerond."
}, Ff = {
  HEADER: "Zendingen",
  FILTER_ALL_SHIPMENTS: "Alle zendingen",
  FILTER_CENTRAL_SORTED: "Centraal gesorteerd",
  FILTER_CANCELLED: "Geannuleerd",
  TABLE_HEADER_TRUNKRSNR: "TrunkrsNR",
  TABLE_HEADER_POSTAL_CODE: "Postcode",
  TABLE_HEADER_ADDRESS: "Adres",
  TABLE_HEADER_CITY: "Stad",
  TABLE_HEADER_TOUR: "Tour",
  TABLE_HEADER_SHIPMENT_STATE: "Staat van verzending",
  RESULT_COUNT: "{{count}} resultaten",
  STATE_CANCELED: "Geannuleerd",
  STATE_HAS_TOUR: "Toegewezen aan route",
  STATE_NO_TOUR: "Open",
  STATE_EXPECTED: "Verwacht",
  NO_TOURS_YET: "Nog geen routes bekend",
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: "Zendingen gesorteerd op regionale hub",
  SHIPMENTS_ACCEPTED_BY_DRIVERS: "Zendingen geaccepteerd door chauffeurs",
  SHIPMENTS_WITH_END_STATE: "Zendingen met eindstatus",
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: "Buurlevering versus niet-levering",
  OUT_OF_MAXCOUNT: "{{count}} van de {{maxCount}}",
  REFRESH_RESULTS: "Resultaten vernieuwen",
  EMPTY_TITLE: "Niets te zien hier!",
  EMPTY_DESC: "Blijf kalm, drink een kopje koffie, en herlaad deze pagina.",
  RELOAD_BUTTON: "Herlaad pagina"
}, Wf = {
  INVENTORY_SCAN: "Voorraadscan",
  INVENTORY_SCAN_DESC: "Dit is je eerste stap bij het plannen van route",
  TOUR_PLANNING: "Routeplanning",
  TOUR_PLANNING_DESC: "Routes aanmaken en aanpassen",
  HANDOVER: "Overhandiging",
  HANDOVER_DESC: "Pakket overhandigen",
  MONITORING: "Toezicht houden",
  MONITORING_DESC: "Volg uw pakketten"
}, Kf = {
  START_PLANNING: {
    TITLE: "Welkom",
    DESCRIPTION: "Hi! Via de volgende stappen helpen wij je om: je pakketten te volgen, je routes te plannen en je dag te monitoren. Zit je er klaar voor?",
    LETS_START: "Laten we beginnen"
  },
  NO_SHIPMENT_FOUND: "Geen zendingen gevonden",
  NO_SHIPMENT_FOUND_TEXT: "Je bent klaar met scannen, je kunt nu doorgaan met het proces",
  THIS_FEATURE_DISABLED: "Deze feature is op dit moment niet beschikbaar",
  INVENTORY_SCAN_300_1400: "De inventaris scan is alleen beschikbaar tussen 3:00 en 14:00",
  NETWORK_NOT_READY: {
    HEADER: "Nothing to see here",
    DESCRIPTION: "Central sorting is not yet done. Please check again later."
  }
}, zf = "Click to open the track & trace page of this parcel.", Yf = "Hallo! Enter your registered number to access the Planner. You’ll receive a 6-digit code after.", jf = "Phone number is required.", Zf = "Sorry, this is not a registered mobile number. Please try again.", Xf = "We have sent a code to {{ number }}. Enter it below.", qf = "Didn’t received it? Resend code in 30s", Qf = "Verify and Login", Jf = "De routes moeten opgeslagen zijn, zodat we zeker kunnen zijn dat de routes die je nu gaat sorteren ook de routes zijn die je vanavond gaat rijden.", eS = "Zodra je chauffeurs hebt toegewezen aan alle routes en de centrale sortering klaar is, kun je verder met het permanent maken van je routes.", tS = "Wijzig de chauffeur voor kar {{ cart }}", nS = "Aktueller Fahrer: {{ driver }}", rS = "Invalid Phone number", oS = "Partner profiel", iS = "Er zijn nog geen actieve routes", aS = "Zie meer stops", sS = "Zie minder stops", cS = "Maak en wijzig routes tot ze tot in de puntjes geoptimaliseerd zijn", uS = "Doorgaan naar {{ location }}", ES = "Ga terug naar {{ location }}", lS = "Overzicht", _S = "Snelheid", dS = "Dit veld is verplicht.", TS = {
  LOGIN: nE,
  EMAIL: rE,
  PASSWORD: oE,
  WRONG_CREDENTIALS: iE,
  CHECK_CREDENTIALS: aE,
  CHECK_SHIPMENTS: sE,
  RELOAD: cE,
  NEXT: uE,
  BACK: EE,
  GO_BACK: lE,
  CONFIRM: _E,
  CANCEL: dE,
  FULL_SCREEN: TE,
  TOUR: fE,
  TOURS: SE,
  OPTIMIZING_1: RE,
  OPTIMIZING_2: NE,
  OPTIMIZING_3: OE,
  DRIVER: IE,
  NO_PARCELS: pE,
  SELECT_DRIVER: hE,
  SAVE: AE,
  NAME: gE,
  LOCATION: vE,
  POSTALCODE: DE,
  ADDRESS: mE,
  STREET: LE,
  NUMBER: CE,
  CITY: PE,
  LAT: yE,
  LNG: UE,
  COUNTRY: bE,
  NETHERLANDS: ME,
  GERMANY: wE,
  PHONE_NUMBER: $E,
  PHONE_NUMBER_NOT_REGISTERED: HE,
  REMARKS: VE,
  SHIPMENTS: BE,
  SHIPMENT: GE,
  GEOCODING_EXCEPTIONS: kE,
  NOT_PLANNED_YET: xE,
  HANDOVER: FE,
  MOVE_TOUR: WE,
  START: KE,
  OPTIMIZE: zE,
  CREATE_NEW_TOURS: YE,
  OPTIMIZE_OPTIONS: jE,
  OPTIMIZE_AGAIN: ZE,
  RUN: XE,
  DRIVER_SPEED: qE,
  FASTER: QE,
  FAST: JE,
  NORMAL: el,
  SLOW: tl,
  VERY_SLOW: nl,
  OPEN_END_TOUR: rl,
  SELECT_ALL: ol,
  HANDOVER_DONE: il,
  LOG_OFF: al,
  RECOVER_CREDENTIALS: sl,
  ADD_TOUR: cl,
  VISIBLE_TOURS: ul,
  OPTIMIZE_TOUR: El,
  EXPORT: ll,
  CLOSE: _l,
  POSITION: dl,
  TIME: Tl,
  SIGNATURE: fl,
  CODE: Sl,
  PROFILE: Rl,
  EDIT_PROFILE: Nl,
  DRIVERS: Ol,
  EDIT_DRIVER: Il,
  ADD_DRIVER: pl,
  CHANGE_PASSWORD: hl,
  CURRENT_PASSWORD: Al,
  NEW_PASSWORD: gl,
  CONFIRM_NEW_PASSWORD: vl,
  WRONG_PASSWORD: Dl,
  WRONG_PASSWORD_MSG: ml,
  PASSWORD_TOO_SHORT: Ll,
  PASSWORD_TOO_SHORT_MSG: Cl,
  PASSWORD_CHANGED: Pl,
  PASSWORD_CHANGED_MSG: yl,
  PASSWORDS_DONT_MATCH: Ul,
  PASSWORDS_DONT_MATCH_MSG: bl,
  FORM_INCOMPLETE: Ml,
  FORM_INCOMPLETE_MSG: wl,
  PROFILE_EDITED: $l,
  PROFILE_EDITED_MSG: Hl,
  UNKOWN_ERROR: Vl,
  UNKOWN_ERROR_MSG: Bl,
  SAVE_ERROR: Gl,
  SAVE_ERROR_MSG: kl,
  DRIVER_ADDED: xl,
  DRIVER_ADDED_MSG: Fl,
  EMAIL_INVALID: Wl,
  EMAIL_INVALID_MSG: Kl,
  UNKNOWN_EMAIL_MSG: zl,
  UNSAVED_CHANGES: Yl,
  NEW_SHIPMENTS_MSG: jl,
  TRAFFIC: Zl,
  MIN_VISITS: Xl,
  BALANCE: ql,
  MIN_VEHICLES: Ql,
  DURATION: Jl,
  CHANGE_COLOR: e_,
  CANCEL_SHIPMENT: t_,
  YES: n_,
  NO: r_,
  SEND_EMAIL: o_,
  SEND_EMAIL_MSG: i_,
  EMAIL_SENT_MSG: a_,
  EDIT_MODE: s_,
  ABT: c_,
  SL1T: u_,
  SL1ST: E_,
  SL2T: l_,
  SL2ST: __,
  SL3T: d_,
  SL3ST: T_,
  SL4T: f_,
  SL4ST: S_,
  SL5T: R_,
  SL5ST: N_,
  NU1T: O_,
  NU1ST: I_,
  NU2T: p_,
  NU2ST: h_,
  NU3T: A_,
  NU3ST: g_,
  NU4T: v_,
  NU4ST: D_,
  NU5T: m_,
  NU5ST: L_,
  STILL_TIME: C_,
  NO_SHIPMENTS: P_,
  HANDOVER_STARTED: y_,
  OPTIMIZE_WARNING: U_,
  DRIVER_WARNING: b_,
  DUPLICATE_EMAIL: M_,
  DUPLICATE_EMAIL_MSG: w_,
  SETTING_ZOOM: $_,
  SETTING_CLUSTER: H_,
  INSTRUCTIONS: V_,
  INSTRUCTIONS_TXT: B_,
  UPDATE: G_,
  UPDATE_TXT: k_,
  UPDATE_VIDEO: x_,
  NEW_UPDATE: F_,
  CART: W_,
  CONFIRMATION: K_,
  RESET_HANDOVER: z_,
  RESET_HANDOVER_MSG: Y_,
  NUMBER_OF_DRIVERS: j_,
  ACTIVE: Z_,
  SEND_CODE: X_,
  GENERIC_ERROR_MSG: q_,
  DASHBOARD: Q_,
  FETCH_TOUR_OVERVIEW: J_,
  NOT_SCANNED_AT_HUB: ed,
  ON_ITS_WAY: td,
  DELIVERED: nd,
  DELIVERED_TO_NEIGHBOUR: rd,
  NOT_DELIVERED: od,
  WRONG_VERIFICATION_CODE: id,
  FEEDBACK_TITLE: ad,
  FEEDBACK_SUBTITLE: sd,
  FEEDBACK_SUBTITLE_2: cd,
  FEEDBACK_LABEL_NAME: ud,
  FEEDBACK_LABEL_EMAIL: Ed,
  FEEDBACK_LABEL_COMMENTS: ld,
  FEEDBACK_CLOSE_BTN: _d,
  FEEDBACK_SUBMIT_BTN: dd,
  FEEDBACK_SUCCESS: Td,
  TOUR_OVERVIEW_PAGE_TITLE: fd,
  CAUTION: Sd,
  CAUTION_CHANGE_DRIVER: Rd,
  LAST_UPDATED: Nd,
  QUICK_TOURS_NO_TOURS_YET: Od,
  RETURNED_TRUNKRS: Id,
  NOT_AT_DEPOT: pd,
  BACK_INTO_PLANNING: hd,
  LOAD_TODO: Ad,
  SHIPMENT_COMMENT_TITLE: gd,
  SHIPMENT_COMMENT_TEXT: vd,
  SHIPMENT_COMMENT_PLACEHOLDER: Dd,
  SHIPMENT_SCANNED_TITLE: md,
  TODO_LIST: Ld,
  TITLE_TODO_LIST: Cd,
  TAB_LABEL_NOT_DELIVERED: Pd,
  TAB_LABEL_NO_END_STATE: yd,
  TAB_LABEL_DONE: Ud,
  BARCODE_TODO: bd,
  TIME_REMAINING: Md,
  DONE_COUNTER_TITLE: wd,
  NON_DELIVERY_REASON: $d,
  TODO_NOT_RETURNED: Hd,
  TODO_RETURNED: Vd,
  TODO_NO_PARCEL: Bd,
  TODO_PARCEL_POSTPONE: Gd,
  LATEST_STATUS: kd,
  SHIPMENT_ADDRESS_HAS_CHANGED: xd,
  NEW_ADDRESS: Fd,
  OLD_ADDRESS: Wd,
  SHIPMENT_ACCEPTED_BY_DRIVER: Kd,
  ADDRESS_NOT_FOUND: zd,
  BUSINESS_CLOSED: Yd,
  BAD_ADDRESS: jd,
  DELIVERY_DAMAGED: Zd,
  NO_TIME_LEFT_IN_TIMESLOT: Xd,
  RECIPIENT_NOT_AT_HOME: qd,
  DRIVER_INVOLVED_IN_ACCIDENT: Qd,
  REFUSED_BY_CUSTOMER: Jd,
  EXTREME_WEATHER_CONDITIONS: eT,
  PARCEL_MISSING: tT,
  DELIVER_ADDRESS_NOT_ACCESSIBLE: nT,
  SHIPMENT_MISSING: rT,
  HEAVILY_DAMAGED: oT,
  TOO_HEAVY: iT,
  TOO_LARGE: aT,
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: sT,
  SHIPMENTS_ACCEPTED_BY_DRIVERS: cT,
  SHIPMENTS_WITH_END_STATE: uT,
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: ET,
  ALL_SHIPMENTS: lT,
  RESULTS: _T,
  WHICH_SHIPMENTS_HAVE_BEEN_SORTED_AT_REGIONAL_HUB: dT,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_SORTED_AT_REGIONAL_HUB: TT,
  WHICH_SHIPMENTS_HAVE_BEEN_ACCEPTED_BY_THEIR_DRIVERS: fT,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_ACCEPTED_BY_THEIR_DRIVERS: ST,
  WHICH_SHIPMENTS_HAVE_AN_END_STATE: RT,
  WHICH_SHIPMENTS_DO_NOT_HAVE_AN_END_STATE: NT,
  WHICH_SHIPMENTS_ARE_DELIVERED_TO_NEIGHBOURS: OT,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_DELIVERED: IT,
  CLEAR_FILTER: pT,
  TRANSFER_TO: hT,
  LOCK_TITLE: AT,
  LOCK_DESCRIPTION: gT,
  LOCK_PLANNING_OWNER: vT,
  LOCK_PLANNING_TITLE: DT,
  PLANNING_FIXED: mT,
  CHOOSE_DRIVER: LT,
  LOCK_PLANNING_DESCRIPTION: CT,
  LOCK_SORTING_OWNER: PT,
  LOCK_SORTING_TITLE: yT,
  LOCK_SORTING_DESCRIPTION: UT,
  LOCK_PLANNING_SAVED: bT,
  LOCK_DRIVERS_OWNER: MT,
  LOCK_DRIVERS_TITLE: wT,
  LOCK_DRIVER_DESCRIPTION: $T,
  LOCK_DRIVER_CTA: HT,
  LOCK_BUTTON: VT,
  FOSSIL: BT,
  ELECTRIC: GT,
  PLANNING_NOT_READY_YET: kT,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_DRIVERS_AVAILABLE_IN: xT,
  INFORMATION: FT,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_NEEDED_DRIVERS_WILL_BE_AVAILABLE_AT: WT,
  SEE_ESTIMATED_AMOUNT_OF_SHIPMENT_AND_DRIVERS_BELOW: KT,
  YOU_CAN_ACCESS_THE_PLANNING_WHEN_IT_IS_COMPLETED: zT,
  ESTIMATED_AMOUNT_OF_SHIPMENTS: YT,
  DRIVERS_YOU_WILL_PROBABLY_NEED: jT,
  CENTRAL_SORTING_DONE_ALERT: ZT,
  WARNING: XT,
  CENTRAL_SORTING_NOT_DONE_ALERT: qT,
  VEHICLE: QT,
  SHOW_FULL_TOUR: JT,
  HIDE_TOUR: ef,
  OPTIMISE_TOUR: tf,
  REVERSE_TOUR: nf,
  COLOR_TOUR: rf,
  CHOOSE_TOUR_COLOUR: of,
  COLOUR_PICK_CANCEL: af,
  AMOUNT_OF_PACKAGES: sf,
  MOVE_TO_DIFFERENT_TOUR: cf,
  DE_SELECT_ALL: uf,
  USE_PREVIOUS_OPTIMIZATION: Ef,
  USE_ROUTIFIC_V2: lf,
  HIDE_TOUR_TOOLTIP: _f,
  UNHIDE_TOUR_TOOLTIP: df,
  OPTIMIZATION_RESULT_ERROR_TITLE: Tf,
  OPTIMIZATION_RESULT_ERROR_DESC_1: ff,
  OPTIMIZATION_RESULT_ERROR_DESC_2: Sf,
  OPTIMIZATION_RESULT_ERROR_DESC_3: Rf,
  OPTIMIZATION_RESULT_ERROR_DESC_4: Nf,
  OPTIMIZATION_RESULT_ERROR_SUPPORT_TEL: Of,
  OPTIMIZATION_RESULT_SUCCESS_TITLE: If,
  OPTIMIZATION_RESULT_SUCCESS_DESC_1: pf,
  OPTIMIZATION_RESULT_SUCCESS_DESC_2: hf,
  OPTIMIZATION_RESULT_SUCCESS_DESC_3: Af,
  OPTIMIZATION_RESULT_BUTTON_RUN_AGAIN: gf,
  OPTIMIZATION_RESULT_BUTTON_ACCEPT: vf,
  OPTIMIZATION_RESULT_BUTTON_RE_OPTIMIZE: Df,
  OPTIMIZATION_RESULT_OVERFLOW_DESC: mf,
  SIDEBAR_HUB_INVENTORY: Lf,
  RETURN_TO_TRUNKRS: Cf,
  SET_ASIDE: Pf,
  ATTENTION_MISSORT: yf,
  ATTENTION_MISSORT_MSG: Uf,
  ATTENTION_SET_ASIDE_MSG: bf,
  HUB_INVENTORY: Mf,
  RETURNS_SCAN: wf,
  SHIPMENT_STATES: $f,
  USERS: Hf,
  TOTAL_DISTANCE: Vf,
  BERMUDA_TEXT_NOTIFICATION: Bf,
  BERMUDA_TEXT_MORE_INFO: Gf,
  BERMUDA_TEXT_CALLOUT: kf,
  GLOBAL_NOTIFICATIONS: xf,
  SHIPMENTS_OVERVIEW: Ff,
  PLANNING_TIMELINE: Wf,
  EMPTY_SCREENS: Kf,
  NAVIGATE_TO_TRACT_N_TRACE: zf,
  LOGIN_DESCRIPTION: Yf,
  PHONE_NUMBER_IS_REQUIRED: jf,
  PHONE_NUMBER_ERROR: Zf,
  SENT_CODE_TO: Xf,
  RESENT_CODE: qf,
  VERIFY_AND_LOGIN: Qf,
  HANDOVER_TOUR_PLANNING_CARD_DESCRIPTION: Jf,
  HANDOVER_ASSIGN_DRIVERS_CARD_DESCRIPTION: eS,
  HANDOVER_CHANGE_DRIVER_FOR_CART: tS,
  HANDOVER_CURRENT_DRIVER: nS,
  INVALID_PHONE_NUMBER: rS,
  PARTNER_PROFILE: oS,
  NO_ACTIVE_TOURS_YET: iS,
  SEE_MORE_STOPS: aS,
  SEE_LESS_STOPS: sS,
  CREATE_AND_EDIT_TOURS: cS,
  PROCEED_TO: uS,
  GO_BACK_TO: ES,
  OVERVIEW: lS,
  SPEED: _S,
  THIS_FIELD_IS_REQUIRED: dS
}, fS = "Loading...", SS = "login", RS = "email", NS = "password", OS = "wrong credentials", IS = "please check your credentials", pS = "check shipments", hS = "reload", AS = "next", gS = "back", vS = "Go back", DS = "Confirm", mS = "cancel", LS = "close", CS = "Scan barcode to handover parcel", PS = "full screen", yS = "tour", US = "tours", bS = "We are now calculating the tours", MS = "Our sophisticated system gives back the best theoretical results", wS = "But you're the expert, so feel free to tune them!", $S = "driver", HS = "no. parcels", VS = "Driver and Vehicle...", BS = "save", GS = "save planning", kS = "save {{ networkType }} planning", xS = "Enable", FS = "Disable", WS = "name", KS = "location", zS = "postalcode", YS = "address", jS = "street", ZS = "number", XS = "city", qS = "lat", QS = "lng", JS = "country", eR = "the Netherlands", tR = "Germany", nR = "phone number", rR = "Phone number is not registered", oR = "Remarks", iR = "Shipments", aR = "shipment", sR = "geocoding exceptions", cR = "-", uR = "handover", ER = "Move to different tour", lR = "duration", _R = "start", dR = "Depart", TR = "Optimize", fR = "Create new tours", SR = "Create new {{ networkType }} tours", RR = "optimize options", NR = "adjust optimization", OR = "run", IR = "driver speed", pR = "faster", hR = "fast", AR = "normal", gR = "slow", vR = "very slow", DR = "leave tours open ended", mR = "select all", LR = "Handover complete", CR = "sign out", PR = "forgot password?", yR = "add tour", UR = "filter tours", bR = "optimize tour", MR = "Print", wR = "position", $R = "time", HR = "signature", VR = "code", BR = "profile", GR = "edit profile", kR = "drivers", xR = "edit driver", FR = "add driver", WR = "change password", KR = "current password", zR = "new password", YR = "confirm new password", jR = "Password is incorrect", ZR = "Your current password is incorrect", XR = "Password too short", qR = "Your new password should contain at least 8 characters", QR = "Password changed", JR = "Your password has been changed. From now on you can login using your new password", eN = "Passwords don't match", tN = "New password does not match the confirm password", nN = "Form incomplete", rN = "Please fill in all requested fields.", oN = "Changes have been saved", iN = "Changes to your profile have been saved.", aN = "Error message", sN = "Something went wrong. Please reload the page and try again", cN = "Saving tours failed", uN = "Something went wrong trying to save the tours. Please reload the page and try again", EN = "driver added", lN = "new driver has been added successfully.", _N = "invalid email address", dN = "the email address you provided is invalid", TN = "The email address you've provided is not linked to an account", fN = "You have unsaved changes. Do you want to save changes now?", SN = "There are new shipments available, which are currently not assigned to any route. Please re-run the optimalization.", RN = "Traffic", NN = "Minimum number of stops", ON = "Balance routes", IN = "Least amount of drivers", pN = "Finish", hN = "Last Stop", AN = "Productivity", gN = "Total time:", vN = "Change color", DN = "Are you sure you want to cancel this shipment?", mN = "yes", LN = "no", CN = "send email", PN = "Fill in your e-mail address and we'll send you a new password you can use to login.", yN = "We've sent a new password to your E-mail address. Once you login, using your new password, you can change your password on your profile page.", UN = "Edit tour", bN = "Close", MN = "New update!", wN = "Take a minute to see what's new", $N = "Multicolli indication", HN = "Multicolli shipments on the map are now indicated by a little star on the marker. By clicking on the marker you can see how many shipments. To move all shipments at once, you can now right-click on the marker to move all shipments simultaneously.", VN = "", BN = "", GN = "", kN = "", xN = "Feedback?", FN = "We're continuously working to improve the Plannr app, so if you have any feedback, suggestion or wishes, we would love to hear them. You can send us an email at wietse@trunkrs.nl.", WN = "Welcome to the Plannr app!", KN = "Take a minute to find out what the Plannr app can do and how it can help you maximize your productivity", zN = "Shipments overview", YN = "View all of today's shipments and edit or cancel them if necessary.", jN = "Tours planner", ZN = "Use our sophisticated system to calculate the best tours and modify them if you like.", XN = "Handover", qN = "Perform the handover manually or use the barcode scanner to automate the process. Finalize the process by printing out a roll card for the driver.", QN = "Try it out!", JN = "Time to explore the app and all of its features! If you have any questions, you can contact us using the live chat button in the bottom-right corner.", eO = "The cut off time hasn't been reached yet, so you still might receive new shipments.", tO = "No shipments available", nO = "All parcels are handovered", rO = "The handover is already in progress.", oO = "Running the optimizer overwrites any previous changes made. You can optimize within the route by hitting the cog-wheel next to a route. Are you sure you want to run the optimizer?", iO = "Warning: Your tours have been saved, but not all tours have an assigned driver yet", aO = "Use different email address", sO = "This email address is already in use by another driver", cO = "Zoom on scroll", uO = "Cluster shipments", EO = "instructions", lO = "View the video below to see what the Plannr app can do.", _O = "Update", dO = "View the video below to see what's new.", TO = "View last update video", fO = "The Plannr app has been updated. Click here to see what's new!", SO = "Cart", RO = "Confirmation", NO = "Start Scanning", OO = "You are now ready for handover", IO = "Reset handover", pO = "You are about to reset the handover. This means you have to re-scan all of the shipments you have already processed.", hO = "Are you sure?", AO = "Change Drivers", gO = "DRIVERS SUCCESSFULLY CHANGED", vO = "Tours have been reassigned!", DO = "FAULTY SORTING", mO = "The parcel you have scanned is from another region. Please send the parcel back to Vianen.", LO = "MISSORT", CO = "THIS SHIPMENT BELONGS TO", PO = "REGION: ", yO = "PLEASE RETURN THIS SHIPMENT TO TRUNKRS CENTRAL HUB VIANEN", UO = "UNKNOWN AREA", bO = "Number of drivers in optimization", MO = "Cancel marked shipments", wO = "Attention!", $O = "Return", HO = "Cancel Shipments", VO = "Reset Handover", BO = "Active", GO = "Mark tour as planned", kO = "You are about to mark this tour as 'Planned'. This actions is irreversible!", xO = "Continue if you are are sure that the tour is planned correctly.", FO = "I understand, don’t ask me again.", WO = "Tour Planned!", KO = "UNDO", zO = "Send code", YO = "Tours Saved", jO = "Tours were saved successfully. If you wish to edit them, please choose 'Edit Tours'. If you wish to proceed to the handover, please choose 'Finish Planning'.", ZO = "Edit Tours", XO = "Finish Planning", qO = "The tours were saved, but not all tours have a driver yet. Click the button below to select drivers for the tours.", QO = "Planning finished", JO = "The planning is finished. You can now proceed to the handover screen and sort the shipments. If you have any questions, please contact the Trunkrs Operations team.", eI = "Incorrect number", tI = "Must be a valid mobile number (incl. +31)", nI = "Upload error", rI = "Something went wrong while uploading", oI = "Error on save", iI = "Saving the driver has failed", aI = "No drivers yet", sI = "You haven't added drivers yet", cI = "Subco Profile", uI = "Move to tour", EI = "Optimizing...", lI = "Updating...", _I = "Saving...", dI = "RETURN TO TRUNKRS", TI = "SET ASIDE!", fI = "Attention", SI = "This shipment does not belong in this region. Please return it to Trunkrs as soon as possible.", RI = "This shipment doesn’t belong to any tours for today.", NI = "Canceled", OI = "Assigned to tour", II = "Not assigned to tour", pI = "Expected", hI = "No tours yet", AI = "Start with optimizing", gI = "Optimize", vI = "Hold on a second!", DI = "It seems something went wrong in the application. The development team has been notified. No worries though, simply reload and you can continue your work.", mI = "Reload Planner", LI = "packages", CI = "Go to tours", PI = "Lock tours", yI = "Before you can continue, you need to lock the tours", UI = "locking tours ...", bI = "Lock tours now", MI = "No drivers assigned", wI = "Please assign drivers to all tours", $I = "Sorry, something went wrong, please try again later.", HI = "Wrong verification code. Please try again.", VI = "Tour progress", BI = "Fetching tour overview", GI = "not scanned at hub", kI = "on it's way", xI = "delivered", FI = "delivered to neighbour", WI = "not delivered", KI = "Whoops, it looks like we’re having issues.", zI = "The Trunkrs team has been notified.", YI = "If you’d like to help, tell us what happened below.", jI = "Your name", ZI = "Your email", XI = "Describe what happened just before the issue.", qI = "Close", QI = "Submit", JI = "Thank you! Together we make Trunkrs better.", ep = "Tour Progress", tp = "Updating the overview...", np = "Last updated", rp = "Your feedback has been sent. Thank you so much for helping us make the Planner better!", op = "To Do list", ip = "To Do list", ap = "Not delivered", sp = "No end state", cp = "Missorted", up = "Returns", Ep = "Done", lp = "Scan barcode to move a shipment back into planning", _p = "Time left", dp = "Done", Tp = "Non-delivery reason", fp = "Not returned", Sp = "Parcel returned", Rp = "We don't have this parcel", Np = "We have this parcel", Op = "Latest Status", Ip = "Accepted by driver", pp = "CAUTION", hp = "You are about to change the driver for this tour. If the current driver is already driving, this will empty his app and cause him problems. All our future references to this tour (billing, analytics) will include the new driver. We will not be able to retrieve the old driver for you. If you are sure you want to make the switch, select the new driver below.", Ap = "Yes, change driver", gp = "Nothing to see here", vp = "Parcel returned to trunkrs", Dp = "Shipment not at depot", mp = "Reached max delivery attempts", Lp = "Reached max out of freezer time", Cp = "Shipment back into planning", Pp = "Loading Todos...", yp = "We don't have this parcel", Up = "Please provide additional information about the whereabouts of the parcel and specify why it is not in your possession.", bp = "Write your explanation here...", Mp = "Scanned parcel", wp = "Address not found", $p = "Business closed", Hp = "Non-existing address", Vp = "Parcel damaged", Bp = "No time left in tour", Gp = "Recipient not home", kp = "Driver in accident", xp = "Refused by recipient", Fp = "Extreme weather conditions", Wp = "Parcel missing", Kp = "Address inaccessible", zp = "Parcel missing", Yp = "Parcel heavily damaged", jp = "Parcel too heavy", Zp = "Parcel too large", Xp = "Shipment Address has been changed!", qp = "New Address", Qp = "Old Address", Jp = "Shipment address has been changed!", eh = "Shipments sorted at regional hub", th = "Shipments accepted by drivers", nh = "Shipments with end state", rh = "All shipments", oh = "Results", ih = "Neighbour delivery vs non delivery", ah = "Which shipments have been sorted at regional hub?", sh = "Which shipments have NOT been sorted at regional hub?", ch = "Which shipments have been accepted by their drivers?", uh = "Which shipments have NOT been accepted by their drivers?", Eh = "Which shipments have an end-state?", lh = "Which shipments DO NOT have an end-state?", _h = "Which shipments are delivered to neighbours?", dh = "Which shipments have not been delivered?", Th = "Clear filter", fh = "Transfer to", Sh = "Subcontractor", Rh = "Fossil", Nh = "Electric", Oh = "Collection tours", Ih = "Tour {{ number }}", ph = "Tour remark", hh = "Select a driver", Ah = "No driver assigned yet.", gh = "Stops", vh = "Collection tour overview", Dh = "Order stops", mh = "Client name", Lh = "Postal code", Ch = "Pick-up time", Ph = "Remarks stop", yh = "End", Uh = "Not ready to handover yet", bh = "Before you can start the handover, the following steps must be complete:", Mh = "Trunkrs", wh = "Planning", $h = "Planning is fixed", Hh = "Choose your drivers below and go to the handover page.", Vh = "The planning needs to be saved, so we can make sure the tours you have created will be the tours your drivers are driving tonight.", Bh = "The planning is done!", Gh = "The planning has been saved!", kh = "Trunkrs", xh = "Central sorting", Fh = "It is necessary for the central sorting to be done before making the tours permanent, so we know what you will deliver today.", Wh = "The central sorting is done!", Kh = "You", zh = "Assign drivers", Yh = "Once you have assigned drivers to the tours and the central sorting is done, you can proceed to make the tours permanent.", jh = "Drivers have been assigned!", Zh = "Start assigning drivers", Xh = "Make tours permanent and start handover", qh = "Planning not ready yet!", Qh = "Estimated amount of shipments and drivers available in", Jh = "Information", eA = "Estimated amount of shipments and needed drivers will be available at", tA = "It seems like the planning isn't ready yet. For your convenience you can find the estimated amount of shipment and the drivers you will need below.", nA = "You can access the planning when it is completed", rA = "Estimated amount of shipments", oA = "Drivers you will probably need", iA = "Mark planning as done", aA = "Hold 3 seconds to mark planning as done", sA = "Planning done", cA = "Planning must be marked as done before assigning drivers", uA = "No collection tours", EA = "No collection tours have been assigned yet.", lA = "Processing...", _A = "The central sorting process is now done. Please reload to start planning.", dA = "WARNING", TA = "The central sorting process hasn't started yet. Until then none of your changes can be saved.", fA = "Freezer Management", SA = "Scan frozen shipments in or out...", RA = "EXPECTED SHIPMENTS", NA = "Address", OA = "Driver", IA = "CURRENTLY IN THE FREEZER", pA = "Merchant", hA = "In since", AA = "Next step", gA = "Back into delivery", vA = "Back to Trunkrs", DA = "Shipment added to the freezer. Brrrr, cold.", mA = "Whoops, this shipment doesn't belong in the freezer!", LA = "Shipment out of the freezer. Keep it fresh!", CA = "Return this shipment to Trunkrs!", PA = "No shipments", yA = "+ Add to new tour", UA = "Driver's Preferred language", bA = "Save Driver", MA = "Vehicle", wA = "Vehicle Type", $A = "Show tour", HA = "Hide tour", VA = "Optimise tour", BA = "Reverse tour", GA = "Color tour", kA = "Choose tour colour", xA = "Cancel", FA = "packages", WA = "Move to different tour", KA = "De-select all", zA = "Select a tour to print", YA = "You can select more than 1 tour to print", jA = "Select all", ZA = "Selected", XA = "Export", qA = "Exporting...", QA = "Not all stops are optimized", JA = "Due to a technical issue we could not optimize all stops. Call Trunkrs to get this solved.", eg = "085 060 1410", tg = "Add Employee", ng = "Add Employee", rg = "Create an employee", og = "Cancel", ig = "Creating", ag = "Please fill up the name", sg = "Please select a language", cg = "Phone number is required", ug = "Planner permission", Eg = "Turning on will enable this employee to access or login to the planner", lg = "BRAVO!", _g = "You have successfully added a new employee.", dg = "Full name", Tg = "Full name", fg = "Preferred Language", Sg = "Select Language", Rg = "Phone number", Ng = "+316", Og = "Edit User", Ig = "Save changes", pg = "Saving changes", hg = "You have successfully updated the employee.", Ag = "Employees", gg = "All Employees", vg = "Planners", Dg = "Inactive", mg = "Deleted", Lg = "Employee name", Cg = "Role", Pg = "Phone number", yg = "Status", Ug = "Manage employee", bg = "Planner, Driver", Mg = "Driver", wg = "Deleted", $g = "Active", Hg = "Inactive", Vg = "Options", Bg = "Edit employee details", Gg = "Delete employee", kg = "No records", xg = "There were no results for this category", Fg = "You will not be able to undo this action.", Wg = "Delete User?", Kg = "Hold 3 secs to delete", zg = "Deleting...", Yg = "{{EMP_NAME}}'s profile was deleted", jg = "Employees", Zg = "Changing the phone number will require the employee to logout and login again for their driverapp and/or planner app to work properly.", Xg = "How many drivers?", qg = "Create Tours", Qg = "Create new {{ networkType }} Tours", Jg = "Create and edit optimal {{ networkType }} tours down to the last detail.", ev = "Create tours for the {{ networkType }}", tv = "Before you switch", nv = "Switching to the power mode with this amount of shipments might result in a very slow or even impossible tour planning. Are you sure you want to switch to the power mode?", rv = "Switch to power mode", ov = "Lite", iv = "Power", av = "Plan Mode", sv = "Save tours", cv = "Re-optimize", uv = "Tour", Ev = "Departure", lv = "Last stop", _v = "Shipments", dv = "Driver", Tv = "Vehicle type", fv = "Planner Lite", Sv = "Create tours from any system, no matter the numbers.", Rv = "Create Tours", Nv = "tours have been created", Ov = "Select driver...", Iv = "Show tour", pv = "Stop", hv = "Street + nr", Av = "Zipcode", gv = "City", vv = "Colli", Dv = "E.T.A", mv = "Not all tours are done before {{ timestamp }}", Lv = "Not all stops have been optimised, call Trunkrs to solve this", Cv = "Power Mode", Pv = "Create and edit optimal tours down to the last detail", yv = "Driver not found", Uv = "The central sorting process hasn't started yet. Until then none of your changes can be saved", bv = "The central sorting process is now done. Please reload to start planning.", Mv = "Reload", wv = "Creating your tours", $v = "Do not refresh or leave the page", Hv = "Last Update", Vv = "Use previous optimization if possible?", Bv = "Use the new (faster) optimalisation?", Gv = "Hide tour in map", kv = "Unhide tour in map", xv = "An error occured during optimization", Fv = "Re-running the optimisation might solve this issue.", Wv = "Would like to run the optimisation again?", Kv = "Something went wrong, we cannot create tours.", zv = "Please contract Trunkrs through your slack channels", Yv = "", jv = "Optimization Results", Zv = "Optimization time:", Xv = "No. of drivers selected:", qv = "Overflow tours created:", Qv = "Run again", Jv = "Accept", eD = "Re-optimize", tD = "Overflow tours are the result of not having enough drivers assigned. You can solve this by re-optimising with more drivers.", nD = "Hub Inventory", rD = "Returns Scan", oD = "Returns Scan is currently disabled and will be available between 3:00 and 14:00.", iD = {
  TITLE: "Hub Inventory",
  TRUNKRSNR: "TrunkrsNr",
  ADDRESS: "Address",
  LAST_DRIVER: "Last Driver",
  INTENDED_DELIVERY_DATE: "Intended Delivery Date",
  IN_SINCE: "In Since",
  STATUS: "Status",
  EMPTY_TITLE: "Nothing to see here!",
  EMPTY_DESC: "Keep calm, drink a coffee and reload this page.",
  RELOAD_BUTTON: "Refresh page"
}, aD = {
  TITLE: "Returns Scan",
  SCAN_INPUT_PLACEHOLDER: "Scan all shipments to your hub",
  AT_REGIONAL_HUB: "At Regional Hub",
  KEEP_IN_REGION: "Keep on Hub",
  BACK_TO_TRUNKRS: "Back to Trunkrs",
  AT_REGIONAL_HUB_PLACEHOLDER: "You are done scanning, now proceed to returning the shipments to their rightful place.",
  KEEP_ON_HUB_PLACEHOLDER: "You need to scan shipments on your hub first.",
  BACK_TO_TRUNKRS_PLACEHOLDER: "You need to scan shipments on your hub first.",
  BUTTON_CONFIRM_RETURNS: "Confirm returns",
  LAST_DRIVER: "Last Driver",
  ADDRESS: "Address",
  SENDER: "Sender",
  ERROR: "ERROR!",
  SCAN_ERROR_TITLE: "Shipment cannot be processed.",
  SCAN_ERROR_DETAILS: "Please contact Trunkrs before you proceed.",
  SCAN_UNSCANNABLE_TITLE: "Shipment already tag as not scannable.",
  RETURNED_SCAN_SUCCESS: "You have successfully returned these shipments.",
  SUCCESS_CALLOUT: "You have successfully returned all these shipments to Trunkrs.",
  CONFIRMED_RETURNS: "Confirmed returns!",
  APOLOGIES: "Apologies!",
  ACKNOWLEDGEMENT: {
    TITLE: "Return Acknowledgement",
    DESCRIPTION: "I hereby confirm to return these shipments to Trunkrs and from this point on they are the collection driver’s responsibility.",
    CONFIRM: "Confirm",
    BACK: "Go back",
    WARNING: "Look out! You have not yet scanned all shipments on your hub, are you sure you want to continue?"
  },
  OWNERSHIP: "Ownership",
  ACTIONS: "Actions",
  SHIPMENT_DETAILS: "Shipment Details",
  REASON: "Reason",
  OTHER_REASON: "Other reason",
  ADDITIONAL_REASON: "Additional reason",
  NOT_AT_REGIONAL_HUB: "Not at Regional Depot",
  TAG_AS_NOT_SCANNABLE: "Tag as not scannable",
  UNSCANNABLE_DESC: "Please select the reason code for the shipment not being at the regional hub, and thus not able to scan.",
  UNSCANNANBLE_REASON_CODES: {
    SHIPMENT_WITH_DRIVER_DELAYED: "Shipment is still with the driver and will not be back on the regional hub today",
    SHIPMENT_WITH_DRIVER_NOT_DELAYED: "Shipment is still with the driver but will be at the regional hub before 17:00",
    SHIPMENT_LOST: "Shipment was lost",
    FALSELY_MARKED_NOT_DELIVERED: "Shipment is delivered in the end anyway",
    DAMAGED_LABEL: "Shipment's label is unreadable or unscannable",
    SHIPMENT_MISSING: "Shipment is missing"
  },
  CAUTION_PROCEED_NEXT: "You are about to proceed to the other step of planning even though you haven’t completed your Inventory Scan. This is fine and you can still return to this step anytime but do note that on MM-DD-YYYY this will be enforced and you can no longer go back.",
  CAUTION_PROCEED_TO_OTHER_STEP: "Proceed to other step",
  SUCCESS: "Success",
  TOAST_DESC: "Shipment {{ trunkrsNr }} moved to Not at Regional Depot",
  SELECT_ONE: "Select one",
  MORE_DETAILS: "More details",
  RETURN_TODAY_TO: "You can return this today to",
  COLLECTION_OPT_ID: "Collection Optimization ID:",
  COLLECTION_TOUR_TAG: "Collection Tour Tag:",
  NO_COLLECTION_TODAY: "You have no collection for <b>{{merchantName}}</b> today. Your next collection is on <b>{{day}}</b> on Collection Optimization ID: <b>{{optimizationId}}</b> and Tour Tag: <b>{{tourTag}}</b>",
  FOR_RETURN_TO_SENDER: "For Return to Sender",
  LOADING: "Scanning. Please wait..",
  DETAILS: {
    SHIPMENT_DETAILS: "Shipment details",
    INTENDED_DELIVERY_DATE: "Intended delivery date"
  },
  TRUNKRS_NR: "TrunkrsNR"
}, sD = {
  DATA_RECEIVED: "Data received",
  DATA_PROCESSED: "Registered",
  SHIPMENT_SORTED: "Sorted (at central hub)",
  SHIPMENT_SORTED_AT_SUB_DEPOT: "Sorted (at regional depot)",
  SHIPMENT_ACCEPTED_BY_DRIVER: "Accepted by driver",
  SHIPMENT_NOT_DELIVERED: "Not delivered",
  RETURN_SHIPMENT_TO_SENDER: "Return to sender",
  RETURN_ACCEPTED_BY_DRIVER: "Return accepted by driver",
  RETURN_ASSIGNED_TO_PICKUP: "Return assigned to driver",
  RETURN_ACCEPTED_BY_TRUNKRS: "Return accepted by Trunkrs",
  RETURN_ACCEPTED_BY_PICKUP_DRIVER: "Return accept by pickup driver",
  RETURN_ACCEPTED_BY_SENDER: "Return accepted by sender",
  EXCEPTION_SHIPMENT_NOT_ARRIVED: "Shipment not arrived",
  EXCEPTION_SHIPMENT_MIS_SORTED: "Missorted",
  EXCEPTION_SHIPMENT_MISS_SORTED: "Missorted",
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER: "Declined by driver",
  EXCEPTION_SHIPMENT_MISSING: "Shipment missing",
  EXCEPTION_SHIPMENT_LOST: "Shipment lost",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER: "Return not accepted by sender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER: "Shipment cancelled by sender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS: "Shipment cancelled by Trunkrs",
  EXCEPTION_SHIPMENT_DESTROYED: "Shipment destroyed",
  EXCEPTION_SHIPMENT_INVESTIGATE: "Shipment for investigation",
  CHANGE_SHIPMENT_ADDRESS_CHANGED: "Address Changed",
  CHANGE_SHIPMENT_NEIGHBOUR_CHANGE: "Neighbor Changed",
  CHANGE_SHIPMENT_POST_PONED: "Postponed",
  CUSTOMER_SERVICE_OVERRULE: "Overruled by Customer Service",
  EXCEPTION_LINEHAUL_ARRIVED_LATE: "Linehaul arrived late",
  EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL: "Not on linehaul",
  EXCEPTION_PICKUP_ARRIVED_LATE: "Pickup arrived late",
  EXCEPTION_PICKUP_NOT_PICKED_UP: "Not picked up",
  EXCEPTION_PICKUP_REFUSED_BY_DRIVER: "Pickup refused by driver",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL: "Not accepted by linehaul",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP: "Not accepted by pickup",
  LINEHAUL_ARRIVED_ON_TIME: "Linehaul arrived on time",
  LINEHAUL_IN_TRANSIT: "Linehaul in transit",
  PICKUP_ACCEPTED_BY_DRIVER: "Pickup accepted by driver",
  PICKUP_ARRIVED_ON_TIME: "Pickup arrived on time",
  PICKUP_DRIVER_ASSIGNED: "Pickup driver assigned",
  PICKUP_PICKED_UP: "Picked up",
  RETURN_ASSIGNED_TO_LINEHAUL: "Return assigned to linehaul",
  SHIPMENT_DELIVERED: "Delivered",
  SHIPMENT_DELIVERED_TO_NEIGHBOR: "Delivered to neighbor",
  PARTNER_OVERRULE: "The shipment has been overruled by the partner"
}, cD = {
  TITLE: "Employees",
  ADD_USER_TITLE: "Add Employee",
  ADD_USER_BUTTON: "Add employee",
  ADD_USER_CREATE_BUTTON: "Create an employee",
  ADD_USER_CANCEL_BUTTON: "Cancel",
  ADD_USER_CREATING_BUTTON: "Creating",
  ADD_USER_NAME_REQUIRED: "Please fill up the name",
  ADD_USER_LANGUAGE_REQUIRED: "Please select a language",
  ADD_USER_PHONE_REQUIRED: "Phone number is required",
  USER_LIST_HEADER: "Employees",
  USER_LIST_TAB_ALL_EMPLOYEES: "All Employees",
  USER_LIST_TAB_PLANNER: "Planners",
  USER_LIST_TAB_INACTIVE: "Inactive",
  USER_LIST_TAB_DELETED: "Deleted",
  USER_LIST_TABLE_EMPLOYEE_NAME: "Employee name",
  USER_LIST_TABLE_ROLE: "Role",
  USER_LIST_TABLE_PHONE_NUMBER: "Phone number",
  USER_LIST_TABLE_STATUS: "Status",
  USER_LIST_TABLE_MANAGE_EMPLOYEE: "Manage employee",
  USER_LIST_TABLE_ROLE_PLANNER: "Planner, Driver",
  USER_LIST_TABLE_ROLE_DRIVER: "Driver",
  USER_LIST_TABLE_ROLE_DELETED: "Deleted",
  USER_LIST_TABLE_ACTIVE: "Active",
  USER_LIST_TABLE_INACTIVE: "Inactive",
  USER_LIST_MENU_OPTIONS: "Options",
  USER_LIST_MENU_EDIT_USER: "Edit employee details",
  USER_LIST_MENU_DELETE_USER: "Delete employee",
  NO_USERS_FOUND: "No records",
  NO_USERS_FOUND_MSG: "There were no results for this category",
  DELETE_USER_SUBTEXT: "You will not be able to undo this action.",
  DELETE_USER_TITLE: "Delete User?",
  LONGPRESS_DELETE_USER: "Hold 3 secs to delete",
  LONGPRESS_DONE: "Deleting...",
  ADD_USER_SUCCESS_MSG: "BRAVO!",
  ADD_USER_SUCCESS_MSG_SUBTEXT: "You have successfully added a new employee.",
  EDIT_USER_SUCCESS_MSG_SUBTEXT: "You have successfully updated the employee.",
  DELETE_USER_SUCCESS_MSG_SUBTEXT: "{{EMP_NAME}}'s profile was deleted",
  IMPORT_DRIVER_MODAL_TITLE: "Import driver to this region",
  DRIVER_PHONE_NUMBER: "Driver's phone number",
  CURRENT_REGION: "Current Region:",
  NOTIF_CANNOT_FIND_DRIVER: "For this phone number we did not find any drivers.",
  AVAILABLE_ASSIGNED: "This driver has already been assigned to a tour in {{region}} and will be removed from that tour if you continue.",
  NOT_AVAILABLE_ASSIGNED: "This driver is assigned to a locked tour and can no longer be moved around.",
  NOTIF_DRIVER_CANNOT_BE_MOVED: "This driver already belongs to your region and cannot be moved.",
  TOAST_DRIVER_IMPORT_SUCCESS: "Driver imported successfully!",
  TOAST_DRIVER_IMPORT_SUCCESS_SUBTEXT: "{{name}} is now available in your region.",
  BUTTON_IMPORT_DRIVER: "Import driver",
  BUTTON_CANCEL: "Close",
  EDIT_INFORMATION_TOOLTIP: "Edit information",
  DELETE_TOOLTIP: "Delete"
}, uD = "Total Distance", ED = "Tour(s) {{text}} have stops that are not fully optimized.", lD = "For some stops we cannot draw tour lines, this is ok", _D = "This tour is not fully optimized. For the red stops below we could not draw tour lines. You can adjust the stops manually or move them to another tour.", dD = {
  BUSY_PEAK_DAYS: "Busy/Peak day today, you need to create new tours once the central sorting is done so you can proceed to handover.",
  CENTRAL_SORTING_IS_DONE: "Central sorting is done. Please create new tours to do handover.",
  HANDOVER_CENTRAL_SORTING_DONE: "Busy/Peak day, you cannot start the handover. You need to create new tours once the central sorting is done."
}, TD = {
  HEADER: "Shipments",
  FILTER_ALL_SHIPMENTS: "All",
  FILTER_CENTRAL_SORTED: "Central Sorted",
  FILTER_CANCELLED: "Cancelled",
  TABLE_HEADER_TRUNKRSNR: "TrunkrsNR",
  TABLE_HEADER_POSTAL_CODE: "Postal Code",
  TABLE_HEADER_ADDRESS: "Address",
  TABLE_HEADER_CITY: "City",
  TABLE_HEADER_TOUR: "Tour",
  TABLE_HEADER_SHIPMENT_STATE: "Shipment State",
  RESULT_COUNT: "{{count}} results",
  STATE_CANCELED: "Canceled",
  STATE_HAS_TOUR: "Assigned to tour",
  STATE_NO_TOUR: "Not assigned to tour",
  STATE_EXPECTED: "Expected",
  NO_TOURS_YET: "No tours yet",
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: "Shipments sorted at regional hub",
  SHIPMENTS_ACCEPTED_BY_DRIVERS: "Shipments accepted by drivers",
  SHIPMENTS_WITH_END_STATE: "Shipments with end state",
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: "Neighbour delivery vs non delivery",
  OUT_OF_MAXCOUNT: "{{count}} out of {{maxCount}}",
  REFRESH_RESULTS: "Refresh Results",
  EMPTY_TITLE: "Nothing to see here!",
  EMPTY_DESC: "Keep calm, drink a coffee and refresh this page.",
  RELOAD_BUTTON: "Refresh page"
}, fD = {
  INVENTORY_SCAN: "Inventory Scan",
  INVENTORY_SCAN_WARNING_TITLE: "Caution",
  INVENTORY_SCAN_DESC: "This is your 1st step in planning tours",
  TOUR_PLANNING: "Tour Planning",
  TOUR_PLANNING_DESC: "Create and edit tours",
  TOUR_PLANNING_DESC_BY_NETWORK: "Create and edit tours for the {{ networkType }}",
  TOUR_PLANNING_DESC_2: "Central sorting not yet done",
  HANDOVER: "Handover",
  HANDOVER_DESC: "Handover Parcel",
  MONITORING: "Monitoring",
  MONITORING_DESC: "Keep track of your parcels"
}, SD = {
  START_PLANNING: {
    TITLE: "Welcome",
    DESCRIPTION: "Hi! The following wizard will help you keep track of your parcels, plan your tours and monitor your day. Are you ready for it?",
    LETS_START: "Let's start"
  },
  NO_SHIPMENT_FOUND: "No shipment found",
  NO_SHIPMENT_FOUND_TEXT: "You are done scanning, now proceed to returning the shipments to their rightful place.",
  THIS_FEATURE_DISABLED: "This feature is disabled",
  INVENTORY_SCAN_300_1400: "Inventory Scan is currently disabled and will be available between 3:00 and 14:00.",
  NETWORK_NOT_READY: {
    HEADER: "Nothing to see here",
    DESCRIPTION: "You can start creating tours after the central sorting is finished."
  },
  WELCOME_WIZARD: {
    HEADER: "Welcome!",
    DESCRIPTION_1: "Hi! The following wizard will help you plan your tours for the day to evening and keep track of your parcels.",
    DESCRIPTION_2: "Select a network below to start."
  }
}, RD = "Click to open the track & trace page of this parcel.", ND = "Hallo! Enter your registered number to access the Planner. You’ll receive a 6-digit code after.", OD = "Phone number is required.", ID = "Sorry, this is not a registered mobile number. Please try again.", pD = "We have sent a code to {{ number }}. Enter it below.", hD = "Didn’t received it? Resend code in 30s", AD = "Verify and log in", gD = "The planning needs to be saved, so we can make sure the tours you have created will be the tours your drivers are driving tonight.", vD = "Once you have assigned drivers to the tours and the central sorting is done, you can proceed to make the tours permanent.", DD = "Change driver for Cart {{ cart }}", mD = "Invalid Phone number", LD = "Partner Profile", CD = "There are no active yours yet.", PD = "See more stops", yD = "See less stops", UD = "Create and edit optimal tours down to the last detail.", bD = "Current driver: {{ driver }}", MD = "Proceed to {{ location }}", wD = "Go back to {{ location }}", $D = "Overview", HD = "Speed", VD = "This field is required.", BD = "Total tours: {{count}}", GD = {
  DAY: "Day",
  NIGHT: "Evening",
  DAY_PLANNING: "Day Planning",
  NIGHT_PLANNING: "Evening Planning",
  HEADER: "{{ networkType }} {{ usage }}",
  WARNING_TITLE: "Switching networks",
  WARNING_CONTENT: "You're about to switch to {{ targetNetworkType }} {{ usage }}. You can go back anytime to {{ networkType }} {{ usage }} using the same switch.",
  WARNING_BUTTON: "Switch to {{ networkType }} {{ usage }}",
  DISABLED: "This is disabled in day planning",
  SWITCH_NETWORK_CALLOUT: "You are now planning tours for the {{ networkType }}"
}, kD = "We temporarily removed the At Regional Hub list to improve loading times. But you can still continue the morning scan as usual.", xD = {
  LOADING: fS,
  LOGIN: SS,
  EMAIL: RS,
  PASSWORD: NS,
  WRONG_CREDENTIALS: OS,
  CHECK_CREDENTIALS: IS,
  CHECK_SHIPMENTS: pS,
  RELOAD: hS,
  NEXT: AS,
  BACK: gS,
  GO_BACK: vS,
  CONFIRM: DS,
  CANCEL: mS,
  CLOSE: LS,
  BARCODE: CS,
  FULL_SCREEN: PS,
  TOUR: yS,
  TOURS: US,
  OPTIMIZING_1: bS,
  OPTIMIZING_2: MS,
  OPTIMIZING_3: wS,
  DRIVER: $S,
  NO_PARCELS: HS,
  SELECT_DRIVER: VS,
  SAVE: BS,
  SAVE_PLANNING: GS,
  SAVE_PLANNING_BY_NETWORK: kS,
  ENABLE_PLANNING: xS,
  DISABLE_PLANNING: FS,
  NAME: WS,
  LOCATION: KS,
  POSTALCODE: zS,
  ADDRESS: YS,
  STREET: jS,
  NUMBER: ZS,
  CITY: XS,
  LAT: qS,
  LNG: QS,
  COUNTRY: JS,
  NETHERLANDS: eR,
  GERMANY: tR,
  PHONE_NUMBER: nR,
  PHONE_NUMBER_NOT_REGISTERED: rR,
  REMARKS: oR,
  SHIPMENTS: iR,
  SHIPMENT: aR,
  GEOCODING_EXCEPTIONS: sR,
  NOT_PLANNED_YET: cR,
  HANDOVER: uR,
  MOVE_TOUR: ER,
  DURATION: lR,
  START: _R,
  DEPART: dR,
  OPTIMIZE: TR,
  CREATE_NEW_TOURS: fR,
  CREATE_NEW_TOURS_BY_NETWORK: SR,
  OPTIMIZE_OPTIONS: RR,
  OPTIMIZE_AGAIN: NR,
  RUN: OR,
  DRIVER_SPEED: IR,
  FASTER: pR,
  FAST: hR,
  NORMAL: AR,
  SLOW: gR,
  VERY_SLOW: vR,
  OPEN_END_TOUR: DR,
  SELECT_ALL: mR,
  HANDOVER_DONE: LR,
  LOG_OFF: CR,
  RECOVER_CREDENTIALS: PR,
  ADD_TOUR: yR,
  VISIBLE_TOURS: UR,
  OPTIMIZE_TOUR: bR,
  EXPORT: MR,
  POSITION: wR,
  TIME: $R,
  SIGNATURE: HR,
  CODE: VR,
  PROFILE: BR,
  EDIT_PROFILE: GR,
  DRIVERS: kR,
  EDIT_DRIVER: xR,
  ADD_DRIVER: FR,
  CHANGE_PASSWORD: WR,
  CURRENT_PASSWORD: KR,
  NEW_PASSWORD: zR,
  CONFIRM_NEW_PASSWORD: YR,
  WRONG_PASSWORD: jR,
  WRONG_PASSWORD_MSG: ZR,
  PASSWORD_TOO_SHORT: XR,
  PASSWORD_TOO_SHORT_MSG: qR,
  PASSWORD_CHANGED: QR,
  PASSWORD_CHANGED_MSG: JR,
  PASSWORDS_DONT_MATCH: eN,
  PASSWORDS_DONT_MATCH_MSG: tN,
  FORM_INCOMPLETE: nN,
  FORM_INCOMPLETE_MSG: rN,
  PROFILE_EDITED: oN,
  PROFILE_EDITED_MSG: iN,
  UNKOWN_ERROR: aN,
  UNKOWN_ERROR_MSG: sN,
  SAVE_ERROR: cN,
  SAVE_ERROR_MSG: uN,
  DRIVER_ADDED: EN,
  DRIVER_ADDED_MSG: lN,
  EMAIL_INVALID: _N,
  EMAIL_INVALID_MSG: dN,
  UNKNOWN_EMAIL_MSG: TN,
  UNSAVED_CHANGES: fN,
  NEW_SHIPMENTS_MSG: SN,
  TRAFFIC: RN,
  MIN_VISITS: NN,
  BALANCE: ON,
  MIN_VEHICLES: IN,
  FINISH: pN,
  LAST_STOP: hN,
  PRODUCTIVITY: AN,
  TOTAL_TIME: gN,
  CHANGE_COLOR: vN,
  CANCEL_SHIPMENT: DN,
  YES: mN,
  NO: LN,
  SEND_EMAIL: CN,
  SEND_EMAIL_MSG: PN,
  EMAIL_SENT_MSG: yN,
  EDIT_MODE: UN,
  ABT: bN,
  SL1T: MN,
  SL1ST: wN,
  SL2T: $N,
  SL2ST: HN,
  SL3T: VN,
  SL3ST: BN,
  SL4T: GN,
  SL4ST: kN,
  SL5T: xN,
  SL5ST: FN,
  NU1T: WN,
  NU1ST: KN,
  NU2T: zN,
  NU2ST: YN,
  NU3T: jN,
  NU3ST: ZN,
  NU4T: XN,
  NU4ST: qN,
  NU5T: QN,
  NU5ST: JN,
  STILL_TIME: eO,
  NO_SHIPMENTS: tO,
  ALL_SHIPMENTS_HANDOVERED: nO,
  HANDOVER_STARTED: rO,
  OPTIMIZE_WARNING: oO,
  DRIVER_WARNING: iO,
  DUPLICATE_EMAIL: aO,
  DUPLICATE_EMAIL_MSG: sO,
  SETTING_ZOOM: cO,
  SETTING_CLUSTER: uO,
  INSTRUCTIONS: EO,
  INSTRUCTIONS_TXT: lO,
  UPDATE: _O,
  UPDATE_TXT: dO,
  UPDATE_VIDEO: TO,
  NEW_UPDATE: fO,
  CART: SO,
  CONFIRMATION: RO,
  START_SCANNING: NO,
  READY_HANDOVER: OO,
  RESET_HANDOVER: IO,
  RESET_HANDOVER_MSG: pO,
  ARE_YOU_SURE: hO,
  CHANGE_DRIVERS: AO,
  CHANGE_DRIVERS_SUCCESS_TITLE: gO,
  CHANGE_DRIVERS_SUCCESS_DESC: vO,
  INVALID_SUBCO_AREA: DO,
  INVALID_SUBCO_AREA_DESC: mO,
  MISSORT: LO,
  SCAN_ERROR_MSG_1: CO,
  SCAN_ERROR_MSG_2: PO,
  SCAN_ERROR_MSG_3: yO,
  UNKNOWN_AREA: UO,
  NUMBER_OF_DRIVERS: bO,
  CANCEL_MARKED_SHIPMENTS: MO,
  ATTENTION: wO,
  RETURN: $O,
  CANCEL_SHIPMENTS: HO,
  RESET_HANDOVER_BTN_TEXT: VO,
  ACTIVE: BO,
  MARK_TOUR_AS_PLANNED: GO,
  MARK_TOUR_MSG_1: kO,
  MARK_TOUR_MSG_2: xO,
  MARK_TOUR_MSG_3: FO,
  TOUR_PLANNED: WO,
  UNDO: KO,
  SEND_CODE: zO,
  TOURS_SAVED: YO,
  TOURS_SAVED_SUCCESSFULLY: jO,
  EDIT_TOURS: ZO,
  PLAN_TOURS: XO,
  TOURS_SAVED_NO_DRIVERS: qO,
  PLANNING_DONE: QO,
  GO_TO_HANDOVER: JO,
  PHONE_INCORRECT: eI,
  PHONE_INCORRECT_MSG: tI,
  IMAGE_ERROR: nI,
  IMAGE_ERROR_MSG: rI,
  SAVE_DRIVER_ERROR: oI,
  SAVE_DRIVER_ERROR_MSG: iI,
  NO_DRIVERS_YET: aI,
  NO_DRIVERS_YET_MSG: sI,
  SUBCO_PROFILE: cI,
  MOVE_TO_TOUR: uI,
  OPTIMIZING: EI,
  ESTIMATING: lI,
  SAVING: _I,
  RETURN_TO_TRUNKRS: dI,
  SET_ASIDE: TI,
  ATTENTION_MISSORT: fI,
  ATTENTION_MISSORT_MSG: SI,
  ATTENTION_SET_ASIDE_MSG: RI,
  STATE_CANCELED: NI,
  STATE_HAS_TOUR: OI,
  STATE_NO_TOUR: II,
  STATE_EXPECTED: pI,
  NO_TOURS_YET: hI,
  START_OPTIMIZING: AI,
  OPTIMIZE_BTN: gI,
  ERROR_PAGE_TITLE: vI,
  ERROR_PAGE_MESSAGE: DI,
  RELOAD_APP: mI,
  PACKAGES: LI,
  GO_TO_TOURS: CI,
  LOCK_TOURS: PI,
  LOCK_TOURS_MSG: yI,
  LOCK_TOURS_MSG_WAIT: UI,
  LOCK_TOURS_NOW: bI,
  NO_DRIVERS_ASSIGNED: MI,
  NO_DRIVERS_ASSIGNED_MSG: wI,
  GENERIC_ERROR_MSG: $I,
  WRONG_VERIFICATION_CODE: HI,
  DASHBOARD: VI,
  FETCH_TOUR_OVERVIEW: BI,
  NOT_SCANNED_AT_HUB: GI,
  ON_ITS_WAY: kI,
  DELIVERED: xI,
  DELIVERED_TO_NEIGHBOUR: FI,
  NOT_DELIVERED: WI,
  FEEDBACK_TITLE: KI,
  FEEDBACK_SUBTITLE: zI,
  FEEDBACK_SUBTITLE_2: YI,
  FEEDBACK_LABEL_NAME: jI,
  FEEDBACK_LABEL_EMAIL: ZI,
  FEEDBACK_LABEL_COMMENTS: XI,
  FEEDBACK_CLOSE_BTN: qI,
  FEEDBACK_SUBMIT_BTN: QI,
  FEEDBACK_LABEL_SUCCESS: JI,
  TOUR_OVERVIEW_PAGE_TITLE: ep,
  UPDATING_OVERVIEW: tp,
  LAST_UPDATED: np,
  FEEDBACK_SUCCESS: rp,
  TODO_LIST: op,
  TITLE_TODO_LIST: ip,
  TAB_LABEL_NOT_DELIVERED: ap,
  TAB_LABEL_NO_END_STATE: sp,
  TAB_LABEL_MISSORTED: cp,
  TAB_LABEL_RETURNS: up,
  TAB_LABEL_DONE: Ep,
  BARCODE_TODO: lp,
  TIME_REMAINING: _p,
  DONE_COUNTER_TITLE: dp,
  NON_DELIVERY_REASON: Tp,
  TODO_NOT_RETURNED: fp,
  TODO_RETURNED: Sp,
  TODO_NO_PARCEL: Rp,
  TODO_PARCEL_POSTPONE: Np,
  LATEST_STATUS: Op,
  SHIPMENT_ACCEPTED_BY_DRIVER: Ip,
  CAUTION: pp,
  CAUTION_CHANGE_DRIVER: hp,
  CHANGE_DRIVER: Ap,
  QUICK_TOURS_NO_TOURS_YET: gp,
  RETURNED_TRUNKRS: vp,
  NOT_AT_DEPOT: Dp,
  MAX_FAILED_DELIVERY_ATTEMPT: mp,
  MAX_OUT_OF_FREEZER_TIME: Lp,
  BACK_INTO_PLANNING: Cp,
  LOAD_TODO: Pp,
  SHIPMENT_COMMENT_TITLE: yp,
  SHIPMENT_COMMENT_TEXT: Up,
  SHIPMENT_COMMENT_PLACEHOLDER: bp,
  SHIPMENT_SCANNED_TITLE: Mp,
  ADDRESS_NOT_FOUND: wp,
  BUSINESS_CLOSED: $p,
  BAD_ADDRESS: Hp,
  DELIVERY_DAMAGED: Vp,
  NO_TIME_LEFT_IN_TIMESLOT: Bp,
  RECIPIENT_NOT_AT_HOME: Gp,
  DRIVER_INVOLVED_IN_ACCIDENT: kp,
  REFUSED_BY_CUSTOMER: xp,
  EXTREME_WEATHER_CONDITIONS: Fp,
  PARCEL_MISSING: Wp,
  DELIVER_ADDRESS_NOT_ACCESSIBLE: Kp,
  SHIPMENT_MISSING: zp,
  HEAVILY_DAMAGED: Yp,
  TOO_HEAVY: jp,
  TOO_LARGE: Zp,
  SHIPMENT_ADDRESS_HAS_CHANGED: Xp,
  NEW_ADDRESS: qp,
  OLD_ADDRESS: Qp,
  SHIPMENT_ADDRESS_CHANGED: Jp,
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: eh,
  SHIPMENTS_ACCEPTED_BY_DRIVERS: th,
  SHIPMENTS_WITH_END_STATE: nh,
  ALL_SHIPMENTS: rh,
  RESULTS: oh,
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: ih,
  WHICH_SHIPMENTS_HAVE_BEEN_SORTED_AT_REGIONAL_HUB: ah,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_SORTED_AT_REGIONAL_HUB: sh,
  WHICH_SHIPMENTS_HAVE_BEEN_ACCEPTED_BY_THEIR_DRIVERS: ch,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_ACCEPTED_BY_THEIR_DRIVERS: uh,
  WHICH_SHIPMENTS_HAVE_AN_END_STATE: Eh,
  WHICH_SHIPMENTS_DO_NOT_HAVE_AN_END_STATE: lh,
  WHICH_SHIPMENTS_ARE_DELIVERED_TO_NEIGHBOURS: _h,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_DELIVERED: dh,
  CLEAR_FILTER: Th,
  TRANSFER_TO: fh,
  SUBCONTRACTOR: Sh,
  FOSSIL: Rh,
  ELECTRIC: Nh,
  COLLECTIONS: Oh,
  COLLECTION_TOUR: Ih,
  TOUR_REMARK: ph,
  COLLECTION_DRIVER_PLACEHOLDER: hh,
  NO_DRIVER_ASSIGNED: Ah,
  STOPS: gh,
  COLLECTION_TOUR_TITLE: vh,
  ORDER_STOPS: Dh,
  CLIENT_TITLE: mh,
  POSTAL: Lh,
  PICKUP_TIME: Ch,
  STOP_REMARK: Ph,
  END: yh,
  LOCK_TITLE: Uh,
  LOCK_DESCRIPTION: bh,
  LOCK_PLANNING_OWNER: Mh,
  LOCK_PLANNING_TITLE: wh,
  PLANNING_FIXED: $h,
  CHOOSE_DRIVER: Hh,
  LOCK_PLANNING_DESCRIPTION: Vh,
  LOCK_PLANNING_DONE: Bh,
  LOCK_PLANNING_SAVED: Gh,
  LOCK_SORTING_OWNER: kh,
  LOCK_SORTING_TITLE: xh,
  LOCK_SORTING_DESCRIPTION: Fh,
  LOCK_SORTING_DONE: Wh,
  LOCK_DRIVERS_OWNER: Kh,
  LOCK_DRIVERS_TITLE: zh,
  LOCK_DRIVER_DESCRIPTION: Yh,
  LOCK_DRIVER_DONE: jh,
  LOCK_DRIVER_CTA: Zh,
  LOCK_BUTTON: Xh,
  PLANNING_NOT_READY_YET: qh,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_DRIVERS_AVAILABLE_IN: Qh,
  INFORMATION: Jh,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_NEEDED_DRIVERS_WILL_BE_AVAILABLE_AT: eA,
  SEE_ESTIMATED_AMOUNT_OF_SHIPMENT_AND_DRIVERS_BELOW: tA,
  YOU_CAN_ACCESS_THE_PLANNING_WHEN_IT_IS_COMPLETED: nA,
  ESTIMATED_AMOUNT_OF_SHIPMENTS: rA,
  DRIVERS_YOU_WILL_PROBABLY_NEED: oA,
  MARK_PLANNING_AS_DONE: iA,
  MARK_PLANNING_AS_DONE_HOLDING: aA,
  MARK_PLANNING_DONE: sA,
  PLANNING_MUST_BE_MARKED_AS_DONE: cA,
  NO_COLLECTION_TOURS: uA,
  NO_COLLECTION_TOURS_DESC: EA,
  PROCESSING: lA,
  CENTRAL_SORTING_DONE_ALERT: _A,
  WARNING: dA,
  CENTRAL_SORTING_NOT_DONE_ALERT: TA,
  FREEZER_MANAGEMENT: fA,
  SCAN_FROZEN_SHIPMENT: SA,
  EXPECTED_SHIPMENTS: RA,
  FROZEN_MANAGEMENT_ADDRESS: NA,
  FROZEN_MANAGEMENT_DRIVER: OA,
  CURRENTLY_IN_THE_FREEZER: IA,
  MERCHANT: pA,
  IN_SINCE: hA,
  NEXT_STEP: AA,
  BACK_INTO_DELIVERY: gA,
  BACK_TO_TRUNKRS: vA,
  SHIPMENT_ADDED_TO_THE_FREEZER: DA,
  SHIPMENT_NOT_ADDED_TO_THE_FREEZER: mA,
  SHIPMENT_OUT_OF_THE_FREEZER: LA,
  RETURN_SHIPMENT: CA,
  FROZEN_MANAGEMENT_NO_SHIPMENTS: PA,
  ADD_TO_NEW_TOUR: yA,
  DRIVER_PREF_LANG: UA,
  SAVE_DRIVER: bA,
  VEHICLE: MA,
  VEHICLE_TYPE: wA,
  SHOW_FULL_TOUR: $A,
  HIDE_TOUR: HA,
  OPTIMISE_TOUR: VA,
  REVERSE_TOUR: BA,
  COLOR_TOUR: GA,
  CHOOSE_TOUR_COLOUR: kA,
  COLOUR_PICK_CANCEL: xA,
  AMOUNT_OF_PACKAGES: FA,
  MOVE_TO_DIFFERENT_TOUR: WA,
  DE_SELECT_ALL: KA,
  SELECT_TOUR_TO_PRINT: zA,
  SELECT_TOUR_TO_PRINT_SUB_DESCRIPTION: YA,
  SELECT_PRINT_ALL: jA,
  SELECTED_PRINT: ZA,
  PRINT_EXPORT: XA,
  PRINT_EXPORT_LOADING: qA,
  OPTIMIZATION_NOTIFICATION_HEADER: QA,
  OPTIMIZATION_NOTIFICATION_SUBTEXT: JA,
  OPTIMIZATION_NOTIFICATION_CONTACT_NO: eg,
  ADD_USER_TITLE: tg,
  ADD_USER_BUTTON: ng,
  ADD_USER_CREATE_BUTTON: rg,
  ADD_USER_CANCEL_BUTTON: og,
  ADD_USER_CREATING_BUTTON: ig,
  ADD_USER_NAME_REQUIRED: ag,
  ADD_USER_LANGUAGE_REQUIRED: sg,
  ADD_USER_PHONE_REQUIRED: cg,
  PLANNER_PERMISSION: ug,
  PLANNER_PERMISSION_SUBTEXT: Eg,
  ADD_USER_SUCCESS_MSG: lg,
  ADD_USER_SUCCESS_MSG_SUBTEXT: _g,
  ADD_USER_FULL_NAME: dg,
  ADD_USER_FULL_NAME_PLACEHOLDER: Tg,
  ADD_USER_PREFERRED_LANGUAGE: fg,
  ADD_USER_PREFERRED_LANGUAGE_PLACEHOLDER: Sg,
  ADD_USER_PREFERRED_PHONE_NUMBER: Rg,
  ADD_USER_PREFERRED_PHONE_NUMBER_PLACEHOLDER: Ng,
  EDIT_USER_TITLE: Og,
  SAVE_USER_BUTTON: Ig,
  SAVING_USER_BUTTON: pg,
  EDIT_USER_SUCCESS_MSG_SUBTEXT: hg,
  USER_LIST_HEADER: Ag,
  USER_LIST_TAB_ALL_EMPLOYEES: gg,
  USER_LIST_TAB_PLANNER: vg,
  USER_LIST_TAB_INACTIVE: Dg,
  USER_LIST_TAB_DELETED: mg,
  USER_LIST_TABLE_EMPLOYEE_NAME: Lg,
  USER_LIST_TABLE_ROLE: Cg,
  USER_LIST_TABLE_PHONE_NUMBER: Pg,
  USER_LIST_TABLE_STATUS: yg,
  USER_LIST_TABLE_MANAGE_EMPLOYEE: Ug,
  USER_LIST_TABLE_ROLE_PLANNER: bg,
  USER_LIST_TABLE_ROLE_DRIVER: Mg,
  USER_LIST_TABLE_ROLE_DELETED: wg,
  USER_LIST_TABLE_ACTIVE: $g,
  USER_LIST_TABLE_INACTIVE: Hg,
  USER_LIST_MENU_OPTIONS: Vg,
  USER_LIST_MENU_EDIT_USER: Bg,
  USER_LIST_MENU_DELETE_USER: Gg,
  NO_USERS_FOUND: kg,
  NO_USERS_FOUND_MSG: xg,
  DELETE_USER_SUBTEXT: Fg,
  DELETE_USER_TITLE: Wg,
  LONGPRESS_DELETE_USER: Kg,
  LONGPRESS_DONE: zg,
  DELETE_USER_SUCCESS_MSG_SUBTEXT: Yg,
  EMPLOYEES: jg,
  EDIT_PHONE_NUMBER_WARNING: Zg,
  HOW_MANY_DRIVERS: Xg,
  CREATE_TOURS: qg,
  CREATE_TOURS_BY_NETWORK: Qg,
  CREATE_AND_EDIT_TOURS_BY_NETWORK: Jg,
  CREATE_TOURS_BY_NETWORK_2: ev,
  SWITCH_POWER_MODE_TITLE: tv,
  SWITCH_POWER_MODE_BODY: nv,
  SWITCH_POWER_MODE_BTN: rv,
  LITE_MODE: ov,
  POWER_MODE: iv,
  PLAN_MODE: av,
  LITE_SAVE_TOURS: sv,
  LITE_RE_OPTIMIZE: cv,
  LITE_TOURS_TABLE_TOUR: uv,
  LITE_TOURS_TABLE_DEPARTURE: Ev,
  LITE_TOURS_TABLE_LAST_STOP: lv,
  LITE_TOURS_TABLE_SHIPMENTS: _v,
  LITE_TOURS_TABLE_DRIVER: dv,
  LITE_TOURS_TABLE_VEHICLE_TYPE: Tv,
  LITE_DEFAULT_HEADER: fv,
  LITE_DEFAULT_SUB_DETAILS: Sv,
  LITE_CREATE_TOURS: Rv,
  LITE_NUMBER_OF_TOURS_CREATED: Nv,
  LITE_SELECT_DRIVER: Ov,
  LITE_SHOW_TOUR: Iv,
  LITE_TOUR_STOP_TABLE_STOP: pv,
  LITE_TOUR_STOP_TABLE_STREET: hv,
  LITE_TOUR_STOP_TABLE_POSTAL_CODE: Av,
  LITE_TOUR_STOP_TABLE_CITY: gv,
  LITE_TOUR_STOP_TABLE_COLLI_COUNT: vv,
  LITE_TOUR_STOP_TABLE_ETA: Dv,
  LITE_NOTIFICATION_MESSAGE_NOT_DONE_BEFORE_TIME: mv,
  LITE_NOTIFICATION_MESSAGE_OPTIMIZATION_FAILURE: Lv,
  NO_TOURS_POWER_TEXT: Cv,
  NO_TOURS_POWER_BODY: Pv,
  LITE_AUTO_COMPLETE_DRIVER_NOT_FOUND: yv,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_NOT_STARTED: Uv,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_IS_DONE: bv,
  LITE_RELOAD: Mv,
  CREATING_TOURS: wv,
  DO_NOT_LEAVE_PAGE: $v,
  LAST_UPDATE: Hv,
  USE_PREVIOUS_OPTIMIZATION: Vv,
  USE_ROUTIFIC_V2: Bv,
  HIDE_TOUR_TOOLTIP: Gv,
  UNHIDE_TOUR_TOOLTIP: kv,
  OPTIMIZATION_RESULT_ERROR_TITLE: xv,
  OPTIMIZATION_RESULT_ERROR_DESC_1: Fv,
  OPTIMIZATION_RESULT_ERROR_DESC_2: Wv,
  OPTIMIZATION_RESULT_ERROR_DESC_3: Kv,
  OPTIMIZATION_RESULT_ERROR_DESC_4: zv,
  OPTIMIZATION_RESULT_ERROR_SUPPORT_TEL: Yv,
  OPTIMIZATION_RESULT_SUCCESS_TITLE: jv,
  OPTIMIZATION_RESULT_SUCCESS_DESC_1: Zv,
  OPTIMIZATION_RESULT_SUCCESS_DESC_2: Xv,
  OPTIMIZATION_RESULT_SUCCESS_DESC_3: qv,
  OPTIMIZATION_RESULT_BUTTON_RUN_AGAIN: Qv,
  OPTIMIZATION_RESULT_BUTTON_ACCEPT: Jv,
  OPTIMIZATION_RESULT_BUTTON_RE_OPTIMIZE: eD,
  OPTIMIZATION_RESULT_OVERFLOW_DESC: tD,
  SIDEBAR_HUB_INVENTORY: nD,
  SIDEBAR_RETURNS_SCAN: rD,
  SIDEBAR_RETURNS_SCAN_NOT_AVAILABLE_TOOLTIP: oD,
  HUB_INVENTORY: iD,
  RETURNS_SCAN: aD,
  SHIPMENT_STATES: sD,
  USERS: cD,
  TOTAL_DISTANCE: uD,
  BERMUDA_TEXT_NOTIFICATION: ED,
  BERMUDA_TEXT_MORE_INFO: lD,
  BERMUDA_TEXT_CALLOUT: _D,
  GLOBAL_NOTIFICATIONS: dD,
  SHIPMENTS_OVERVIEW: TD,
  PLANNING_TIMELINE: fD,
  EMPTY_SCREENS: SD,
  NAVIGATE_TO_TRACT_N_TRACE: RD,
  LOGIN_DESCRIPTION: ND,
  PHONE_NUMBER_IS_REQUIRED: OD,
  PHONE_NUMBER_ERROR: ID,
  SENT_CODE_TO: pD,
  RESENT_CODE: hD,
  VERIFY_AND_LOGIN: AD,
  HANDOVER_TOUR_PLANNING_CARD_DESCRIPTION: gD,
  HANDOVER_ASSIGN_DRIVERS_CARD_DESCRIPTION: vD,
  HANDOVER_CHANGE_DRIVER_FOR_CART: DD,
  INVALID_PHONE_NUMBER: mD,
  PARTNER_PROFILE: LD,
  NO_ACTIVE_TOURS_YET: CD,
  SEE_MORE_STOPS: PD,
  SEE_LESS_STOPS: yD,
  CREATE_AND_EDIT_TOURS: UD,
  HANDOVER_CURRENT_DRIVER: bD,
  PROCEED_TO: MD,
  GO_BACK_TO: wD,
  OVERVIEW: $D,
  SPEED: HD,
  THIS_FIELD_IS_REQUIRED: VD,
  TOUR_COUNT: BD,
  NETWORK_TYPE: GD,
  TEMPORARY_FIX: kD
}, FD = "Loading...", WD = "login", KD = "email", zD = "password", YD = "wrong credentials", jD = "please check your credentials", ZD = "check shipments", XD = "reload", qD = "next", QD = "back", JD = "Go back", em = "Confirm", tm = "cancel", nm = "close", rm = "Scan barcode to handover parcel", om = "full screen", im = "tour", am = "tours", sm = "We are now calculating the tours", cm = "Our sophisticated system gives back the best theoretical results", um = "But you're the expert, so feel free to tune them!", Em = "driver", lm = "no. parcels", _m = "Driver and Vehicle...", dm = "save", Tm = "save planning", fm = "Enable", Sm = "Disable", Rm = "name", Nm = "location", Om = "postalcode", Im = "address", pm = "street", hm = "number", Am = "city", gm = "lat", vm = "lng", Dm = "country", mm = "the Netherlands", Lm = "Germany", Cm = "phone number", Pm = "Phone number is not registered", ym = "Remarks", Um = "Shipments", bm = "shipment", Mm = "geocoding exceptions", wm = "-", $m = "handover", Hm = "Move to different tour", Vm = "duration", Bm = "start", Gm = "Depart", km = "Optimize", xm = "Create new tours", Fm = "optimize options", Wm = "adjust optimization", Km = "run", zm = "driver speed", Ym = "faster", jm = "fast", Zm = "normal", Xm = "slow", qm = "very slow", Qm = "leave tours open ended", Jm = "select all", eL = "Handover complete", tL = "sign out", nL = "forgot password?", rL = "add tour", oL = "filter tours", iL = "optimize tour", aL = "print", sL = "position", cL = "time", uL = "signature", EL = "code", lL = "profile", _L = "edit profile", dL = "drivers", TL = "edit driver", fL = "add driver", SL = "change password", RL = "current password", NL = "new password", OL = "confirm new password", IL = "Password is incorrect", pL = "Your current password is incorrect", hL = "Password too short", AL = "Your new password should contain at least 8 characters", gL = "Password changed", vL = "Your password has been changed. From now on you can login using your new password", DL = "Passwords don't match", mL = "New password does not match the confirm password", LL = "Form incomplete", CL = "Please fill in all requested fields.", PL = "Changes have been saved", yL = "Changes to your profile have been saved.", UL = "Error message", bL = "Something went wrong. Please reload the page and try again", ML = "Saving tours failed", wL = "Something went wrong trying to save the tours. Please reload the page and try again", $L = "driver added", HL = "new driver has been added successfully.", VL = "invalid email address", BL = "the email address you provided is invalid", GL = "The email address you've provided is not linked to an account", kL = "You have unsaved changes. Do you want to save changes now?", xL = "There are new shipments available, which are currently not assigned to any route. Please re-run the optimalization.", FL = "Traffic", WL = "Minimum number of stops", KL = "Balance routes", zL = "Least amount of drivers", YL = "Finish", jL = "Last Stop", ZL = "Productivity", XL = "Total time:", qL = "Change color", QL = "Are you sure you want to cancel this shipment?", JL = "yes", eC = "no", tC = "send email", nC = "Fill in your e-mail address and we'll send you a new password you can use to login.", rC = "We've sent a new password to your E-mail address. Once you login, using your new password, you can change your password on your profile page.", oC = "Edit tour", iC = "Close", aC = "New update!", sC = "Take a minute to see what's new", cC = "Multicolli indication", uC = "Multicolli shipments on the map are now indicated by a little star on the marker. By clicking on the marker you can see how many shipments. To move all shipments at once, you can now right-click on the marker to move all shipments simultaneously.", EC = "", lC = "", _C = "", dC = "", TC = "Feedback?", fC = "We're continuously working to improve the Plannr app, so if you have any feedback, suggestion or wishes, we would love to hear them. You can send us an email at wietse@trunkrs.nl.", SC = "Welcome to the Plannr app!", RC = "Take a minute to find out what the Plannr app can do and how it can help you maximize your productivity", NC = "Shipments overview", OC = "View all of today's shipments and edit or cancel them if necessary.", IC = "Tours planner", pC = "Use our sophisticated system to calculate the best tours and modify them if you like.", hC = "Handover", AC = "Perform the handover manually or use the barcode scanner to automate the process. Finalize the process by printing out a roll card for the driver.", gC = "Try it out!", vC = "Time to explore the app and all of its features! If you have any questions, you can contact us using the live chat button in the bottom-right corner.", DC = "The cut off time hasn't been reached yet, so you still might receive new shipments.", mC = "No shipments available", LC = "All parcels are handovered", CC = "The handover is already in progress.", PC = "Running the optimizer overwrites any previous changes made. You can optimize within the route by hitting the cog-wheel next to a route. Are you sure you want to run the optimizer?", yC = "Warning: Your tours have been saved, but not all tours have an assigned driver yet", UC = "Use different email address", bC = "This email address is already in use by another driver", MC = "Zoom on scroll", wC = "Cluster shipments", $C = "instructions", HC = "View the video below to see what the Plannr app can do.", VC = "Update", BC = "View the video below to see what's new.", GC = "View last update video", kC = "The Plannr app has been updated. Click here to see what's new!", xC = "Cart", FC = "Confirmation", WC = "Reset handover", KC = "You are about to reset the handover. This means you have to re-scan all of the shipments you have already processed.", zC = "Are you sure?", YC = "Change Drivers", jC = "DRIVERS SUCCESSFULLY CHANGED", ZC = "Tours have been reassigned!", XC = "FAULTY SORTING", qC = "The parcel you have scanned is from another region. Please send the parcel back to Vianen.", QC = "MISSORT", JC = "THIS SHIPMENT BELONGS TO", eP = "REGION: ", tP = "PLEASE RETURN THIS SHIPMENT TO TRUNKRS CENTRAL HUB VIANEN", nP = "UNKNOWN AREA", rP = "Number of drivers in optimization", oP = "Cancel marked shipments", iP = "Attention!", aP = "Return", sP = "Cancel Shipments", cP = "Reset Handover", uP = "Active", EP = "Mark tour as planned", lP = "You are about to mark this tour as 'Planned'. This actions is irreversible!", _P = "Continue if you are are sure that the tour is planned correctly.", dP = "I understand, don’t ask me again.", TP = "Tour Planned!", fP = "UNDO", SP = "Send code", RP = "Tours Saved", NP = "Tours were saved successfully. If you wish to edit them, please choose 'Edit Tours'. If you wish to proceed to the handover, please choose 'Finish Planning'.", OP = "Edit Tours", IP = "Finish Planning", pP = "The tours were saved, but not all tours have a driver yet. Click the button below to select drivers for the tours.", hP = "Planning finished", AP = "The planning is finished. You can now proceed to the handover screen and sort the shipments. If you have any questions, please contact the Trunkrs Operations team.", gP = "Incorrect number", vP = "Must be a valid mobile number (incl. +31)", DP = "Upload error", mP = "Something went wrong while uploading", LP = "Error on save", CP = "Saving the driver has failed", PP = "No drivers yet", yP = "You haven't added drivers yet", UP = "Subco Profile", bP = "Move to tour", MP = "Optimizing...", wP = "Updating...", $P = "Saving...", HP = "RETURN TO TRUNKRS", VP = "SET ASIDE!", BP = "Attention", GP = "This shipment does not belong in this region. Please return it to Trunkrs as soon as possible.", kP = "This shipment doesn’t belong to any tours for today.", xP = "Canceled", FP = "Assigned to tour", WP = "Not assigned to tour", KP = "Expected", zP = "No tours yet", YP = "Start with optimizing", jP = "Optimize", ZP = "Hold on a second!", XP = "It seems something went wrong in the application. The development team has been notified. No worries though, simply reload and you can continue your work.", qP = "Reload Planner", QP = "packages", JP = "Go to tours", ey = "Lock tours", ty = "Before you can continue, you need to lock the tours", ny = "locking tours ...", ry = "Lock tours now", oy = "No drivers assigned", iy = "Please assign drivers to all tours", ay = "Sorry, something went wrong, please try again later.", sy = "Wrong verification code. Please try again.", cy = "Tour progress", uy = "Fetching tour overview", Ey = "not scanned at hub", ly = "on it's way", _y = "delivered", dy = "delivered to neighbour", Ty = "not delivered", fy = "Whoops, it looks like we’re having issues.", Sy = "The Trunkrs team has been notified.", Ry = "If you’d like to help, tell us what happened below.", Ny = "Your name", Oy = "Your email", Iy = "Describe what happened just before the issue.", py = "Close", hy = "Submit", Ay = "Thank you! Together we make Trunkrs better.", gy = "Tour Progress", vy = "Updating the overview...", Dy = "Last updated", my = "Your feedback has been sent. Thank you so much for helping us make the Planner better!", Ly = "To Do list", Cy = "To Do list", Py = "Not delivered", yy = "No end state", Uy = "Missorted", by = "Returns", My = "Done", wy = "Scan barcode to move a shipment back into planning", $y = "Time left", Hy = "Done", Vy = "Non-delivery reason", By = "Not returned", Gy = "Parcel returned", ky = "We don't have this parcel", xy = "We have this parcel", Fy = "Latest Status", Wy = "Accepted by driver", Ky = "CAUTION", zy = "You are about to change the driver for this tour. If the current driver is already driving, this will empty his app and cause him problems. All our future references to this tour (billing, analytics) will include the new driver. We will not be able to retrieve the old driver for you. If you are sure you want to make the switch, select the new driver below.", Yy = "Yes, change driver", jy = "Nothing to see here", Zy = "Parcel returned to trunkrs", Xy = "Shipment not at depot", qy = "Reached max delivery attempts", Qy = "Reached max out of freezer time", Jy = "Shipment back into planning", eU = "Loading Todos...", tU = "We don't have this parcel", nU = "Please provide additional information about the whereabouts of the parcel and specify why it is not in your possession.", rU = "Write your explanation here...", oU = "Scanned parcel", iU = "Address not found", aU = "Business closed", sU = "Non-existing address", cU = "Parcel damaged", uU = "No time left in tour", EU = "Recipient not home", lU = "Driver in accident", _U = "Refused by recipient", dU = "Extreme weather conditions", TU = "Parcel missing", fU = "Address inaccessible", SU = "Parcel missing", RU = "Parcel heavily damaged", NU = "Parcel too heavy", OU = "Parcel too large", IU = "Shipment Address has been changed!", pU = "New Address", hU = "Old Address", AU = "Shipment address has been changed!", gU = "Shipments sorted at regional hub", vU = "Shipments accepted by drivers", DU = "Shipments with end state", mU = "All shipments", LU = "Results", CU = "Neighbour delivery vs non delivery", PU = "Which shipments have been sorted at regional hub?", yU = "Which shipments have NOT been sorted at regional hub?", UU = "Which shipments have been accepted by their drivers?", bU = "Which shipments have NOT been accepted by their drivers?", MU = "Which shipments have an end-state?", wU = "Which shipments DO NOT have an end-state?", $U = "Which shipments are delivered to neighbours?", HU = "Which shipments have not been delivered?", VU = "Clear filter", BU = "Transfer to", GU = "Subcontractor", kU = "Fossil", xU = "Electric", FU = "Collection tours", WU = "Tour {{ number }}", KU = "Tour remark", zU = "Select a driver", YU = "No driver assigned yet.", jU = "Stops", ZU = "Collection tour overview", XU = "Order stops", qU = "Client name", QU = "Postal code", JU = "Pick-up time", eb = "Remarks stop", tb = "End", nb = "Not ready to handover yet", rb = "Before you can start the handover, the following steps must be complete:", ob = "Trunkrs", ib = "Planning", ab = "Planning is fixed", sb = "Choose your drivers below and go to the handover page.", cb = "The planning needs to be saved, so we can make sure the tours you have created will be the tours your drivers are driving tonight.", ub = "The planning is done!", Eb = "The planning has been saved!", lb = "Trunkrs", _b = "Central sorting", db = "It is necessary for the central sorting to be done before making the tours permanent, so we know what you will deliver today.", Tb = "The central sorting is done!", fb = "You", Sb = "Assign drivers", Rb = "Once you have assigned drivers to the tours and the central sorting is done, you can proceed to make the tours permanent.", Nb = "Drivers have been assigned!", Ob = "Start assigning drivers", Ib = "Make tours permanent and start handover", pb = "Planning not ready yet!", hb = "Estimated amount of shipments and drivers available in", Ab = "Information", gb = "Estimated amount of shipments and needed drivers will be available at", vb = "It seems like the planning isn't ready yet. For your convenience you can find the estimated amount of shipment and the drivers you will need below.", Db = "You can access the planning when it is completed", mb = "Estimated amount of shipments", Lb = "Drivers you will probably need", Cb = "Mark planning as done", Pb = "Hold 3 seconds to mark planning as done", yb = "Planning done", Ub = "Planning must be marked as done before assigning drivers", bb = "No collection tours", Mb = "No collection tours have been assigned yet.", wb = "Processing...", $b = "The central sorting process is now done. Please reload to start planning.", Hb = "WARNING", Vb = "The central sorting process hasn't started yet. Until then none of your changes can be saved.", Bb = "Freezer Management", Gb = "Scan frozen shipments in or out...", kb = "EXPECTED SHIPMENTS", xb = "Address", Fb = "Driver", Wb = "CURRENTLY IN THE FREEZER", Kb = "Merchant", zb = "In since", Yb = "Next step", jb = "Back into delivery", Zb = "Back to Trunkrs", Xb = "Shipment added to the freezer. Brrrr, cold.", qb = "Whoops, this shipment doesn't belong in the freezer!", Qb = "Shipment out of the freezer. Keep it fresh!", Jb = "Return this shipment to Trunkrs!", eM = "No shipments", tM = "+ Add to new tour", nM = "Driver's Preferred language", rM = "Save Driver", oM = "Vehicle", iM = "Vehicle Type", aM = "Show tour", sM = "Hide tour", cM = "Optimise tour", uM = "Reverse tour", EM = "Color tour", lM = "Choose tour colour", _M = "Cancel", dM = "packages", TM = "Move to different tour", fM = "De-select all", SM = "Select a tour to print", RM = "You can select more than 1 tour to print", NM = "Select all", OM = "Selected", IM = "Export", pM = "Exporting...", hM = "Not all stops are optimized", AM = "Due to a technical issue we could not optimize all stops. Call Trunkrs to get this solved.", gM = "085 060 1410", vM = "Add Employee", DM = "Add Employee", mM = "Create an employee", LM = "Cancel", CM = "Creating", PM = "Please fill up the name", yM = "Please select a language", UM = "Phone number is required", bM = "Planner permission", MM = "Turning on will enable this employee to access or login to the planner", wM = "BRAVO!", $M = "You have successfully added a new employee.", HM = "Full name", VM = "Full name", BM = "Preferred Language", GM = "Select Language", kM = "Phone number", xM = "+316", FM = "Edit User", WM = "Save changes", KM = "Saving changes", zM = "You have successfully updated the employee.", YM = "Employees", jM = "All Employees", ZM = "Planners", XM = "Inactive", qM = "Deleted", QM = "Employee name", JM = "Role", ew = "Phone number", tw = "Status", nw = "Manage employee", rw = "Planner, Driver", ow = "Driver", iw = "Deleted", aw = "Active", sw = "Inactive", cw = "Options", uw = "Edit employee details", Ew = "Delete employee", lw = "No records", _w = "There were no results for this category", dw = "You will not be able to undo this action.", Tw = "Delete User?", fw = "Hold 3 secs to delete", Sw = "Deleting...", Rw = "{{EMP_NAME}}'s profile was deleted", Nw = "Employees", Ow = "Changing the phone number will require the employee to logout and login again for their driverapp and/or planner app to work properly.", Iw = "How many drivers?", pw = "Create Tours", hw = "Before you switch", Aw = "Switching to the power mode with this amount of shipments might result in a very slow or even impossible tour planning. Are you sure you want to switch to the power mode?", gw = "Switch to power mode", vw = "Lite", Dw = "Power", mw = "Plan Mode", Lw = "Save tours", Cw = "Re-optimize", Pw = "Tour", yw = "Departure", Uw = "Last stop", bw = "Shipments", Mw = "Driver", ww = "Vehicle type", $w = "Planner Lite", Hw = "Create tours from any system, no matter the numbers.", Vw = "Create Tours", Bw = "tours have been created", Gw = "Select driver...", kw = "Show tour", xw = "Stop", Fw = "Street + nr", Ww = "Zipcode", Kw = "City", zw = "Colli", Yw = "E.T.A", jw = "Not all tours are done before 22:00", Zw = "Not all stops have been optimised, call Trunkrs to solve this", Xw = "Power Mode", qw = "Create and edit optimal tours down to the last detail", Qw = "Driver not found", Jw = "The central sorting process hasn't started yet. Until then none of your changes can be saved", e$ = "The central sorting process is now done. Please reload to start planning.", t$ = "Reload", n$ = "Creating your tours", r$ = "Do not refresh or leave the page", o$ = "Last Update", i$ = "Use previous optimization if possible?", a$ = "Use the new (faster) optimalisation?", s$ = "Hide tour in map", c$ = "Unhide tour in map", u$ = "An error occured during optimization", E$ = "Re-running the optimisation might solve this issue.", l$ = "Would like to run the optimisation again?", _$ = "Something went wrong, we cannot create tours", d$ = "Please contract Trunkrs through your slack channels", T$ = "", f$ = "Optimization Results", S$ = "Optimization time:", R$ = "No. of drivers selected:", N$ = "Overflow tours created:", O$ = "Run again", I$ = "Accept", p$ = "Re-optimize", h$ = "Overflow tours are the result of not having enough drivers assigned. You can solve this by re-optimising with more drivers.", A$ = "Hub Inventory", g$ = "Returns Scan", v$ = "Returns Scan is currently disabled and will be available between 3:00 and 14:00.", D$ = {
  TITLE: "Hub Inventory",
  TRUNKRSNR: "TrunkrsNr",
  ADDRESS: "Address",
  LAST_DRIVER: "Last Driver",
  INTENDED_DELIVERY_DATE: "Intended Delivery Date",
  IN_SINCE: "In Since",
  STATUS: "Status",
  EMPTY_TITLE: "Nothing to see here!",
  EMPTY_DESC: "Keep calm, drink a coffee and reload this page.",
  RELOAD_BUTTON: "Refresh page"
}, m$ = {
  TITLE: "Returns Scan",
  SCAN_INPUT_PLACEHOLDER: "Scan all shipments to your hub",
  AT_REGIONAL_HUB: "At Regional Hub",
  KEEP_IN_REGION: "Keep on Hub",
  BACK_TO_TRUNKRS: "Back to Trunkrs",
  AT_REGIONAL_HUB_PLACEHOLDER: "You are done scanning, now proceed to returning the shipments to their rightful place.",
  KEEP_ON_HUB_PLACEHOLDER: "Scan shipments on your hub first",
  BACK_TO_TRUNKRS_PLACEHOLDER: "Scan shipments on your hub first",
  BUTTON_CONFIRM_RETURNS: "Confirm returns",
  LAST_DRIVER: "Last Driver",
  ADDRESS: "Address",
  SENDER: "Sender",
  ERROR: "ERROR!",
  SCAN_ERROR_TITLE: "Shipment cannot be processed.",
  SCAN_ERROR_DETAILS: "Please contact Trunkrs before you proceed.",
  RETURNED_SCAN_SUCCESS: "You have successfully returned these shipments.",
  ACKNOWLEDGEMENT: {
    TITLE: "Return Acknowledgement",
    DESCRIPTION: "I hereby confirm to return these shipments to Trunkrs and from this point on they are the collection driver’s responsibility.",
    CONFIRM: "Confirm",
    BACK: "Go back",
    WARNING: "Look out! You have not yet scanned all shipments on your hub, are you sure you want to continue?"
  },
  OWNERSHIP: "Ownership",
  ACTIONS: "Actions",
  SHIPMENT_DETAILS: "Shipment Details",
  REASON: "Reason",
  NOT_AT_REGIONAL_HUB: "Not at Regional Hub",
  RETURN_TODAY_TO: "Vous pouvez le retourner aujourd'hui à",
  COLLECTION_OPT_ID: "ID d'optimisation de collecte :",
  COLLECTION_TOUR_TAG: "Étiquette de la tournée de collecte :",
  NO_COLLECTION_TODAY: "Vous n'avez aucune collecte pour <b>{{merchantName}}</b> aujourd'hui. Votre prochaine collecte est prévue le <b>{{day}}</b> avec l'ID d'optimisation de collecte : <b>{{optimizationId}}</b> et Tour Tag : <b>{{tourTag}}</b>",
  FOR_RETURN_TO_SENDER: "Pour le retour à l'expéditeur",
  LOADING: `Balayage.
S'il vous plaît, attendez..`,
  DETAILS: {
    SHIPMENT_DETAILS: "Détails de l'envoi",
    INTENDED_DELIVERY_DATE: "Date de livraison prévue"
  },
  TRUNKRS_NR: "TrunkrsNR"
}, L$ = {
  DATA_RECEIVED: "Data received",
  DATA_PROCESSED: "Registered",
  SHIPMENT_SORTED: "Sorted (at central hub)",
  SHIPMENT_SORTED_AT_SUB_DEPOT: "Sorted (at regional depot)",
  SHIPMENT_ACCEPTED_BY_DRIVER: "Accepted by driver",
  SHIPMENT_NOT_DELIVERED: "Not delivered",
  RETURN_SHIPMENT_TO_SENDER: "Return to sender",
  RETURN_ACCEPTED_BY_DRIVER: "Return accepted by driver",
  RETURN_ASSIGNED_TO_PICKUP: "Return assigned to driver",
  RETURN_ACCEPTED_BY_TRUNKRS: "Return accepted by Trunkrs",
  RETURN_ACCEPTED_BY_PICKUP_DRIVER: "Return accept by pickup driver",
  RETURN_ACCEPTED_BY_SENDER: "Return accepted by sender",
  EXCEPTION_SHIPMENT_NOT_ARRIVED: "Shipment not arrived",
  EXCEPTION_SHIPMENT_MIS_SORTED: "Missorted",
  EXCEPTION_SHIPMENT_MISS_SORTED: "Missorted",
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER: "Declined by driver",
  EXCEPTION_SHIPMENT_MISSING: "Shipment missing",
  EXCEPTION_SHIPMENT_LOST: "Shipment lost",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER: "Return not accepted by sender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER: "Shipment cancelled by sender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS: "Shipment cancelled by Trunkrs",
  EXCEPTION_SHIPMENT_DESTROYED: "Shipment destroyed",
  EXCEPTION_SHIPMENT_INVESTIGATE: "Shipment for investigation",
  CHANGE_SHIPMENT_ADDRESS_CHANGED: "Address Changed",
  CHANGE_SHIPMENT_NEIGHBOUR_CHANGE: "Neighbor Changed",
  CHANGE_SHIPMENT_POST_PONED: "Postponed",
  CUSTOMER_SERVICE_OVERRULE: "Overruled by Customer Service",
  EXCEPTION_LINEHAUL_ARRIVED_LATE: "Linehaul arrived late",
  EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL: "Not on linehaul",
  EXCEPTION_PICKUP_ARRIVED_LATE: "Pickup arrived late",
  EXCEPTION_PICKUP_NOT_PICKED_UP: "Not picked up",
  EXCEPTION_PICKUP_REFUSED_BY_DRIVER: "Pickup refused by driver",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL: "Not accepted by linehaul",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP: "Not accepted by pickup",
  LINEHAUL_ARRIVED_ON_TIME: "Linehaul arrived on time",
  LINEHAUL_IN_TRANSIT: "Linehaul in transit",
  PICKUP_ACCEPTED_BY_DRIVER: "Pickup accepted by driver",
  PICKUP_ARRIVED_ON_TIME: "Pickup arrived on time",
  PICKUP_DRIVER_ASSIGNED: "Pickup driver assigned",
  PICKUP_PICKED_UP: "Picked up",
  RETURN_ASSIGNED_TO_LINEHAUL: "Return assigned to linehaul",
  SHIPMENT_DELIVERED: "Delivered",
  SHIPMENT_DELIVERED_TO_NEIGHBOR: "Delivered to neighbor",
  PARTNER_OVERRULE: "The shipment has been overruled by the partner"
}, C$ = {
  TITLE: "Employees",
  ADD_USER_TITLE: "Add Employee",
  ADD_USER_BUTTON: "Add employee",
  ADD_USER_CREATE_BUTTON: "Create an employee",
  ADD_USER_CANCEL_BUTTON: "Cancel",
  ADD_USER_CREATING_BUTTON: "Creating",
  ADD_USER_NAME_REQUIRED: "Please fill up the name",
  ADD_USER_LANGUAGE_REQUIRED: "Please select a language",
  ADD_USER_PHONE_REQUIRED: "Phone number is required",
  USER_LIST_HEADER: "Employees",
  USER_LIST_TAB_ALL_EMPLOYEES: "All Employees",
  USER_LIST_TAB_PLANNER: "Planners",
  USER_LIST_TAB_INACTIVE: "Inactive",
  USER_LIST_TAB_DELETED: "Deleted",
  USER_LIST_TABLE_EMPLOYEE_NAME: "Employee name",
  USER_LIST_TABLE_ROLE: "Role",
  USER_LIST_TABLE_PHONE_NUMBER: "Phone number",
  USER_LIST_TABLE_STATUS: "Status",
  USER_LIST_TABLE_MANAGE_EMPLOYEE: "Manage employee",
  USER_LIST_TABLE_ROLE_PLANNER: "Planner, Driver",
  USER_LIST_TABLE_ROLE_DRIVER: "Driver",
  USER_LIST_TABLE_ROLE_DELETED: "Deleted",
  USER_LIST_TABLE_ACTIVE: "Active",
  USER_LIST_TABLE_INACTIVE: "Inactive",
  USER_LIST_MENU_OPTIONS: "Options",
  USER_LIST_MENU_EDIT_USER: "Edit employee details",
  USER_LIST_MENU_DELETE_USER: "Delete employee",
  NO_USERS_FOUND: "No records",
  NO_USERS_FOUND_MSG: "There were no results for this category",
  DELETE_USER_SUBTEXT: "You will not be able to undo this action.",
  DELETE_USER_TITLE: "Delete User?",
  LONGPRESS_DELETE_USER: "Hold 3 secs to delete",
  LONGPRESS_DONE: "Deleting...",
  ADD_USER_SUCCESS_MSG: "BRAVO!",
  ADD_USER_SUCCESS_MSG_SUBTEXT: "You have successfully added a new employee.",
  EDIT_USER_SUCCESS_MSG_SUBTEXT: "You have successfully updated the employee.",
  DELETE_USER_SUCCESS_MSG_SUBTEXT: "{{EMP_NAME}}'s profile was deleted",
  IMPORT_DRIVER_MODAL_TITLE: "Import driver to this region",
  DRIVER_PHONE_NUMBER: "Driver's phone number",
  CURRENT_REGION: "Current Region:",
  NOTIF_CANNOT_FIND_DRIVER: "For this phone number we did not find any drivers.",
  AVAILABLE_ASSIGNED: "This driver has already been assigned to a tour in {{region}} and will be removed from that tour if you continue.",
  NOT_AVAILABLE_ASSIGNED: "This driver is assigned to a locked tour and can no longer be moved around.",
  NOTIF_DRIVER_CANNOT_BE_MOVED: "This driver already belongs to your region and cannot be moved.",
  TOAST_DRIVER_IMPORT_SUCCESS: "Driver imported successfully!",
  TOAST_DRIVER_IMPORT_SUCCESS_SUBTEXT: "{{name}} is now available in your region.",
  BUTTON_IMPORT_DRIVER: "Import driver",
  BUTTON_CANCEL: "Close",
  EDIT_INFORMATION_TOOLTIP: "Edit information",
  DELETE_TOOLTIP: "Delete"
}, P$ = "Total Distance", y$ = "Tour(s) {{text}} have stops that are not fully optimized.", U$ = "For some stops we cannot draw tour lines, this is ok", b$ = "This tour is not fully optimized. For the red stops below we could not draw tour lines. You can adjust the stops manually or move them to another tour.", M$ = {
  BUSY_PEAK_DAYS: "Busy/Peak day today, you need to create new tours once the central sorting is done so you can proceed to handover.",
  CENTRAL_SORTING_IS_DONE: "Central sorting is done. Please create new tours to do handover.",
  HANDOVER_CENTRAL_SORTING_DONE: "Busy/Peak day, you cannot start the handover. You need to create new tours once the central sorting is done."
}, w$ = {
  HEADER: "Shipments",
  FILTER_ALL_SHIPMENTS: "All Shipments",
  FILTER_CENTRAL_SORTED: "Central Sorted",
  FILTER_CANCELLED: "Cancelled",
  TABLE_HEADER_TRUNKRSNR: "TrunkrsNR",
  TABLE_HEADER_POSTAL_CODE: "Postal Code",
  TABLE_HEADER_ADDRESS: "Address",
  TABLE_HEADER_CITY: "City",
  TABLE_HEADER_TOUR: "Tour",
  TABLE_HEADER_SHIPMENT_STATE: "Shipment State",
  RESULT_COUNT: "{{count}} results",
  STATE_CANCELED: "Canceled",
  STATE_HAS_TOUR: "Assigned to tour",
  STATE_NO_TOUR: "Not assigned to tour",
  STATE_EXPECTED: "Expected",
  NO_TOURS_YET: "No tours yet",
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: "Shipments sorted at regional hub",
  SHIPMENTS_ACCEPTED_BY_DRIVERS: "Shipments accepted by drivers",
  SHIPMENTS_WITH_END_STATE: "Shipments with end state",
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: "Neighbour delivery vs non delivery",
  OUT_OF_MAXCOUNT: "{{count}} out of {{maxCount}}",
  REFRESH_RESULTS: "Refresh Results",
  EMPTY_TITLE: "Nothing to see here!",
  EMPTY_DESC: "Keep calm, drink a coffee and reload this page.",
  RELOAD_BUTTON: "Refresh page"
}, $$ = {
  INVENTORY_SCAN: "Inventory Scan",
  INVENTORY_SCAN_DESC: "This is your 1st step in planning tours",
  TOUR_PLANNING: "Tour Planning",
  TOUR_PLANNING_DESC: "Create and edit tours",
  HANDOVER: "Handover",
  HANDOVER_DESC: "Handover Parcel",
  MONITORING: "Monitoring",
  MONITORING_DESC: "Keep track of your parcels"
}, H$ = {
  START_PLANNING: {
    TITLE: "Welcome",
    DESCRIPTION: "Hi! The following wizard will help you keep track of your parcels, plan your tours and monitor your day. Are you ready for it?",
    LETS_START: "Let's start"
  },
  NO_SHIPMENT_FOUND: "No shipment found",
  NO_SHIPMENT_FOUND_TEXT: "You are done scanning, now proceed to returning the shipments to their rightful place.",
  THIS_FEATURE_DISABLED: "This feature is disabled",
  INVENTORY_SCAN_300_1400: "Inventory Scan is currently disabled and will be available between 3:00 and 14:00."
}, V$ = "Click to open the track & trace page of this parcel.", B$ = "Hallo! Enter your registered number to access the Planner. You’ll receive a 6-digit code after.", G$ = "Phone number is required.", k$ = "Sorry, this is not a registered mobile number. Please try again.", x$ = "We have sent a code to {{ number }}. Enter it below.", F$ = "Didn’t received it? Resend code in 30s", W$ = "Verify and Login", K$ = "The planning needs to be saved, so we can make sure the tours you have created will be the tours your drivers are driving tonight.", z$ = "Once you have assigned drivers to the tours and the central sorting is done, you can proceed to make the tours permanent.", Y$ = "Change driver for Cart {{ cart }}", j$ = "Current driver: {{ driver }}", Z$ = "Invalid Phone number", X$ = "Partner Profile", q$ = "There are no active yours yet.", Q$ = "See more stops", J$ = "See less stops", e1 = "Create and edit optimal tours down to the last detail.", t1 = "Proceed to {{ location }}", n1 = "Go back to {{ location }}", r1 = "Overview", o1 = "Speed", i1 = "This field is required.", a1 = {
  LOADING: FD,
  LOGIN: WD,
  EMAIL: KD,
  PASSWORD: zD,
  WRONG_CREDENTIALS: YD,
  CHECK_CREDENTIALS: jD,
  CHECK_SHIPMENTS: ZD,
  RELOAD: XD,
  NEXT: qD,
  BACK: QD,
  GO_BACK: JD,
  CONFIRM: em,
  CANCEL: tm,
  CLOSE: nm,
  BARCODE: rm,
  FULL_SCREEN: om,
  TOUR: im,
  TOURS: am,
  OPTIMIZING_1: sm,
  OPTIMIZING_2: cm,
  OPTIMIZING_3: um,
  DRIVER: Em,
  NO_PARCELS: lm,
  SELECT_DRIVER: _m,
  SAVE: dm,
  SAVE_PLANNING: Tm,
  ENABLE_PLANNING: fm,
  DISABLE_PLANNING: Sm,
  NAME: Rm,
  LOCATION: Nm,
  POSTALCODE: Om,
  ADDRESS: Im,
  STREET: pm,
  NUMBER: hm,
  CITY: Am,
  LAT: gm,
  LNG: vm,
  COUNTRY: Dm,
  NETHERLANDS: mm,
  GERMANY: Lm,
  PHONE_NUMBER: Cm,
  PHONE_NUMBER_NOT_REGISTERED: Pm,
  REMARKS: ym,
  SHIPMENTS: Um,
  SHIPMENT: bm,
  GEOCODING_EXCEPTIONS: Mm,
  NOT_PLANNED_YET: wm,
  HANDOVER: $m,
  MOVE_TOUR: Hm,
  DURATION: Vm,
  START: Bm,
  DEPART: Gm,
  OPTIMIZE: km,
  CREATE_NEW_TOURS: xm,
  OPTIMIZE_OPTIONS: Fm,
  OPTIMIZE_AGAIN: Wm,
  RUN: Km,
  DRIVER_SPEED: zm,
  FASTER: Ym,
  FAST: jm,
  NORMAL: Zm,
  SLOW: Xm,
  VERY_SLOW: qm,
  OPEN_END_TOUR: Qm,
  SELECT_ALL: Jm,
  HANDOVER_DONE: eL,
  LOG_OFF: tL,
  RECOVER_CREDENTIALS: nL,
  ADD_TOUR: rL,
  VISIBLE_TOURS: oL,
  OPTIMIZE_TOUR: iL,
  EXPORT: aL,
  POSITION: sL,
  TIME: cL,
  SIGNATURE: uL,
  CODE: EL,
  PROFILE: lL,
  EDIT_PROFILE: _L,
  DRIVERS: dL,
  EDIT_DRIVER: TL,
  ADD_DRIVER: fL,
  CHANGE_PASSWORD: SL,
  CURRENT_PASSWORD: RL,
  NEW_PASSWORD: NL,
  CONFIRM_NEW_PASSWORD: OL,
  WRONG_PASSWORD: IL,
  WRONG_PASSWORD_MSG: pL,
  PASSWORD_TOO_SHORT: hL,
  PASSWORD_TOO_SHORT_MSG: AL,
  PASSWORD_CHANGED: gL,
  PASSWORD_CHANGED_MSG: vL,
  PASSWORDS_DONT_MATCH: DL,
  PASSWORDS_DONT_MATCH_MSG: mL,
  FORM_INCOMPLETE: LL,
  FORM_INCOMPLETE_MSG: CL,
  PROFILE_EDITED: PL,
  PROFILE_EDITED_MSG: yL,
  UNKOWN_ERROR: UL,
  UNKOWN_ERROR_MSG: bL,
  SAVE_ERROR: ML,
  SAVE_ERROR_MSG: wL,
  DRIVER_ADDED: $L,
  DRIVER_ADDED_MSG: HL,
  EMAIL_INVALID: VL,
  EMAIL_INVALID_MSG: BL,
  UNKNOWN_EMAIL_MSG: GL,
  UNSAVED_CHANGES: kL,
  NEW_SHIPMENTS_MSG: xL,
  TRAFFIC: FL,
  MIN_VISITS: WL,
  BALANCE: KL,
  MIN_VEHICLES: zL,
  FINISH: YL,
  LAST_STOP: jL,
  PRODUCTIVITY: ZL,
  TOTAL_TIME: XL,
  CHANGE_COLOR: qL,
  CANCEL_SHIPMENT: QL,
  YES: JL,
  NO: eC,
  SEND_EMAIL: tC,
  SEND_EMAIL_MSG: nC,
  EMAIL_SENT_MSG: rC,
  EDIT_MODE: oC,
  ABT: iC,
  SL1T: aC,
  SL1ST: sC,
  SL2T: cC,
  SL2ST: uC,
  SL3T: EC,
  SL3ST: lC,
  SL4T: _C,
  SL4ST: dC,
  SL5T: TC,
  SL5ST: fC,
  NU1T: SC,
  NU1ST: RC,
  NU2T: NC,
  NU2ST: OC,
  NU3T: IC,
  NU3ST: pC,
  NU4T: hC,
  NU4ST: AC,
  NU5T: gC,
  NU5ST: vC,
  STILL_TIME: DC,
  NO_SHIPMENTS: mC,
  ALL_SHIPMENTS_HANDOVERED: LC,
  HANDOVER_STARTED: CC,
  OPTIMIZE_WARNING: PC,
  DRIVER_WARNING: yC,
  DUPLICATE_EMAIL: UC,
  DUPLICATE_EMAIL_MSG: bC,
  SETTING_ZOOM: MC,
  SETTING_CLUSTER: wC,
  INSTRUCTIONS: $C,
  INSTRUCTIONS_TXT: HC,
  UPDATE: VC,
  UPDATE_TXT: BC,
  UPDATE_VIDEO: GC,
  NEW_UPDATE: kC,
  CART: xC,
  CONFIRMATION: FC,
  RESET_HANDOVER: WC,
  RESET_HANDOVER_MSG: KC,
  ARE_YOU_SURE: zC,
  CHANGE_DRIVERS: YC,
  CHANGE_DRIVERS_SUCCESS_TITLE: jC,
  CHANGE_DRIVERS_SUCCESS_DESC: ZC,
  INVALID_SUBCO_AREA: XC,
  INVALID_SUBCO_AREA_DESC: qC,
  MISSORT: QC,
  SCAN_ERROR_MSG_1: JC,
  SCAN_ERROR_MSG_2: eP,
  SCAN_ERROR_MSG_3: tP,
  UNKNOWN_AREA: nP,
  NUMBER_OF_DRIVERS: rP,
  CANCEL_MARKED_SHIPMENTS: oP,
  ATTENTION: iP,
  RETURN: aP,
  CANCEL_SHIPMENTS: sP,
  RESET_HANDOVER_BTN_TEXT: cP,
  ACTIVE: uP,
  MARK_TOUR_AS_PLANNED: EP,
  MARK_TOUR_MSG_1: lP,
  MARK_TOUR_MSG_2: _P,
  MARK_TOUR_MSG_3: dP,
  TOUR_PLANNED: TP,
  UNDO: fP,
  SEND_CODE: SP,
  TOURS_SAVED: RP,
  TOURS_SAVED_SUCCESSFULLY: NP,
  EDIT_TOURS: OP,
  PLAN_TOURS: IP,
  TOURS_SAVED_NO_DRIVERS: pP,
  PLANNING_DONE: hP,
  GO_TO_HANDOVER: AP,
  PHONE_INCORRECT: gP,
  PHONE_INCORRECT_MSG: vP,
  IMAGE_ERROR: DP,
  IMAGE_ERROR_MSG: mP,
  SAVE_DRIVER_ERROR: LP,
  SAVE_DRIVER_ERROR_MSG: CP,
  NO_DRIVERS_YET: PP,
  NO_DRIVERS_YET_MSG: yP,
  SUBCO_PROFILE: UP,
  MOVE_TO_TOUR: bP,
  OPTIMIZING: MP,
  ESTIMATING: wP,
  SAVING: $P,
  RETURN_TO_TRUNKRS: HP,
  SET_ASIDE: VP,
  ATTENTION_MISSORT: BP,
  ATTENTION_MISSORT_MSG: GP,
  ATTENTION_SET_ASIDE_MSG: kP,
  STATE_CANCELED: xP,
  STATE_HAS_TOUR: FP,
  STATE_NO_TOUR: WP,
  STATE_EXPECTED: KP,
  NO_TOURS_YET: zP,
  START_OPTIMIZING: YP,
  OPTIMIZE_BTN: jP,
  ERROR_PAGE_TITLE: ZP,
  ERROR_PAGE_MESSAGE: XP,
  RELOAD_APP: qP,
  PACKAGES: QP,
  GO_TO_TOURS: JP,
  LOCK_TOURS: ey,
  LOCK_TOURS_MSG: ty,
  LOCK_TOURS_MSG_WAIT: ny,
  LOCK_TOURS_NOW: ry,
  NO_DRIVERS_ASSIGNED: oy,
  NO_DRIVERS_ASSIGNED_MSG: iy,
  GENERIC_ERROR_MSG: ay,
  WRONG_VERIFICATION_CODE: sy,
  DASHBOARD: cy,
  FETCH_TOUR_OVERVIEW: uy,
  NOT_SCANNED_AT_HUB: Ey,
  ON_ITS_WAY: ly,
  DELIVERED: _y,
  DELIVERED_TO_NEIGHBOUR: dy,
  NOT_DELIVERED: Ty,
  FEEDBACK_TITLE: fy,
  FEEDBACK_SUBTITLE: Sy,
  FEEDBACK_SUBTITLE_2: Ry,
  FEEDBACK_LABEL_NAME: Ny,
  FEEDBACK_LABEL_EMAIL: Oy,
  FEEDBACK_LABEL_COMMENTS: Iy,
  FEEDBACK_CLOSE_BTN: py,
  FEEDBACK_SUBMIT_BTN: hy,
  FEEDBACK_LABEL_SUCCESS: Ay,
  TOUR_OVERVIEW_PAGE_TITLE: gy,
  UPDATING_OVERVIEW: vy,
  LAST_UPDATED: Dy,
  FEEDBACK_SUCCESS: my,
  TODO_LIST: Ly,
  TITLE_TODO_LIST: Cy,
  TAB_LABEL_NOT_DELIVERED: Py,
  TAB_LABEL_NO_END_STATE: yy,
  TAB_LABEL_MISSORTED: Uy,
  TAB_LABEL_RETURNS: by,
  TAB_LABEL_DONE: My,
  BARCODE_TODO: wy,
  TIME_REMAINING: $y,
  DONE_COUNTER_TITLE: Hy,
  NON_DELIVERY_REASON: Vy,
  TODO_NOT_RETURNED: By,
  TODO_RETURNED: Gy,
  TODO_NO_PARCEL: ky,
  TODO_PARCEL_POSTPONE: xy,
  LATEST_STATUS: Fy,
  SHIPMENT_ACCEPTED_BY_DRIVER: Wy,
  CAUTION: Ky,
  CAUTION_CHANGE_DRIVER: zy,
  CHANGE_DRIVER: Yy,
  QUICK_TOURS_NO_TOURS_YET: jy,
  RETURNED_TRUNKRS: Zy,
  NOT_AT_DEPOT: Xy,
  MAX_FAILED_DELIVERY_ATTEMPT: qy,
  MAX_OUT_OF_FREEZER_TIME: Qy,
  BACK_INTO_PLANNING: Jy,
  LOAD_TODO: eU,
  SHIPMENT_COMMENT_TITLE: tU,
  SHIPMENT_COMMENT_TEXT: nU,
  SHIPMENT_COMMENT_PLACEHOLDER: rU,
  SHIPMENT_SCANNED_TITLE: oU,
  ADDRESS_NOT_FOUND: iU,
  BUSINESS_CLOSED: aU,
  BAD_ADDRESS: sU,
  DELIVERY_DAMAGED: cU,
  NO_TIME_LEFT_IN_TIMESLOT: uU,
  RECIPIENT_NOT_AT_HOME: EU,
  DRIVER_INVOLVED_IN_ACCIDENT: lU,
  REFUSED_BY_CUSTOMER: _U,
  EXTREME_WEATHER_CONDITIONS: dU,
  PARCEL_MISSING: TU,
  DELIVER_ADDRESS_NOT_ACCESSIBLE: fU,
  SHIPMENT_MISSING: SU,
  HEAVILY_DAMAGED: RU,
  TOO_HEAVY: NU,
  TOO_LARGE: OU,
  SHIPMENT_ADDRESS_HAS_CHANGED: IU,
  NEW_ADDRESS: pU,
  OLD_ADDRESS: hU,
  SHIPMENT_ADDRESS_CHANGED: AU,
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: gU,
  SHIPMENTS_ACCEPTED_BY_DRIVERS: vU,
  SHIPMENTS_WITH_END_STATE: DU,
  ALL_SHIPMENTS: mU,
  RESULTS: LU,
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: CU,
  WHICH_SHIPMENTS_HAVE_BEEN_SORTED_AT_REGIONAL_HUB: PU,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_SORTED_AT_REGIONAL_HUB: yU,
  WHICH_SHIPMENTS_HAVE_BEEN_ACCEPTED_BY_THEIR_DRIVERS: UU,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_ACCEPTED_BY_THEIR_DRIVERS: bU,
  WHICH_SHIPMENTS_HAVE_AN_END_STATE: MU,
  WHICH_SHIPMENTS_DO_NOT_HAVE_AN_END_STATE: wU,
  WHICH_SHIPMENTS_ARE_DELIVERED_TO_NEIGHBOURS: $U,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_DELIVERED: HU,
  CLEAR_FILTER: VU,
  TRANSFER_TO: BU,
  SUBCONTRACTOR: GU,
  FOSSIL: kU,
  ELECTRIC: xU,
  COLLECTIONS: FU,
  COLLECTION_TOUR: WU,
  TOUR_REMARK: KU,
  COLLECTION_DRIVER_PLACEHOLDER: zU,
  NO_DRIVER_ASSIGNED: YU,
  STOPS: jU,
  COLLECTION_TOUR_TITLE: ZU,
  ORDER_STOPS: XU,
  CLIENT_TITLE: qU,
  POSTAL: QU,
  PICKUP_TIME: JU,
  STOP_REMARK: eb,
  END: tb,
  LOCK_TITLE: nb,
  LOCK_DESCRIPTION: rb,
  LOCK_PLANNING_OWNER: ob,
  LOCK_PLANNING_TITLE: ib,
  PLANNING_FIXED: ab,
  CHOOSE_DRIVER: sb,
  LOCK_PLANNING_DESCRIPTION: cb,
  LOCK_PLANNING_DONE: ub,
  LOCK_PLANNING_SAVED: Eb,
  LOCK_SORTING_OWNER: lb,
  LOCK_SORTING_TITLE: _b,
  LOCK_SORTING_DESCRIPTION: db,
  LOCK_SORTING_DONE: Tb,
  LOCK_DRIVERS_OWNER: fb,
  LOCK_DRIVERS_TITLE: Sb,
  LOCK_DRIVER_DESCRIPTION: Rb,
  LOCK_DRIVER_DONE: Nb,
  LOCK_DRIVER_CTA: Ob,
  LOCK_BUTTON: Ib,
  PLANNING_NOT_READY_YET: pb,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_DRIVERS_AVAILABLE_IN: hb,
  INFORMATION: Ab,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_NEEDED_DRIVERS_WILL_BE_AVAILABLE_AT: gb,
  SEE_ESTIMATED_AMOUNT_OF_SHIPMENT_AND_DRIVERS_BELOW: vb,
  YOU_CAN_ACCESS_THE_PLANNING_WHEN_IT_IS_COMPLETED: Db,
  ESTIMATED_AMOUNT_OF_SHIPMENTS: mb,
  DRIVERS_YOU_WILL_PROBABLY_NEED: Lb,
  MARK_PLANNING_AS_DONE: Cb,
  MARK_PLANNING_AS_DONE_HOLDING: Pb,
  MARK_PLANNING_DONE: yb,
  PLANNING_MUST_BE_MARKED_AS_DONE: Ub,
  NO_COLLECTION_TOURS: bb,
  NO_COLLECTION_TOURS_DESC: Mb,
  PROCESSING: wb,
  CENTRAL_SORTING_DONE_ALERT: $b,
  WARNING: Hb,
  CENTRAL_SORTING_NOT_DONE_ALERT: Vb,
  FREEZER_MANAGEMENT: Bb,
  SCAN_FROZEN_SHIPMENT: Gb,
  EXPECTED_SHIPMENTS: kb,
  FROZEN_MANAGEMENT_ADDRESS: xb,
  FROZEN_MANAGEMENT_DRIVER: Fb,
  CURRENTLY_IN_THE_FREEZER: Wb,
  MERCHANT: Kb,
  IN_SINCE: zb,
  NEXT_STEP: Yb,
  BACK_INTO_DELIVERY: jb,
  BACK_TO_TRUNKRS: Zb,
  SHIPMENT_ADDED_TO_THE_FREEZER: Xb,
  SHIPMENT_NOT_ADDED_TO_THE_FREEZER: qb,
  SHIPMENT_OUT_OF_THE_FREEZER: Qb,
  RETURN_SHIPMENT: Jb,
  FROZEN_MANAGEMENT_NO_SHIPMENTS: eM,
  ADD_TO_NEW_TOUR: tM,
  DRIVER_PREF_LANG: nM,
  SAVE_DRIVER: rM,
  VEHICLE: oM,
  VEHICLE_TYPE: iM,
  SHOW_FULL_TOUR: aM,
  HIDE_TOUR: sM,
  OPTIMISE_TOUR: cM,
  REVERSE_TOUR: uM,
  COLOR_TOUR: EM,
  CHOOSE_TOUR_COLOUR: lM,
  COLOUR_PICK_CANCEL: _M,
  AMOUNT_OF_PACKAGES: dM,
  MOVE_TO_DIFFERENT_TOUR: TM,
  DE_SELECT_ALL: fM,
  SELECT_TOUR_TO_PRINT: SM,
  SELECT_TOUR_TO_PRINT_SUB_DESCRIPTION: RM,
  SELECT_PRINT_ALL: NM,
  SELECTED_PRINT: OM,
  PRINT_EXPORT: IM,
  PRINT_EXPORT_LOADING: pM,
  OPTIMIZATION_NOTIFICATION_HEADER: hM,
  OPTIMIZATION_NOTIFICATION_SUBTEXT: AM,
  OPTIMIZATION_NOTIFICATION_CONTACT_NO: gM,
  ADD_USER_TITLE: vM,
  ADD_USER_BUTTON: DM,
  ADD_USER_CREATE_BUTTON: mM,
  ADD_USER_CANCEL_BUTTON: LM,
  ADD_USER_CREATING_BUTTON: CM,
  ADD_USER_NAME_REQUIRED: PM,
  ADD_USER_LANGUAGE_REQUIRED: yM,
  ADD_USER_PHONE_REQUIRED: UM,
  PLANNER_PERMISSION: bM,
  PLANNER_PERMISSION_SUBTEXT: MM,
  ADD_USER_SUCCESS_MSG: wM,
  ADD_USER_SUCCESS_MSG_SUBTEXT: $M,
  ADD_USER_FULL_NAME: HM,
  ADD_USER_FULL_NAME_PLACEHOLDER: VM,
  ADD_USER_PREFERRED_LANGUAGE: BM,
  ADD_USER_PREFERRED_LANGUAGE_PLACEHOLDER: GM,
  ADD_USER_PREFERRED_PHONE_NUMBER: kM,
  ADD_USER_PREFERRED_PHONE_NUMBER_PLACEHOLDER: xM,
  EDIT_USER_TITLE: FM,
  SAVE_USER_BUTTON: WM,
  SAVING_USER_BUTTON: KM,
  EDIT_USER_SUCCESS_MSG_SUBTEXT: zM,
  USER_LIST_HEADER: YM,
  USER_LIST_TAB_ALL_EMPLOYEES: jM,
  USER_LIST_TAB_PLANNER: ZM,
  USER_LIST_TAB_INACTIVE: XM,
  USER_LIST_TAB_DELETED: qM,
  USER_LIST_TABLE_EMPLOYEE_NAME: QM,
  USER_LIST_TABLE_ROLE: JM,
  USER_LIST_TABLE_PHONE_NUMBER: ew,
  USER_LIST_TABLE_STATUS: tw,
  USER_LIST_TABLE_MANAGE_EMPLOYEE: nw,
  USER_LIST_TABLE_ROLE_PLANNER: rw,
  USER_LIST_TABLE_ROLE_DRIVER: ow,
  USER_LIST_TABLE_ROLE_DELETED: iw,
  USER_LIST_TABLE_ACTIVE: aw,
  USER_LIST_TABLE_INACTIVE: sw,
  USER_LIST_MENU_OPTIONS: cw,
  USER_LIST_MENU_EDIT_USER: uw,
  USER_LIST_MENU_DELETE_USER: Ew,
  NO_USERS_FOUND: lw,
  NO_USERS_FOUND_MSG: _w,
  DELETE_USER_SUBTEXT: dw,
  DELETE_USER_TITLE: Tw,
  LONGPRESS_DELETE_USER: fw,
  LONGPRESS_DONE: Sw,
  DELETE_USER_SUCCESS_MSG_SUBTEXT: Rw,
  EMPLOYEES: Nw,
  EDIT_PHONE_NUMBER_WARNING: Ow,
  HOW_MANY_DRIVERS: Iw,
  CREATE_TOURS: pw,
  SWITCH_POWER_MODE_TITLE: hw,
  SWITCH_POWER_MODE_BODY: Aw,
  SWITCH_POWER_MODE_BTN: gw,
  LITE_MODE: vw,
  POWER_MODE: Dw,
  PLAN_MODE: mw,
  LITE_SAVE_TOURS: Lw,
  LITE_RE_OPTIMIZE: Cw,
  LITE_TOURS_TABLE_TOUR: Pw,
  LITE_TOURS_TABLE_DEPARTURE: yw,
  LITE_TOURS_TABLE_LAST_STOP: Uw,
  LITE_TOURS_TABLE_SHIPMENTS: bw,
  LITE_TOURS_TABLE_DRIVER: Mw,
  LITE_TOURS_TABLE_VEHICLE_TYPE: ww,
  LITE_DEFAULT_HEADER: $w,
  LITE_DEFAULT_SUB_DETAILS: Hw,
  LITE_CREATE_TOURS: Vw,
  LITE_NUMBER_OF_TOURS_CREATED: Bw,
  LITE_SELECT_DRIVER: Gw,
  LITE_SHOW_TOUR: kw,
  LITE_TOUR_STOP_TABLE_STOP: xw,
  LITE_TOUR_STOP_TABLE_STREET: Fw,
  LITE_TOUR_STOP_TABLE_POSTAL_CODE: Ww,
  LITE_TOUR_STOP_TABLE_CITY: Kw,
  LITE_TOUR_STOP_TABLE_COLLI_COUNT: zw,
  LITE_TOUR_STOP_TABLE_ETA: Yw,
  LITE_NOTIFICATION_MESSAGE_NOT_DONE_BEFORE_TIME: jw,
  LITE_NOTIFICATION_MESSAGE_OPTIMIZATION_FAILURE: Zw,
  NO_TOURS_POWER_TEXT: Xw,
  NO_TOURS_POWER_BODY: qw,
  LITE_AUTO_COMPLETE_DRIVER_NOT_FOUND: Qw,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_NOT_STARTED: Jw,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_IS_DONE: e$,
  LITE_RELOAD: t$,
  CREATING_TOURS: n$,
  DO_NOT_LEAVE_PAGE: r$,
  LAST_UPDATE: o$,
  USE_PREVIOUS_OPTIMIZATION: i$,
  USE_ROUTIFIC_V2: a$,
  HIDE_TOUR_TOOLTIP: s$,
  UNHIDE_TOUR_TOOLTIP: c$,
  OPTIMIZATION_RESULT_ERROR_TITLE: u$,
  OPTIMIZATION_RESULT_ERROR_DESC_1: E$,
  OPTIMIZATION_RESULT_ERROR_DESC_2: l$,
  OPTIMIZATION_RESULT_ERROR_DESC_3: _$,
  OPTIMIZATION_RESULT_ERROR_DESC_4: d$,
  OPTIMIZATION_RESULT_ERROR_SUPPORT_TEL: T$,
  OPTIMIZATION_RESULT_SUCCESS_TITLE: f$,
  OPTIMIZATION_RESULT_SUCCESS_DESC_1: S$,
  OPTIMIZATION_RESULT_SUCCESS_DESC_2: R$,
  OPTIMIZATION_RESULT_SUCCESS_DESC_3: N$,
  OPTIMIZATION_RESULT_BUTTON_RUN_AGAIN: O$,
  OPTIMIZATION_RESULT_BUTTON_ACCEPT: I$,
  OPTIMIZATION_RESULT_BUTTON_RE_OPTIMIZE: p$,
  OPTIMIZATION_RESULT_OVERFLOW_DESC: h$,
  SIDEBAR_HUB_INVENTORY: A$,
  SIDEBAR_RETURNS_SCAN: g$,
  SIDEBAR_RETURNS_SCAN_NOT_AVAILABLE_TOOLTIP: v$,
  HUB_INVENTORY: D$,
  RETURNS_SCAN: m$,
  SHIPMENT_STATES: L$,
  USERS: C$,
  TOTAL_DISTANCE: P$,
  BERMUDA_TEXT_NOTIFICATION: y$,
  BERMUDA_TEXT_MORE_INFO: U$,
  BERMUDA_TEXT_CALLOUT: b$,
  GLOBAL_NOTIFICATIONS: M$,
  SHIPMENTS_OVERVIEW: w$,
  PLANNING_TIMELINE: $$,
  EMPTY_SCREENS: H$,
  NAVIGATE_TO_TRACT_N_TRACE: V$,
  LOGIN_DESCRIPTION: B$,
  PHONE_NUMBER_IS_REQUIRED: G$,
  PHONE_NUMBER_ERROR: k$,
  SENT_CODE_TO: x$,
  RESENT_CODE: F$,
  VERIFY_AND_LOGIN: W$,
  HANDOVER_TOUR_PLANNING_CARD_DESCRIPTION: K$,
  HANDOVER_ASSIGN_DRIVERS_CARD_DESCRIPTION: z$,
  HANDOVER_CHANGE_DRIVER_FOR_CART: Y$,
  HANDOVER_CURRENT_DRIVER: j$,
  INVALID_PHONE_NUMBER: Z$,
  PARTNER_PROFILE: X$,
  NO_ACTIVE_TOURS_YET: q$,
  SEE_MORE_STOPS: Q$,
  SEE_LESS_STOPS: J$,
  CREATE_AND_EDIT_TOURS: e1,
  PROCEED_TO: t1,
  GO_BACK_TO: n1,
  OVERVIEW: r1,
  SPEED: o1,
  THIS_FIELD_IS_REQUIRED: i1
}, s1 = "Laden...", c1 = "login", u1 = "email", E1 = "wachtwoord", l1 = "verkeerde gegevens", _1 = "controleer uw gegevens", d1 = "haal pakketten op", T1 = "herladen", f1 = "volgende", S1 = "terug", R1 = "Ga terug", N1 = "Bevestig", O1 = "annuleren", I1 = "sluiten", p1 = "Scan de barcode om het pakket te handoveren", h1 = "full screen", A1 = "route", g1 = "routes", v1 = "We zijn voor je bezig", D1 = "Het systeem probeert altijd de beste route te vinden", m1 = "Maar jij bent de expert!", L1 = "chauffeur", C1 = "aantal pakketten", P1 = "Chauffeur en voertuig...  ", y1 = "opslaan", U1 = "planning opslaan", b1 = "Sla {{ networkType }} planning op", M1 = "Inschakelen", w1 = "Uitschakelen", $1 = "naam", H1 = "locatie", V1 = "postcode", B1 = "adres", G1 = "straat", k1 = "nummer", x1 = "stad", F1 = "lat", W1 = "lng", K1 = "land", z1 = "Nederland", Y1 = "Duitsland", j1 = "Telefoonnummer", Z1 = "Telefoonnummer is niet geregistreerd", X1 = "Opmerkingen", q1 = "Pakketten", Q1 = "pakket", J1 = "geocode fout", eH = "-", tH = "handover", nH = "verplaats naar een andere route", rH = "duur", oH = "Startijd", iH = "Vertrek", aH = "Optimaliseren", sH = "Maak nieuwe tours", cH = "Plan nieuwe {{ networkType }} routes", uH = "Plan routes voor {{ networkType }}", EH = "optimalisatie opties", lH = "pas optimalisatie aan", _H = "ga", dH = "rijsnelheid", TH = "sneller", fH = "snel", SH = "normaal", RH = "langzaam", NH = "heel langzaam", OH = "Openeind routes", IH = "selecteer alles", pH = "Handover klaar", hH = "Uitloggen", AH = "wachtwoord herstellen", gH = "route toevoegen", vH = "filter routes", DH = "optimaliseer route", mH = "Printen", LH = "positie", CH = "tijd", PH = "handtekening", yH = "code", UH = "profiel", bH = "profiel aanpassen", MH = "chauffeurs", wH = "chauffeur aanpassen", $H = "chauffeur toevoegen", HH = "wachtwoord wijzigen", VH = "huidige wachtwoord", BH = "nieuw wachtwoord", GH = "nieuw wachtwoord herhalen", kH = "Wachtwoord is incorrect", xH = "Uw huidige wachtwoord is incorrect", FH = "Wachtwoord te kort", WH = "Het nieuwe wachtwoord moet minstens 8 characters bevatten", KH = "Wachtwoord gewijzigd", zH = "Uw wachtwoord is gewijzigd. U kunt voortaan inloggen met uw nieuwe wachtwoord.", YH = "Wachtwoorden komen niet overeen", jH = "Uw opgegeven wachtwoorden komen niet overeen.", ZH = "Formulier incompleet", XH = "Vul aub alle velden in.", qH = "Wijzigingen opgeslagen", QH = "U profiel is aangepast.", JH = "Foutmelding", e0 = "Er is iets fout gegaan bij het opslaan. Herlaad de pagina en probeer opnieuw.", t0 = "Opslaan routes mislukt!", n0 = "Er is iets fout gegaan bij het opslaan. Herlaad de pagina en probeer opnieuw.", r0 = "chauffeur toegevoegd", o0 = "nieuwe chauffeur is succesvol aangemaakt", i0 = "ongeldig e-mail adres", a0 = "het opgegeven e-email adres in ongeldig", s0 = "Het opgegeven email adres is niet gekoppeld aan een account", c0 = "Uw wijzigingen zijn nog niet opgeslagen, wilt u de wijzigingen nu opslaan?", u0 = "Er staan nieuw pakketten klaar die nog niet worden meegenomen in de geplande route. Optimaliseer de route nogmaals.", E0 = "Verkeer", l0 = "Minimum aantal stops", _0 = "Routes gelijk trekken", d0 = "Zo min mogelijk chauffeurs", T0 = "Eind", f0 = "Laatste stop", S0 = "Productiviteit", R0 = "Totale duur", N0 = "Wijzig kleur", O0 = "Weet u zeker dat u dit pakket wil annuleren?", I0 = "Ja", p0 = "Nee", h0 = "Verstuur email", A0 = "Vul uw E-mail adres in en wij verzenden u een nieuw wachtwoord.", g0 = "Wij hebben u een nieuw wachtwoord gestuurd. Nadat u bent ingelogged, met uw nieuwe wachtwoord, kunt u uw wachtwoord wijzigen op uw profiel pagina.", v0 = "Route bewerken", D0 = "Sluiten", m0 = "Nieuwe update!", L0 = "Neem even de tijd om te kijken wat er nieuw is", C0 = "Multicolli indicatie", P0 = "Multicolli zendingen worden nu aangegeven op de kaart met een sterretje op de pin. Door op de pin te klikken kunt u zien om hoeveel zendingen het gaat. Om alle zendingen tegelijk te verplaatsten kunt u nu de rechtermuis-knop functie gebruiken.", y0 = "", U0 = "", b0 = "", M0 = "", w0 = "Feedback?", $0 = "Wij zijn continu de Plannr app aan het verbeteren om het plannen zo gebruiksvriendelijk mogelijk te maken. Heeft u opmerkingen of speciale wensen, dan horen we dat graag. U kunt dan een e-mail sturen naar wietse@trunkrs.nl.", H0 = "Welkom bij de Plannr app!", V0 = "Neem even de tijd om te kijken wat de app allemaal kan en hoe het uw productiviteit kan maximaliseren.", B0 = "Pakketten overzicht", G0 = "Bekijk alle pakketten van vandaag en wijzig of annuleer ze indien nodig.", k0 = "Route planner", x0 = "Gebruik onze route planner om de beste routes te berekenen en pas ze zonodig aan.", F0 = "Handover", W0 = "Voer de handover handmatig uit of gebruik de barcode scanner om het proces te automatiseren door het pakket te scannen.", K0 = "Probeer het eens!", z0 = "Tijd om de app te verkennen! Als er vragen zijn kan je contact met ons opnemen middels de live chat, rechts-onder in beeld.", Y0 = "The cut off tijd in nog niet bereikt, dus u zou nog pakketten kunnen ontvangen.", j0 = "Geen pakketten beschikbaar", Z0 = "Alle pakketten zijn overgedragen", X0 = "De handover is al begonnen.", q0 = "Als u opnieuw de optimalisatie uitvoert, worden alle vorige wijzigingen overschreven. U kunt ook individuele routes optimaliseren door op het tandwiel te klikken. Weet u zeker dat u door wil gaan?", Q0 = "Waarschuwing: Uw routes zijn opgeslagen, maar nog niet alle routes hebben een chauffeur.", J0 = "Gebruik een ander email adres", eV = "Dit email adres is al toegewezen aan een andere chauffeur", tV = "Zoom door scroll", nV = "Cluster pakketten", rV = "instructies", oV = "Bekijk de onderstaande video om een indruk te krijgen van de Plannr app.", iV = "Update", aV = "Bekijk de onderstaande video om te zien wat er bij de laatste update is toegevoegd aan de app.", sV = "Bekijk de laatste update video (engelstalig)", cV = "de Plannr app is geüpdatet. Klik hier om te zien wat er is veranderd!", uV = "Kar", EV = "Bevestiging", lV = "Begin met scannen", _V = "U bent nu klaar voor de overdracht", dV = "Overdracht resetten", TV = "Je staat op het punt om de handover terug te draaien. Dit betekent dat je alle pakketten die je tot nu toe gescand hebt opnieuw zal moeten scannen op route.", fV = "Let op!", SV = "Wijzig chauffeurs", RV = "U heeft de chauffeurs succesvol gewijzigd", NV = "De routes zijn succesvol toegewezen aan de nieuw gekozen chauffeurs", OV = "Foutieve sortering", IV = "Het pakket dat je gescanned hebt is van een andere regio. Graag het pakket terug sturen naar Vianen.", pV = "MISSORT", hV = "Deze zending hoort bij", AV = "De regio: ", gV = "A.u.b. dit pakket naar de centrale hub in Vianen retourneren", vV = "Onbekend gebied", DV = "Hoeveel chauffeurs wil je gebruiken?", mV = "Annuleer gemarkeerde zendingen", LV = "Let Op!", CV = "Terug", PV = "Annuleer zendingen", yV = "Draai handover terug", UV = "Actief", bV = "Bevestig routeplanning", MV = "Je staat op het punt om de routeplanning te bevestigen. Deze actie is onomkeerbaar!", wV = "Ga door als je zeker weet dat je tevreden bent met de routeplanning.", $V = "Ik begrijp het, vraag mij dit voortaan niet meer.", HV = "Route Bevestigd", VV = "ONGEDAAN MAKEN", BV = "Code versturen", GV = "Routes opgeslagen", kV = "De routes zijn succesvol opgeslagen. Mocht je ze toch nog willen wijzigen, dan kun je op 'Routes Bewerken' klikken. Wil je verder naar de handover? Dan kun je op 'Planning Definitief Maken' klikken.", xV = "Route Bewerken", FV = "Route Definitief Maken", WV = "De routes zijn succesvol opgeslagen. Je hebt alleen nog geen (of niet op alle routes) chauffeurs gekozen. Klik hier onder op de knop om je chauffeurs te kiezen en de routes op te slaan.", KV = "Planning compleet", zV = "De planning is compleet. Je kunt nu verder naar het handover scherm om de zendingen te sorteren. Als je vragen hebt kun je contact opnemen met het Trunkrs Operations team.", YV = "Ongeldig nummer", jV = "Moet een geldig mobiel nummer zijn (incl. +31)", ZV = "Upload fout", XV = "Er is iets mis gegaan bij het uploaden", qV = "Opslaan mislukt", QV = "Het opslaan van de chauffeur is mislukt", JV = "Geen chauffeurs toegevoegd", eB = "Je hebt nog geen chauffeurs toegevoegd", tB = "Subco Pofiel", nB = "Verplaats naar", rB = "Optimaliseren...", oB = "Updaten...", iB = "Opslaan...", aB = "RETOUR AAN TRUNKRS", sB = "OPZIJ ZETTEN!", cB = "Let op", uB = "Deze zending is in de verkeerde regio, retourneer de zending zo snel mogelijk aan Trunkrs.", EB = "Deze zending hoort niet bij de tours voor vandaag", lB = "Geannuleerd", _B = "Toegewezen aan route", dB = "Open", TB = "Verwacht", fB = "Nog geen routes bekend", SB = "Start optimalisatie", RB = "Optimaliseren", NB = "O Jee! Wacht Even!", OB = "Het lijkt dat er op dat de planner niet meer reageert. Geen zorgen, even herladen en je bent terug waar je was.", IB = "Planner Herladen", pB = "Pakketten", hB = "Ga naar routes", AB = "Routes permanent maken", gB = "De routes zijn nog niet permanent, maak ze permanent om verder te kunnen", vB = "Routes worden permanent gemaakt ...", DB = "Maak permanent", mB = "Nog geen chauffeurs", LB = "De routes zijn nog niet (allemaal) voorzien van chauffeurs", CB = "Sorry, er is iets misgegaan, probeer het later opnieuw.", PB = "Verkeerde verificatiecode. Probeer het opnieuw.", yB = "Route voortgang", UB = "Touroverzicht ophalen", bB = "niet gescand op hub", MB = "onderweg", wB = "geleverd", $B = "geleverd aan buurman", HB = "niet geleverd", VB = "Oeps, het lijkt er op dat er iets fout is gegaan.", BB = "Het Trunkrs team is op de hoogte gebracht.", GB = "Als je ons wilt helpen, vertel precies wat er gebeurde.", kB = "Je naam", xB = "Je email", FB = "Omschrijf zo precies mogelijk wat er gebeurde voor de crash.", WB = "Sluiten", KB = "Verzenden", zB = "Je feedback is verzonden. Dank je wel voor je hulp bij het verbeteren van de Planner.", YB = "Tour voortgang", jB = "Overzicht wordt geupdated...", ZB = "Pas op", XB = "Je staat op het punt om de chauffeur voor deze route te wijzigen. Als de huidige chauffeur al onderweg is, zal zijn app hierna leeg zijn en kan hij niet verder. Deze tour zal na de wijziging (in de facturering en cijfers) toe worden gewezen aan de nieuwe chauffeur. Wij zijn niet in staat om dit op een later moment terug te draaien. Weet je zeker dat de chauffeur wilt veranderen? Zo ja kies hieronder dan de nieuwe chauffeur.", qB = "Wijzig de chauffeur", QB = "Er is hier niets te zien", JB = "Pakket terug naar Trunkrs", eG = "Pakket niet op depot", tG = "Max. Bezorgpogingen bereikt", nG = "Max bereikt buiten vriestijd", rG = "Pakket terug in planning", oG = "Laden Todos...", iG = "Pakket niet op depot", aG = "Geeft alsjeblieft meer informatie over de locatie van dit pakket en waarom het niet op het depot is.", sG = "Schrijf hier je uitleg...", cG = "Gescanned pakket", uG = "To Do List", EG = "To Do List", lG = "Niet afgeleverd", _G = "Geen eindstatus", dG = "Missorts", TG = "geeft terug", fG = "Verwerkt", SG = "Scan barcode om het pakket te verwerken", RG = "Tijd over", NG = "Verwerkt", OG = "Reden niet afgeleverd", IG = "Niet terug", pG = "Pakket terug", hG = "Pakket niet op depot", AG = "Pakket op depot", gG = "Laatste Status", vG = "Verzendadres is gewijzigd!", DG = "Nieuw adres", mG = "Oud adres", LG = "Dit adres is gewijzigd!", CG = "Geaccepteerd door driver", PG = "Adres niet gevonden", yG = "Zakelijk adres gesloten", UG = "Niet kloppend adres", bG = "Pakket beschadigd", MG = "Geen tijd over in route", wG = "Ontvanger niet thuis", $G = "Chauffeur in ongeluk", HG = "Geweigerd door ontvanger", VG = "Weersomstandigheden", BG = "Pakket missend", GG = "Adres ontoegankelijk", kG = "Pakket missend", xG = "Zwaar beschadigd", FG = "Pakket te zwaar", WG = "Pakket te groot", KG = "Zendingen gesorteerd op regionale hub", zG = "Zendingen geaccepteerd door chauffeurs", YG = "Zendingen met eindstatus", jG = "Buurlevering versus niet-levering", ZG = "Alle zendingen", XG = "Resultaten", qG = "Welke zendingen zijn gesorteerd op regionale hub?", QG = "Welke zendingen zijn NIET op regionale hub gesorteerd?", JG = "Welke zendingen zijn geaccepteerd door hun chauffeurs?", ek = "Welke zendingen zijn NIET geaccepteerd door hun chauffeurs?", tk = "Welke zendingen hebben een eindstaat?", nk = "Welke zendingen hebben GEEN eindstaat?", rk = "Welke zendingen worden afgeleverd bij buren?", ok = "Welke zendingen zijn niet geleverd?", ik = "Filter wissen", ak = "Overzetten naar", sk = "Nog niet klaar voor de handover", ck = "Voordat de handover kan beginnen, moeten de volgende stappen doorlopen worden:", uk = "Trunkrs", Ek = "Planning", lk = "Planning staat vast", _k = "Kies hieronder je chauffeurs en ga naar de handover pagina.", dk = "De planning moet worden bewaard, zodat we ervoor kunnen zorgen dat de tours die u heeft gemaakt de tours zijn die uw chauffeurs vanavond rijden.", Tk = "De planning is klaar!", fk = "De planning is opgeslagen!", Sk = "Trunkrs", Rk = "Centrale sortering", Nk = "De centrale sortering moet worden afgerond voordat je de routes permanent kan maken. Op deze manier weten we zeker dat alle zendingen mee gaan.", Ok = "De centrale sortering is klaar!", Ik = "Jij", pk = "Chauffeurs toewijzen", hk = "Zodra je de chauffeurs hebt toegewezen en de centrale planning compleet is, kun je de routes permanent maken.", Ak = "De chauffeurs zijn toegewezen!", gk = "Wijs chauffeurs toe aan routes", vk = "Maak de tours permanent en start de handover", Dk = "Fossiele brandstof", mk = "Elektrisch", Lk = "Subcontractor", Ck = "Collectie routes", Pk = "Route {{ number }}", yk = "Opmerking route", Uk = "Selecteer een driver", bk = "Geen driver toegewezen.", Mk = "Stops", wk = "Route overzicht", $k = "Volgorde stops", Hk = "Klant naam", Vk = "postcode", Bk = "Ophaal tijd", Gk = "Opmerking stops", kk = "Einde", xk = "Planning nog niet klaar!", Fk = "Geschat aantal zendingen en chauffeurs beschikbaar in", Wk = "Informatie", Kk = "Het geschatte aantal zendingen en benodigde chauffeurs zijn beschikbaar op", zk = "Het lijkt erop dat de planning nog niet klaar is. Voor uw gemak vindt u hieronder het geschatte aantal zendingen en de stuurprogramma's die u nodig hebt.", Yk = "U hebt toegang tot de planning wanneer deze is voltooid", jk = "Geschat aantal zendingen", Zk = "Stuurprogramma's die u waarschijnlijk nodig zult hebben", Xk = "Planning voltooien", qk = "Houd 3 seconden ingedrukt om te voltooien", Qk = "Planning voltooid", Jk = "Chauffeurs kunnen worden toegewezen wanneer de planning klaar is.", ex = "Geen collectie routes", tx = "Er zijn nog geen collectie routes aan je toegewezen.", nx = "Het centrale sorteerproces is nu klaar. Laad opnieuw om te beginnen met plannen.", rx = "WAARSCHUWING", ox = "Het centrale sorteerproces is nog niet gestart. Tot die tijd kun je wijzigingen nog niet opslaan.", ix = "Vriezer Management", ax = "Voeg zendingen toe aan de vriezer of verwijder deze...", sx = "VERWACHTE ZENDINGEN", cx = "Adres", ux = "Driver", Ex = "MOMENTEEL IN DE VRIEZER", lx = "Verzender", _x = "In sinds", dx = "Volgende stap", Tx = "Terug in proces", fx = "Retour naar Trunkrs", Sx = "Zending toegevoegd in de vriezer. Brrrr, koud.", Rx = "Oeps, deze zending hoort niet in de vriezer thuis!", Nx = "Zending verwijderd uit de vriezer, houd 'm vers!", Ox = "Retourneer deze zending naar Trunkrs!", Ix = "Geen zendingen", px = "+ Toevoegen aan nieuwe tour", hx = "Voorkeurstaal van de bestuurder", Ax = "Bewaar stuurprogramma", gx = "Voertuig", vx = "Voertuigtype", Dx = "Bekijk route", mx = "Route verbergen", Lx = "Route optimaliseren", Cx = "Route omdraaien", Px = "Route kleur", yx = "Kies route kleur", Ux = "Sluiten", bx = "pakketten", Mx = "Verplaats naar andere route", wx = "Alles de-selecteren", $x = "Kies een route om te printen", Hx = "Je kan meer dan 1 route selecteren", Vx = "Alles selecteren", Bx = "Geselecteerd", Gx = "Exporteer", kx = "We zijn aan het exporteren...", xx = "Niet alle stops zijn geoptimaliseerd", Fx = "Wegens een technische fout hebben we niet alle stops kunnen optimaliseren. Bel Trunkrs om dit opgelost te krijgen.", Wx = "085 060 1410", Kx = "Werknemer toevoegen", zx = "Werknemer toevoegen", Yx = "Voeg toe", jx = "Sluiten", Zx = "Toevoegen", Xx = "Naam is vereist", qx = "Taalvoorkeur is vereist", Qx = "Telefoonnummer is vereist", Jx = "Planner toegang", e2 = "Wanneer je dit selecteert, krijgt de gebruiker toegang tot de planner.", t2 = "BRAVO!", n2 = "We hebben de nieuwe werknemer aangemaakt.", r2 = "Volledige naam", o2 = "Jan Jansen", i2 = "Taalvoorkeur", a2 = "Kies taal", s2 = "Telefoonnummer", c2 = "+316", u2 = "Verwijder gebruiker", E2 = "Bewerk gebruikersgegevens", l2 = "Bewerk gebruiker", _2 = "Wijzigingen opslaan", d2 = "Wijzigingen opslaan", T2 = "Je hebt de medewerker succesvol geüpdatet.", f2 = "Werknemers", S2 = "Alle werknemers", R2 = "Planners", N2 = "Inactief", O2 = "Verwijderd", I2 = "Naam", p2 = "Functie", h2 = "Telefoonnummer", A2 = "Status", g2 = "Gegevens aanpassen", v2 = "Planner, Chauffeur", D2 = "Chauffeur", m2 = "Verwijderd", L2 = "Actief", C2 = "Inactief", P2 = "Opties", y2 = "Gegevens aanpassen", U2 = "Verwijder werknemer", b2 = "Niets gevonden", M2 = "Er zijn geen werknemers die voldoen aan deze categorie", w2 = "U kunt deze actie niet ongedaan maken.", $2 = "Verwijder gebruiker?", H2 = "Verwijderen (3sec indrukken)", V2 = "Verwijderen...", B2 = "{{EMP_NAME}}'s profiel is verwijderd", G2 = "Werknemers", k2 = "Als u het telefoonnummer wijzigt, moet de medewerker uitloggen en opnieuw inloggen om zijn chauffeurapp en / of planner-app goed te laten werken.", x2 = "Hoeveel chauffeurs?", F2 = "Creëer routes", W2 = "Plan nieuwe {{ networkType }} routes", K2 = "Plan optimale routes voor {{ networkType }}.", z2 = "Voordat je overstapt", Y2 = "Overschakelen naar de power modus met dit aantal zendingen kan resulteren in een zeer trage of zelfs onmogelijke reisplanning. Weet u zeker dat u naar de power modus wilt overschakelen?", j2 = "Overschakelen", Z2 = "Lite", X2 = "Power", q2 = "Plan-modus", Q2 = "Planning opslaan", J2 = "Maak nieuwe routes", eF = "Route", tF = "Starttijd", nF = "Laatste stop", rF = "Pakketten", oF = "Chauffeur", iF = "Voertuig", aF = "Lite Mode", sF = "Creëer routes vanaf elk systeem, ongeacht de hoeveelheid zendingen.", cF = "Creëer routes", uF = "routes zijn gemaakt.", EF = "Chauffeur en voertuig...", lF = "Toon route", _F = "Stop", dF = "Straat + Huisnummer", TF = "Postcode", fF = "Stad", SF = "Colli", RF = "Aankomsttijd", NF = "Niet alle routes zijn klaar voor 22:00", OF = "Niet alle stops zijn geoptimaliseerd. Bel Trunkrs om dit op te lossen.", IF = "Power Mode", pF = "Creëer de ultieme routes, tot de laatste detail", hF = "Chauffeur niet gevonden", AF = "Het centrale sorteerproces is nog niet gestart. Tot die tijd kun je wijzigingen nog niet opslaan.", gF = "Het centrale sorteerproces is klaar, herlaad de pagina a.u.b.", vF = "Herladen", DF = "Routes maken", mF = "Verlaat of refresh de pagina niet", LF = "Laatste update", CF = "Gebruik indien mogelijk de vorige optimalisatie?", PF = "Nieuwe (snellere) optimalisatie gebruiken?", yF = "Verberg route op kaart", UF = "Toon route op kaart", bF = "Er is een fout opgetreden tijdens het optimaliseren", MF = "Opnieuw optimaliseren kan dit probleem oplossen", wF = "Wil je opnieuw optimaliseren?", $F = "Er is iets mis gegaan, we kunnen geen routes maken.", HF = "Neem contact op met Trunkrs via jullie slack kanalen", VF = "", BF = "Optimalisatie resultaten", GF = "Optimalisatie tijd:", kF = "Hoeveelheid chauffeurs geselecteerd:", xF = "Overflow routes gecreëerd:", FF = "Probeer opnieuw", WF = "Accepteren", KF = "Opnieuw optimaliseren", zF = "Overflow-tours zijn het gevolg van het feit dat er niet genoeg chauffeurs zijn toegewezen. U kunt dit oplossen door opnieuw te optimaliseren met meer chauffeur.", YF = "Hub Inventaris", jF = "Retour Scan", ZF = "De Retour Scan is alleen beschikbaar tussen 03:00 en 14:00.", XF = {
  TITLE: "Hub Inventaris",
  TRUNKRSNR: "TrunkrsNr",
  ADDRESS: "Adres",
  LAST_DRIVER: "Laatste Chauffeur",
  INTENDED_DELIVERY_DATE: "Originele afleverdatum",
  IN_SINCE: "Op depot sinds",
  STATUS: "Status",
  EMPTY_TITLE: "Niets te zien hier!",
  EMPTY_DESC: "Blijf kalm, drink een kopje koffie, en herlaad deze pagina.",
  RELOAD_BUTTON: "Herlaad pagina"
}, qF = {
  TITLE: "Retour Scan",
  SCAN_INPUT_PLACEHOLDER: "Scan alle zendingen op de hub",
  AT_REGIONAL_HUB: "Momenteel op hub",
  KEEP_IN_REGION: "Blijft op hub",
  BACK_TO_TRUNKRS: "Retour naar Trunkrs",
  AT_REGIONAL_HUB_PLACEHOLDER: "Je bent klaar met scannen, zorg er voor dat de zendingen op de juiste bestemming aankomen.",
  KEEP_ON_HUB_PLACEHOLDER: "Scan eerst een van de zendingen op de hub",
  BACK_TO_TRUNKRS_PLACEHOLDER: "Scan eerst een van de zendingen op de hub",
  BUTTON_CONFIRM_RETURNS: "Bevestig retouren",
  LAST_DRIVER: "Laatste Chauffeur",
  ADDRESS: "Adres",
  SENDER: "Verzender",
  ERROR: "FOUT",
  SCAN_ERROR_TITLE: "Zending kan niet worden verwerkt.",
  SCAN_ERROR_DETAILS: "Neem contact op met Trunkrs voordat je doorgaat.",
  SCAN_UNSCANNABLE_TITLE: "Zending reeds gemarkeerd als 'niet scanbaar'.",
  RETURNED_SCAN_SUCCESS: "Deze zendingen zijn succesvol geretourneerd.",
  SUCCESS_CALLOUT: "You have successfully returned all these shipments to Trunkrs.",
  CONFIRMED_RETURNS: "Confirmed returns!",
  APOLOGIES: "Apologies!",
  ACKNOWLEDGEMENT: {
    TITLE: "Retouren Bevestigen",
    DESCRIPTION: "Hierbij bevestig ik dat deze zendingen geretourneerd worden aan Trunkrs en dat de chauffeur die deze zending retourneert vanaf nu verantwoordelijk is.",
    CONFIRM: "Bevestig",
    BACK: "Ga terug",
    WARNING: "Let op! Je hebt nog niet alle zendingen op je hub gescand, weet je zeker dat door wil gaan?"
  },
  OWNERSHIP: "Eigenaar",
  ACTIONS: "Acties",
  SHIPMENT_DETAILS: "Details van de verzending",
  REASON: "Reden",
  OTHER_REASON: "Andere reden",
  ADDITIONAL_REASON: "Aanvullende reden",
  NOT_AT_REGIONAL_HUB: "Niet op het regionale depot",
  TAG_AS_NOT_SCANNABLE: "Als 'niet scanbaar' gemarkeerd",
  UNSCANNABLE_DESC: "Selecteer hieronder de reden voor het ontbreken van de zending op de locatie waardoor het niet mogelijk is deze te scannen.",
  UNSCANNANBLE_REASON_CODES: {
    SHIPMENT_WITH_DRIVER_DELAYED: "Zending is nog bij chauffeur en komt vandaag niet terug op depot",
    SHIPMENT_WITH_DRIVER_NOT_DELAYED: "Zending is nog bij chauffeur en is nog voor 17:00 terug op depot",
    SHIPMENT_LOST: "Zending is zoekgeraakt",
    FALSELY_MARKED_NOT_DELIVERED: "Zending is toch geleverd",
    DAMAGED_LABEL: "De barcode/label van de zending is niet leesbaar/scanbaar",
    SHIPMENT_MISSING: "Zending is vermist"
  },
  CAUTION_PROCEED_NEXT: "U staat op het punt om naar de volgende stap van het planningsproces te gaan, alhoewel de 'Voorraadscan' nog niet is voltooid. U kunt nog steeds terug naar de Voorraadscan, maar wees attent dat vanaf [DATE] het onmogelijk is om het planningsproces te vervolgen zonder de voorraadscan compleet af te ronden.",
  CAUTION_PROCEED_TO_OTHER_STEP: "Vervolg naar andere stap",
  SUCCESS: "Succesvol",
  TOAST_DESC: "Zending {{ trunkrsNr }} verplaatst naar 'Niet op regionale depot'",
  SELECT_ONE: "Kies een",
  MORE_DETAILS: "Meer details",
  RETURN_TODAY_TO: "U kunt dit vandaag nog terugsturen naar",
  COLLECTION_OPT_ID: "Verzamelingsoptimalisatie-ID:",
  COLLECTION_TOUR_TAG: "Collectie Tour Tag:",
  NO_COLLECTION_TODAY: "U heeft vandaag geen incasso voor <b>{{merchantName}}</b>. Uw volgende incasso is op <b>{{day}}</b> met Incasso-optimalisatie-ID: <b>{{optimizationId}}</b> en Tour Tag: <b>{{tourTag}}</b>",
  FOR_RETURN_TO_SENDER: "Voor retour naar afzender",
  LOADING: `Scannen.
Even geduld aub..`,
  DETAILS: {
    SHIPMENT_DETAILS: "Verzendingsdetails",
    INTENDED_DELIVERY_DATE: "Beoogde leverdatum"
  },
  TRUNKRS_NR: "TrunkrsNR"
}, QF = {
  DATA_RECEIVED: "Data ontvangen",
  DATA_PROCESSED: "Aangemeld voor verzending",
  SHIPMENT_SORTED: "Gesorteerd (centrale hub)",
  SHIPMENT_SORTED_AT_SUB_DEPOT: "Gesorteerd (regionaal depot)",
  SHIPMENT_ACCEPTED_BY_DRIVER: "Geaccepteerd door chauffeur",
  SHIPMENT_NOT_DELIVERED: "Niet afgeleverd",
  RETURN_SHIPMENT_TO_SENDER: "Retour naar webshop",
  RETURN_ACCEPTED_BY_DRIVER: "Retour geaccepteerd door chauffeur",
  RETURN_ASSIGNED_TO_PICKUP: "Retour toegewezen aan collectie",
  RETURN_ACCEPTED_BY_TRUNKRS: "Retour geaccepteerd door Trunkrs",
  RETURN_ACCEPTED_BY_PICKUP_DRIVER: "Retour geaccepteerd door collectie chauffeur",
  RETURN_ACCEPTED_BY_SENDER: "Retour geaccepteerd door verzender",
  EXCEPTION_SHIPMENT_NOT_ARRIVED: "Niet aangekomen",
  EXCEPTION_SHIPMENT_MIS_SORTED: "Verkeerd gesorteerd",
  EXCEPTION_SHIPMENT_MISS_SORTED: "Foutief gesorteerd",
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER: "Geweigerd door chauffeur",
  EXCEPTION_SHIPMENT_MISSING: "Zending vermist",
  EXCEPTION_SHIPMENT_LOST: "Zending kwijt",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER: "Retour geweigerd door verzender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER: "Geannuleerd door verzender",
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS: "Geannuleerd door Trunkrs",
  EXCEPTION_SHIPMENT_DESTROYED: "Zending vernietigd",
  EXCEPTION_SHIPMENT_INVESTIGATE: "Zending wordt onderzocht",
  CHANGE_SHIPMENT_ADDRESS_CHANGED: "Adres gewijzigd",
  CHANGE_SHIPMENT_NEIGHBOUR_CHANGE: "Buuradres gewijzigd",
  CHANGE_SHIPMENT_POST_PONED: "Zending gepostponed",
  CUSTOMER_SERVICE_OVERRULE: "Customer Service overrule",
  EXCEPTION_LINEHAUL_ARRIVED_LATE: "Linehaul laat gearriveerd",
  EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL: "Niet op linehaul",
  EXCEPTION_PICKUP_ARRIVED_LATE: "Collectie laat aangekomen",
  EXCEPTION_PICKUP_NOT_PICKED_UP: "Niet opgehaald",
  EXCEPTION_PICKUP_REFUSED_BY_DRIVER: "Collectie geweigerd door chauffeur",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL: "Retour geweigerd door linehaul",
  EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP: "Retour geweigerd door collectie",
  LINEHAUL_ARRIVED_ON_TIME: "Linehaul op tijd aangekomen",
  LINEHAUL_IN_TRANSIT: "Linehaul onderweg",
  PICKUP_ACCEPTED_BY_DRIVER: "Collectie geaccepteerd door chauffeur",
  PICKUP_ARRIVED_ON_TIME: "Collectie op tijd aangekomen",
  PICKUP_DRIVER_ASSIGNED: "Collectie chauffeur toegewezen",
  PICKUP_PICKED_UP: "Gecollecteerd",
  RETURN_ASSIGNED_TO_LINEHAUL: "Retour toegewezen aan linehaul",
  SHIPMENT_DELIVERED: "Afgeleverd",
  SHIPMENT_DELIVERED_TO_NEIGHBOR: "Afgeleverd bij buur",
  PARTNER_OVERRULE: "The shipment has been overruled by the partner"
}, JF = {
  TITLE: "Werknemers",
  ADD_USER_TITLE: "Werknemer toevoegen",
  ADD_USER_BUTTON: "Werknemer toevoegen",
  ADD_USER_CREATE_BUTTON: "Voeg toe",
  ADD_USER_CANCEL_BUTTON: "Sluiten",
  ADD_USER_CREATING_BUTTON: "Toevoegen",
  ADD_USER_NAME_REQUIRED: "Naam is vereist",
  ADD_USER_LANGUAGE_REQUIRED: "Taalvoorkeur is vereist",
  ADD_USER_PHONE_REQUIRED: "Telefoonnummer is vereist",
  USER_LIST_HEADER: "Werknemers",
  USER_LIST_TAB_ALL_EMPLOYEES: "Alle werknemers",
  USER_LIST_TAB_PLANNER: "Planners",
  USER_LIST_TAB_INACTIVE: "Inactief",
  USER_LIST_TAB_DELETED: "Verwijderd",
  USER_LIST_TABLE_EMPLOYEE_NAME: "Naam",
  USER_LIST_TABLE_ROLE: "Functie",
  USER_LIST_TABLE_PHONE_NUMBER: "Telefoonnummer",
  USER_LIST_TABLE_STATUS: "Status",
  USER_LIST_TABLE_MANAGE_EMPLOYEE: "Gegevens aanpassen",
  USER_LIST_TABLE_ROLE_PLANNER: "Planner, Chauffeur",
  USER_LIST_TABLE_ROLE_DRIVER: "Chauffeur",
  USER_LIST_TABLE_ROLE_DELETED: "Verwijderd",
  USER_LIST_TABLE_ACTIVE: "Actief",
  USER_LIST_TABLE_INACTIVE: "Inactief",
  USER_LIST_MENU_OPTIONS: "Opties",
  USER_LIST_MENU_EDIT_USER: "Gegevens aanpassen",
  USER_LIST_MENU_DELETE_USER: "Verwijder werknemer",
  NO_USERS_FOUND: "Niets gevonden",
  NO_USERS_FOUND_MSG: "Er zijn geen werknemers die voldoen aan deze categorie",
  DELETE_USER_SUBTEXT: "U kunt deze actie niet ongedaan maken.",
  DELETE_USER_TITLE: "Verwijder gebruiker?",
  LONGPRESS_DELETE_USER: "houden 3 secs to verwijderen",
  LONGPRESS_DONE: "Verwijderen...",
  DELETE_USER_SUCCESS_MSG_SUBTEXT: "{{EMP_NAME}}'s profiel is verwijderd",
  ADD_USER_SUCCESS_MSG: "BRAVO!",
  ADD_USER_SUCCESS_MSG_SUBTEXT: "We hebben de nieuwe werknemer aangemaakt.",
  EDIT_USER_SUCCESS_MSG_SUBTEXT: "Je hebt de medewerker succesvol geüpdatet.",
  IMPORT_DRIVER_MODAL_TITLE: "Importeer chauffeur naar deze regio",
  DRIVER_PHONE_NUMBER: "Telefoonnummer chauffeur",
  CURRENT_REGION: "Huidige regio:",
  NOTIF_CANNOT_FIND_DRIVER: "Er zijn geen chauffeurs gevonden met dit telefoonnummer.",
  AVAILABLE_ASSIGNED: "Deze chauffeur is al aan een route in {{region}} toegewezen en zal van deze route worden verwijderd als je doorgaat.",
  NOT_AVAILABLE_ASSIGNED: "Deze chauffeur is al onderdeel van deze regio.",
  NOTIF_DRIVER_CANNOT_BE_MOVED: "Deze chauffeur is al aan een route in ZOS toegewezen en zal van deze route worden verwijderd als je doorgaat.",
  TOAST_DRIVER_IMPORT_SUCCESS: "Chauffeur succesvol geïmporteerd!",
  TOAST_DRIVER_IMPORT_SUCCESS_SUBTEXT: "{{name}} is nu beschikbaar in deze regio.",
  BUTTON_IMPORT_DRIVER: "Importeer chauffeur",
  BUTTON_CANCEL: "Sluiten",
  EDIT_INFORMATION_TOOLTIP: "Informatie wijzigen",
  DELETE_TOOLTIP: "Verwijderen"
}, eW = "Totale Afstand", tW = "Tour(s) {{text}} bevatten stop(s) die niet volledig geoptimaliseerd konden worden.", nW = "Voor sommige stops konden we geen routelijnen trekken, dit is geen probleem.", rW = "Deze route is niet volledig geoptimaliseerd. Voor de rode stops konden we geen routelijnen trekken. Deze stops kunnen handmatig worden aangepast of naar een andere route worden verplaatst.", oW = {
  BUSY_PEAK_DAYS: "Drukke dag. Er kan nog niet begonnen worden met de handover. Maak nieuwe tours zodra de centrale sortering is afgerond.",
  CENTRAL_SORTING_IS_DONE: "De centrale sortering is afgerond. Maak nieuwe tours voordat je start met de handover.",
  HANDOVER_CENTRAL_SORTING_DONE: "Drukke dag. Er kan nog niet begonnen worden met de handover. Maak nieuwe tours zodra de centrale sortering is afgerond."
}, iW = {
  HEADER: "Zendingen",
  FILTER_ALL_SHIPMENTS: "Alle",
  FILTER_CENTRAL_SORTED: "Centraal gesorteerd",
  FILTER_CANCELLED: "Geannuleerd",
  TABLE_HEADER_TRUNKRSNR: "TrunkrsNR",
  TABLE_HEADER_POSTAL_CODE: "Postcode",
  TABLE_HEADER_ADDRESS: "Adres",
  TABLE_HEADER_CITY: "Stad",
  TABLE_HEADER_TOUR: "Tour",
  TABLE_HEADER_SHIPMENT_STATE: "Staat van verzending",
  RESULT_COUNT: "{{count}} resultaten",
  STATE_CANCELED: "Geannuleerd",
  STATE_HAS_TOUR: "Toegewezen aan route",
  STATE_NO_TOUR: "Open",
  STATE_EXPECTED: "Verwacht",
  NO_TOURS_YET: "Nog geen routes bekend",
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: "Zendingen gesorteerd op regionale hub",
  SHIPMENTS_ACCEPTED_BY_DRIVERS: "Zendingen geaccepteerd door chauffeurs",
  SHIPMENTS_WITH_END_STATE: "Zendingen met eindstatus",
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: "Buurlevering versus niet-levering",
  OUT_OF_MAXCOUNT: "{{count}} van de {{maxCount}}",
  REFRESH_RESULTS: "Resultaten vernieuwen",
  EMPTY_TITLE: "Niets te zien hier!",
  EMPTY_DESC: "Wacht enkele momenten en herlaad daarna deze pagina",
  RELOAD_BUTTON: "Herlaad pagina"
}, aW = {
  INVENTORY_SCAN: "Voorraadscan",
  INVENTORY_SCAN_WARNING_TITLE: "Pas op",
  INVENTORY_SCAN_DESC: "Dit is je eerste stap bij het plannen van route",
  TOUR_PLANNING: "Routeplanning",
  TOUR_PLANNING_DESC: "Routes aanmaken en aanpassen",
  TOUR_PLANNING_DESC_BY_NETWORK: "Plan routes voor {{ networkType }}",
  TOUR_PLANNING_DESC_2: "Centrale sortering is nog niet klaar",
  HANDOVER: "Overhandiging",
  HANDOVER_DESC: "Pakket overhandigen",
  MONITORING: "Toezicht houden",
  MONITORING_DESC: "Volg uw pakketten"
}, sW = {
  START_PLANNING: {
    TITLE: "Welkom",
    DESCRIPTION: "Hi! Via de volgende stappen helpen wij je om: je pakketten te volgen, je routes te plannen en je dag te monitoren. Zit je er klaar voor?",
    LETS_START: "Laten we beginnen"
  },
  NO_SHIPMENT_FOUND: "Geen zendingen gevonden",
  NO_SHIPMENT_FOUND_TEXT: "Je bent klaar met scannen, je kunt nu doorgaan met het proces",
  THIS_FEATURE_DISABLED: "Deze feature is op dit moment niet beschikbaar",
  INVENTORY_SCAN_300_1400: "De inventaris scan is alleen beschikbaar tussen 3:00 en 14:00",
  NETWORK_NOT_READY: {
    HEADER: "Niets te zien hier!",
    DESCRIPTION: "De centrale sortering is nog niet klaar. Nog even geduld."
  },
  WELCOME_WIZARD: {
    HEADER: "Welkom!",
    DESCRIPTION_1: "De planner applicatie helpt je om routes te plannen voor zowel het dag- als avondnetwerk.",
    DESCRIPTION_2: "Selecteer het netwerk waar je voor wil plannen"
  }
}, cW = "Klik hier om de track & trace van dit pakket te bekijken.", uW = "Hallo! Voer hier je telefoonnummer in om een 6-cijferige inlogcode te ontvangen.", EW = "Telefoonnummer is verplicht", lW = "Dit telefoonnummer is niet geregistreerd, probeer een ander nummer.", _W = "We hebben je inlogcode verstuurd naar {{ number }}", dW = "Niet ontvangen? Vraag over 30s een nieuwe code aan", TW = "Bevestigen en inloggen", fW = "De routes moeten opgeslagen zijn, zodat we zeker weten dat de routes die je nu gaat sorteren ook de routes zijn die je vanavond gaat uitrijden.", SW = "Zodra je chauffeurs hebt toegewezen aan alle routes en de centrale sortering klaar is, kun je verder met het permanent maken van je routes.", RW = "Wijzig de chauffeur voor kar {{ cart }}", NW = "Huidige bestuurder: {{ driver }}", OW = "Ongeldig telefoonnummer", IW = "Partnerprofiel", pW = "Er zijn nog geen actieve routes", hW = "Zie meer stops", AW = "Zie minder stops", gW = "Maak en wijzig routes tot ze tot in de puntjes geoptimaliseerd zijn", vW = "Doorgaan naar {{ location }}", DW = "Ga terug naar {{ location }}", mW = "Overzicht", LW = "Snelheid", CW = "Dit veld is verplicht.", PW = "Totale routes: {{count}}", yW = {
  DAY: "Dag",
  NIGHT: "Avond",
  DAY_PLANNING: "Dag planning",
  NIGHT_PLANNING: "Avond planning",
  HEADER: "{{ networkType }} {{ usage }}",
  PLANNING: "Planning",
  SHIPMENTS: "Zendingen",
  WARNING_TITLE: "Van netwerk wisselen",
  WARNING_CONTENT: "Je staat op het punt om te wisselen naar {{ networkType }} {{ usage }}. Je kan altijd terug naar het andere netwerk {{ networkType }} {{ usage }} door gebruik te maken van dezelfde knop.",
  WARNING_BUTTON: "Wissel naar {{ networkType }} {{ usage }}",
  DISABLED: "Deze functie is niet beschikbaar in dag planning",
  SWITCH_NETWORK_CALLOUT: "Je bent nu routes aan het plannen voor {{ networkType }}"
}, UW = "We temporarily removed the At Regional Hub list to improve loading times. But you can still continue the morning scan as usual.", bW = {
  LOADING: s1,
  LOGIN: c1,
  EMAIL: u1,
  PASSWORD: E1,
  WRONG_CREDENTIALS: l1,
  CHECK_CREDENTIALS: _1,
  CHECK_SHIPMENTS: d1,
  RELOAD: T1,
  NEXT: f1,
  BACK: S1,
  GO_BACK: R1,
  CONFIRM: N1,
  CANCEL: O1,
  CLOSE: I1,
  BARCODE: p1,
  FULL_SCREEN: h1,
  TOUR: A1,
  TOURS: g1,
  OPTIMIZING_1: v1,
  OPTIMIZING_2: D1,
  OPTIMIZING_3: m1,
  DRIVER: L1,
  NO_PARCELS: C1,
  SELECT_DRIVER: P1,
  SAVE: y1,
  SAVE_PLANNING: U1,
  SAVE_PLANNING_BY_NETWORK: b1,
  ENABLE_PLANNING: M1,
  DISABLE_PLANNING: w1,
  NAME: $1,
  LOCATION: H1,
  POSTALCODE: V1,
  ADDRESS: B1,
  STREET: G1,
  NUMBER: k1,
  CITY: x1,
  LAT: F1,
  LNG: W1,
  COUNTRY: K1,
  NETHERLANDS: z1,
  GERMANY: Y1,
  PHONE_NUMBER: j1,
  PHONE_NUMBER_NOT_REGISTERED: Z1,
  REMARKS: X1,
  SHIPMENTS: q1,
  SHIPMENT: Q1,
  GEOCODING_EXCEPTIONS: J1,
  NOT_PLANNED_YET: eH,
  HANDOVER: tH,
  MOVE_TOUR: nH,
  DURATION: rH,
  START: oH,
  DEPART: iH,
  OPTIMIZE: aH,
  CREATE_NEW_TOURS: sH,
  CREATE_NEW_TOURS_BY_NETWORK: cH,
  CREATE_TOURS_BY_NETWORK_2: uH,
  OPTIMIZE_OPTIONS: EH,
  OPTIMIZE_AGAIN: lH,
  RUN: _H,
  DRIVER_SPEED: dH,
  FASTER: TH,
  FAST: fH,
  NORMAL: SH,
  SLOW: RH,
  VERY_SLOW: NH,
  OPEN_END_TOUR: OH,
  SELECT_ALL: IH,
  HANDOVER_DONE: pH,
  LOG_OFF: hH,
  RECOVER_CREDENTIALS: AH,
  ADD_TOUR: gH,
  VISIBLE_TOURS: vH,
  OPTIMIZE_TOUR: DH,
  EXPORT: mH,
  POSITION: LH,
  TIME: CH,
  SIGNATURE: PH,
  CODE: yH,
  PROFILE: UH,
  EDIT_PROFILE: bH,
  DRIVERS: MH,
  EDIT_DRIVER: wH,
  ADD_DRIVER: $H,
  CHANGE_PASSWORD: HH,
  CURRENT_PASSWORD: VH,
  NEW_PASSWORD: BH,
  CONFIRM_NEW_PASSWORD: GH,
  WRONG_PASSWORD: kH,
  WRONG_PASSWORD_MSG: xH,
  PASSWORD_TOO_SHORT: FH,
  PASSWORD_TOO_SHORT_MSG: WH,
  PASSWORD_CHANGED: KH,
  PASSWORD_CHANGED_MSG: zH,
  PASSWORDS_DONT_MATCH: YH,
  PASSWORDS_DONT_MATCH_MSG: jH,
  FORM_INCOMPLETE: ZH,
  FORM_INCOMPLETE_MSG: XH,
  PROFILE_EDITED: qH,
  PROFILE_EDITED_MSG: QH,
  UNKOWN_ERROR: JH,
  UNKOWN_ERROR_MSG: e0,
  SAVE_ERROR: t0,
  SAVE_ERROR_MSG: n0,
  DRIVER_ADDED: r0,
  DRIVER_ADDED_MSG: o0,
  EMAIL_INVALID: i0,
  EMAIL_INVALID_MSG: a0,
  UNKNOWN_EMAIL_MSG: s0,
  UNSAVED_CHANGES: c0,
  NEW_SHIPMENTS_MSG: u0,
  TRAFFIC: E0,
  MIN_VISITS: l0,
  BALANCE: _0,
  MIN_VEHICLES: d0,
  FINISH: T0,
  LAST_STOP: f0,
  PRODUCTIVITY: S0,
  TOTAL_TIME: R0,
  CHANGE_COLOR: N0,
  CANCEL_SHIPMENT: O0,
  YES: I0,
  NO: p0,
  SEND_EMAIL: h0,
  SEND_EMAIL_MSG: A0,
  EMAIL_SENT_MSG: g0,
  EDIT_MODE: v0,
  ABT: D0,
  SL1T: m0,
  SL1ST: L0,
  SL2T: C0,
  SL2ST: P0,
  SL3T: y0,
  SL3ST: U0,
  SL4T: b0,
  SL4ST: M0,
  SL5T: w0,
  SL5ST: $0,
  NU1T: H0,
  NU1ST: V0,
  NU2T: B0,
  NU2ST: G0,
  NU3T: k0,
  NU3ST: x0,
  NU4T: F0,
  NU4ST: W0,
  NU5T: K0,
  NU5ST: z0,
  STILL_TIME: Y0,
  NO_SHIPMENTS: j0,
  ALL_SHIPMENTS_HANDOVERED: Z0,
  HANDOVER_STARTED: X0,
  OPTIMIZE_WARNING: q0,
  DRIVER_WARNING: Q0,
  DUPLICATE_EMAIL: J0,
  DUPLICATE_EMAIL_MSG: eV,
  SETTING_ZOOM: tV,
  SETTING_CLUSTER: nV,
  INSTRUCTIONS: rV,
  INSTRUCTIONS_TXT: oV,
  UPDATE: iV,
  UPDATE_TXT: aV,
  UPDATE_VIDEO: sV,
  NEW_UPDATE: cV,
  CART: uV,
  CONFIRMATION: EV,
  START_SCANNING: lV,
  READY_HANDOVER: _V,
  RESET_HANDOVER: dV,
  RESET_HANDOVER_MSG: TV,
  ARE_YOU_SURE: fV,
  CHANGE_DRIVERS: SV,
  CHANGE_DRIVERS_SUCCESS_TITLE: RV,
  CHANGE_DRIVERS_SUCCESS_DESC: NV,
  INVALID_SUBCO_AREA: OV,
  INVALID_SUBCO_AREA_DESC: IV,
  MISSORT: pV,
  SCAN_ERROR_MSG_1: hV,
  SCAN_ERROR_MSG_2: AV,
  SCAN_ERROR_MSG_3: gV,
  UNKNOWN_AREA: vV,
  NUMBER_OF_DRIVERS: DV,
  CANCEL_MARKED_SHIPMENTS: mV,
  ATTENTION: LV,
  RETURN: CV,
  CANCEL_SHIPMENTS: PV,
  RESET_HANDOVER_BTN_TEXT: yV,
  ACTIVE: UV,
  MARK_TOUR_AS_PLANNED: bV,
  MARK_TOUR_MSG_1: MV,
  MARK_TOUR_MSG_2: wV,
  MARK_TOUR_MSG_3: $V,
  TOUR_PLANNED: HV,
  UNDO: VV,
  SEND_CODE: BV,
  TOURS_SAVED: GV,
  TOURS_SAVED_SUCCESSFULLY: kV,
  EDIT_TOURS: xV,
  PLAN_TOURS: FV,
  TOURS_SAVED_NO_DRIVERS: WV,
  PLANNING_DONE: KV,
  GO_TO_HANDOVER: zV,
  PHONE_INCORRECT: YV,
  PHONE_INCORRECT_MSG: jV,
  IMAGE_ERROR: ZV,
  IMAGE_ERROR_MSG: XV,
  SAVE_DRIVER_ERROR: qV,
  SAVE_DRIVER_ERROR_MSG: QV,
  NO_DRIVERS_YET: JV,
  NO_DRIVERS_YET_MSG: eB,
  SUBCO_PROFILE: tB,
  MOVE_TO_TOUR: nB,
  OPTIMIZING: rB,
  ESTIMATING: oB,
  SAVING: iB,
  RETURN_TO_TRUNKRS: aB,
  SET_ASIDE: sB,
  ATTENTION_MISSORT: cB,
  ATTENTION_MISSORT_MSG: uB,
  ATTENTION_SET_ASIDE_MSG: EB,
  STATE_CANCELED: lB,
  STATE_HAS_TOUR: _B,
  STATE_NO_TOUR: dB,
  STATE_EXPECTED: TB,
  NO_TOURS_YET: fB,
  START_OPTIMIZING: SB,
  OPTIMIZE_BTN: RB,
  ERROR_PAGE_TITLE: NB,
  ERROR_PAGE_MESSAGE: OB,
  RELOAD_APP: IB,
  PACKAGES: pB,
  GO_TO_TOURS: hB,
  LOCK_TOURS: AB,
  LOCK_TOURS_MSG: gB,
  LOCK_TOURS_MSG_WAIT: vB,
  LOCK_TOURS_NOW: DB,
  NO_DRIVERS_ASSIGNED: mB,
  NO_DRIVERS_ASSIGNED_MSG: LB,
  GENERIC_ERROR_MSG: CB,
  WRONG_VERIFICATION_CODE: PB,
  DASHBOARD: yB,
  FETCH_TOUR_OVERVIEW: UB,
  NOT_SCANNED_AT_HUB: bB,
  ON_ITS_WAY: MB,
  DELIVERED: wB,
  DELIVERED_TO_NEIGHBOUR: $B,
  NOT_DELIVERED: HB,
  FEEDBACK_TITLE: VB,
  FEEDBACK_SUBTITLE: BB,
  FEEDBACK_SUBTITLE_2: GB,
  FEEDBACK_LABEL_NAME: kB,
  FEEDBACK_LABEL_EMAIL: xB,
  FEEDBACK_LABEL_COMMENTS: FB,
  FEEDBACK_CLOSE_BTN: WB,
  FEEDBACK_SUBMIT_BTN: KB,
  FEEDBACK_LABEL_SUCCESS: zB,
  TOUR_OVERVIEW_PAGE_TITLE: YB,
  UPDATING_OVERVIEW: jB,
  CAUTION: ZB,
  CAUTION_CHANGE_DRIVER: XB,
  CHANGE_DRIVER: qB,
  QUICK_TOURS_NO_TOURS_YET: QB,
  RETURNED_TRUNKRS: JB,
  NOT_AT_DEPOT: eG,
  MAX_FAILED_DELIVERY_ATTEMPT: tG,
  MAX_OUT_OF_FREEZER_TIME: nG,
  BACK_INTO_PLANNING: rG,
  LOAD_TODO: oG,
  SHIPMENT_COMMENT_TITLE: iG,
  SHIPMENT_COMMENT_TEXT: aG,
  SHIPMENT_COMMENT_PLACEHOLDER: sG,
  SHIPMENT_SCANNED_TITLE: cG,
  TODO_LIST: uG,
  TITLE_TODO_LIST: EG,
  TAB_LABEL_NOT_DELIVERED: lG,
  TAB_LABEL_NO_END_STATE: _G,
  TAB_LABEL_MISSORTED: dG,
  TAB_LABEL_RETURNS: TG,
  TAB_LABEL_DONE: fG,
  BARCODE_TODO: SG,
  TIME_REMAINING: RG,
  DONE_COUNTER_TITLE: NG,
  NON_DELIVERY_REASON: OG,
  TODO_NOT_RETURNED: IG,
  TODO_RETURNED: pG,
  TODO_NO_PARCEL: hG,
  TODO_PARCEL_POSTPONE: AG,
  LATEST_STATUS: gG,
  SHIPMENT_ADDRESS_HAS_CHANGED: vG,
  NEW_ADDRESS: DG,
  OLD_ADDRESS: mG,
  SHIPMENT_ADDRESS_CHANGED: LG,
  SHIPMENT_ACCEPTED_BY_DRIVER: CG,
  ADDRESS_NOT_FOUND: PG,
  BUSINESS_CLOSED: yG,
  BAD_ADDRESS: UG,
  DELIVERY_DAMAGED: bG,
  NO_TIME_LEFT_IN_TIMESLOT: MG,
  RECIPIENT_NOT_AT_HOME: wG,
  DRIVER_INVOLVED_IN_ACCIDENT: $G,
  REFUSED_BY_CUSTOMER: HG,
  EXTREME_WEATHER_CONDITIONS: VG,
  PARCEL_MISSING: BG,
  DELIVER_ADDRESS_NOT_ACCESSIBLE: GG,
  SHIPMENT_MISSING: kG,
  HEAVILY_DAMAGED: xG,
  TOO_HEAVY: FG,
  TOO_LARGE: WG,
  SHIPMENTS_SORTED_AT_REGIONAL_HUB: KG,
  SHIPMENTS_ACCEPTED_BY_DRIVERS: zG,
  SHIPMENTS_WITH_END_STATE: YG,
  NEIGHBOUR_DELIVERY_VS_NON_DELIVERY: jG,
  ALL_SHIPMENTS: ZG,
  RESULTS: XG,
  WHICH_SHIPMENTS_HAVE_BEEN_SORTED_AT_REGIONAL_HUB: qG,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_SORTED_AT_REGIONAL_HUB: QG,
  WHICH_SHIPMENTS_HAVE_BEEN_ACCEPTED_BY_THEIR_DRIVERS: JG,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_ACCEPTED_BY_THEIR_DRIVERS: ek,
  WHICH_SHIPMENTS_HAVE_AN_END_STATE: tk,
  WHICH_SHIPMENTS_DO_NOT_HAVE_AN_END_STATE: nk,
  WHICH_SHIPMENTS_ARE_DELIVERED_TO_NEIGHBOURS: rk,
  WHICH_SHIPMENTS_HAVE_NOT_BEEN_DELIVERED: ok,
  CLEAR_FILTER: ik,
  TRANSFER_TO: ak,
  LOCK_TITLE: sk,
  LOCK_DESCRIPTION: ck,
  LOCK_PLANNING_OWNER: uk,
  LOCK_PLANNING_TITLE: Ek,
  PLANNING_FIXED: lk,
  CHOOSE_DRIVER: _k,
  LOCK_PLANNING_DESCRIPTION: dk,
  LOCK_PLANNING_DONE: Tk,
  LOCK_PLANNING_SAVED: fk,
  LOCK_SORTING_OWNER: Sk,
  LOCK_SORTING_TITLE: Rk,
  LOCK_SORTING_DESCRIPTION: Nk,
  LOCK_SORTING_DONE: Ok,
  LOCK_DRIVERS_OWNER: Ik,
  LOCK_DRIVERS_TITLE: pk,
  LOCK_DRIVER_DESCRIPTION: hk,
  LOCK_DRIVER_DONE: Ak,
  LOCK_DRIVER_CTA: gk,
  LOCK_BUTTON: vk,
  FOSSIL: Dk,
  ELECTRIC: mk,
  SUBCONTRACTOR: Lk,
  COLLECTIONS: Ck,
  COLLECTION_TOUR: Pk,
  TOUR_REMARK: yk,
  COLLECTION_DRIVER_PLACEHOLDER: Uk,
  NO_DRIVER_ASSIGNED: bk,
  STOPS: Mk,
  COLLECTION_TOUR_TITLE: wk,
  ORDER_STOPS: $k,
  CLIENT_TITLE: Hk,
  POSTAL: Vk,
  PICKUP_TIME: Bk,
  STOP_REMARK: Gk,
  END: kk,
  PLANNING_NOT_READY_YET: xk,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_DRIVERS_AVAILABLE_IN: Fk,
  INFORMATION: Wk,
  ESTIMATED_AMOUNT_OF_SHIPMENTS_AND_NEEDED_DRIVERS_WILL_BE_AVAILABLE_AT: Kk,
  SEE_ESTIMATED_AMOUNT_OF_SHIPMENT_AND_DRIVERS_BELOW: zk,
  YOU_CAN_ACCESS_THE_PLANNING_WHEN_IT_IS_COMPLETED: Yk,
  ESTIMATED_AMOUNT_OF_SHIPMENTS: jk,
  DRIVERS_YOU_WILL_PROBABLY_NEED: Zk,
  MARK_PLANNING_AS_DONE: Xk,
  MARK_PLANNING_AS_DONE_HOLDING: qk,
  MARK_PLANNING_DONE: Qk,
  PLANNING_MUST_BE_MARKED_AS_DONE: Jk,
  NO_COLLECTION_TOURS: ex,
  NO_COLLECTION_TOURS_DESC: tx,
  CENTRAL_SORTING_DONE_ALERT: nx,
  WARNING: rx,
  CENTRAL_SORTING_NOT_DONE_ALERT: ox,
  FREEZER_MANAGEMENT: ix,
  SCAN_FROZEN_SHIPMENT: ax,
  EXPECTED_SHIPMENTS: sx,
  FROZEN_MANAGEMENT_ADDRESS: cx,
  FROZEN_MANAGEMENT_DRIVER: ux,
  CURRENTLY_IN_THE_FREEZER: Ex,
  MERCHANT: lx,
  IN_SINCE: _x,
  NEXT_STEP: dx,
  BACK_INTO_DELIVERY: Tx,
  BACK_TO_TRUNKRS: fx,
  SHIPMENT_ADDED_TO_THE_FREEZER: Sx,
  SHIPMENT_NOT_ADDED_TO_THE_FREEZER: Rx,
  SHIPMENT_OUT_OF_THE_FREEZER: Nx,
  RETURN_SHIPMENT: Ox,
  FROZEN_MANAGEMENT_NO_SHIPMENTS: Ix,
  ADD_TO_NEW_TOUR: px,
  DRIVER_PREF_LANG: hx,
  SAVE_DRIVER: Ax,
  VEHICLE: gx,
  VEHICLE_TYPE: vx,
  SHOW_FULL_TOUR: Dx,
  HIDE_TOUR: mx,
  OPTIMISE_TOUR: Lx,
  REVERSE_TOUR: Cx,
  COLOR_TOUR: Px,
  CHOOSE_TOUR_COLOUR: yx,
  COLOUR_PICK_CANCEL: Ux,
  AMOUNT_OF_PACKAGES: bx,
  MOVE_TO_DIFFERENT_TOUR: Mx,
  DE_SELECT_ALL: wx,
  SELECT_TOUR_TO_PRINT: $x,
  SELECT_TOUR_TO_PRINT_SUB_DESCRIPTION: Hx,
  SELECT_PRINT_ALL: Vx,
  SELECTED_PRINT: Bx,
  PRINT_EXPORT: Gx,
  PRINT_EXPORT_LOADING: kx,
  OPTIMIZATION_NOTIFICATION_HEADER: xx,
  OPTIMIZATION_NOTIFICATION_SUBTEXT: Fx,
  OPTIMIZATION_NOTIFICATION_CONTACT_NO: Wx,
  ADD_USER_TITLE: Kx,
  ADD_USER_BUTTON: zx,
  ADD_USER_CREATE_BUTTON: Yx,
  ADD_USER_CANCEL_BUTTON: jx,
  ADD_USER_CREATING_BUTTON: Zx,
  ADD_USER_NAME_REQUIRED: Xx,
  ADD_USER_LANGUAGE_REQUIRED: qx,
  ADD_USER_PHONE_REQUIRED: Qx,
  PLANNER_PERMISSION: Jx,
  PLANNER_PERMISSION_SUBTEXT: e2,
  ADD_USER_SUCCESS_MSG: t2,
  ADD_USER_SUCCESS_MSG_SUBTEXT: n2,
  ADD_USER_FULL_NAME: r2,
  ADD_USER_FULL_NAME_PLACEHOLDER: o2,
  ADD_USER_PREFERRED_LANGUAGE: i2,
  ADD_USER_PREFERRED_LANGUAGE_PLACEHOLDER: a2,
  ADD_USER_PREFERRED_PHONE_NUMBER: s2,
  ADD_USER_PREFERRED_PHONE_NUMBER_PLACEHOLDER: c2,
  DELETE_USER: u2,
  EDIT_USER: E2,
  EDIT_USER_TITLE: l2,
  SAVE_USER_BUTTON: _2,
  SAVING_USER_BUTTON: d2,
  EDIT_USER_SUCCESS_MSG_SUBTEXT: T2,
  USER_LIST_HEADER: f2,
  USER_LIST_TAB_ALL_EMPLOYEES: S2,
  USER_LIST_TAB_PLANNER: R2,
  USER_LIST_TAB_INACTIVE: N2,
  USER_LIST_TAB_DELETED: O2,
  USER_LIST_TABLE_EMPLOYEE_NAME: I2,
  USER_LIST_TABLE_ROLE: p2,
  USER_LIST_TABLE_PHONE_NUMBER: h2,
  USER_LIST_TABLE_STATUS: A2,
  USER_LIST_TABLE_MANAGE_EMPLOYEE: g2,
  USER_LIST_TABLE_ROLE_PLANNER: v2,
  USER_LIST_TABLE_ROLE_DRIVER: D2,
  USER_LIST_TABLE_ROLE_DELETED: m2,
  USER_LIST_TABLE_ACTIVE: L2,
  USER_LIST_TABLE_INACTIVE: C2,
  USER_LIST_MENU_OPTIONS: P2,
  USER_LIST_MENU_EDIT_USER: y2,
  USER_LIST_MENU_DELETE_USER: U2,
  NO_USERS_FOUND: b2,
  NO_USERS_FOUND_MSG: M2,
  DELETE_USER_SUBTEXT: w2,
  DELETE_USER_TITLE: $2,
  LONGPRESS_DELETE_USER: H2,
  LONGPRESS_DONE: V2,
  DELETE_USER_SUCCESS_MSG_SUBTEXT: B2,
  EMPLOYEES: G2,
  EDIT_PHONE_NUMBER_WARNING: k2,
  HOW_MANY_DRIVERS: x2,
  CREATE_TOURS: F2,
  CREATE_TOURS_BY_NETWORK: W2,
  CREATE_AND_EDIT_TOURS_BY_NETWORK: K2,
  SWITCH_POWER_MODE_TITLE: z2,
  SWITCH_POWER_MODE_BODY: Y2,
  SWITCH_POWER_MODE_BTN: j2,
  LITE_MODE: Z2,
  POWER_MODE: X2,
  PLAN_MODE: q2,
  LITE_SAVE_TOURS: Q2,
  LITE_RE_OPTIMIZE: J2,
  LITE_TOURS_TABLE_TOUR: eF,
  LITE_TOURS_TABLE_DEPARTURE: tF,
  LITE_TOURS_TABLE_LAST_STOP: nF,
  LITE_TOURS_TABLE_SHIPMENTS: rF,
  LITE_TOURS_TABLE_DRIVER: oF,
  LITE_TOURS_TABLE_VEHICLE_TYPE: iF,
  LITE_DEFAULT_HEADER: aF,
  LITE_DEFAULT_SUB_DETAILS: sF,
  LITE_CREATE_TOURS: cF,
  LITE_NUMBER_OF_TOURS_CREATED: uF,
  LITE_SELECT_DRIVER: EF,
  LITE_SHOW_TOUR: lF,
  LITE_TOUR_STOP_TABLE_STOP: _F,
  LITE_TOUR_STOP_TABLE_STREET: dF,
  LITE_TOUR_STOP_TABLE_POSTAL_CODE: TF,
  LITE_TOUR_STOP_TABLE_CITY: fF,
  LITE_TOUR_STOP_TABLE_COLLI_COUNT: SF,
  LITE_TOUR_STOP_TABLE_ETA: RF,
  LITE_NOTIFICATION_MESSAGE_NOT_DONE_BEFORE_TIME: NF,
  LITE_NOTIFICATION_MESSAGE_OPTIMIZATION_FAILURE: OF,
  NO_TOURS_POWER_TEXT: IF,
  NO_TOURS_POWER_BODY: pF,
  LITE_AUTO_COMPLETE_DRIVER_NOT_FOUND: hF,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_NOT_STARTED: AF,
  LITE_NOTIFICATION_MESSAGE_CENTRAL_SORTING_IS_DONE: gF,
  LITE_RELOAD: vF,
  CREATING_TOURS: DF,
  DO_NOT_LEAVE_PAGE: mF,
  LAST_UPDATE: LF,
  USE_PREVIOUS_OPTIMIZATION: CF,
  USE_ROUTIFIC_V2: PF,
  HIDE_TOUR_TOOLTIP: yF,
  UNHIDE_TOUR_TOOLTIP: UF,
  OPTIMIZATION_RESULT_ERROR_TITLE: bF,
  OPTIMIZATION_RESULT_ERROR_DESC_1: MF,
  OPTIMIZATION_RESULT_ERROR_DESC_2: wF,
  OPTIMIZATION_RESULT_ERROR_DESC_3: $F,
  OPTIMIZATION_RESULT_ERROR_DESC_4: HF,
  OPTIMIZATION_RESULT_ERROR_SUPPORT_TEL: VF,
  OPTIMIZATION_RESULT_SUCCESS_TITLE: BF,
  OPTIMIZATION_RESULT_SUCCESS_DESC_1: GF,
  OPTIMIZATION_RESULT_SUCCESS_DESC_2: kF,
  OPTIMIZATION_RESULT_SUCCESS_DESC_3: xF,
  OPTIMIZATION_RESULT_BUTTON_RUN_AGAIN: FF,
  OPTIMIZATION_RESULT_BUTTON_ACCEPT: WF,
  OPTIMIZATION_RESULT_BUTTON_RE_OPTIMIZE: KF,
  OPTIMIZATION_RESULT_OVERFLOW_DESC: zF,
  SIDEBAR_HUB_INVENTORY: YF,
  SIDEBAR_RETURNS_SCAN: jF,
  SIDEBAR_RETURNS_SCAN_NOT_AVAILABLE_TOOLTIP: ZF,
  HUB_INVENTORY: XF,
  RETURNS_SCAN: qF,
  SHIPMENT_STATES: QF,
  USERS: JF,
  TOTAL_DISTANCE: eW,
  BERMUDA_TEXT_NOTIFICATION: tW,
  BERMUDA_TEXT_MORE_INFO: nW,
  BERMUDA_TEXT_CALLOUT: rW,
  GLOBAL_NOTIFICATIONS: oW,
  SHIPMENTS_OVERVIEW: iW,
  PLANNING_TIMELINE: aW,
  EMPTY_SCREENS: sW,
  NAVIGATE_TO_TRACT_N_TRACE: cW,
  LOGIN_DESCRIPTION: uW,
  PHONE_NUMBER_IS_REQUIRED: EW,
  PHONE_NUMBER_ERROR: lW,
  SENT_CODE_TO: _W,
  RESENT_CODE: dW,
  VERIFY_AND_LOGIN: TW,
  HANDOVER_TOUR_PLANNING_CARD_DESCRIPTION: fW,
  HANDOVER_ASSIGN_DRIVERS_CARD_DESCRIPTION: SW,
  HANDOVER_CHANGE_DRIVER_FOR_CART: RW,
  HANDOVER_CURRENT_DRIVER: NW,
  INVALID_PHONE_NUMBER: OW,
  PARTNER_PROFILE: IW,
  NO_ACTIVE_TOURS_YET: pW,
  SEE_MORE_STOPS: hW,
  SEE_LESS_STOPS: AW,
  CREATE_AND_EDIT_TOURS: gW,
  PROCEED_TO: vW,
  GO_BACK_TO: DW,
  OVERVIEW: mW,
  SPEED: LW,
  THIS_FIELD_IS_REQUIRED: CW,
  TOUR_COUNT: PW,
  NETWORK_TYPE: yW,
  TEMPORARY_FIX: UW
};
Gu.use(ms).use(Fu).init({
  resources: {
    de: {
      translation: TS
    },
    en: {
      translation: xD
    },
    fr: {
      translation: a1
    },
    nl: {
      translation: bW
    }
  },
  detection: {
    order: [
      "navigator",
      "querystring",
      "cookie",
      "localStorage",
      "sessionStorage",
      "htmlTag",
      "path",
      "subdomain"
    ]
  },
  fallbackLng: "nl",
  debug: process.env.NODE_ENV === "development",
  interpolation: {
    escapeValue: !1
    // react already safes from xss
  }
});
var po = { exports: {} }, $r = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bi;
function MW() {
  if (Bi)
    return $r;
  Bi = 1;
  var e = zt;
  function t(l, f) {
    return l === f && (l !== 0 || 1 / l === 1 / f) || l !== l && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(l, f) {
    var _ = f(), S = r({ inst: { value: _, getSnapshot: f } }), d = S[0].inst, T = S[1];
    return i(function() {
      d.value = _, d.getSnapshot = f, c(d) && T({ inst: d });
    }, [l, _, f]), o(function() {
      return c(d) && T({ inst: d }), l(function() {
        c(d) && T({ inst: d });
      });
    }, [l]), a(_), _;
  }
  function c(l) {
    var f = l.getSnapshot;
    l = l.value;
    try {
      var _ = f();
      return !n(l, _);
    } catch {
      return !0;
    }
  }
  function u(l, f) {
    return f();
  }
  var E = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return $r.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : E, $r;
}
var Hr = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gi;
function wW() {
  return Gi || (Gi = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = zt, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(N) {
      {
        for (var I = arguments.length, R = new Array(I > 1 ? I - 1 : 0), p = 1; p < I; p++)
          R[p - 1] = arguments[p];
        r("error", N, R);
      }
    }
    function r(N, I, R) {
      {
        var p = t.ReactDebugCurrentFrame, A = p.getStackAddendum();
        A !== "" && (I += "%s", R = R.concat([A]));
        var g = R.map(function(v) {
          return String(v);
        });
        g.unshift("Warning: " + I), Function.prototype.apply.call(console[N], console, g);
      }
    }
    function o(N, I) {
      return N === I && (N !== 0 || 1 / N === 1 / I) || N !== N && I !== I;
    }
    var i = typeof Object.is == "function" ? Object.is : o, a = e.useState, s = e.useEffect, c = e.useLayoutEffect, u = e.useDebugValue, E = !1, l = !1;
    function f(N, I, R) {
      E || e.startTransition !== void 0 && (E = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var p = I();
      if (!l) {
        var A = I();
        i(p, A) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), l = !0);
      }
      var g = a({
        inst: {
          value: p,
          getSnapshot: I
        }
      }), v = g[0].inst, D = g[1];
      return c(function() {
        v.value = p, v.getSnapshot = I, _(v) && D({
          inst: v
        });
      }, [N, p, I]), s(function() {
        _(v) && D({
          inst: v
        });
        var m = function() {
          _(v) && D({
            inst: v
          });
        };
        return N(m);
      }, [N]), u(p), p;
    }
    function _(N) {
      var I = N.getSnapshot, R = N.value;
      try {
        var p = I();
        return !i(R, p);
      } catch {
        return !0;
      }
    }
    function S(N, I, R) {
      return I();
    }
    var d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", T = !d, O = T ? S : f, h = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : O;
    Hr.useSyncExternalStore = h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Hr;
}
process.env.NODE_ENV === "production" ? po.exports = MW() : po.exports = wW();
var Ls = po.exports, ho = { exports: {} }, Vr = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ki;
function $W() {
  if (ki)
    return Vr;
  ki = 1;
  var e = zt, t = Ls;
  function n(u, E) {
    return u === E && (u !== 0 || 1 / u === 1 / E) || u !== u && E !== E;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
  return Vr.useSyncExternalStoreWithSelector = function(u, E, l, f, _) {
    var S = i(null);
    if (S.current === null) {
      var d = { hasValue: !1, value: null };
      S.current = d;
    } else
      d = S.current;
    S = s(function() {
      function O(p) {
        if (!h) {
          if (h = !0, N = p, p = f(p), _ !== void 0 && d.hasValue) {
            var A = d.value;
            if (_(A, p))
              return I = A;
          }
          return I = p;
        }
        if (A = I, r(N, p))
          return A;
        var g = f(p);
        return _ !== void 0 && _(A, g) ? A : (N = p, I = g);
      }
      var h = !1, N, I, R = l === void 0 ? null : l;
      return [function() {
        return O(E());
      }, R === null ? void 0 : function() {
        return O(R());
      }];
    }, [E, l, f, _]);
    var T = o(u, S[0], S[1]);
    return a(function() {
      d.hasValue = !0, d.value = T;
    }, [T]), c(T), T;
  }, Vr;
}
var Br = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xi;
function HW() {
  return xi || (xi = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = zt, t = Ls;
    function n(E, l) {
      return E === l && (E !== 0 || 1 / E === 1 / l) || E !== E && l !== l;
    }
    var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
    function u(E, l, f, _, S) {
      var d = i(null), T;
      d.current === null ? (T = {
        hasValue: !1,
        value: null
      }, d.current = T) : T = d.current;
      var O = s(function() {
        var R = !1, p, A, g = function(L) {
          if (!R) {
            R = !0, p = L;
            var P = _(L);
            if (S !== void 0 && T.hasValue) {
              var U = T.value;
              if (S(U, P))
                return A = U, U;
            }
            return A = P, P;
          }
          var M = p, H = A;
          if (r(M, L))
            return H;
          var x = _(L);
          return S !== void 0 && S(H, x) ? H : (p = L, A = x, x);
        }, v = f === void 0 ? null : f, D = function() {
          return g(l());
        }, m = v === null ? void 0 : function() {
          return g(v());
        };
        return [D, m];
      }, [l, f, _, S]), h = O[0], N = O[1], I = o(E, h, N);
      return a(function() {
        T.hasValue = !0, T.value = I;
      }, [I]), c(I), I;
    }
    Br.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Br;
}
process.env.NODE_ENV === "production" ? ho.exports = $W() : ho.exports = HW();
var VW = ho.exports;
function BW(e) {
  e();
}
let Cs = BW;
const GW = (e) => Cs = e, kW = () => Cs, Fi = Symbol.for("react-redux-context"), Wi = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function xW() {
  var e;
  if (!Y.createContext)
    return {};
  const t = (e = Wi[Fi]) != null ? e : Wi[Fi] = /* @__PURE__ */ new Map();
  let n = t.get(Y.createContext);
  return n || (n = Y.createContext(null), process.env.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), t.set(Y.createContext, n)), n;
}
const dt = /* @__PURE__ */ xW();
function jo(e = dt) {
  return function() {
    const n = Yt(e);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return n;
  };
}
const Ps = /* @__PURE__ */ jo(), FW = () => {
  throw new Error("uSES not initialized!");
};
let ys = FW;
const WW = (e) => {
  ys = e;
}, KW = (e, t) => e === t;
function zW(e = dt) {
  const t = e === dt ? Ps : jo(e);
  return function(r, o = {}) {
    const {
      equalityFn: i = KW,
      stabilityCheck: a = void 0,
      noopCheck: s = void 0
    } = typeof o == "function" ? {
      equalityFn: o
    } : o;
    if (process.env.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: c,
      subscription: u,
      getServerState: E,
      stabilityCheck: l,
      noopCheck: f
    } = t(), _ = ee(!0), S = ve({
      [r.name](T) {
        const O = r(T);
        if (process.env.NODE_ENV !== "production") {
          const h = typeof a > "u" ? l : a;
          if (h === "always" || h === "once" && _.current) {
            const I = r(T);
            i(O, I) || console.warn("Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
              state: T,
              selected: O,
              selected2: I
            });
          }
          const N = typeof s > "u" ? f : s;
          (N === "always" || N === "once" && _.current) && O === T && console.warn("Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`), _.current && (_.current = !1);
        }
        return O;
      }
    }[r.name], [r, l, a]), d = ys(u.addNestedSub, c.getState, E || c.getState, S, i);
    return Oo(d), d;
  };
}
const Us = /* @__PURE__ */ zW();
function ce() {
  return ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ce.apply(this, arguments);
}
var Ao = { exports: {} }, ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ki;
function YW() {
  if (Ki)
    return ne;
  Ki = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, d = e ? Symbol.for("react.block") : 60121, T = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
  function N(R) {
    if (typeof R == "object" && R !== null) {
      var p = R.$$typeof;
      switch (p) {
        case t:
          switch (R = R.type, R) {
            case c:
            case u:
            case r:
            case i:
            case o:
            case l:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case s:
                case E:
                case S:
                case _:
                case a:
                  return R;
                default:
                  return p;
              }
          }
        case n:
          return p;
      }
    }
  }
  function I(R) {
    return N(R) === u;
  }
  return ne.AsyncMode = c, ne.ConcurrentMode = u, ne.ContextConsumer = s, ne.ContextProvider = a, ne.Element = t, ne.ForwardRef = E, ne.Fragment = r, ne.Lazy = S, ne.Memo = _, ne.Portal = n, ne.Profiler = i, ne.StrictMode = o, ne.Suspense = l, ne.isAsyncMode = function(R) {
    return I(R) || N(R) === c;
  }, ne.isConcurrentMode = I, ne.isContextConsumer = function(R) {
    return N(R) === s;
  }, ne.isContextProvider = function(R) {
    return N(R) === a;
  }, ne.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === t;
  }, ne.isForwardRef = function(R) {
    return N(R) === E;
  }, ne.isFragment = function(R) {
    return N(R) === r;
  }, ne.isLazy = function(R) {
    return N(R) === S;
  }, ne.isMemo = function(R) {
    return N(R) === _;
  }, ne.isPortal = function(R) {
    return N(R) === n;
  }, ne.isProfiler = function(R) {
    return N(R) === i;
  }, ne.isStrictMode = function(R) {
    return N(R) === o;
  }, ne.isSuspense = function(R) {
    return N(R) === l;
  }, ne.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === r || R === u || R === i || R === o || R === l || R === f || typeof R == "object" && R !== null && (R.$$typeof === S || R.$$typeof === _ || R.$$typeof === a || R.$$typeof === s || R.$$typeof === E || R.$$typeof === T || R.$$typeof === O || R.$$typeof === h || R.$$typeof === d);
  }, ne.typeOf = N, ne;
}
var re = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zi;
function jW() {
  return zi || (zi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, d = e ? Symbol.for("react.block") : 60121, T = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
    function N($) {
      return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === r || $ === u || $ === i || $ === o || $ === l || $ === f || typeof $ == "object" && $ !== null && ($.$$typeof === S || $.$$typeof === _ || $.$$typeof === a || $.$$typeof === s || $.$$typeof === E || $.$$typeof === T || $.$$typeof === O || $.$$typeof === h || $.$$typeof === d);
    }
    function I($) {
      if (typeof $ == "object" && $ !== null) {
        var se = $.$$typeof;
        switch (se) {
          case t:
            var W = $.type;
            switch (W) {
              case c:
              case u:
              case r:
              case i:
              case o:
              case l:
                return W;
              default:
                var Pe = W && W.$$typeof;
                switch (Pe) {
                  case s:
                  case E:
                  case S:
                  case _:
                  case a:
                    return Pe;
                  default:
                    return se;
                }
            }
          case n:
            return se;
        }
      }
    }
    var R = c, p = u, A = s, g = a, v = t, D = E, m = r, L = S, P = _, U = n, M = i, H = o, x = l, F = !1;
    function z($) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), y($) || I($) === c;
    }
    function y($) {
      return I($) === u;
    }
    function b($) {
      return I($) === s;
    }
    function V($) {
      return I($) === a;
    }
    function w($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function B($) {
      return I($) === E;
    }
    function G($) {
      return I($) === r;
    }
    function k($) {
      return I($) === S;
    }
    function K($) {
      return I($) === _;
    }
    function X($) {
      return I($) === n;
    }
    function Q($) {
      return I($) === i;
    }
    function q($) {
      return I($) === o;
    }
    function ae($) {
      return I($) === l;
    }
    re.AsyncMode = R, re.ConcurrentMode = p, re.ContextConsumer = A, re.ContextProvider = g, re.Element = v, re.ForwardRef = D, re.Fragment = m, re.Lazy = L, re.Memo = P, re.Portal = U, re.Profiler = M, re.StrictMode = H, re.Suspense = x, re.isAsyncMode = z, re.isConcurrentMode = y, re.isContextConsumer = b, re.isContextProvider = V, re.isElement = w, re.isForwardRef = B, re.isFragment = G, re.isLazy = k, re.isMemo = K, re.isPortal = X, re.isProfiler = Q, re.isStrictMode = q, re.isSuspense = ae, re.isValidElementType = N, re.typeOf = I;
  }()), re;
}
process.env.NODE_ENV === "production" ? Ao.exports = YW() : Ao.exports = jW();
var Zo = Ao.exports, bs = Zo, ZW = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, XW = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ms = {};
Ms[bs.ForwardRef] = ZW;
Ms[bs.Memo] = XW;
var oe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yi;
function qW() {
  if (Yi)
    return oe;
  Yi = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), S;
  S = Symbol.for("react.module.reference");
  function d(T) {
    if (typeof T == "object" && T !== null) {
      var O = T.$$typeof;
      switch (O) {
        case e:
          switch (T = T.type, T) {
            case n:
            case o:
            case r:
            case u:
            case E:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case s:
                case a:
                case c:
                case f:
                case l:
                case i:
                  return T;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  return oe.ContextConsumer = a, oe.ContextProvider = i, oe.Element = e, oe.ForwardRef = c, oe.Fragment = n, oe.Lazy = f, oe.Memo = l, oe.Portal = t, oe.Profiler = o, oe.StrictMode = r, oe.Suspense = u, oe.SuspenseList = E, oe.isAsyncMode = function() {
    return !1;
  }, oe.isConcurrentMode = function() {
    return !1;
  }, oe.isContextConsumer = function(T) {
    return d(T) === a;
  }, oe.isContextProvider = function(T) {
    return d(T) === i;
  }, oe.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === e;
  }, oe.isForwardRef = function(T) {
    return d(T) === c;
  }, oe.isFragment = function(T) {
    return d(T) === n;
  }, oe.isLazy = function(T) {
    return d(T) === f;
  }, oe.isMemo = function(T) {
    return d(T) === l;
  }, oe.isPortal = function(T) {
    return d(T) === t;
  }, oe.isProfiler = function(T) {
    return d(T) === o;
  }, oe.isStrictMode = function(T) {
    return d(T) === r;
  }, oe.isSuspense = function(T) {
    return d(T) === u;
  }, oe.isSuspenseList = function(T) {
    return d(T) === E;
  }, oe.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === n || T === o || T === r || T === u || T === E || T === _ || typeof T == "object" && T !== null && (T.$$typeof === f || T.$$typeof === l || T.$$typeof === i || T.$$typeof === a || T.$$typeof === c || T.$$typeof === S || T.getModuleId !== void 0);
  }, oe.typeOf = d, oe;
}
var ie = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ji;
function QW() {
  return ji || (ji = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), S = !1, d = !1, T = !1, O = !1, h = !1, N;
    N = Symbol.for("react.module.reference");
    function I(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === o || h || W === r || W === u || W === E || O || W === _ || S || d || T || typeof W == "object" && W !== null && (W.$$typeof === f || W.$$typeof === l || W.$$typeof === i || W.$$typeof === a || W.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === N || W.getModuleId !== void 0));
    }
    function R(W) {
      if (typeof W == "object" && W !== null) {
        var Pe = W.$$typeof;
        switch (Pe) {
          case e:
            var He = W.type;
            switch (He) {
              case n:
              case o:
              case r:
              case u:
              case E:
                return He;
              default:
                var Ye = He && He.$$typeof;
                switch (Ye) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case l:
                  case i:
                    return Ye;
                  default:
                    return Pe;
                }
            }
          case t:
            return Pe;
        }
      }
    }
    var p = a, A = i, g = e, v = c, D = n, m = f, L = l, P = t, U = o, M = r, H = u, x = E, F = !1, z = !1;
    function y(W) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function b(W) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(W) {
      return R(W) === a;
    }
    function w(W) {
      return R(W) === i;
    }
    function B(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function G(W) {
      return R(W) === c;
    }
    function k(W) {
      return R(W) === n;
    }
    function K(W) {
      return R(W) === f;
    }
    function X(W) {
      return R(W) === l;
    }
    function Q(W) {
      return R(W) === t;
    }
    function q(W) {
      return R(W) === o;
    }
    function ae(W) {
      return R(W) === r;
    }
    function $(W) {
      return R(W) === u;
    }
    function se(W) {
      return R(W) === E;
    }
    ie.ContextConsumer = p, ie.ContextProvider = A, ie.Element = g, ie.ForwardRef = v, ie.Fragment = D, ie.Lazy = m, ie.Memo = L, ie.Portal = P, ie.Profiler = U, ie.StrictMode = M, ie.Suspense = H, ie.SuspenseList = x, ie.isAsyncMode = y, ie.isConcurrentMode = b, ie.isContextConsumer = V, ie.isContextProvider = w, ie.isElement = B, ie.isForwardRef = G, ie.isFragment = k, ie.isLazy = K, ie.isMemo = X, ie.isPortal = Q, ie.isProfiler = q, ie.isStrictMode = ae, ie.isSuspense = $, ie.isSuspenseList = se, ie.isValidElementType = I, ie.typeOf = R;
  }()), ie;
}
process.env.NODE_ENV === "production" ? qW() : QW();
function JW() {
  const e = kW();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], o = t;
      for (; o; )
        r.push(o), o = o.next;
      return r;
    },
    subscribe(r) {
      let o = !0, i = n = {
        callback: r,
        next: null,
        prev: n
      };
      return i.prev ? i.prev.next = i : t = i, function() {
        !o || t === null || (o = !1, i.next ? i.next.prev = i.prev : n = i.prev, i.prev ? i.prev.next = i.next : t = i.next);
      };
    }
  };
}
const Zi = {
  notify() {
  },
  get: () => []
};
function e3(e, t) {
  let n, r = Zi;
  function o(l) {
    return c(), r.subscribe(l);
  }
  function i() {
    r.notify();
  }
  function a() {
    E.onStateChange && E.onStateChange();
  }
  function s() {
    return !!n;
  }
  function c() {
    n || (n = t ? t.addNestedSub(a) : e.subscribe(a), r = JW());
  }
  function u() {
    n && (n(), n = void 0, r.clear(), r = Zi);
  }
  const E = {
    addNestedSub: o,
    notifyNestedSubs: i,
    handleChangeWrapper: a,
    isSubscribed: s,
    trySubscribe: c,
    tryUnsubscribe: u,
    getListeners: () => r
  };
  return E;
}
const t3 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", n3 = t3 ? Y.useLayoutEffect : Y.useEffect;
function Xi(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function qn(e, t) {
  if (Xi(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (let o = 0; o < n.length; o++)
    if (!Object.prototype.hasOwnProperty.call(t, n[o]) || !Xi(e[n[o]], t[n[o]]))
      return !1;
  return !0;
}
function r3({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: o = "once",
  noopCheck: i = "once"
}) {
  const a = Y.useMemo(() => {
    const u = e3(e);
    return {
      store: e,
      subscription: u,
      getServerState: r ? () => r : void 0,
      stabilityCheck: o,
      noopCheck: i
    };
  }, [e, r, o, i]), s = Y.useMemo(() => e.getState(), [e]);
  n3(() => {
    const {
      subscription: u
    } = a;
    return u.onStateChange = u.notifyNestedSubs, u.trySubscribe(), s !== e.getState() && u.notifyNestedSubs(), () => {
      u.tryUnsubscribe(), u.onStateChange = void 0;
    };
  }, [a, s]);
  const c = t || dt;
  return /* @__PURE__ */ Y.createElement(c.Provider, {
    value: a
  }, n);
}
function ws(e = dt) {
  const t = (
    // @ts-ignore
    e === dt ? Ps : (
      // @ts-ignore
      jo(e)
    )
  );
  return function() {
    const {
      store: r
    } = t();
    return r;
  };
}
const $s = /* @__PURE__ */ ws();
function o3(e = dt) {
  const t = (
    // @ts-ignore
    e === dt ? $s : ws(e)
  );
  return function() {
    return t().dispatch;
  };
}
const Hs = /* @__PURE__ */ o3();
WW(VW.useSyncExternalStoreWithSelector);
GW(ps);
function Vs(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Vs(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Xo() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Vs(e)) && (r && (r += " "), r += t);
  return r;
}
const Bs = dn({});
var Ge = function() {
  return Ge = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ge.apply(this, arguments);
};
function Gs(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function i3(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var a3 = function() {
}, ks = typeof window < "u", s3 = ks ? Sr : te;
const c3 = s3;
var xs = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function u3() {
  var e = Re(null), t = e[0], n = e[1], r = Re(xs), o = r[0], i = r[1], a = Oe(function() {
    return new window.ResizeObserver(function(s) {
      if (s[0]) {
        var c = s[0].contentRect, u = c.x, E = c.y, l = c.width, f = c.height, _ = c.top, S = c.left, d = c.bottom, T = c.right;
        i({ x: u, y: E, width: l, height: f, top: _, left: S, bottom: d, right: T });
      }
    });
  }, []);
  return c3(function() {
    if (t)
      return a.observe(t), function() {
        a.disconnect();
      };
  }, [t]), [n, o];
}
const E3 = ks && typeof window.ResizeObserver < "u" ? u3 : function() {
  return [a3, xs];
};
function l3() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Fs(t)) && (r && (r += " "), r += n);
  return r;
}
function Fs(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = Fs(e[r])) && (n && (n += " "), n += t);
  return n;
}
var qo = "-";
function _3(e) {
  var t = T3(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function i(s) {
    var c = s.split(qo);
    return c[0] === "" && c.length !== 1 && c.shift(), Ws(c, t) || d3(s);
  }
  function a(s, c) {
    var u = n[s] || [];
    return c && o[s] ? [].concat(u, o[s]) : u;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: a
  };
}
function Ws(e, t) {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? Ws(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var i = e.join(qo);
    return (a = t.validators.find(function(s) {
      var c = s.validator;
      return c(i);
    })) == null ? void 0 : a.classGroupId;
  }
}
var qi = /^\[(.+)\]$/;
function d3(e) {
  if (qi.test(e)) {
    var t = qi.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function T3(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = S3(Object.entries(e.classGroups), n);
  return o.forEach(function(i) {
    var a = i[0], s = i[1];
    go(s, r, a, t);
  }), r;
}
function go(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var i = o === "" ? t : Qi(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (f3(o)) {
        go(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(a) {
      var s = a[0], c = a[1];
      go(c, Qi(t, s), n, r);
    });
  });
}
function Qi(e, t) {
  var n = e;
  return t.split(qo).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function f3(e) {
  return e.isThemeGetter;
}
function S3(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], i = o.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var c = s[0], u = s[1];
        return [t + c, u];
      })) : a;
    });
    return [r, i];
  }) : e;
}
function R3(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, a) {
    n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return o(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : o(a, s);
    }
  };
}
var Ks = "!";
function N3(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(a) {
    for (var s = [], c = 0, u = 0, E, l = 0; l < a.length; l++) {
      var f = a[l];
      if (c === 0) {
        if (f === r && (n || a.slice(l, l + o) === t)) {
          s.push(a.slice(u, l)), u = l + o;
          continue;
        }
        if (f === "/") {
          E = l;
          continue;
        }
      }
      f === "[" ? c++ : f === "]" && c--;
    }
    var _ = s.length === 0 ? a : a.substring(u), S = _.startsWith(Ks), d = S ? _.substring(1) : _, T = E && E > u ? E - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: S,
      baseClassName: d,
      maybePostfixModifierPosition: T
    };
  };
}
function O3(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function I3(e) {
  return {
    cache: R3(e.cacheSize),
    splitModifiers: N3(e),
    ..._3(e)
  };
}
var p3 = /\s+/;
function h3(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(p3).map(function(a) {
    var s = n(a), c = s.modifiers, u = s.hasImportantModifier, E = s.baseClassName, l = s.maybePostfixModifierPosition, f = r(l ? E.substring(0, l) : E), _ = !!l;
    if (!f) {
      if (!l)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (f = r(E), !f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      _ = !1;
    }
    var S = O3(c).join(":"), d = u ? S + Ks : S;
    return {
      isTailwindClass: !0,
      modifierId: d,
      classGroupId: f,
      originalClassName: a,
      hasPostfixModifier: _
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, c = a.classGroupId, u = a.hasPostfixModifier, E = s + c;
    return i.has(E) ? !1 : (i.add(E), o(c, u).forEach(function(l) {
      return i.add(s + l);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function A3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, i, a = s;
  function s(u) {
    var E = t[0], l = t.slice(1), f = l.reduce(function(_, S) {
      return S(_);
    }, E());
    return r = I3(f), o = r.cache.get, i = r.cache.set, a = c, c(u);
  }
  function c(u) {
    var E = o(u);
    if (E)
      return E;
    var l = h3(u, r);
    return i(u, l), l;
  }
  return function() {
    return a(l3.apply(null, arguments));
  };
}
function ue(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var zs = /^\[(?:([a-z-]+):)?(.+)\]$/i, g3 = /^\d+\/\d+$/, v3 = /* @__PURE__ */ new Set(["px", "full", "screen"]), D3 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, m3 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, L3 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function ye(e) {
  return vt(e) || v3.has(e) || g3.test(e) || vo(e);
}
function vo(e) {
  return Pt(e, "length", M3);
}
function C3(e) {
  return Pt(e, "size", Ys);
}
function P3(e) {
  return Pt(e, "position", Ys);
}
function y3(e) {
  return Pt(e, "url", w3);
}
function Dn(e) {
  return Pt(e, "number", vt);
}
function vt(e) {
  return !Number.isNaN(Number(e));
}
function U3(e) {
  return e.endsWith("%") && vt(e.slice(0, -1));
}
function tn(e) {
  return Ji(e) || Pt(e, "number", Ji);
}
function J(e) {
  return zs.test(e);
}
function nn() {
  return !0;
}
function tt(e) {
  return D3.test(e);
}
function b3(e) {
  return Pt(e, "", $3);
}
function Pt(e, t, n) {
  var r = zs.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function M3(e) {
  return m3.test(e);
}
function Ys() {
  return !1;
}
function w3(e) {
  return e.startsWith("url(");
}
function Ji(e) {
  return Number.isInteger(Number(e));
}
function $3(e) {
  return L3.test(e);
}
function H3() {
  var e = ue("colors"), t = ue("spacing"), n = ue("blur"), r = ue("brightness"), o = ue("borderColor"), i = ue("borderRadius"), a = ue("borderSpacing"), s = ue("borderWidth"), c = ue("contrast"), u = ue("grayscale"), E = ue("hueRotate"), l = ue("invert"), f = ue("gap"), _ = ue("gradientColorStops"), S = ue("gradientColorStopPositions"), d = ue("inset"), T = ue("margin"), O = ue("opacity"), h = ue("padding"), N = ue("saturate"), I = ue("scale"), R = ue("sepia"), p = ue("skew"), A = ue("space"), g = ue("translate"), v = function() {
    return ["auto", "contain", "none"];
  }, D = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, m = function() {
    return ["auto", J, t];
  }, L = function() {
    return [J, t];
  }, P = function() {
    return ["", ye];
  }, U = function() {
    return ["auto", vt, J];
  }, M = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, H = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, x = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, F = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, z = function() {
    return ["", "0", J];
  }, y = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, b = function() {
    return [vt, Dn];
  }, V = function() {
    return [vt, J];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [nn],
      spacing: [ye],
      blur: ["none", "", tt, J],
      brightness: b(),
      borderColor: [e],
      borderRadius: ["none", "", "full", tt, J],
      borderSpacing: L(),
      borderWidth: P(),
      contrast: b(),
      grayscale: z(),
      hueRotate: V(),
      invert: z(),
      gap: L(),
      gradientColorStops: [e],
      gradientColorStopPositions: [U3, vo],
      inset: m(),
      margin: m(),
      opacity: b(),
      padding: L(),
      saturate: b(),
      scale: b(),
      sepia: z(),
      skew: V(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", J]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [tt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(M(), [J])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: v()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": v()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": v()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [d]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [d]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [d]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [d]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [d]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [d]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [d]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [d]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [d]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", tn]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: m()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", J]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", tn]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [nn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", tn]
        }, J]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [nn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [tn]
        }, J]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", J]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", J]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(F())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(F(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(F(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [h]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [h]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [h]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [h]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [h]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [h]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [h]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [h]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [h]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [T]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [T]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [T]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [T]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [T]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [T]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [T]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [T]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [T]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", J, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", J, ye]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [tt]
        }, tt, J]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [J, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", J, ye]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [J, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", tt, vo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Dn]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [nn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", J]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", vt, Dn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", J, ye]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", J]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", J]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [O]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [O]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(H(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ye]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", J, ye]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", J]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", J]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [O]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(M(), [P3])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", C3]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, y3]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [S]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [S]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [S]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [_]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [_]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [_]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [O]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(H(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [O]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: H()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(H())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [J, ye]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ye]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: P()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [O]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ye]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", tt, b3]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [nn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [O]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": x()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": x()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", tt, J]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [E]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [l]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [N]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [E]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [l]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [O]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [N]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", J]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: V()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", J]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: V()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", J]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [I]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [I]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [I]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [tn, J]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [g]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [g]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [p]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [p]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", J]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", J]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", J]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ye, Dn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var V3 = /* @__PURE__ */ A3(H3);
const kt = (...e) => V3(Xo(...e)), Do = ({ children: e, className: t, flat: n, primary: r, ...o }) => /* @__PURE__ */ C(
  "button",
  {
    ...o,
    className: kt(
      "h-10 rounded bg-white px-4 font-body text-indigo-50 shadow-elevation-1 outline-1 outline-violet-50 hover:bg-gray-34 disabled:bg-gray-34 disabled:text-gray-50",
      n && "shadow-elevation-0",
      r && "bg-green-50 hover:bg-green-55",
      t
    ),
    children: e
  }
), ea = ({ children: e, count: t, className: n }) => /* @__PURE__ */ j(
  "div",
  {
    className: kt(
      "flex w-fit flex-row items-center gap-6 rounded-full bg-violet-50 px-3 py-2 text-indigo-50",
      n
    ),
    children: [
      /* @__PURE__ */ C("span", { className: "font-heading text-sm", children: e }),
      /* @__PURE__ */ C("span", { className: "rounded-full bg-white px-1 font-body text-xs text-indigo-50", children: t.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: !1
      }) })
    ]
  }
);
function pe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Qo(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = /* @__PURE__ */ dn(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function u(l) {
      const { scope: f, children: _, ...S } = l, d = (f == null ? void 0 : f[e][c]) || s, T = Oe(
        () => S,
        Object.values(S)
      );
      return /* @__PURE__ */ Z(d.Provider, {
        value: T
      }, _);
    }
    function E(l, f) {
      const _ = (f == null ? void 0 : f[e][c]) || s, S = Yt(_);
      if (S)
        return S;
      if (a !== void 0)
        return a;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      E
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ dn(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Oe(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    B3(o, ...t)
  ];
}
function B3(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return Oe(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Tt(e) {
  const t = ee(e);
  return te(() => {
    t.current = e;
  }), Oe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function js({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = G3({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = Tt(n), c = ve((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else
      o(u);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    c
  ];
}
function G3({ defaultProp: e, onChange: t }) {
  const n = Re(e), [r] = n, o = ee(r), i = Tt(t);
  return te(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function k3(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Zs(...e) {
  return (t) => e.forEach(
    (n) => k3(n, t)
  );
}
function It(...e) {
  return ve(Zs(...e), e);
}
const x3 = ["top", "right", "bottom", "left"], ft = Math.min, ge = Math.max, Qn = Math.round, mn = Math.floor, St = (e) => ({
  x: e,
  y: e
}), F3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, W3 = {
  start: "end",
  end: "start"
};
function mo(e, t, n) {
  return ge(e, ft(t, n));
}
function Xe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qe(e) {
  return e.split("-")[0];
}
function jt(e) {
  return e.split("-")[1];
}
function Jo(e) {
  return e === "x" ? "y" : "x";
}
function ei(e) {
  return e === "y" ? "height" : "width";
}
function Zt(e) {
  return ["top", "bottom"].includes(qe(e)) ? "y" : "x";
}
function ti(e) {
  return Jo(Zt(e));
}
function K3(e, t, n) {
  n === void 0 && (n = !1);
  const r = jt(e), o = ti(e), i = ei(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Jn(a)), [a, Jn(a)];
}
function z3(e) {
  const t = Jn(e);
  return [Lo(e), t, Lo(t)];
}
function Lo(e) {
  return e.replace(/start|end/g, (t) => W3[t]);
}
function Y3(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function j3(e, t, n, r) {
  const o = jt(e);
  let i = Y3(qe(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Lo)))), i;
}
function Jn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => F3[t]);
}
function Z3(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Xs(e) {
  return typeof e != "number" ? Z3(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function er(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function ta(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Zt(t), a = ti(t), s = ei(a), c = qe(t), u = i === "y", E = r.x + r.width / 2 - o.width / 2, l = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let _;
  switch (c) {
    case "top":
      _ = {
        x: E,
        y: r.y - o.height
      };
      break;
    case "bottom":
      _ = {
        x: E,
        y: r.y + r.height
      };
      break;
    case "right":
      _ = {
        x: r.x + r.width,
        y: l
      };
      break;
    case "left":
      _ = {
        x: r.x - o.width,
        y: l
      };
      break;
    default:
      _ = {
        x: r.x,
        y: r.y
      };
  }
  switch (jt(t)) {
    case "start":
      _[a] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      _[a] += f * (n && u ? -1 : 1);
      break;
  }
  return _;
}
const X3 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: E,
    y: l
  } = ta(u, r, c), f = r, _ = {}, S = 0;
  for (let d = 0; d < s.length; d++) {
    const {
      name: T,
      fn: O
    } = s[d], {
      x: h,
      y: N,
      data: I,
      reset: R
    } = await O({
      x: E,
      y: l,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: _,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (E = h ?? E, l = N ?? l, _ = {
      ..._,
      [T]: {
        ..._[T],
        ...I
      }
    }, R && S <= 50) {
      S++, typeof R == "object" && (R.placement && (f = R.placement), R.rects && (u = R.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : R.rects), {
        x: E,
        y: l
      } = ta(u, f, c)), d = -1;
      continue;
    }
  }
  return {
    x: E,
    y: l,
    placement: f,
    strategy: o,
    middlewareData: _
  };
};
async function fn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: E = "viewport",
    elementContext: l = "floating",
    altBoundary: f = !1,
    padding: _ = 0
  } = Xe(t, e), S = Xs(_), T = s[f ? l === "floating" ? "reference" : "floating" : l], O = er(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(T))) == null || n ? T : T.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: E,
    strategy: c
  })), h = l === "floating" ? {
    ...a.floating,
    x: r,
    y: o
  } : a.reference, N = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), I = await (i.isElement == null ? void 0 : i.isElement(N)) ? await (i.getScale == null ? void 0 : i.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = er(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: h,
    offsetParent: N,
    strategy: c
  }) : h);
  return {
    top: (O.top - R.top + S.top) / I.y,
    bottom: (R.bottom - O.bottom + S.bottom) / I.y,
    left: (O.left - R.left + S.left) / I.x,
    right: (R.right - O.right + S.right) / I.x
  };
}
const na = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = Xe(e, t) || {};
    if (c == null)
      return {};
    const E = Xs(u), l = {
      x: n,
      y: r
    }, f = ti(o), _ = ei(f), S = await a.getDimensions(c), d = f === "y", T = d ? "top" : "left", O = d ? "bottom" : "right", h = d ? "clientHeight" : "clientWidth", N = i.reference[_] + i.reference[f] - l[f] - i.floating[_], I = l[f] - i.reference[f], R = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let p = R ? R[h] : 0;
    (!p || !await (a.isElement == null ? void 0 : a.isElement(R))) && (p = s.floating[h] || i.floating[_]);
    const A = N / 2 - I / 2, g = p / 2 - S[_] / 2 - 1, v = ft(E[T], g), D = ft(E[O], g), m = v, L = p - S[_] - D, P = p / 2 - S[_] / 2 + A, U = mo(m, P, L), H = jt(o) != null && P != U && i.reference[_] / 2 - (P < m ? v : D) - S[_] / 2 < 0 ? P < m ? m - P : L - P : 0;
    return {
      [f]: l[f] - H,
      data: {
        [f]: U,
        centerOffset: P - U + H
      }
    };
  }
}), q3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: a,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: E = !0,
        fallbackPlacements: l,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: _ = "none",
        flipAlignment: S = !0,
        ...d
      } = Xe(e, t), T = qe(r), O = qe(a) === a, h = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), N = l || (O || !S ? [Jn(a)] : z3(a));
      !l && _ !== "none" && N.push(...j3(a, S, _, h));
      const I = [a, ...N], R = await fn(t, d), p = [];
      let A = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (u && p.push(R[T]), E) {
        const m = K3(r, i, h);
        p.push(R[m[0]], R[m[1]]);
      }
      if (A = [...A, {
        placement: r,
        overflows: p
      }], !p.every((m) => m <= 0)) {
        var g, v;
        const m = (((g = o.flip) == null ? void 0 : g.index) || 0) + 1, L = I[m];
        if (L)
          return {
            data: {
              index: m,
              overflows: A
            },
            reset: {
              placement: L
            }
          };
        let P = (v = A.filter((U) => U.overflows[0] <= 0).sort((U, M) => U.overflows[1] - M.overflows[1])[0]) == null ? void 0 : v.placement;
        if (!P)
          switch (f) {
            case "bestFit": {
              var D;
              const U = (D = A.map((M) => [M.placement, M.overflows.filter((H) => H > 0).reduce((H, x) => H + x, 0)]).sort((M, H) => M[1] - H[1])[0]) == null ? void 0 : D[0];
              U && (P = U);
              break;
            }
            case "initialPlacement":
              P = a;
              break;
          }
        if (r !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
function ra(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function oa(e) {
  return x3.some((t) => e[t] >= 0);
}
const Q3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Xe(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await fn(t, {
            ...o,
            elementContext: "reference"
          }), a = ra(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: oa(a)
            }
          };
        }
        case "escaped": {
          const i = await fn(t, {
            ...o,
            altBoundary: !0
          }), a = ra(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: oa(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function J3(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = qe(n), s = jt(n), c = Zt(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, E = i && c ? -1 : 1, l = Xe(t, e);
  let {
    mainAxis: f,
    crossAxis: _,
    alignmentAxis: S
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof S == "number" && (_ = s === "end" ? S * -1 : S), c ? {
    x: _ * E,
    y: f * u
  } : {
    x: f * u,
    y: _ * E
  };
}
const eK = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await J3(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, tK = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (T) => {
            let {
              x: O,
              y: h
            } = T;
            return {
              x: O,
              y: h
            };
          }
        },
        ...c
      } = Xe(e, t), u = {
        x: n,
        y: r
      }, E = await fn(t, c), l = Zt(qe(o)), f = Jo(l);
      let _ = u[f], S = u[l];
      if (i) {
        const T = f === "y" ? "top" : "left", O = f === "y" ? "bottom" : "right", h = _ + E[T], N = _ - E[O];
        _ = mo(h, _, N);
      }
      if (a) {
        const T = l === "y" ? "top" : "left", O = l === "y" ? "bottom" : "right", h = S + E[T], N = S - E[O];
        S = mo(h, S, N);
      }
      const d = s.fn({
        ...t,
        [f]: _,
        [l]: S
      });
      return {
        ...d,
        data: {
          x: d.x - n,
          y: d.y - r
        }
      };
    }
  };
}, nK = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = Xe(e, t), E = {
        x: n,
        y: r
      }, l = Zt(o), f = Jo(l);
      let _ = E[f], S = E[l];
      const d = Xe(s, t), T = typeof d == "number" ? {
        mainAxis: d,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...d
      };
      if (c) {
        const N = f === "y" ? "height" : "width", I = i.reference[f] - i.floating[N] + T.mainAxis, R = i.reference[f] + i.reference[N] - T.mainAxis;
        _ < I ? _ = I : _ > R && (_ = R);
      }
      if (u) {
        var O, h;
        const N = f === "y" ? "width" : "height", I = ["top", "left"].includes(qe(o)), R = i.reference[l] - i.floating[N] + (I && ((O = a.offset) == null ? void 0 : O[l]) || 0) + (I ? 0 : T.crossAxis), p = i.reference[l] + i.reference[N] + (I ? 0 : ((h = a.offset) == null ? void 0 : h[l]) || 0) - (I ? T.crossAxis : 0);
        S < R ? S = R : S > p && (S = p);
      }
      return {
        [f]: _,
        [l]: S
      };
    }
  };
}, rK = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: a = () => {
        },
        ...s
      } = Xe(e, t), c = await fn(t, s), u = qe(n), E = jt(n), l = Zt(n) === "y", {
        width: f,
        height: _
      } = r.floating;
      let S, d;
      u === "top" || u === "bottom" ? (S = u, d = E === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (d = u, S = E === "end" ? "top" : "bottom");
      const T = _ - c[S], O = f - c[d], h = !t.middlewareData.shift;
      let N = T, I = O;
      if (l) {
        const p = f - c.left - c.right;
        I = E || h ? ft(O, p) : p;
      } else {
        const p = _ - c.top - c.bottom;
        N = E || h ? ft(T, p) : p;
      }
      if (h && !E) {
        const p = ge(c.left, 0), A = ge(c.right, 0), g = ge(c.top, 0), v = ge(c.bottom, 0);
        l ? I = f - 2 * (p !== 0 || A !== 0 ? p + A : ge(c.left, c.right)) : N = _ - 2 * (g !== 0 || v !== 0 ? g + v : ge(c.top, c.bottom));
      }
      await a({
        ...t,
        availableWidth: I,
        availableHeight: N
      });
      const R = await o.getDimensions(i.floating);
      return f !== R.width || _ !== R.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Rt(e) {
  return qs(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function De(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function et(e) {
  var t;
  return (t = (qs(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function qs(e) {
  return e instanceof Node || e instanceof De(e).Node;
}
function Qe(e) {
  return e instanceof Element || e instanceof De(e).Element;
}
function We(e) {
  return e instanceof HTMLElement || e instanceof De(e).HTMLElement;
}
function ia(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof De(e).ShadowRoot;
}
function hn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function oK(e) {
  return ["table", "td", "th"].includes(Rt(e));
}
function ni(e) {
  const t = ri(), n = Ce(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function iK(e) {
  let t = xt(e);
  for (; We(t) && !Ir(t); ) {
    if (ni(t))
      return t;
    t = xt(t);
  }
  return null;
}
function ri() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ir(e) {
  return ["html", "body", "#document"].includes(Rt(e));
}
function Ce(e) {
  return De(e).getComputedStyle(e);
}
function pr(e) {
  return Qe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function xt(e) {
  if (Rt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ia(e) && e.host || // Fallback.
    et(e)
  );
  return ia(t) ? t.host : t;
}
function Qs(e) {
  const t = xt(e);
  return Ir(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : We(t) && hn(t) ? t : Qs(t);
}
function tr(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Qs(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = De(r);
  return o ? t.concat(i, i.visualViewport || [], hn(r) ? r : []) : t.concat(r, tr(r));
}
function Js(e) {
  const t = Ce(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = We(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Qn(n) !== i || Qn(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function oi(e) {
  return Qe(e) ? e : e.contextElement;
}
function Ht(e) {
  const t = oi(e);
  if (!We(t))
    return St(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Js(t);
  let a = (i ? Qn(n.width) : n.width) / r, s = (i ? Qn(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const aK = /* @__PURE__ */ St(0);
function ec(e) {
  const t = De(e);
  return !ri() || !t.visualViewport ? aK : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sK(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== De(e) ? !1 : t;
}
function Ct(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = oi(e);
  let a = St(1);
  t && (r ? Qe(r) && (a = Ht(r)) : a = Ht(e));
  const s = sK(i, n, r) ? ec(i) : St(0);
  let c = (o.left + s.x) / a.x, u = (o.top + s.y) / a.y, E = o.width / a.x, l = o.height / a.y;
  if (i) {
    const f = De(i), _ = r && Qe(r) ? De(r) : r;
    let S = f.frameElement;
    for (; S && r && _ !== f; ) {
      const d = Ht(S), T = S.getBoundingClientRect(), O = Ce(S), h = T.left + (S.clientLeft + parseFloat(O.paddingLeft)) * d.x, N = T.top + (S.clientTop + parseFloat(O.paddingTop)) * d.y;
      c *= d.x, u *= d.y, E *= d.x, l *= d.y, c += h, u += N, S = De(S).frameElement;
    }
  }
  return er({
    width: E,
    height: l,
    x: c,
    y: u
  });
}
function cK(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = We(n), i = et(n);
  if (n === i)
    return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = St(1);
  const c = St(0);
  if ((o || !o && r !== "fixed") && ((Rt(n) !== "body" || hn(i)) && (a = pr(n)), We(n))) {
    const u = Ct(n);
    s = Ht(n), c.x = u.x + n.clientLeft, c.y = u.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - a.scrollLeft * s.x + c.x,
    y: t.y * s.y - a.scrollTop * s.y + c.y
  };
}
function uK(e) {
  return Array.from(e.getClientRects());
}
function tc(e) {
  return Ct(et(e)).left + pr(e).scrollLeft;
}
function EK(e) {
  const t = et(e), n = pr(e), r = e.ownerDocument.body, o = ge(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = ge(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + tc(e);
  const s = -n.scrollTop;
  return Ce(r).direction === "rtl" && (a += ge(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function lK(e, t) {
  const n = De(e), r = et(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    const u = ri();
    (!u || u && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function _K(e, t) {
  const n = Ct(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = We(e) ? Ht(e) : St(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, c = o * i.x, u = r * i.y;
  return {
    width: a,
    height: s,
    x: c,
    y: u
  };
}
function aa(e, t, n) {
  let r;
  if (t === "viewport")
    r = lK(e, n);
  else if (t === "document")
    r = EK(et(e));
  else if (Qe(t))
    r = _K(t, n);
  else {
    const o = ec(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return er(r);
}
function nc(e, t) {
  const n = xt(e);
  return n === t || !Qe(n) || Ir(n) ? !1 : Ce(n).position === "fixed" || nc(n, t);
}
function dK(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = tr(e).filter((s) => Qe(s) && Rt(s) !== "body"), o = null;
  const i = Ce(e).position === "fixed";
  let a = i ? xt(e) : e;
  for (; Qe(a) && !Ir(a); ) {
    const s = Ce(a), c = ni(a);
    !c && s.position === "fixed" && (o = null), (i ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || hn(a) && !c && nc(e, a)) ? r = r.filter((E) => E !== a) : o = s, a = xt(a);
  }
  return t.set(e, r), r;
}
function TK(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? dK(t, this._c) : [].concat(n), r], s = a[0], c = a.reduce((u, E) => {
    const l = aa(t, E, o);
    return u.top = ge(l.top, u.top), u.right = ft(l.right, u.right), u.bottom = ft(l.bottom, u.bottom), u.left = ge(l.left, u.left), u;
  }, aa(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function fK(e) {
  return Js(e);
}
function SK(e, t, n) {
  const r = We(t), o = et(t), i = n === "fixed", a = Ct(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = St(0);
  if (r || !r && !i)
    if ((Rt(t) !== "body" || hn(o)) && (s = pr(t)), r) {
      const u = Ct(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else
      o && (c.x = tc(o));
  return {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function sa(e, t) {
  return !We(e) || Ce(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function rc(e, t) {
  const n = De(e);
  if (!We(e))
    return n;
  let r = sa(e, t);
  for (; r && oK(r) && Ce(r).position === "static"; )
    r = sa(r, t);
  return r && (Rt(r) === "html" || Rt(r) === "body" && Ce(r).position === "static" && !ni(r)) ? n : r || iK(e) || n;
}
const RK = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || rc, i = this.getDimensions;
  return {
    reference: SK(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function NK(e) {
  return Ce(e).direction === "rtl";
}
const OK = {
  convertOffsetParentRelativeRectToViewportRelativeRect: cK,
  getDocumentElement: et,
  getClippingRect: TK,
  getOffsetParent: rc,
  getElementRects: RK,
  getClientRects: uK,
  getDimensions: fK,
  getScale: Ht,
  isElement: Qe,
  isRTL: NK
};
function IK(e, t) {
  let n = null, r;
  const o = et(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: E,
      width: l,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !l || !f)
      return;
    const _ = mn(E), S = mn(o.clientWidth - (u + l)), d = mn(o.clientHeight - (E + f)), T = mn(u), h = {
      rootMargin: -_ + "px " + -S + "px " + -d + "px " + -T + "px",
      threshold: ge(0, ft(1, c)) || 1
    };
    let N = !0;
    function I(R) {
      const p = R[0].intersectionRatio;
      if (p !== c) {
        if (!N)
          return a();
        p ? a(!1, p) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      N = !1;
    }
    try {
      n = new IntersectionObserver(I, {
        ...h,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(I, h);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function pK(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = oi(e), E = o || i ? [...u ? tr(u) : [], ...tr(t)] : [];
  E.forEach((O) => {
    o && O.addEventListener("scroll", n, {
      passive: !0
    }), i && O.addEventListener("resize", n);
  });
  const l = u && s ? IK(u, n) : null;
  let f = -1, _ = null;
  a && (_ = new ResizeObserver((O) => {
    let [h] = O;
    h && h.target === u && _ && (_.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      _ && _.observe(t);
    })), n();
  }), u && !c && _.observe(u), _.observe(t));
  let S, d = c ? Ct(e) : null;
  c && T();
  function T() {
    const O = Ct(e);
    d && (O.x !== d.x || O.y !== d.y || O.width !== d.width || O.height !== d.height) && n(), d = O, S = requestAnimationFrame(T);
  }
  return n(), () => {
    E.forEach((O) => {
      o && O.removeEventListener("scroll", n), i && O.removeEventListener("resize", n);
    }), l && l(), _ && _.disconnect(), _ = null, c && cancelAnimationFrame(S);
  };
}
const hK = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: OK,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return X3(e, t, {
    ...o,
    platform: i
  });
}, AK = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? na({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? na({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var xn = typeof document < "u" ? Sr : te;
function nr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!nr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !nr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function oc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ca(e, t) {
  const n = oc(e);
  return Math.round(t * n) / n;
}
function ua(e) {
  const t = Y.useRef(e);
  return xn(() => {
    t.current = e;
  }), t;
}
function gK(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [E, l] = Y.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, _] = Y.useState(r);
  nr(f, r) || _(r);
  const [S, d] = Y.useState(null), [T, O] = Y.useState(null), h = Y.useCallback((H) => {
    H != p.current && (p.current = H, d(H));
  }, [d]), N = Y.useCallback((H) => {
    H !== A.current && (A.current = H, O(H));
  }, [O]), I = i || S, R = a || T, p = Y.useRef(null), A = Y.useRef(null), g = Y.useRef(E), v = ua(c), D = ua(o), m = Y.useCallback(() => {
    if (!p.current || !A.current)
      return;
    const H = {
      placement: t,
      strategy: n,
      middleware: f
    };
    D.current && (H.platform = D.current), hK(p.current, A.current, H).then((x) => {
      const F = {
        ...x,
        isPositioned: !0
      };
      L.current && !nr(g.current, F) && (g.current = F, pu.flushSync(() => {
        l(F);
      }));
    });
  }, [f, t, n, D]);
  xn(() => {
    u === !1 && g.current.isPositioned && (g.current.isPositioned = !1, l((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [u]);
  const L = Y.useRef(!1);
  xn(() => (L.current = !0, () => {
    L.current = !1;
  }), []), xn(() => {
    if (I && (p.current = I), R && (A.current = R), I && R) {
      if (v.current)
        return v.current(I, R, m);
      m();
    }
  }, [I, R, m, v]);
  const P = Y.useMemo(() => ({
    reference: p,
    floating: A,
    setReference: h,
    setFloating: N
  }), [h, N]), U = Y.useMemo(() => ({
    reference: I,
    floating: R
  }), [I, R]), M = Y.useMemo(() => {
    const H = {
      position: n,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return H;
    const x = ca(U.floating, E.x), F = ca(U.floating, E.y);
    return s ? {
      ...H,
      transform: "translate(" + x + "px, " + F + "px)",
      ...oc(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: x,
      top: F
    };
  }, [n, s, U.floating, E.x, E.y]);
  return Y.useMemo(() => ({
    ...E,
    update: m,
    refs: P,
    elements: U,
    floatingStyles: M
  }), [E, m, P, U, M]);
}
const ii = /* @__PURE__ */ Te((e, t) => {
  const { children: n, ...r } = e, o = st.toArray(n), i = o.find(DK);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? st.count(a) > 1 ? st.only(null) : /* @__PURE__ */ lt(a) ? a.props.children : null : c);
    return /* @__PURE__ */ Z(Co, ce({}, r, {
      ref: t
    }), /* @__PURE__ */ lt(a) ? /* @__PURE__ */ Rr(a, void 0, s) : null);
  }
  return /* @__PURE__ */ Z(Co, ce({}, r, {
    ref: t
  }), n);
});
ii.displayName = "Slot";
const Co = /* @__PURE__ */ Te((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ lt(n) ? /* @__PURE__ */ Rr(n, {
    ...mK(r, n.props),
    ref: t ? Zs(t, n.ref) : n.ref
  }) : st.count(n) > 1 ? st.only(null) : null;
});
Co.displayName = "SlotClone";
const vK = ({ children: e }) => /* @__PURE__ */ Z(Os, null, e);
function DK(e) {
  return /* @__PURE__ */ lt(e) && e.type === vK;
}
function mK(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const LK = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $e = LK.reduce((e, t) => {
  const n = /* @__PURE__ */ Te((r, o) => {
    const { asChild: i, ...a } = r, s = i ? ii : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Z(s, ce({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function CK(e, t) {
  e && hs(
    () => e.dispatchEvent(t)
  );
}
const PK = /* @__PURE__ */ Te((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ Z($e.svg, ce({}, i, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ Z("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), yK = PK, Ft = globalThis != null && globalThis.document ? Sr : () => {
};
function UK(e) {
  const [t, n] = Re(void 0);
  return Ft(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const ic = "Popper", [ac, sc] = Qo(ic), [bK, cc] = ac(ic), MK = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = Re(null);
  return /* @__PURE__ */ Z(bK, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, wK = "PopperAnchor", $K = /* @__PURE__ */ Te((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, i = cc(wK, n), a = ee(null), s = It(t, a);
  return te(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ Z($e.div, ce({}, o, {
    ref: s
  }));
}), uc = "PopperContent", [HK, VK] = ac(uc), BK = /* @__PURE__ */ Te((e, t) => {
  var n, r, o, i, a, s, c, u;
  const { __scopePopper: E, side: l = "bottom", sideOffset: f = 0, align: _ = "center", alignOffset: S = 0, arrowPadding: d = 0, collisionBoundary: T = [], collisionPadding: O = 0, sticky: h = "partial", hideWhenDetached: N = !1, avoidCollisions: I = !0, onPlaced: R, ...p } = e, A = cc(uc, E), [g, v] = Re(null), D = It(
    t,
    (W) => v(W)
  ), [m, L] = Re(null), P = UK(m), U = (n = P == null ? void 0 : P.width) !== null && n !== void 0 ? n : 0, M = (r = P == null ? void 0 : P.height) !== null && r !== void 0 ? r : 0, H = l + (_ !== "center" ? "-" + _ : ""), x = typeof O == "number" ? O : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...O
  }, F = Array.isArray(T) ? T : [
    T
  ], z = F.length > 0, y = {
    padding: x,
    boundary: F.filter(FK),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: z
  }, { refs: b, floatingStyles: V, placement: w, isPositioned: B, middlewareData: G } = gK({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: H,
    whileElementsMounted: pK,
    elements: {
      reference: A.anchor
    },
    middleware: [
      eK({
        mainAxis: f + M,
        alignmentAxis: S
      }),
      I && tK({
        mainAxis: !0,
        crossAxis: !1,
        limiter: h === "partial" ? nK() : void 0,
        ...y
      }),
      I && q3({
        ...y
      }),
      rK({
        ...y,
        apply: ({ elements: W, rects: Pe, availableWidth: He, availableHeight: Ye }) => {
          const { width: Qt, height: Jt } = Pe.reference, pt = W.floating.style;
          pt.setProperty("--radix-popper-available-width", `${He}px`), pt.setProperty("--radix-popper-available-height", `${Ye}px`), pt.setProperty("--radix-popper-anchor-width", `${Qt}px`), pt.setProperty("--radix-popper-anchor-height", `${Jt}px`);
        }
      }),
      m && AK({
        element: m,
        padding: d
      }),
      WK({
        arrowWidth: U,
        arrowHeight: M
      }),
      N && Q3({
        strategy: "referenceHidden"
      })
    ]
  }), [k, K] = Ec(w), X = Tt(R);
  Ft(() => {
    B && (X == null || X());
  }, [
    B,
    X
  ]);
  const Q = (o = G.arrow) === null || o === void 0 ? void 0 : o.x, q = (i = G.arrow) === null || i === void 0 ? void 0 : i.y, ae = ((a = G.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [$, se] = Re();
  return Ft(() => {
    g && se(window.getComputedStyle(g).zIndex);
  }, [
    g
  ]), /* @__PURE__ */ Z("div", {
    ref: b.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...V,
      transform: B ? V.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: $,
      "--radix-popper-transform-origin": [
        (s = G.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = G.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Z(HK, {
    scope: E,
    placedSide: k,
    onArrowChange: L,
    arrowX: Q,
    arrowY: q,
    shouldHideArrow: ae
  }, /* @__PURE__ */ Z($e.div, ce({
    "data-side": k,
    "data-align": K
  }, p, {
    ref: D,
    style: {
      ...p.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: B ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = G.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
}), GK = "PopperArrow", kK = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, xK = /* @__PURE__ */ Te(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = VK(GK, r), a = kK[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Z("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Z(yK, ce({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function FK(e) {
  return e !== null;
}
const WK = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, i, a;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = l ? 0 : e.arrowWidth, _ = l ? 0 : e.arrowHeight, [S, d] = Ec(s), T = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[d], O = ((r = (o = u.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, h = ((i = (a = u.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + _ / 2;
    let N = "", I = "";
    return S === "bottom" ? (N = l ? T : `${O}px`, I = `${-_}px`) : S === "top" ? (N = l ? T : `${O}px`, I = `${c.floating.height + _}px`) : S === "right" ? (N = `${-_}px`, I = l ? T : `${h}px`) : S === "left" && (N = `${c.floating.width + _}px`, I = l ? T : `${h}px`), {
      data: {
        x: N,
        y: I
      }
    };
  }
});
function Ec(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const KK = MK, zK = $K, YK = BK, jK = xK, lc = /* @__PURE__ */ Te((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ hu.createPortal(/* @__PURE__ */ Z($e.div, ce({}, o, {
    ref: t
  })), r) : null;
});
function ZK(e, t) {
  return Ou((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Xt = (e) => {
  const { present: t, children: n } = e, r = XK(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : st.only(n), i = It(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Rr(o, {
    ref: i
  }) : null;
};
Xt.displayName = "Presence";
function XK(e) {
  const [t, n] = Re(), r = ee({}), o = ee(e), i = ee("none"), a = e ? "mounted" : "unmounted", [s, c] = ZK(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return te(() => {
    const u = Ln(r.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), Ft(() => {
    const u = r.current, E = o.current;
    if (E !== e) {
      const f = i.current, _ = Ln(u);
      e ? c("MOUNT") : _ === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(E && f !== _ ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), Ft(() => {
    if (t) {
      const u = (l) => {
        const _ = Ln(r.current).includes(l.animationName);
        l.target === t && _ && hs(
          () => c("ANIMATION_END")
        );
      }, E = (l) => {
        l.target === t && (i.current = Ln(r.current));
      };
      return t.addEventListener("animationstart", E), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", E), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: ve((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Ln(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function qK(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Tt(e);
  te(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Po = "dismissableLayer.update", QK = "dismissableLayer.pointerDownOutside", JK = "dismissableLayer.focusOutside";
let Ea;
const ez = /* @__PURE__ */ dn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), _c = /* @__PURE__ */ Te((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...u } = e, E = Yt(ez), [l, f] = Re(null), _ = (n = l == null ? void 0 : l.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, S] = Re({}), d = It(
    t,
    (g) => f(g)
  ), T = Array.from(E.layers), [O] = [
    ...E.layersWithOutsidePointerEventsDisabled
  ].slice(-1), h = T.indexOf(O), N = l ? T.indexOf(l) : -1, I = E.layersWithOutsidePointerEventsDisabled.size > 0, R = N >= h, p = tz((g) => {
    const v = g.target, D = [
      ...E.branches
    ].some(
      (m) => m.contains(v)
    );
    !R || D || (i == null || i(g), s == null || s(g), g.defaultPrevented || c == null || c());
  }, _), A = nz((g) => {
    const v = g.target;
    [
      ...E.branches
    ].some(
      (m) => m.contains(v)
    ) || (a == null || a(g), s == null || s(g), g.defaultPrevented || c == null || c());
  }, _);
  return qK((g) => {
    N === E.layers.size - 1 && (o == null || o(g), !g.defaultPrevented && c && (g.preventDefault(), c()));
  }, _), te(() => {
    if (l)
      return r && (E.layersWithOutsidePointerEventsDisabled.size === 0 && (Ea = _.body.style.pointerEvents, _.body.style.pointerEvents = "none"), E.layersWithOutsidePointerEventsDisabled.add(l)), E.layers.add(l), la(), () => {
        r && E.layersWithOutsidePointerEventsDisabled.size === 1 && (_.body.style.pointerEvents = Ea);
      };
  }, [
    l,
    _,
    r,
    E
  ]), te(() => () => {
    l && (E.layers.delete(l), E.layersWithOutsidePointerEventsDisabled.delete(l), la());
  }, [
    l,
    E
  ]), te(() => {
    const g = () => S({});
    return document.addEventListener(Po, g), () => document.removeEventListener(Po, g);
  }, []), /* @__PURE__ */ Z($e.div, ce({}, u, {
    ref: d,
    style: {
      pointerEvents: I ? R ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: pe(e.onFocusCapture, A.onFocusCapture),
    onBlurCapture: pe(e.onBlurCapture, A.onBlurCapture),
    onPointerDownCapture: pe(e.onPointerDownCapture, p.onPointerDownCapture)
  }));
});
function tz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Tt(e), r = ee(!1), o = ee(() => {
  });
  return te(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          dc(QK, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, {
          once: !0
        })) : u();
      }
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function nz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Tt(e), r = ee(!1);
  return te(() => {
    const o = (i) => {
      i.target && !r.current && dc(JK, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function la() {
  const e = new CustomEvent(Po);
  document.dispatchEvent(e);
}
function dc(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? CK(o, i) : o.dispatchEvent(i);
}
let Gr;
const Tc = "HoverCard", [fc, x6] = Qo(Tc, [
  sc
]), hr = sc(), [rz, Ar] = fc(Tc), oz = (e) => {
  const { __scopeHoverCard: t, children: n, open: r, defaultOpen: o, onOpenChange: i, openDelay: a = 700, closeDelay: s = 300 } = e, c = hr(t), u = ee(0), E = ee(0), l = ee(!1), f = ee(!1), [_ = !1, S] = js({
    prop: r,
    defaultProp: o,
    onChange: i
  }), d = ve(() => {
    clearTimeout(E.current), u.current = window.setTimeout(
      () => S(!0),
      a
    );
  }, [
    a,
    S
  ]), T = ve(() => {
    clearTimeout(u.current), !l.current && !f.current && (E.current = window.setTimeout(
      () => S(!1),
      s
    ));
  }, [
    s,
    S
  ]), O = ve(
    () => S(!1),
    [
      S
    ]
  );
  return te(() => () => {
    clearTimeout(u.current), clearTimeout(E.current);
  }, []), /* @__PURE__ */ Z(rz, {
    scope: t,
    open: _,
    onOpenChange: S,
    onOpen: d,
    onClose: T,
    onDismiss: O,
    hasSelectionRef: l,
    isPointerDownOnContentRef: f
  }, /* @__PURE__ */ Z(KK, c, n));
}, iz = "HoverCardTrigger", az = /* @__PURE__ */ Te((e, t) => {
  const { __scopeHoverCard: n, ...r } = e, o = Ar(iz, n), i = hr(n);
  return /* @__PURE__ */ Z(zK, ce({
    asChild: !0
  }, i), /* @__PURE__ */ Z($e.a, ce({
    "data-state": o.open ? "open" : "closed"
  }, r, {
    ref: t,
    onPointerEnter: pe(e.onPointerEnter, rr(o.onOpen)),
    onPointerLeave: pe(e.onPointerLeave, rr(o.onClose)),
    onFocus: pe(e.onFocus, o.onOpen),
    onBlur: pe(e.onBlur, o.onClose),
    onTouchStart: pe(
      e.onTouchStart,
      (a) => a.preventDefault()
    )
  })));
}), Sc = "HoverCardPortal", [sz, cz] = fc(Sc, {
  forceMount: void 0
}), uz = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: r, container: o } = e, i = Ar(Sc, t);
  return /* @__PURE__ */ Z(sz, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Z(Xt, {
    present: n || i.open
  }, /* @__PURE__ */ Z(lc, {
    asChild: !0,
    container: o
  }, r)));
}, yo = "HoverCardContent", Ez = /* @__PURE__ */ Te((e, t) => {
  const n = cz(yo, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, i = Ar(yo, e.__scopeHoverCard);
  return /* @__PURE__ */ Z(Xt, {
    present: r || i.open
  }, /* @__PURE__ */ Z(lz, ce({
    "data-state": i.open ? "open" : "closed"
  }, o, {
    onPointerEnter: pe(e.onPointerEnter, rr(i.onOpen)),
    onPointerLeave: pe(e.onPointerLeave, rr(i.onClose)),
    ref: t
  })));
}), lz = /* @__PURE__ */ Te((e, t) => {
  const { __scopeHoverCard: n, onEscapeKeyDown: r, onPointerDownOutside: o, onFocusOutside: i, onInteractOutside: a, ...s } = e, c = Ar(yo, n), u = hr(n), E = ee(null), l = It(t, E), [f, _] = Re(!1);
  return te(() => {
    if (f) {
      const S = document.body;
      return Gr = S.style.userSelect || S.style.webkitUserSelect, S.style.userSelect = "none", S.style.webkitUserSelect = "none", () => {
        S.style.userSelect = Gr, S.style.webkitUserSelect = Gr;
      };
    }
  }, [
    f
  ]), te(() => {
    if (E.current) {
      const S = () => {
        _(!1), c.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var d;
          ((d = document.getSelection()) === null || d === void 0 ? void 0 : d.toString()) !== "" && (c.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", S), () => {
        document.removeEventListener("pointerup", S), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [
    c.isPointerDownOnContentRef,
    c.hasSelectionRef
  ]), te(() => {
    E.current && dz(E.current).forEach(
      (d) => d.setAttribute("tabindex", "-1")
    );
  }), /* @__PURE__ */ Z(_c, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onInteractOutside: a,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: pe(i, (S) => {
      S.preventDefault();
    }),
    onDismiss: c.onDismiss
  }, /* @__PURE__ */ Z(YK, ce({}, u, s, {
    onPointerDown: pe(s.onPointerDown, (S) => {
      S.currentTarget.contains(S.target) && _(!0), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !0;
    }),
    ref: l,
    style: {
      ...s.style,
      userSelect: f ? "text" : void 0,
      // Safari requires prefix
      WebkitUserSelect: f ? "text" : void 0,
      "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
      "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
      "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
    }
  })));
}), _z = /* @__PURE__ */ Te((e, t) => {
  const { __scopeHoverCard: n, ...r } = e, o = hr(n);
  return /* @__PURE__ */ Z(jK, ce({}, o, r, {
    ref: t
  }));
});
function rr(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function dz(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
const ai = oz, si = az, ci = uz, ui = Ez, Ei = _z, Tz = () => /* @__PURE__ */ C("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.3939 15.4167L17.4167 9.39395L16.0025 7.97974L10.6868 13.2954L8.70709 11.3156L7.29288 12.7298L9.97973 15.4167L10.6868 16.1238L11.3939 15.4167Z",
    fill: "#1ED771"
  }
) }), Rc = ({ children: e, icon: t, classes: n }) => /* @__PURE__ */ j(
  "div",
  {
    className: kt(
      "flex flex-row items-center justify-center gap-2 rounded-md bg-blue-light-fade px-8 py-2 max-w-[500px]",
      n == null ? void 0 : n.root
    ),
    children: [
      /* @__PURE__ */ C("div", { className: "h-6 w-6", children: t }),
      /* @__PURE__ */ C("span", { className: kt("font-heading text-md text-indigo-50", n == null ? void 0 : n.message), children: e })
    ]
  }
), fz = () => /* @__PURE__ */ j(ai, { openDelay: 200, closeDelay: 0, children: [
  /* @__PURE__ */ C(si, { asChild: !0, children: /* @__PURE__ */ C("a", { children: /* @__PURE__ */ C(
    Rc,
    {
      classes: {
        root: "bg-green-light-fade cursor-pointer"
      },
      icon: /* @__PURE__ */ C(Tz, {}),
      children: "Returned"
    }
  ) }) }),
  /* @__PURE__ */ C(ci, { children: /* @__PURE__ */ j(
    ui,
    {
      side: "top",
      align: "end",
      className: "rounded-sm bg-indigo-50 p-2 font-body text-xs text-white shadow-elevation-2",
      children: [
        "You have successfully returned these shipments.",
        /* @__PURE__ */ C(Ei, { className: "fill-indigo-50" })
      ]
    }
  ) })
] });
var Sz = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const Rz = /* @__PURE__ */ ku(Sz);
var Nz = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function _a(e) {
  var t = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (t.name = n[1], (Rz[n[1]] || e.charAt(e.length - 2) === "/") && (t.voidElement = !0), t.name.startsWith("!--"))) {
    var r = e.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? e.slice(4, r) : "" };
  }
  for (var o = new RegExp(Nz), i = null; (i = o.exec(e)) !== null; )
    if (i[0].trim())
      if (i[1]) {
        var a = i[1].trim(), s = [a, ""];
        a.indexOf("=") > -1 && (s = a.split("=")), t.attrs[s[0]] = s[1], o.lastIndex--;
      } else
        i[2] && (t.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return t;
}
var Oz = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, Iz = /^\s*$/, pz = /* @__PURE__ */ Object.create(null);
function Nc(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function(n) {
        var r = [];
        for (var o in n)
          r.push(o + '="' + n[o] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(Nc, "") + "</" + t.name + ">";
    case "comment":
      return e + "<!--" + t.comment + "-->";
  }
}
var hz = { parse: function(e, t) {
  t || (t = {}), t.components || (t.components = pz);
  var n, r = [], o = [], i = -1, a = !1;
  if (e.indexOf("<") !== 0) {
    var s = e.indexOf("<");
    r.push({ type: "text", content: s === -1 ? e : e.substring(0, s) });
  }
  return e.replace(Oz, function(c, u) {
    if (a) {
      if (c !== "</" + n.name + ">")
        return;
      a = !1;
    }
    var E, l = c.charAt(1) !== "/", f = c.startsWith("<!--"), _ = u + c.length, S = e.charAt(_);
    if (f) {
      var d = _a(c);
      return i < 0 ? (r.push(d), r) : ((E = o[i]).children.push(d), r);
    }
    if (l && (i++, (n = _a(c)).type === "tag" && t.components[n.name] && (n.type = "component", a = !0), n.voidElement || a || !S || S === "<" || n.children.push({ type: "text", content: e.slice(_, e.indexOf("<", _)) }), i === 0 && r.push(n), (E = o[i - 1]) && E.children.push(n), o[i] = n), (!l || n.voidElement) && (i > -1 && (n.voidElement || n.name === c.slice(2, -1)) && (i--, n = i === -1 ? r : o[i]), !a && S !== "<" && S)) {
      E = i === -1 ? r : o[i].children;
      var T = e.indexOf("<", _), O = e.slice(_, T === -1 ? void 0 : T);
      Iz.test(O) && (O = " "), (T > -1 && i + E.length >= 0 || O !== " ") && E.push({ type: "text", content: O });
    }
  }), r;
}, stringify: function(e) {
  return e.reduce(function(t, n) {
    return t + Nc("", n);
  }, "");
} };
function Fn() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    typeof t[0] == "string" && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const da = {};
function or() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && da[t[0]] || (typeof t[0] == "string" && (da[t[0]] = /* @__PURE__ */ new Date()), Fn(...t));
}
const Oc = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
};
function Ta(e, t, n) {
  e.loadNamespaces(t, Oc(e, n));
}
function fa(e, t, n, r) {
  typeof n == "string" && (n = [n]), n.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, Oc(e, r));
}
function Az(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = t.languages[0], o = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const a = (s, c) => {
    const u = t.services.backendConnector.state[`${s}|${c}`];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(r, e) && (!o || a(i, e)));
}
function gz(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (or("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (o, i) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !i(o.isLanguageChangingTo, e))
        return !1;
    }
  }) : Az(e, t, n);
}
const vz = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Dz = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, mz = (e) => Dz[e], Lz = (e) => e.replace(vz, mz);
let Cz = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Lz
};
function Ic() {
  return Cz;
}
let Pz;
function li() {
  return Pz;
}
function kr(e, t) {
  if (!e)
    return !1;
  const n = e.props ? e.props.children : e.children;
  return t ? n.length > 0 : !!n;
}
function xr(e) {
  if (!e)
    return [];
  const t = e.props ? e.props.children : e.children;
  return e.props && e.props.i18nIsDynamicList ? $t(t) : t;
}
function yz(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every((t) => lt(t));
}
function $t(e) {
  return Array.isArray(e) ? e : [e];
}
function Uz(e, t) {
  const n = {
    ...t
  };
  return n.props = Object.assign(e.props, t.props), n;
}
function pc(e, t) {
  if (!e)
    return "";
  let n = "";
  const r = $t(e), o = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
  return r.forEach((i, a) => {
    if (typeof i == "string")
      n += `${i}`;
    else if (lt(i)) {
      const s = Object.keys(i.props).length, c = o.indexOf(i.type) > -1, u = i.props.children;
      if (!u && c && s === 0)
        n += `<${i.type}/>`;
      else if (!u && (!c || s !== 0))
        n += `<${a}></${a}>`;
      else if (i.props.i18nIsDynamicList)
        n += `<${a}></${a}>`;
      else if (c && s === 1 && typeof u == "string")
        n += `<${i.type}>${u}</${i.type}>`;
      else {
        const E = pc(u, t);
        n += `<${a}>${E}</${a}>`;
      }
    } else if (i === null)
      Fn("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (typeof i == "object") {
      const {
        format: s,
        ...c
      } = i, u = Object.keys(c);
      if (u.length === 1) {
        const E = s ? `${u[0]}, ${s}` : u[0];
        n += `{{${E}}}`;
      } else
        Fn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", i);
    } else
      Fn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", i);
  }), n;
}
function bz(e, t, n, r, o, i) {
  if (t === "")
    return [];
  const a = r.transKeepBasicHtmlNodesFor || [], s = t && new RegExp(a.map((T) => `<${T}`).join("|")).test(t);
  if (!e && !s && !i)
    return [t];
  const c = {};
  function u(T) {
    $t(T).forEach((h) => {
      typeof h != "string" && (kr(h) ? u(xr(h)) : typeof h == "object" && !lt(h) && Object.assign(c, h));
    });
  }
  u(e);
  const E = hz.parse(`<0>${t}</0>`), l = {
    ...c,
    ...o
  };
  function f(T, O, h) {
    const N = xr(T), I = S(N, O.children, h);
    return yz(N) && I.length === 0 || T.props && T.props.i18nIsDynamicList ? N : I;
  }
  function _(T, O, h, N, I) {
    T.dummy ? (T.children = O, h.push(Rr(T, {
      key: N
    }, I ? void 0 : O))) : h.push(...st.map([T], (R) => {
      const p = {
        ...R.props
      };
      return delete p.i18nIsDynamicList, zt.createElement(R.type, ce({}, p, {
        key: N,
        ref: R.ref
      }, I ? {} : {
        children: O
      }));
    }));
  }
  function S(T, O, h) {
    const N = $t(T);
    return $t(O).reduce((R, p, A) => {
      const g = p.children && p.children[0] && p.children[0].content && n.services.interpolator.interpolate(p.children[0].content, l, n.language);
      if (p.type === "tag") {
        let v = N[parseInt(p.name, 10)];
        h.length === 1 && !v && (v = h[0][p.name]), v || (v = {});
        const D = Object.keys(p.attrs).length !== 0 ? Uz({
          props: p.attrs
        }, v) : v, m = lt(D), L = m && kr(p, !0) && !p.voidElement, P = s && typeof D == "object" && D.dummy && !m, U = typeof e == "object" && e !== null && Object.hasOwnProperty.call(e, p.name);
        if (typeof D == "string") {
          const M = n.services.interpolator.interpolate(D, l, n.language);
          R.push(M);
        } else if (kr(D) || L) {
          const M = f(D, p, h);
          _(D, M, R, A);
        } else if (P) {
          const M = S(N, p.children, h);
          _(D, M, R, A);
        } else if (Number.isNaN(parseFloat(p.name)))
          if (U) {
            const M = f(D, p, h);
            _(D, M, R, A, p.voidElement);
          } else if (r.transSupportBasicHtmlNodes && a.indexOf(p.name) > -1)
            if (p.voidElement)
              R.push(Z(p.name, {
                key: `${p.name}-${A}`
              }));
            else {
              const M = S(N, p.children, h);
              R.push(Z(p.name, {
                key: `${p.name}-${A}`
              }, M));
            }
          else if (p.voidElement)
            R.push(`<${p.name} />`);
          else {
            const M = S(N, p.children, h);
            R.push(`<${p.name}>${M}</${p.name}>`);
          }
        else if (typeof D == "object" && !m) {
          const M = p.children[0] ? g : null;
          M && R.push(M);
        } else
          _(D, g, R, A, p.children.length !== 1 || !g);
      } else if (p.type === "text") {
        const v = r.transWrapTextNodes, D = i ? r.unescape(n.services.interpolator.interpolate(p.content, l, n.language)) : n.services.interpolator.interpolate(p.content, l, n.language);
        v ? R.push(Z(v, {
          key: `${p.name}-${A}`
        }, D)) : R.push(D);
      }
      return R;
    }, []);
  }
  const d = S([{
    dummy: !0,
    children: e || []
  }], E, $t(e || []));
  return xr(d[0]);
}
function Mz(e) {
  let {
    children: t,
    count: n,
    parent: r,
    i18nKey: o,
    context: i,
    tOptions: a = {},
    values: s,
    defaults: c,
    components: u,
    ns: E,
    i18n: l,
    t: f,
    shouldUnescape: _,
    ...S
  } = e;
  const d = l || li();
  if (!d)
    return or("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  const T = f || d.t.bind(d) || ((L) => L);
  i && (a.context = i);
  const O = {
    ...Ic(),
    ...d.options && d.options.react
  };
  let h = E || T.ns || d.options && d.options.defaultNS;
  h = typeof h == "string" ? [h] : h || ["translation"];
  const N = pc(t, O), I = c || N || O.transEmptyNodeValue || o, {
    hashTransKey: R
  } = O, p = o || (R ? R(N || I) : N || I), A = s ? a.interpolation : {
    interpolation: {
      ...a.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, g = {
    ...a,
    count: n,
    ...s,
    ...A,
    defaultValue: I,
    ns: h
  }, v = p ? T(p, g) : I, D = bz(u || t, v, d, O, g, _), m = r !== void 0 ? r : O.defaultTransParent;
  return m ? Z(m, S, D) : D;
}
const hc = dn();
class wz {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function $z(e) {
  let {
    children: t,
    count: n,
    parent: r,
    i18nKey: o,
    context: i,
    tOptions: a = {},
    values: s,
    defaults: c,
    components: u,
    ns: E,
    i18n: l,
    t: f,
    shouldUnescape: _,
    ...S
  } = e;
  const {
    i18n: d,
    defaultNS: T
  } = Yt(hc) || {}, O = l || d || li(), h = f || O && O.t.bind(O);
  return Mz({
    children: t,
    count: n,
    parent: r,
    i18nKey: o,
    context: i,
    tOptions: a,
    values: s,
    defaults: c,
    components: u,
    ns: E || h && h.ns || T || O && O.options && O.options.defaultNS,
    i18n: O,
    t: f,
    shouldUnescape: _,
    ...S
  });
}
const Hz = (e, t) => {
  const n = ee();
  return te(() => {
    n.current = t ? n.current : e;
  }, [e, t]), n.current;
};
function Vz(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: o
  } = Yt(hc) || {}, i = n || r || li();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new wz()), !i) {
    or("You will need to pass in an i18next instance by using initReactI18next");
    const N = (R, p) => typeof p == "string" ? p : p && typeof p == "object" && typeof p.defaultValue == "string" ? p.defaultValue : Array.isArray(R) ? R[R.length - 1] : R, I = [N, {}, !1];
    return I.t = N, I.i18n = {}, I.ready = !1, I;
  }
  i.options.react && i.options.react.wait !== void 0 && or("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...Ic(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: c
  } = a;
  let u = e || o || i.options && i.options.defaultNS;
  u = typeof u == "string" ? [u] : u || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(u);
  const E = (i.isInitialized || i.initializedStoreOnce) && u.every((N) => gz(N, i, a));
  function l() {
    return i.getFixedT(t.lng || null, a.nsMode === "fallback" ? u : u[0], c);
  }
  const [f, _] = Re(l);
  let S = u.join();
  t.lng && (S = `${t.lng}${S}`);
  const d = Hz(S), T = ee(!0);
  te(() => {
    const {
      bindI18n: N,
      bindI18nStore: I
    } = a;
    T.current = !0, !E && !s && (t.lng ? fa(i, t.lng, u, () => {
      T.current && _(l);
    }) : Ta(i, u, () => {
      T.current && _(l);
    })), E && d && d !== S && T.current && _(l);
    function R() {
      T.current && _(l);
    }
    return N && i && i.on(N, R), I && i && i.store.on(I, R), () => {
      T.current = !1, N && i && N.split(" ").forEach((p) => i.off(p, R)), I && i && I.split(" ").forEach((p) => i.store.off(p, R));
    };
  }, [i, S]);
  const O = ee(!0);
  te(() => {
    T.current && !O.current && _(l), O.current = !1;
  }, [i, c]);
  const h = [f, i, E];
  if (h.t = f, h.i18n = i, h.ready = E, E || !E && !s)
    return h;
  throw new Promise((N) => {
    t.lng ? fa(i, t.lng, u, () => N()) : Ta(i, u, () => N());
  });
}
const Le = () => {
  const { t: e } = Vz(), { t, trans: n } = Yt(Bs);
  return {
    t: t ?? e,
    trans: n || $z
  };
}, gr = () => Hs(), _i = Us;
function _e(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var o = Yz[e], i = o ? typeof o == "function" ? o.apply(null, n) : o : "unknown error nr: " + e;
    throw Error("[Immer] " + i);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(a) {
    return "'" + a + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Ue(e) {
  return !!e && !!e[Ee];
}
function be(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var o = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return o === Object || typeof o == "function" && Function.toString.call(o) === jz;
  }(e) || Array.isArray(e) || !!e[En] || !!(!((t = e.constructor) === null || t === void 0) && t[En]) || vr(e) || Dr(e));
}
function Bz(e) {
  return Ue(e) || _e(23, e), e[Ee].t;
}
function Nt(e, t, n) {
  n === void 0 && (n = !1), Ot(e) === 0 ? (n ? Object.keys : Vt)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, o) {
    return t(o, r, e);
  });
}
function Ot(e) {
  var t = e[Ee];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : vr(e) ? 2 : Dr(e) ? 3 : 0;
}
function ut(e, t) {
  return Ot(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Wn(e, t) {
  return Ot(e) === 2 ? e.get(t) : e[t];
}
function Ac(e, t, n) {
  var r = Ot(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function gc(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function vr(e) {
  return Kz && e instanceof Map;
}
function Dr(e) {
  return zz && e instanceof Set;
}
function ot(e) {
  return e.o || e.t;
}
function di(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = Dc(e);
  delete t[Ee];
  for (var n = Vt(t), r = 0; r < n.length; r++) {
    var o = n[r], i = t[o];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: e[o] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function Ti(e, t) {
  return t === void 0 && (t = !1), fi(e) || Ue(e) || !be(e) || (Ot(e) > 1 && (e.set = e.add = e.clear = e.delete = Gz), Object.freeze(e), t && Nt(e, function(n, r) {
    return Ti(r, !0);
  }, !0)), e;
}
function Gz() {
  _e(2);
}
function fi(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Fe(e) {
  var t = wo[e];
  return t || _e(18, e), t;
}
function vc(e, t) {
  wo[e] || (wo[e] = t);
}
function Uo() {
  return process.env.NODE_ENV === "production" || Wt || _e(0), Wt;
}
function Fr(e, t) {
  t && (Fe("Patches"), e.u = [], e.s = [], e.v = t);
}
function ir(e) {
  bo(e), e.p.forEach(kz), e.p = null;
}
function bo(e) {
  e === Wt && (Wt = e.l);
}
function Sa(e) {
  return Wt = { p: [], l: Wt, h: e, m: !0, _: 0 };
}
function kz(e) {
  var t = e[Ee];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function Wr(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || Fe("ES5").S(t, e, r), r ? (n[Ee].P && (ir(t), _e(4)), be(e) && (e = ar(t, e), t.l || sr(t, e)), t.u && Fe("Patches").M(n[Ee].t, e, t.u, t.s)) : e = ar(t, n, []), ir(t), t.u && t.v(t.u, t.s), e !== Ri ? e : void 0;
}
function ar(e, t, n) {
  if (fi(t))
    return t;
  var r = t[Ee];
  if (!r)
    return Nt(t, function(s, c) {
      return Ra(e, r, t, s, c, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return sr(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var o = r.i === 4 || r.i === 5 ? r.o = di(r.k) : r.o, i = o, a = !1;
    r.i === 3 && (i = new Set(o), o.clear(), a = !0), Nt(i, function(s, c) {
      return Ra(e, r, o, s, c, n, a);
    }), sr(e, o, !1), n && e.u && Fe("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function Ra(e, t, n, r, o, i, a) {
  if (process.env.NODE_ENV !== "production" && o === n && _e(5), Ue(o)) {
    var s = ar(e, o, i && t && t.i !== 3 && !ut(t.R, r) ? i.concat(r) : void 0);
    if (Ac(n, r, s), !Ue(s))
      return;
    e.m = !1;
  } else
    a && n.add(o);
  if (be(o) && !fi(o)) {
    if (!e.h.D && e._ < 1)
      return;
    ar(e, o), t && t.A.l || sr(e, o);
  }
}
function sr(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && Ti(t, n);
}
function Kr(e, t) {
  var n = e[Ee];
  return (n ? ot(n) : e)[t];
}
function Na(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function it(e) {
  e.P || (e.P = !0, e.l && it(e.l));
}
function zr(e) {
  e.o || (e.o = di(e.t));
}
function Mo(e, t, n) {
  var r = vr(t) ? Fe("MapSet").F(t, n) : Dr(t) ? Fe("MapSet").T(t, n) : e.O ? function(o, i) {
    var a = Array.isArray(o), s = { i: a ? 1 : 0, A: i ? i.A : Uo(), P: !1, I: !1, R: {}, l: i, t: o, k: null, o: null, j: null, C: !1 }, c = s, u = Sn;
    a && (c = [s], u = cn);
    var E = Proxy.revocable(c, u), l = E.revoke, f = E.proxy;
    return s.k = f, s.j = l, f;
  }(t, n) : Fe("ES5").J(t, n);
  return (n ? n.A : Uo()).p.push(r), r;
}
function xz(e) {
  return Ue(e) || _e(22, e), function t(n) {
    if (!be(n))
      return n;
    var r, o = n[Ee], i = Ot(n);
    if (o) {
      if (!o.P && (o.i < 4 || !Fe("ES5").K(o)))
        return o.t;
      o.I = !0, r = Oa(n, i), o.I = !1;
    } else
      r = Oa(n, i);
    return Nt(r, function(a, s) {
      o && Wn(o.t, a) === s || Ac(r, a, t(s));
    }), i === 3 ? new Set(r) : r;
  }(e);
}
function Oa(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return di(e);
}
function Fz() {
  function e(a, s) {
    var c = i[a];
    return c ? c.enumerable = s : i[a] = c = { configurable: !0, enumerable: s, get: function() {
      var u = this[Ee];
      return process.env.NODE_ENV !== "production" && o(u), Sn.get(u, a);
    }, set: function(u) {
      var E = this[Ee];
      process.env.NODE_ENV !== "production" && o(E), Sn.set(E, a, u);
    } }, c;
  }
  function t(a) {
    for (var s = a.length - 1; s >= 0; s--) {
      var c = a[s][Ee];
      if (!c.P)
        switch (c.i) {
          case 5:
            r(c) && it(c);
            break;
          case 4:
            n(c) && it(c);
        }
    }
  }
  function n(a) {
    for (var s = a.t, c = a.k, u = Vt(c), E = u.length - 1; E >= 0; E--) {
      var l = u[E];
      if (l !== Ee) {
        var f = s[l];
        if (f === void 0 && !ut(s, l))
          return !0;
        var _ = c[l], S = _ && _[Ee];
        if (S ? S.t !== f : !gc(_, f))
          return !0;
      }
    }
    var d = !!s[Ee];
    return u.length !== Vt(s).length + (d ? 0 : 1);
  }
  function r(a) {
    var s = a.k;
    if (s.length !== a.t.length)
      return !0;
    var c = Object.getOwnPropertyDescriptor(s, s.length - 1);
    if (c && !c.get)
      return !0;
    for (var u = 0; u < s.length; u++)
      if (!s.hasOwnProperty(u))
        return !0;
    return !1;
  }
  function o(a) {
    a.g && _e(3, JSON.stringify(ot(a)));
  }
  var i = {};
  vc("ES5", { J: function(a, s) {
    var c = Array.isArray(a), u = function(l, f) {
      if (l) {
        for (var _ = Array(f.length), S = 0; S < f.length; S++)
          Object.defineProperty(_, "" + S, e(S, !0));
        return _;
      }
      var d = Dc(f);
      delete d[Ee];
      for (var T = Vt(d), O = 0; O < T.length; O++) {
        var h = T[O];
        d[h] = e(h, l || !!d[h].enumerable);
      }
      return Object.create(Object.getPrototypeOf(f), d);
    }(c, a), E = { i: c ? 5 : 4, A: s ? s.A : Uo(), P: !1, I: !1, R: {}, l: s, t: a, k: u, o: null, g: !1, C: !1 };
    return Object.defineProperty(u, Ee, { value: E, writable: !0 }), u;
  }, S: function(a, s, c) {
    c ? Ue(s) && s[Ee].A === a && t(a.p) : (a.u && function u(E) {
      if (E && typeof E == "object") {
        var l = E[Ee];
        if (l) {
          var f = l.t, _ = l.k, S = l.R, d = l.i;
          if (d === 4)
            Nt(_, function(I) {
              I !== Ee && (f[I] !== void 0 || ut(f, I) ? S[I] || u(_[I]) : (S[I] = !0, it(l)));
            }), Nt(f, function(I) {
              _[I] !== void 0 || ut(_, I) || (S[I] = !1, it(l));
            });
          else if (d === 5) {
            if (r(l) && (it(l), S.length = !0), _.length < f.length)
              for (var T = _.length; T < f.length; T++)
                S[T] = !1;
            else
              for (var O = f.length; O < _.length; O++)
                S[O] = !0;
            for (var h = Math.min(_.length, f.length), N = 0; N < h; N++)
              _.hasOwnProperty(N) || (S[N] = !0), S[N] === void 0 && u(_[N]);
          }
        }
      }
    }(a.p[0]), t(a.p));
  }, K: function(a) {
    return a.i === 4 ? n(a) : r(a);
  } });
}
function Wz() {
  function e(r) {
    if (!be(r))
      return r;
    if (Array.isArray(r))
      return r.map(e);
    if (vr(r))
      return new Map(Array.from(r.entries()).map(function(a) {
        return [a[0], e(a[1])];
      }));
    if (Dr(r))
      return new Set(Array.from(r).map(e));
    var o = Object.create(Object.getPrototypeOf(r));
    for (var i in r)
      o[i] = e(r[i]);
    return ut(r, En) && (o[En] = r[En]), o;
  }
  function t(r) {
    return Ue(r) ? e(r) : r;
  }
  var n = "add";
  vc("Patches", { $: function(r, o) {
    return o.forEach(function(i) {
      for (var a = i.path, s = i.op, c = r, u = 0; u < a.length - 1; u++) {
        var E = Ot(c), l = a[u];
        typeof l != "string" && typeof l != "number" && (l = "" + l), E !== 0 && E !== 1 || l !== "__proto__" && l !== "constructor" || _e(24), typeof c == "function" && l === "prototype" && _e(24), typeof (c = Wn(c, l)) != "object" && _e(15, a.join("/"));
      }
      var f = Ot(c), _ = e(i.value), S = a[a.length - 1];
      switch (s) {
        case "replace":
          switch (f) {
            case 2:
              return c.set(S, _);
            case 3:
              _e(16);
            default:
              return c[S] = _;
          }
        case n:
          switch (f) {
            case 1:
              return S === "-" ? c.push(_) : c.splice(S, 0, _);
            case 2:
              return c.set(S, _);
            case 3:
              return c.add(_);
            default:
              return c[S] = _;
          }
        case "remove":
          switch (f) {
            case 1:
              return c.splice(S, 1);
            case 2:
              return c.delete(S);
            case 3:
              return c.delete(i.value);
            default:
              return delete c[S];
          }
        default:
          _e(17, s);
      }
    }), r;
  }, N: function(r, o, i, a) {
    switch (r.i) {
      case 0:
      case 4:
      case 2:
        return function(s, c, u, E) {
          var l = s.t, f = s.o;
          Nt(s.R, function(_, S) {
            var d = Wn(l, _), T = Wn(f, _), O = S ? ut(l, _) ? "replace" : n : "remove";
            if (d !== T || O !== "replace") {
              var h = c.concat(_);
              u.push(O === "remove" ? { op: O, path: h } : { op: O, path: h, value: T }), E.push(O === n ? { op: "remove", path: h } : O === "remove" ? { op: n, path: h, value: t(d) } : { op: "replace", path: h, value: t(d) });
            }
          });
        }(r, o, i, a);
      case 5:
      case 1:
        return function(s, c, u, E) {
          var l = s.t, f = s.R, _ = s.o;
          if (_.length < l.length) {
            var S = [_, l];
            l = S[0], _ = S[1];
            var d = [E, u];
            u = d[0], E = d[1];
          }
          for (var T = 0; T < l.length; T++)
            if (f[T] && _[T] !== l[T]) {
              var O = c.concat([T]);
              u.push({ op: "replace", path: O, value: t(_[T]) }), E.push({ op: "replace", path: O, value: t(l[T]) });
            }
          for (var h = l.length; h < _.length; h++) {
            var N = c.concat([h]);
            u.push({ op: n, path: N, value: t(_[h]) });
          }
          l.length < _.length && E.push({ op: "replace", path: c.concat(["length"]), value: l.length });
        }(r, o, i, a);
      case 3:
        return function(s, c, u, E) {
          var l = s.t, f = s.o, _ = 0;
          l.forEach(function(S) {
            if (!f.has(S)) {
              var d = c.concat([_]);
              u.push({ op: "remove", path: d, value: S }), E.unshift({ op: n, path: d, value: S });
            }
            _++;
          }), _ = 0, f.forEach(function(S) {
            if (!l.has(S)) {
              var d = c.concat([_]);
              u.push({ op: n, path: d, value: S }), E.unshift({ op: "remove", path: d, value: S });
            }
            _++;
          });
        }(r, o, i, a);
    }
  }, M: function(r, o, i, a) {
    i.push({ op: "replace", path: [], value: o === Ri ? void 0 : o }), a.push({ op: "replace", path: [], value: r });
  } });
}
var Ia, Wt, Si = typeof Symbol < "u" && typeof Symbol("x") == "symbol", Kz = typeof Map < "u", zz = typeof Set < "u", pa = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", Ri = Si ? Symbol.for("immer-nothing") : ((Ia = {})["immer-nothing"] = !0, Ia), En = Si ? Symbol.for("immer-draftable") : "__$immer_draftable", Ee = Si ? Symbol.for("immer-state") : "__$immer_state", Yz = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, jz = "" + Object.prototype.constructor, Vt = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, Dc = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Vt(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, wo = {}, Sn = { get: function(e, t) {
  if (t === Ee)
    return e;
  var n = ot(e);
  if (!ut(n, t))
    return function(o, i, a) {
      var s, c = Na(i, a);
      return c ? "value" in c ? c.value : (s = c.get) === null || s === void 0 ? void 0 : s.call(o.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !be(r) ? r : r === Kr(e.t, t) ? (zr(e), e.o[t] = Mo(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in ot(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(ot(e));
}, set: function(e, t, n) {
  var r = Na(ot(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var o = Kr(ot(e), t), i = o == null ? void 0 : o[Ee];
    if (i && i.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (gc(n, o) && (n !== void 0 || ut(e.t, t)))
      return !0;
    zr(e), it(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return Kr(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, zr(e), it(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = ot(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  _e(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  _e(12);
} }, cn = {};
Nt(Sn, function(e, t) {
  cn[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), cn.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && _e(13), cn.set.call(this, e, t, void 0);
}, cn.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && _e(14), Sn.set.call(this, e[0], t, n, e[0]);
};
var Zz = function() {
  function e(n) {
    var r = this;
    this.O = pa, this.D = !0, this.produce = function(o, i, a) {
      if (typeof o == "function" && typeof i != "function") {
        var s = i;
        i = o;
        var c = r;
        return function(d) {
          var T = this;
          d === void 0 && (d = s);
          for (var O = arguments.length, h = Array(O > 1 ? O - 1 : 0), N = 1; N < O; N++)
            h[N - 1] = arguments[N];
          return c.produce(d, function(I) {
            var R;
            return (R = i).call.apply(R, [T, I].concat(h));
          });
        };
      }
      var u;
      if (typeof i != "function" && _e(6), a !== void 0 && typeof a != "function" && _e(7), be(o)) {
        var E = Sa(r), l = Mo(r, o, void 0), f = !0;
        try {
          u = i(l), f = !1;
        } finally {
          f ? ir(E) : bo(E);
        }
        return typeof Promise < "u" && u instanceof Promise ? u.then(function(d) {
          return Fr(E, a), Wr(d, E);
        }, function(d) {
          throw ir(E), d;
        }) : (Fr(E, a), Wr(u, E));
      }
      if (!o || typeof o != "object") {
        if ((u = i(o)) === void 0 && (u = o), u === Ri && (u = void 0), r.D && Ti(u, !0), a) {
          var _ = [], S = [];
          Fe("Patches").M(o, u, _, S), a(_, S);
        }
        return u;
      }
      _e(21, o);
    }, this.produceWithPatches = function(o, i) {
      if (typeof o == "function")
        return function(u) {
          for (var E = arguments.length, l = Array(E > 1 ? E - 1 : 0), f = 1; f < E; f++)
            l[f - 1] = arguments[f];
          return r.produceWithPatches(u, function(_) {
            return o.apply(void 0, [_].concat(l));
          });
        };
      var a, s, c = r.produce(o, i, function(u, E) {
        a = u, s = E;
      });
      return typeof Promise < "u" && c instanceof Promise ? c.then(function(u) {
        return [u, a, s];
      }) : [c, a, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    be(n) || _e(8), Ue(n) && (n = xz(n));
    var r = Sa(this), o = Mo(this, n, void 0);
    return o[Ee].C = !0, bo(r), o;
  }, t.finishDraft = function(n, r) {
    var o = n && n[Ee];
    process.env.NODE_ENV !== "production" && (o && o.C || _e(9), o.I && _e(10));
    var i = o.A;
    return Fr(i, r), Wr(void 0, i);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !pa && _e(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var o;
    for (o = r.length - 1; o >= 0; o--) {
      var i = r[o];
      if (i.path.length === 0 && i.op === "replace") {
        n = i.value;
        break;
      }
    }
    o > -1 && (r = r.slice(o + 1));
    var a = Fe("Patches").$;
    return Ue(n) ? a(n, r) : this.produce(n, function(s) {
      return a(s, r);
    });
  }, e;
}(), me = new Zz(), An = me.produce, mc = me.produceWithPatches.bind(me);
me.setAutoFreeze.bind(me);
me.setUseProxies.bind(me);
var ha = me.applyPatches.bind(me);
me.createDraft.bind(me);
me.finishDraft.bind(me);
function Rn(e) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rn(e);
}
function Xz(e, t) {
  if (Rn(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Rn(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qz(e) {
  var t = Xz(e, "string");
  return Rn(t) === "symbol" ? t : String(t);
}
function Qz(e, t, n) {
  return t = qz(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Aa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ga(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Aa(Object(n), !0).forEach(function(r) {
      Qz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Aa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ne(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var va = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Yr = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, mt = {
  INIT: "@@redux/INIT" + Yr(),
  REPLACE: "@@redux/REPLACE" + Yr(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Yr();
  }
};
function Lc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Jz(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (nY(e))
    return "date";
  if (tY(e))
    return "error";
  var n = eY(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function eY(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function tY(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function nY(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function ht(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Jz(e)), t;
}
function Cc(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Ne(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(1) : "Expected the enhancer to be a function. Instead, received: '" + ht(n) + "'");
    return n(Cc)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Ne(2) : "Expected the root reducer to be a function. Instead, received: '" + ht(e) + "'");
  var o = e, i = t, a = [], s = a, c = !1;
  function u() {
    s === a && (s = a.slice());
  }
  function E() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Ne(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function l(d) {
    if (typeof d != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(4) : "Expected the listener to be a function. Instead, received: '" + ht(d) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Ne(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var T = !0;
    return u(), s.push(d), function() {
      if (T) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? Ne(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        T = !1, u();
        var h = s.indexOf(d);
        s.splice(h, 1), a = null;
      }
    };
  }
  function f(d) {
    if (!Lc(d))
      throw new Error(process.env.NODE_ENV === "production" ? Ne(7) : "Actions must be plain objects. Instead, the actual type was: '" + ht(d) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof d.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Ne(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, i = o(i, d);
    } finally {
      c = !1;
    }
    for (var T = a = s, O = 0; O < T.length; O++) {
      var h = T[O];
      h();
    }
    return d;
  }
  function _(d) {
    if (typeof d != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(10) : "Expected the nextReducer to be a function. Instead, received: '" + ht(d));
    o = d, f({
      type: mt.REPLACE
    });
  }
  function S() {
    var d, T = l;
    return d = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(h) {
        if (typeof h != "object" || h === null)
          throw new Error(process.env.NODE_ENV === "production" ? Ne(11) : "Expected the observer to be an object. Instead, received: '" + ht(h) + "'");
        function N() {
          h.next && h.next(E());
        }
        N();
        var I = T(N);
        return {
          unsubscribe: I
        };
      }
    }, d[va] = function() {
      return this;
    }, d;
  }
  return f({
    type: mt.INIT
  }), r = {
    dispatch: f,
    subscribe: l,
    getState: E,
    replaceReducer: _
  }, r[va] = S, r;
}
function Da(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function rY(e, t, n, r) {
  var o = Object.keys(t), i = n && n.type === mt.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (o.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Lc(e))
    return "The " + i + ' has unexpected type of "' + ht(e) + '". Expected argument to be an object with the following ' + ('keys: "' + o.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !r[s];
  });
  if (a.forEach(function(s) {
    r[s] = !0;
  }), !(n && n.type === mt.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + i + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + o.join('", "') + '". Unexpected keys will be ignored.');
}
function oY(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], r = n(void 0, {
      type: mt.INIT
    });
    if (typeof r > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: mt.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Ne(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + mt.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function Pc(e) {
  for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
    var o = t[r];
    process.env.NODE_ENV !== "production" && typeof e[o] > "u" && Da('No reducer provided for key "' + o + '"'), typeof e[o] == "function" && (n[o] = e[o]);
  }
  var i = Object.keys(n), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    oY(n);
  } catch (c) {
    s = c;
  }
  return function(u, E) {
    if (u === void 0 && (u = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var l = rY(u, n, E, a);
      l && Da(l);
    }
    for (var f = !1, _ = {}, S = 0; S < i.length; S++) {
      var d = i[S], T = n[d], O = u[d], h = T(O, E);
      if (typeof h > "u") {
        var N = E && E.type;
        throw new Error(process.env.NODE_ENV === "production" ? Ne(14) : "When called with an action of type " + (N ? '"' + String(N) + '"' : "(unknown type)") + ', the slice reducer for key "' + d + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      _[d] = h, f = f || h !== O;
    }
    return f = f || i.length !== Object.keys(u).length, f ? _ : u;
  };
}
function cr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, o) {
    return function() {
      return r(o.apply(void 0, arguments));
    };
  });
}
function iY() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var o = r.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? Ne(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: o.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return i = cr.apply(void 0, s)(o.dispatch), ga(ga({}, o), {}, {
        dispatch: i
      });
    };
  };
}
var ur = "NOT_FOUND";
function aY(e) {
  var t;
  return {
    get: function(r) {
      return t && e(t.key, r) ? t.value : ur;
    },
    put: function(r, o) {
      t = {
        key: r,
        value: o
      };
    },
    getEntries: function() {
      return t ? [t] : [];
    },
    clear: function() {
      t = void 0;
    }
  };
}
function sY(e, t) {
  var n = [];
  function r(s) {
    var c = n.findIndex(function(E) {
      return t(s, E.key);
    });
    if (c > -1) {
      var u = n[c];
      return c > 0 && (n.splice(c, 1), n.unshift(u)), u.value;
    }
    return ur;
  }
  function o(s, c) {
    r(s) === ur && (n.unshift({
      key: s,
      value: c
    }), n.length > e && n.pop());
  }
  function i() {
    return n;
  }
  function a() {
    n = [];
  }
  return {
    get: r,
    put: o,
    getEntries: i,
    clear: a
  };
}
var cY = function(t, n) {
  return t === n;
};
function uY(e) {
  return function(n, r) {
    if (n === null || r === null || n.length !== r.length)
      return !1;
    for (var o = n.length, i = 0; i < o; i++)
      if (!e(n[i], r[i]))
        return !1;
    return !0;
  };
}
function $o(e, t) {
  var n = typeof t == "object" ? t : {
    equalityCheck: t
  }, r = n.equalityCheck, o = r === void 0 ? cY : r, i = n.maxSize, a = i === void 0 ? 1 : i, s = n.resultEqualityCheck, c = uY(o), u = a === 1 ? aY(c) : sY(a, c);
  function E() {
    var l = u.get(arguments);
    if (l === ur) {
      if (l = e.apply(null, arguments), s) {
        var f = u.getEntries(), _ = f.find(function(S) {
          return s(S.value, l);
        });
        _ && (l = _.value);
      }
      u.put(arguments, l);
    }
    return l;
  }
  return E.clearCache = function() {
    return u.clear();
  }, E;
}
function EY(e) {
  var t = Array.isArray(e[0]) ? e[0] : e;
  if (!t.every(function(r) {
    return typeof r == "function";
  })) {
    var n = t.map(function(r) {
      return typeof r == "function" ? "function " + (r.name || "unnamed") + "()" : typeof r;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + n + "]");
  }
  return t;
}
function lY(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = function() {
    for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
      s[c] = arguments[c];
    var u = 0, E, l = {
      memoizeOptions: void 0
    }, f = s.pop();
    if (typeof f == "object" && (l = f, f = s.pop()), typeof f != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof f + "]");
    var _ = l, S = _.memoizeOptions, d = S === void 0 ? n : S, T = Array.isArray(d) ? d : [d], O = EY(s), h = e.apply(void 0, [function() {
      return u++, f.apply(null, arguments);
    }].concat(T)), N = e(function() {
      for (var R = [], p = O.length, A = 0; A < p; A++)
        R.push(O[A].apply(null, arguments));
      return E = h.apply(null, R), E;
    });
    return Object.assign(N, {
      resultFunc: f,
      memoizedResultFunc: h,
      dependencies: O,
      lastResult: function() {
        return E;
      },
      recomputations: function() {
        return u;
      },
      resetRecomputations: function() {
        return u = 0;
      }
    }), N;
  };
  return o;
}
var ln = /* @__PURE__ */ lY($o);
function yc(e) {
  var t = function(r) {
    var o = r.dispatch, i = r.getState;
    return function(a) {
      return function(s) {
        return typeof s == "function" ? s(o, i, e) : a(s);
      };
    };
  };
  return t;
}
var Uc = yc();
Uc.withExtraArgument = yc;
const ma = Uc;
var bc = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), _Y = globalThis && globalThis.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(E) {
      return c([u, E]);
    };
  }
  function c(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, o && (i = u[0] & 2 ? o.return : u[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, u[1])).done)
          return i;
        switch (o = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, o = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (E) {
        u = [6, E], o = 0;
      } finally {
        r = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Kt = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, o = e.length; n < r; n++, o++)
    e[o] = t[n];
  return e;
}, dY = Object.defineProperty, TY = Object.defineProperties, fY = Object.getOwnPropertyDescriptors, La = Object.getOwnPropertySymbols, SY = Object.prototype.hasOwnProperty, RY = Object.prototype.propertyIsEnumerable, Ca = function(e, t, n) {
  return t in e ? dY(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, Et = function(e, t) {
  for (var n in t || (t = {}))
    SY.call(t, n) && Ca(e, n, t[n]);
  if (La)
    for (var r = 0, o = La(t); r < o.length; r++) {
      var n = o[r];
      RY.call(t, n) && Ca(e, n, t[n]);
    }
  return e;
}, jr = function(e, t) {
  return TY(e, fY(t));
}, NY = function(e, t, n) {
  return new Promise(function(r, o) {
    var i = function(c) {
      try {
        s(n.next(c));
      } catch (u) {
        o(u);
      }
    }, a = function(c) {
      try {
        s(n.throw(c));
      } catch (u) {
        o(u);
      }
    }, s = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
    };
    s((n = n.apply(e, t)).next());
  });
}, OY = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? cr : cr.apply(null, arguments);
};
function Je(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function Mc(e, t) {
  var n = 0;
  return {
    measureTime: function(r) {
      var o = Date.now();
      try {
        return r();
      } finally {
        var i = Date.now();
        n += i - o;
      }
    },
    warnIfExceeded: function() {
      n > e && console.warn(t + " took " + n + "ms, which is more than the warning threshold of " + e + `ms.
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var IY = (
  /** @class */
  function(e) {
    bc(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var o = e.apply(this, n) || this;
      return Object.setPrototypeOf(o, t.prototype), o;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, Kt([void 0], n[0].concat(this))))() : new (t.bind.apply(t, Kt([void 0], n.concat(this))))();
    }, t;
  }(Array)
), pY = (
  /** @class */
  function(e) {
    bc(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var o = e.apply(this, n) || this;
      return Object.setPrototypeOf(o, t.prototype), o;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, Kt([void 0], n[0].concat(this))))() : new (t.bind.apply(t, Kt([void 0], n.concat(this))))();
    }, t;
  }(Array)
);
function Ho(e) {
  return be(e) ? An(e, function() {
  }) : e;
}
var hY = process.env.NODE_ENV === "production", Pa = "Invariant failed";
function ya(e, t) {
  if (!e)
    throw hY ? new Error(Pa) : new Error(Pa + ": " + (t || ""));
}
function AY(e, t, n, r) {
  return JSON.stringify(e, gY(t, r), n);
}
function gY(e, t) {
  var n = [], r = [];
  return t || (t = function(o, i) {
    return n[0] === i ? "[Circular ~]" : "[Circular ~." + r.slice(0, n.indexOf(i)).join(".") + "]";
  }), function(o, i) {
    if (n.length > 0) {
      var a = n.indexOf(this);
      ~a ? n.splice(a + 1) : n.push(this), ~a ? r.splice(a, 1 / 0, o) : r.push(o), ~n.indexOf(i) && (i = t.call(this, o, i));
    } else
      n.push(i);
    return e == null ? i : e.call(this, o, i);
  };
}
function vY(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function DY(e, t, n) {
  var r = wc(e, t, n);
  return {
    detectMutations: function() {
      return $c(e, t, r, n);
    }
  };
}
function wc(e, t, n, r) {
  t === void 0 && (t = []), r === void 0 && (r = "");
  var o = { value: n };
  if (!e(n)) {
    o.children = {};
    for (var i in n) {
      var a = r ? r + "." + i : i;
      t.length && t.indexOf(a) !== -1 || (o.children[i] = wc(e, t, n[i], a));
    }
  }
  return o;
}
function $c(e, t, n, r, o, i) {
  t === void 0 && (t = []), o === void 0 && (o = !1), i === void 0 && (i = "");
  var a = n ? n.value : void 0, s = a === r;
  if (o && !s && !Number.isNaN(r))
    return { wasMutated: !0, path: i };
  if (e(a) || e(r))
    return { wasMutated: !1 };
  var c = {};
  for (var u in n.children)
    c[u] = !0;
  for (var u in r)
    c[u] = !0;
  var E = t.length > 0, l = function(_) {
    var S = i ? i + "." + _ : _;
    if (E) {
      var d = t.some(function(O) {
        return O instanceof RegExp ? O.test(S) : S === O;
      });
      if (d)
        return "continue";
    }
    var T = $c(e, t, n.children[_], r[_], s, S);
    if (T.wasMutated)
      return { value: T };
  };
  for (var u in c) {
    var f = l(u);
    if (typeof f == "object")
      return f.value;
  }
  return { wasMutated: !1 };
}
function mY(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(c) {
        return function(u) {
          return c(u);
        };
      };
    };
  var t = e.isImmutable, n = t === void 0 ? vY : t, r = e.ignoredPaths, o = e.warnAfter, i = o === void 0 ? 32 : o, a = e.ignore;
  r = r || a;
  var s = DY.bind(null, n, r);
  return function(c) {
    var u = c.getState, E = u(), l = s(E), f;
    return function(_) {
      return function(S) {
        var d = Mc(i, "ImmutableStateInvariantMiddleware");
        d.measureTime(function() {
          E = u(), f = l.detectMutations(), l = s(E), ya(!f.wasMutated, "A state mutation was detected between dispatches, in the path '" + (f.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var T = _(S);
        return d.measureTime(function() {
          E = u(), f = l.detectMutations(), l = s(E), f.wasMutated && ya(!f.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (f.path || "") + ". Take a look at the reducer(s) handling the action " + AY(S) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), d.warnIfExceeded(), T;
      };
    };
  };
}
function Hc(e) {
  var t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || Je(e);
}
function Vo(e, t, n, r, o, i) {
  t === void 0 && (t = ""), n === void 0 && (n = Hc), o === void 0 && (o = []);
  var a;
  if (!n(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || i != null && i.has(e))
    return !1;
  for (var s = r != null ? r(e) : Object.entries(e), c = o.length > 0, u = function(T, O) {
    var h = t ? t + "." + T : T;
    if (c) {
      var N = o.some(function(I) {
        return I instanceof RegExp ? I.test(h) : h === I;
      });
      if (N)
        return "continue";
    }
    if (!n(O))
      return { value: {
        keyPath: h,
        value: O
      } };
    if (typeof O == "object" && (a = Vo(O, h, n, r, o, i), a))
      return { value: a };
  }, E = 0, l = s; E < l.length; E++) {
    var f = l[E], _ = f[0], S = f[1], d = u(_, S);
    if (typeof d == "object")
      return d.value;
  }
  return i && Vc(e) && i.add(e), !1;
}
function Vc(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var t = 0, n = Object.values(e); t < n.length; t++) {
    var r = n[t];
    if (!(typeof r != "object" || r === null) && !Vc(r))
      return !1;
  }
  return !0;
}
function LY(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(N) {
        return function(I) {
          return N(I);
        };
      };
    };
  var t = e.isSerializable, n = t === void 0 ? Hc : t, r = e.getEntries, o = e.ignoredActions, i = o === void 0 ? [] : o, a = e.ignoredActionPaths, s = a === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : a, c = e.ignoredPaths, u = c === void 0 ? [] : c, E = e.warnAfter, l = E === void 0 ? 32 : E, f = e.ignoreState, _ = f === void 0 ? !1 : f, S = e.ignoreActions, d = S === void 0 ? !1 : S, T = e.disableCache, O = T === void 0 ? !1 : T, h = !O && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(N) {
    return function(I) {
      return function(R) {
        var p = I(R), A = Mc(l, "SerializableStateInvariantMiddleware");
        return !d && !(i.length && i.indexOf(R.type) !== -1) && A.measureTime(function() {
          var g = Vo(R, "", n, r, s, h);
          if (g) {
            var v = g.keyPath, D = g.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + v + "`. Value:", D, `
Take a look at the logic that dispatched this action: `, R, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), _ || (A.measureTime(function() {
          var g = N.getState(), v = Vo(g, "", n, r, u, h);
          if (v) {
            var D = v.keyPath, m = v.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + D + "`. Value:", m, `
Take a look at the reducer(s) handling this action type: ` + R.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), A.warnIfExceeded()), p;
      };
    };
  };
}
function Zr(e) {
  return typeof e == "boolean";
}
function CY() {
  return function(t) {
    return PY(t);
  };
}
function PY(e) {
  e === void 0 && (e = {});
  var t = e.thunk, n = t === void 0 ? !0 : t, r = e.immutableCheck, o = r === void 0 ? !0 : r, i = e.serializableCheck, a = i === void 0 ? !0 : i, s = new IY();
  if (n && (Zr(n) ? s.push(ma) : s.push(ma.withExtraArgument(n.extraArgument))), process.env.NODE_ENV !== "production") {
    if (o) {
      var c = {};
      Zr(o) || (c = o), s.unshift(mY(c));
    }
    if (a) {
      var u = {};
      Zr(a) || (u = a), s.push(LY(u));
    }
  }
  return s;
}
var Xr = process.env.NODE_ENV === "production";
function yY(e) {
  var t = CY(), n = e || {}, r = n.reducer, o = r === void 0 ? void 0 : r, i = n.middleware, a = i === void 0 ? t() : i, s = n.devTools, c = s === void 0 ? !0 : s, u = n.preloadedState, E = u === void 0 ? void 0 : u, l = n.enhancers, f = l === void 0 ? void 0 : l, _;
  if (typeof o == "function")
    _ = o;
  else if (Je(o))
    _ = Pc(o);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var S = a;
  if (typeof S == "function" && (S = S(t), !Xr && !Array.isArray(S)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!Xr && S.some(function(I) {
    return typeof I != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var d = iY.apply(void 0, S), T = cr;
  c && (T = OY(Et({
    trace: !Xr
  }, typeof c == "object" && c)));
  var O = new pY(d), h = O;
  Array.isArray(f) ? h = Kt([d], f) : typeof f == "function" && (h = f(O));
  var N = T.apply(void 0, h);
  return Cc(_, E, N);
}
function he(e, t) {
  function n() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    if (t) {
      var i = t.apply(void 0, r);
      if (!i)
        throw new Error("prepareAction did not return an object");
      return Et(Et({
        type: e,
        payload: i.payload
      }, "meta" in i && { meta: i.meta }), "error" in i && { error: i.error });
    }
    return { type: e, payload: r[0] };
  }
  return n.toString = function() {
    return "" + e;
  }, n.type = e, n.match = function(r) {
    return r.type === e;
  }, n;
}
function Bc(e) {
  var t = {}, n = [], r, o = {
    addCase: function(i, a) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (r)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var s = typeof i == "string" ? i : i.type;
      if (s in t)
        throw new Error("addCase cannot be called with two reducers for the same action type");
      return t[s] = a, o;
    },
    addMatcher: function(i, a) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({ matcher: i, reducer: a }), o;
    },
    addDefaultCase: function(i) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return r = i, o;
    }
  };
  return e(o), [t, n, r];
}
function UY(e) {
  return typeof e == "function";
}
var Ua = !1;
function bY(e, t, n, r) {
  n === void 0 && (n = []), process.env.NODE_ENV !== "production" && typeof t == "object" && (Ua || (Ua = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var o = typeof t == "function" ? Bc(t) : [t, n, r], i = o[0], a = o[1], s = o[2], c;
  if (UY(e))
    c = function() {
      return Ho(e());
    };
  else {
    var u = Ho(e);
    c = function() {
      return u;
    };
  }
  function E(l, f) {
    l === void 0 && (l = c());
    var _ = Kt([
      i[f.type]
    ], a.filter(function(S) {
      var d = S.matcher;
      return d(f);
    }).map(function(S) {
      var d = S.reducer;
      return d;
    }));
    return _.filter(function(S) {
      return !!S;
    }).length === 0 && (_ = [s]), _.reduce(function(S, d) {
      if (d)
        if (Ue(S)) {
          var T = S, O = d(T, f);
          return O === void 0 ? S : O;
        } else {
          if (be(S))
            return An(S, function(h) {
              return d(h, f);
            });
          var O = d(S, f);
          if (O === void 0) {
            if (S === null)
              return S;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return O;
        }
      return S;
    }, l);
  }
  return E.getInitialState = c, E;
}
var ba = !1;
function MY(e, t) {
  return e + "/" + t;
}
function At(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var n = typeof e.initialState == "function" ? e.initialState : Ho(e.initialState), r = e.reducers || {}, o = Object.keys(r), i = {}, a = {}, s = {};
  o.forEach(function(E) {
    var l = r[E], f = MY(t, E), _, S;
    "reducer" in l ? (_ = l.reducer, S = l.prepare) : _ = l, i[E] = _, a[f] = _, s[E] = S ? he(f, S) : he(f);
  });
  function c() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (ba || (ba = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var E = typeof e.extraReducers == "function" ? Bc(e.extraReducers) : [e.extraReducers], l = E[0], f = l === void 0 ? {} : l, _ = E[1], S = _ === void 0 ? [] : _, d = E[2], T = d === void 0 ? void 0 : d, O = Et(Et({}, f), a);
    return bY(n, function(h) {
      for (var N in O)
        h.addCase(N, O[N]);
      for (var I = 0, R = S; I < R.length; I++) {
        var p = R[I];
        h.addMatcher(p.matcher, p.reducer);
      }
      T && h.addDefaultCase(T);
    });
  }
  var u;
  return {
    name: t,
    reducer: function(E, l) {
      return u || (u = c()), u(E, l);
    },
    actions: s,
    caseReducers: i,
    getInitialState: function() {
      return u || (u = c()), u.getInitialState();
    }
  };
}
var wY = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Gc = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", n = e; n--; )
    t += wY[Math.random() * 64 | 0];
  return t;
}, $Y = [
  "name",
  "message",
  "stack",
  "code"
], qr = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), Ma = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), HY = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, n = 0, r = $Y; n < r.length; n++) {
      var o = r[n];
      typeof e[o] == "string" && (t[o] = e[o]);
    }
    return t;
  }
  return { message: String(e) };
}, wa = function() {
  function e(t, n, r) {
    var o = he(t + "/fulfilled", function(E, l, f, _) {
      return {
        payload: E,
        meta: jr(Et({}, _ || {}), {
          arg: f,
          requestId: l,
          requestStatus: "fulfilled"
        })
      };
    }), i = he(t + "/pending", function(E, l, f) {
      return {
        payload: void 0,
        meta: jr(Et({}, f || {}), {
          arg: l,
          requestId: E,
          requestStatus: "pending"
        })
      };
    }), a = he(t + "/rejected", function(E, l, f, _, S) {
      return {
        payload: _,
        error: (r && r.serializeError || HY)(E || "Rejected"),
        meta: jr(Et({}, S || {}), {
          arg: f,
          requestId: l,
          rejectedWithValue: !!_,
          requestStatus: "rejected",
          aborted: (E == null ? void 0 : E.name) === "AbortError",
          condition: (E == null ? void 0 : E.name) === "ConditionError"
        })
      };
    }), s = !1, c = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function E() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return E.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (s || (s = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, E;
      }()
    );
    function u(E) {
      return function(l, f, _) {
        var S = r != null && r.idGenerator ? r.idGenerator(E) : Gc(), d = new c(), T;
        function O(N) {
          T = N, d.abort();
        }
        var h = function() {
          return NY(this, null, function() {
            var N, I, R, p, A, g, v;
            return _Y(this, function(D) {
              switch (D.label) {
                case 0:
                  return D.trys.push([0, 4, , 5]), p = (N = r == null ? void 0 : r.condition) == null ? void 0 : N.call(r, E, { getState: f, extra: _ }), BY(p) ? [4, p] : [3, 2];
                case 1:
                  p = D.sent(), D.label = 2;
                case 2:
                  if (p === !1 || d.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return A = new Promise(function(m, L) {
                    return d.signal.addEventListener("abort", function() {
                      return L({
                        name: "AbortError",
                        message: T || "Aborted"
                      });
                    });
                  }), l(i(S, E, (I = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : I.call(r, { requestId: S, arg: E }, { getState: f, extra: _ }))), [4, Promise.race([
                    A,
                    Promise.resolve(n(E, {
                      dispatch: l,
                      getState: f,
                      extra: _,
                      requestId: S,
                      signal: d.signal,
                      abort: O,
                      rejectWithValue: function(m, L) {
                        return new qr(m, L);
                      },
                      fulfillWithValue: function(m, L) {
                        return new Ma(m, L);
                      }
                    })).then(function(m) {
                      if (m instanceof qr)
                        throw m;
                      return m instanceof Ma ? o(m.payload, S, E, m.meta) : o(m, S, E);
                    })
                  ])];
                case 3:
                  return R = D.sent(), [3, 5];
                case 4:
                  return g = D.sent(), R = g instanceof qr ? a(null, S, E, g.payload, g.meta) : a(g, S, E), [3, 5];
                case 5:
                  return v = r && !r.dispatchConditionRejection && a.match(R) && R.meta.condition, v || l(R), [2, R];
              }
            });
          });
        }();
        return Object.assign(h, {
          abort: O,
          requestId: S,
          arg: E,
          unwrap: function() {
            return h.then(VY);
          }
        });
      };
    }
    return Object.assign(u, {
      pending: i,
      rejected: a,
      fulfilled: o,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
}();
function VY(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function BY(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var GY = function(e) {
  return e && typeof e.match == "function";
}, kc = function(e, t) {
  return GY(e) ? e.match(t) : e(t);
};
function qt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(n) {
    return e.some(function(r) {
      return kc(r, n);
    });
  };
}
function _n() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(n) {
    return e.every(function(r) {
      return kc(r, n);
    });
  };
}
function mr(e, t) {
  if (!e || !e.meta)
    return !1;
  var n = typeof e.meta.requestId == "string", r = t.indexOf(e.meta.requestStatus) > -1;
  return n && r;
}
function gn(e) {
  return typeof e[0] == "function" && "pending" in e[0] && "fulfilled" in e[0] && "rejected" in e[0];
}
function Ni() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(n) {
    return mr(n, ["pending"]);
  } : gn(e) ? function(n) {
    var r = e.map(function(i) {
      return i.pending;
    }), o = qt.apply(void 0, r);
    return o(n);
  } : Ni()(e[0]);
}
function Nn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(n) {
    return mr(n, ["rejected"]);
  } : gn(e) ? function(n) {
    var r = e.map(function(i) {
      return i.rejected;
    }), o = qt.apply(void 0, r);
    return o(n);
  } : Nn()(e[0]);
}
function Lr() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = function(r) {
    return r && r.meta && r.meta.rejectedWithValue;
  };
  return e.length === 0 ? function(r) {
    var o = _n(Nn.apply(void 0, e), n);
    return o(r);
  } : gn(e) ? function(r) {
    var o = _n(Nn.apply(void 0, e), n);
    return o(r);
  } : Lr()(e[0]);
}
function yt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(n) {
    return mr(n, ["fulfilled"]);
  } : gn(e) ? function(n) {
    var r = e.map(function(i) {
      return i.fulfilled;
    }), o = qt.apply(void 0, r);
    return o(n);
  } : yt()(e[0]);
}
function Bo() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(n) {
    return mr(n, ["pending", "fulfilled", "rejected"]);
  } : gn(e) ? function(n) {
    for (var r = [], o = 0, i = e; o < i.length; o++) {
      var a = i[o];
      r.push(a.pending, a.rejected, a.fulfilled);
    }
    var s = qt.apply(void 0, r);
    return s(n);
  } : Bo()(e[0]);
}
var Oi = "listenerMiddleware";
he(Oi + "/add");
he(Oi + "/removeAll");
he(Oi + "/remove");
var un = "RTK_autoBatch", Qr = function() {
  return function(e) {
    var t;
    return {
      payload: e,
      meta: (t = {}, t[un] = !0, t)
    };
  };
}, $a;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Fz();
const kY = {
  shouldRefetchLastScan: !1,
  activeShipmentDetails: void 0,
  showReturnAcknowledement: !1
}, xc = At({
  name: "morningScan",
  initialState: kY,
  reducers: {
    setActiveShipmentDetails: (e, t) => {
      e.activeShipmentDetails = t.payload;
    },
    setReturnAcknowledgementModal: (e, t) => {
      e.showReturnAcknowledement = t.payload;
    }
  }
}), { setActiveShipmentDetails: Fc, setReturnAcknowledgementModal: Go } = xc.actions, Ii = (e) => e.morningScan, xY = xc.reducer, FY = (e, t) => e instanceof Date && !isNaN(e.getTime()) ? e.toISOString().split("T")[0] : t, WY = () => FY(/* @__PURE__ */ new Date(), (/* @__PURE__ */ new Date()).toISOString().split("T")[0]);
var Er = globalThis && globalThis.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(E) {
      return c([u, E]);
    };
  }
  function c(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, o && (i = u[0] & 2 ? o.return : u[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, u[1])).done)
          return i;
        switch (o = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, o = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (E) {
        u = [6, E], o = 0;
      } finally {
        r = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, lr = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, o = e.length; n < r; n++, o++)
    e[o] = t[n];
  return e;
}, KY = Object.defineProperty, zY = Object.defineProperties, YY = Object.getOwnPropertyDescriptors, _r = Object.getOwnPropertySymbols, Wc = Object.prototype.hasOwnProperty, Kc = Object.prototype.propertyIsEnumerable, Ha = function(e, t, n) {
  return t in e ? KY(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, Se = function(e, t) {
  for (var n in t || (t = {}))
    Wc.call(t, n) && Ha(e, n, t[n]);
  if (_r)
    for (var r = 0, o = _r(t); r < o.length; r++) {
      var n = o[r];
      Kc.call(t, n) && Ha(e, n, t[n]);
    }
  return e;
}, ke = function(e, t) {
  return zY(e, YY(t));
}, Va = function(e, t) {
  var n = {};
  for (var r in e)
    Wc.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && _r)
    for (var o = 0, i = _r(e); o < i.length; o++) {
      var r = i[o];
      t.indexOf(r) < 0 && Kc.call(e, r) && (n[r] = e[r]);
    }
  return n;
}, dr = function(e, t, n) {
  return new Promise(function(r, o) {
    var i = function(c) {
      try {
        s(n.next(c));
      } catch (u) {
        o(u);
      }
    }, a = function(c) {
      try {
        s(n.throw(c));
      } catch (u) {
        o(u);
      }
    }, s = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
    };
    s((n = n.apply(e, t)).next());
  });
}, le;
(function(e) {
  e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected";
})(le || (le = {}));
function jY(e) {
  return {
    status: e,
    isUninitialized: e === le.uninitialized,
    isLoading: e === le.pending,
    isSuccess: e === le.fulfilled,
    isError: e === le.rejected
  };
}
function ZY(e) {
  return new RegExp("(^|:)//").test(e);
}
var XY = function(e) {
  return e.replace(/\/$/, "");
}, qY = function(e) {
  return e.replace(/^\//, "");
};
function QY(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  if (ZY(t))
    return t;
  var n = e.endsWith("/") || !t.startsWith("?") ? "/" : "";
  return e = XY(e), t = qY(t), "" + e + n + t;
}
var Ba = function(e) {
  return [].concat.apply([], e);
};
function JY() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function ej() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
var Ga = Je;
function zc(e, t) {
  if (e === t || !(Ga(e) && Ga(t) || Array.isArray(e) && Array.isArray(t)))
    return t;
  for (var n = Object.keys(t), r = Object.keys(e), o = n.length === r.length, i = Array.isArray(t) ? [] : {}, a = 0, s = n; a < s.length; a++) {
    var c = s[a];
    i[c] = zc(e[c], t[c]), o && (o = e[c] === i[c]);
  }
  return o ? e : i;
}
var ka = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return fetch.apply(void 0, e);
}, tj = function(e) {
  return e.status >= 200 && e.status <= 299;
}, nj = function(e) {
  return /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "");
};
function xa(e) {
  if (!Je(e))
    return e;
  for (var t = Se({}, e), n = 0, r = Object.entries(t); n < r.length; n++) {
    var o = r[n], i = o[0], a = o[1];
    a === void 0 && delete t[i];
  }
  return t;
}
function rj(e) {
  var t = this;
  e === void 0 && (e = {});
  var n = e, r = n.baseUrl, o = n.prepareHeaders, i = o === void 0 ? function(N) {
    return N;
  } : o, a = n.fetchFn, s = a === void 0 ? ka : a, c = n.paramsSerializer, u = n.isJsonContentType, E = u === void 0 ? nj : u, l = n.jsonContentType, f = l === void 0 ? "application/json" : l, _ = n.jsonReplacer, S = n.timeout, d = n.responseHandler, T = n.validateStatus, O = Va(n, [
    "baseUrl",
    "prepareHeaders",
    "fetchFn",
    "paramsSerializer",
    "isJsonContentType",
    "jsonContentType",
    "jsonReplacer",
    "timeout",
    "responseHandler",
    "validateStatus"
  ]);
  return typeof fetch > "u" && s === ka && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), function(N, I) {
    return dr(t, null, function() {
      var R, p, A, g, v, D, m, L, P, U, M, H, x, F, z, y, b, V, w, B, G, k, K, X, Q, q, ae, $, se, W, Pe, He, Ye, Qt, Jt, pt;
      return Er(this, function(Ve) {
        switch (Ve.label) {
          case 0:
            return R = I.signal, p = I.getState, A = I.extra, g = I.endpoint, v = I.forced, D = I.type, L = typeof N == "string" ? { url: N } : N, P = L.url, U = L.headers, M = U === void 0 ? new Headers(O.headers) : U, H = L.params, x = H === void 0 ? void 0 : H, F = L.responseHandler, z = F === void 0 ? d ?? "json" : F, y = L.validateStatus, b = y === void 0 ? T ?? tj : y, V = L.timeout, w = V === void 0 ? S : V, B = Va(L, [
              "url",
              "headers",
              "params",
              "responseHandler",
              "validateStatus",
              "timeout"
            ]), G = Se(ke(Se({}, O), {
              signal: R
            }), B), M = new Headers(xa(M)), k = G, [4, i(M, {
              getState: p,
              extra: A,
              endpoint: g,
              forced: v,
              type: D
            })];
          case 1:
            k.headers = Ve.sent() || M, K = function(Be) {
              return typeof Be == "object" && (Je(Be) || Array.isArray(Be) || typeof Be.toJSON == "function");
            }, !G.headers.has("content-type") && K(G.body) && G.headers.set("content-type", f), K(G.body) && E(G.headers) && (G.body = JSON.stringify(G.body, _)), x && (X = ~P.indexOf("?") ? "&" : "?", Q = c ? c(x) : new URLSearchParams(xa(x)), P += X + Q), P = QY(r, P), q = new Request(P, G), ae = q.clone(), m = { request: ae }, se = !1, W = w && setTimeout(function() {
              se = !0, I.abort();
            }, w), Ve.label = 2;
          case 2:
            return Ve.trys.push([2, 4, 5, 6]), [4, s(q)];
          case 3:
            return $ = Ve.sent(), [3, 6];
          case 4:
            return Pe = Ve.sent(), [2, {
              error: {
                status: se ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                error: String(Pe)
              },
              meta: m
            }];
          case 5:
            return W && clearTimeout(W), [
              7
              /*endfinally*/
            ];
          case 6:
            He = $.clone(), m.response = He, Qt = "", Ve.label = 7;
          case 7:
            return Ve.trys.push([7, 9, , 10]), [4, Promise.all([
              h($, z).then(function(Be) {
                return Ye = Be;
              }, function(Be) {
                return Jt = Be;
              }),
              He.text().then(function(Be) {
                return Qt = Be;
              }, function() {
              })
            ])];
          case 8:
            if (Ve.sent(), Jt)
              throw Jt;
            return [3, 10];
          case 9:
            return pt = Ve.sent(), [2, {
              error: {
                status: "PARSING_ERROR",
                originalStatus: $.status,
                data: Qt,
                error: String(pt)
              },
              meta: m
            }];
          case 10:
            return [2, b($, Ye) ? {
              data: Ye,
              meta: m
            } : {
              error: {
                status: $.status,
                data: Ye
              },
              meta: m
            }];
        }
      });
    });
  };
  function h(N, I) {
    return dr(this, null, function() {
      var R;
      return Er(this, function(p) {
        switch (p.label) {
          case 0:
            return typeof I == "function" ? [2, I(N)] : (I === "content-type" && (I = E(N.headers) ? "json" : "text"), I !== "json" ? [3, 2] : [4, N.text()]);
          case 1:
            return R = p.sent(), [2, R.length ? JSON.parse(R) : null];
          case 2:
            return [2, N.text()];
        }
      });
    });
  }
}
var Fa = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = void 0), this.value = t, this.meta = n;
    }
    return e;
  }()
), pi = /* @__PURE__ */ he("__rtkq/focused"), Yc = /* @__PURE__ */ he("__rtkq/unfocused"), hi = /* @__PURE__ */ he("__rtkq/online"), jc = /* @__PURE__ */ he("__rtkq/offline"), Ke;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(Ke || (Ke = {}));
function Zc(e) {
  return e.type === Ke.query;
}
function oj(e) {
  return e.type === Ke.mutation;
}
function Xc(e, t, n, r, o, i) {
  return ij(e) ? e(t, n, r, o).map(ko).map(i) : Array.isArray(e) ? e.map(ko).map(i) : [];
}
function ij(e) {
  return typeof e == "function";
}
function ko(e) {
  return typeof e == "string" ? { type: e } : e;
}
function Jr(e) {
  return e != null;
}
var On = Symbol("forceQueryFn"), xo = function(e) {
  return typeof e[On] == "function";
};
function aj(e) {
  var t = e.serializeQueryArgs, n = e.queryThunk, r = e.mutationThunk, o = e.api, i = e.context, a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), c = o.internalActions, u = c.unsubscribeQueryResult, E = c.removeMutationResult, l = c.updateSubscriptionOptions;
  return {
    buildInitiateQuery: N,
    buildInitiateMutation: I,
    getRunningQueryThunk: S,
    getRunningMutationThunk: d,
    getRunningQueriesThunk: T,
    getRunningMutationsThunk: O,
    getRunningOperationPromises: _,
    removalWarning: f
  };
  function f() {
    throw new Error(`This method had to be removed due to a conceptual bug in RTK.
       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.
       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.`);
  }
  function _() {
    if (typeof process < "u" && process.env.NODE_ENV === "development")
      f();
    else {
      var R = function(p) {
        return Array.from(p.values()).flatMap(function(A) {
          return A ? Object.values(A) : [];
        });
      };
      return lr(lr([], R(a)), R(s)).filter(Jr);
    }
  }
  function S(R, p) {
    return function(A) {
      var g, v = i.endpointDefinitions[R], D = t({
        queryArgs: p,
        endpointDefinition: v,
        endpointName: R
      });
      return (g = a.get(A)) == null ? void 0 : g[D];
    };
  }
  function d(R, p) {
    return function(A) {
      var g;
      return (g = s.get(A)) == null ? void 0 : g[p];
    };
  }
  function T() {
    return function(R) {
      return Object.values(a.get(R) || {}).filter(Jr);
    };
  }
  function O() {
    return function(R) {
      return Object.values(s.get(R) || {}).filter(Jr);
    };
  }
  function h(R) {
    if (process.env.NODE_ENV !== "production") {
      if (h.triggered)
        return;
      var p = R(o.internalActions.internal_probeSubscription({
        queryCacheKey: "DOES_NOT_EXIST",
        requestId: "DUMMY_REQUEST_ID"
      }));
      if (h.triggered = !0, typeof p != "boolean")
        throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + o.reducerPath + `" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function N(R, p) {
    var A = function(g, v) {
      var D = v === void 0 ? {} : v, m = D.subscribe, L = m === void 0 ? !0 : m, P = D.forceRefetch, U = D.subscriptionOptions, M = On, H = D[M];
      return function(x, F) {
        var z, y, b = t({
          queryArgs: g,
          endpointDefinition: p,
          endpointName: R
        }), V = n((z = {
          type: "query",
          subscribe: L,
          forceRefetch: P,
          subscriptionOptions: U,
          endpointName: R,
          originalArgs: g,
          queryCacheKey: b
        }, z[On] = H, z)), w = o.endpoints[R].select(g), B = x(V), G = w(F());
        h(x);
        var k = B.requestId, K = B.abort, X = G.requestId !== k, Q = (y = a.get(x)) == null ? void 0 : y[b], q = function() {
          return w(F());
        }, ae = Object.assign(H ? B.then(q) : X && !Q ? Promise.resolve(G) : Promise.all([Q, B]).then(q), {
          arg: g,
          requestId: k,
          subscriptionOptions: U,
          queryCacheKey: b,
          abort: K,
          unwrap: function() {
            return dr(this, null, function() {
              var se;
              return Er(this, function(W) {
                switch (W.label) {
                  case 0:
                    return [4, ae];
                  case 1:
                    if (se = W.sent(), se.isError)
                      throw se.error;
                    return [2, se.data];
                }
              });
            });
          },
          refetch: function() {
            return x(A(g, { subscribe: !1, forceRefetch: !0 }));
          },
          unsubscribe: function() {
            L && x(u({
              queryCacheKey: b,
              requestId: k
            }));
          },
          updateSubscriptionOptions: function(se) {
            ae.subscriptionOptions = se, x(l({
              endpointName: R,
              requestId: k,
              queryCacheKey: b,
              options: se
            }));
          }
        });
        if (!Q && !X && !H) {
          var $ = a.get(x) || {};
          $[b] = ae, a.set(x, $), ae.then(function() {
            delete $[b], Object.keys($).length || a.delete(x);
          });
        }
        return ae;
      };
    };
    return A;
  }
  function I(R) {
    return function(p, A) {
      var g = A === void 0 ? {} : A, v = g.track, D = v === void 0 ? !0 : v, m = g.fixedCacheKey;
      return function(L, P) {
        var U = r({
          type: "mutation",
          endpointName: R,
          originalArgs: p,
          track: D,
          fixedCacheKey: m
        }), M = L(U);
        h(L);
        var H = M.requestId, x = M.abort, F = M.unwrap, z = M.unwrap().then(function(w) {
          return { data: w };
        }).catch(function(w) {
          return { error: w };
        }), y = function() {
          L(E({ requestId: H, fixedCacheKey: m }));
        }, b = Object.assign(z, {
          arg: M.arg,
          requestId: H,
          abort: x,
          unwrap: F,
          unsubscribe: y,
          reset: y
        }), V = s.get(L) || {};
        return s.set(L, V), V[H] = b, b.then(function() {
          delete V[H], Object.keys(V).length || s.delete(L);
        }), m && (V[m] = b, b.then(function() {
          V[m] === b && (delete V[m], Object.keys(V).length || s.delete(L));
        })), b;
      };
    };
  }
}
function Wa(e) {
  return e;
}
function sj(e) {
  var t = this, n = e.reducerPath, r = e.baseQuery, o = e.context.endpointDefinitions, i = e.serializeQueryArgs, a = e.api, s = function(N, I, R) {
    return function(p) {
      var A = o[N];
      p(a.internalActions.queryResultPatched({
        queryCacheKey: i({
          queryArgs: I,
          endpointDefinition: A,
          endpointName: N
        }),
        patches: R
      }));
    };
  }, c = function(N, I, R) {
    return function(p, A) {
      var g, v, D = a.endpoints[N].select(I)(A()), m = {
        patches: [],
        inversePatches: [],
        undo: function() {
          return p(a.util.patchQueryData(N, I, m.inversePatches));
        }
      };
      if (D.status === le.uninitialized)
        return m;
      if ("data" in D)
        if (be(D.data)) {
          var L = mc(D.data, R), P = L[1], U = L[2];
          (g = m.patches).push.apply(g, P), (v = m.inversePatches).push.apply(v, U);
        } else {
          var M = R(D.data);
          m.patches.push({ op: "replace", path: [], value: M }), m.inversePatches.push({
            op: "replace",
            path: [],
            value: D.data
          });
        }
      return p(a.util.patchQueryData(N, I, m.patches)), m;
    };
  }, u = function(N, I, R) {
    return function(p) {
      var A;
      return p(a.endpoints[N].initiate(I, (A = {
        subscribe: !1,
        forceRefetch: !0
      }, A[On] = function() {
        return {
          data: R
        };
      }, A)));
    };
  }, E = function(N, I) {
    return dr(t, [N, I], function(R, p) {
      var A, g, v, D, m, L, P, U, M, H, x, F, z, y, b, V, w, B, G = p.signal, k = p.abort, K = p.rejectWithValue, X = p.fulfillWithValue, Q = p.dispatch, q = p.getState, ae = p.extra;
      return Er(this, function($) {
        switch ($.label) {
          case 0:
            A = o[R.endpointName], $.label = 1;
          case 1:
            return $.trys.push([1, 8, , 13]), g = Wa, v = void 0, D = {
              signal: G,
              abort: k,
              dispatch: Q,
              getState: q,
              extra: ae,
              endpoint: R.endpointName,
              type: R.type,
              forced: R.type === "query" ? l(R, q()) : void 0
            }, m = R.type === "query" ? R[On] : void 0, m ? (v = m(), [3, 6]) : [3, 2];
          case 2:
            return A.query ? [4, r(A.query(R.originalArgs), D, A.extraOptions)] : [3, 4];
          case 3:
            return v = $.sent(), A.transformResponse && (g = A.transformResponse), [3, 6];
          case 4:
            return [4, A.queryFn(R.originalArgs, D, A.extraOptions, function(se) {
              return r(se, D, A.extraOptions);
            })];
          case 5:
            v = $.sent(), $.label = 6;
          case 6:
            if (typeof process < "u" && process.env.NODE_ENV === "development") {
              if (L = A.query ? "`baseQuery`" : "`queryFn`", P = void 0, !v)
                P = L + " did not return anything.";
              else if (typeof v != "object")
                P = L + " did not return an object.";
              else if (v.error && v.data)
                P = L + " returned an object containing both `error` and `result`.";
              else if (v.error === void 0 && v.data === void 0)
                P = L + " returned an object containing neither a valid `error` and `result`. At least one of them should not be `undefined`";
              else
                for (U = 0, M = Object.keys(v); U < M.length; U++)
                  if (H = M[U], H !== "error" && H !== "data" && H !== "meta") {
                    P = "The object returned by " + L + " has the unknown property " + H + ".";
                    break;
                  }
              P && console.error("Error encountered handling the endpoint " + R.endpointName + `.
              ` + P + "\n              It needs to return an object with either the shape `{ data: <value> }` or `{ error: <value> }` that may contain an optional `meta` property.\n              Object returned was:", v);
            }
            if (v.error)
              throw new Fa(v.error, v.meta);
            return x = X, [4, g(v.data, v.meta, R.originalArgs)];
          case 7:
            return [2, x.apply(void 0, [$.sent(), (w = {
              fulfilledTimeStamp: Date.now(),
              baseQueryMeta: v.meta
            }, w[un] = !0, w)])];
          case 8:
            if (F = $.sent(), z = F, !(z instanceof Fa))
              return [3, 12];
            y = Wa, A.query && A.transformErrorResponse && (y = A.transformErrorResponse), $.label = 9;
          case 9:
            return $.trys.push([9, 11, , 12]), b = K, [4, y(z.value, z.meta, R.originalArgs)];
          case 10:
            return [2, b.apply(void 0, [$.sent(), (B = { baseQueryMeta: z.meta }, B[un] = !0, B)])];
          case 11:
            return V = $.sent(), z = V, [3, 12];
          case 12:
            throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error('An unhandled error occurred processing a request for the endpoint "' + R.endpointName + `".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, z) : console.error(z), z;
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  function l(N, I) {
    var R, p, A, g, v = (p = (R = I[n]) == null ? void 0 : R.queries) == null ? void 0 : p[N.queryCacheKey], D = (A = I[n]) == null ? void 0 : A.config.refetchOnMountOrArgChange, m = v == null ? void 0 : v.fulfilledTimeStamp, L = (g = N.forceRefetch) != null ? g : N.subscribe && D;
    return L ? L === !0 || (Number(/* @__PURE__ */ new Date()) - Number(m)) / 1e3 >= L : !1;
  }
  var f = wa(n + "/executeQuery", E, {
    getPendingMeta: function() {
      var N;
      return N = { startedTimeStamp: Date.now() }, N[un] = !0, N;
    },
    condition: function(N, I) {
      var R = I.getState, p, A, g, v = R(), D = (A = (p = v[n]) == null ? void 0 : p.queries) == null ? void 0 : A[N.queryCacheKey], m = D == null ? void 0 : D.fulfilledTimeStamp, L = N.originalArgs, P = D == null ? void 0 : D.originalArgs, U = o[N.endpointName];
      return xo(N) ? !0 : (D == null ? void 0 : D.status) === "pending" ? !1 : l(N, v) || Zc(U) && ((g = U == null ? void 0 : U.forceRefetch) != null && g.call(U, {
        currentArg: L,
        previousArg: P,
        endpointState: D,
        state: v
      })) ? !0 : !m;
    },
    dispatchConditionRejection: !0
  }), _ = wa(n + "/executeMutation", E, {
    getPendingMeta: function() {
      var N;
      return N = { startedTimeStamp: Date.now() }, N[un] = !0, N;
    }
  }), S = function(N) {
    return "force" in N;
  }, d = function(N) {
    return "ifOlderThan" in N;
  }, T = function(N, I, R) {
    return function(p, A) {
      var g = S(R) && R.force, v = d(R) && R.ifOlderThan, D = function(U) {
        return U === void 0 && (U = !0), a.endpoints[N].initiate(I, { forceRefetch: U });
      }, m = a.endpoints[N].select(I)(A());
      if (g)
        p(D());
      else if (v) {
        var L = m == null ? void 0 : m.fulfilledTimeStamp;
        if (!L) {
          p(D());
          return;
        }
        var P = (Number(/* @__PURE__ */ new Date()) - Number(new Date(L))) / 1e3 >= v;
        P && p(D());
      } else
        p(D(!1));
    };
  };
  function O(N) {
    return function(I) {
      var R, p;
      return ((p = (R = I == null ? void 0 : I.meta) == null ? void 0 : R.arg) == null ? void 0 : p.endpointName) === N;
    };
  }
  function h(N, I) {
    return {
      matchPending: _n(Ni(N), O(I)),
      matchFulfilled: _n(yt(N), O(I)),
      matchRejected: _n(Nn(N), O(I))
    };
  }
  return {
    queryThunk: f,
    mutationThunk: _,
    prefetch: T,
    updateQueryData: c,
    upsertQueryData: u,
    patchQueryData: s,
    buildMatchThunkActions: h
  };
}
function qc(e, t, n, r) {
  return Xc(n[e.meta.arg.endpointName][t], yt(e) ? e.payload : void 0, Lr(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, r);
}
function Cn(e, t, n) {
  var r = e[t];
  r && n(r);
}
function In(e) {
  var t;
  return (t = "arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) != null ? t : e.requestId;
}
function Ka(e, t, n) {
  var r = e[In(t)];
  r && n(r);
}
var rn = {};
function cj(e) {
  var t = e.reducerPath, n = e.queryThunk, r = e.mutationThunk, o = e.context, i = o.endpointDefinitions, a = o.apiUid, s = o.extractRehydrationInfo, c = o.hasRehydrationInfo, u = e.assertTagType, E = e.config, l = he(t + "/resetApiState"), f = At({
    name: t + "/queries",
    initialState: rn,
    reducers: {
      removeQueryResult: {
        reducer: function(R, p) {
          var A = p.payload.queryCacheKey;
          delete R[A];
        },
        prepare: Qr()
      },
      queryResultPatched: function(R, p) {
        var A = p.payload, g = A.queryCacheKey, v = A.patches;
        Cn(R, g, function(D) {
          D.data = ha(D.data, v.concat());
        });
      }
    },
    extraReducers: function(R) {
      R.addCase(n.pending, function(p, A) {
        var g = A.meta, v = A.meta.arg, D, m, L = xo(v);
        (v.subscribe || L) && ((m = p[D = v.queryCacheKey]) != null || (p[D] = {
          status: le.uninitialized,
          endpointName: v.endpointName
        })), Cn(p, v.queryCacheKey, function(P) {
          P.status = le.pending, P.requestId = L && P.requestId ? P.requestId : g.requestId, v.originalArgs !== void 0 && (P.originalArgs = v.originalArgs), P.startedTimeStamp = g.startedTimeStamp;
        });
      }).addCase(n.fulfilled, function(p, A) {
        var g = A.meta, v = A.payload;
        Cn(p, g.arg.queryCacheKey, function(D) {
          var m;
          if (!(D.requestId !== g.requestId && !xo(g.arg))) {
            var L = i[g.arg.endpointName].merge;
            if (D.status = le.fulfilled, L)
              if (D.data !== void 0) {
                var P = g.fulfilledTimeStamp, U = g.arg, M = g.baseQueryMeta, H = g.requestId, x = An(D.data, function(F) {
                  return L(F, v, {
                    arg: U.originalArgs,
                    baseQueryMeta: M,
                    fulfilledTimeStamp: P,
                    requestId: H
                  });
                });
                D.data = x;
              } else
                D.data = v;
            else
              D.data = (m = i[g.arg.endpointName].structuralSharing) == null || m ? zc(Ue(D.data) ? Bz(D.data) : D.data, v) : v;
            delete D.error, D.fulfilledTimeStamp = g.fulfilledTimeStamp;
          }
        });
      }).addCase(n.rejected, function(p, A) {
        var g = A.meta, v = g.condition, D = g.arg, m = g.requestId, L = A.error, P = A.payload;
        Cn(p, D.queryCacheKey, function(U) {
          if (!v) {
            if (U.requestId !== m)
              return;
            U.status = le.rejected, U.error = P ?? L;
          }
        });
      }).addMatcher(c, function(p, A) {
        for (var g = s(A).queries, v = 0, D = Object.entries(g); v < D.length; v++) {
          var m = D[v], L = m[0], P = m[1];
          ((P == null ? void 0 : P.status) === le.fulfilled || (P == null ? void 0 : P.status) === le.rejected) && (p[L] = P);
        }
      });
    }
  }), _ = At({
    name: t + "/mutations",
    initialState: rn,
    reducers: {
      removeMutationResult: {
        reducer: function(R, p) {
          var A = p.payload, g = In(A);
          g in R && delete R[g];
        },
        prepare: Qr()
      }
    },
    extraReducers: function(R) {
      R.addCase(r.pending, function(p, A) {
        var g = A.meta, v = A.meta, D = v.requestId, m = v.arg, L = v.startedTimeStamp;
        m.track && (p[In(g)] = {
          requestId: D,
          status: le.pending,
          endpointName: m.endpointName,
          startedTimeStamp: L
        });
      }).addCase(r.fulfilled, function(p, A) {
        var g = A.payload, v = A.meta;
        v.arg.track && Ka(p, v, function(D) {
          D.requestId === v.requestId && (D.status = le.fulfilled, D.data = g, D.fulfilledTimeStamp = v.fulfilledTimeStamp);
        });
      }).addCase(r.rejected, function(p, A) {
        var g = A.payload, v = A.error, D = A.meta;
        D.arg.track && Ka(p, D, function(m) {
          m.requestId === D.requestId && (m.status = le.rejected, m.error = g ?? v);
        });
      }).addMatcher(c, function(p, A) {
        for (var g = s(A).mutations, v = 0, D = Object.entries(g); v < D.length; v++) {
          var m = D[v], L = m[0], P = m[1];
          ((P == null ? void 0 : P.status) === le.fulfilled || (P == null ? void 0 : P.status) === le.rejected) && L !== (P == null ? void 0 : P.requestId) && (p[L] = P);
        }
      });
    }
  }), S = At({
    name: t + "/invalidation",
    initialState: rn,
    reducers: {},
    extraReducers: function(R) {
      R.addCase(f.actions.removeQueryResult, function(p, A) {
        for (var g = A.payload.queryCacheKey, v = 0, D = Object.values(p); v < D.length; v++)
          for (var m = D[v], L = 0, P = Object.values(m); L < P.length; L++) {
            var U = P[L], M = U.indexOf(g);
            M !== -1 && U.splice(M, 1);
          }
      }).addMatcher(c, function(p, A) {
        for (var g, v, D, m, L = s(A).provided, P = 0, U = Object.entries(L); P < U.length; P++)
          for (var M = U[P], H = M[0], x = M[1], F = 0, z = Object.entries(x); F < z.length; F++)
            for (var y = z[F], b = y[0], V = y[1], w = (m = (v = (g = p[H]) != null ? g : p[H] = {})[D = b || "__internal_without_id"]) != null ? m : v[D] = [], B = 0, G = V; B < G.length; B++) {
              var k = G[B], K = w.includes(k);
              K || w.push(k);
            }
      }).addMatcher(qt(yt(n), Lr(n)), function(p, A) {
        for (var g, v, D, m, L = qc(A, "providesTags", i, u), P = A.meta.arg.queryCacheKey, U = 0, M = Object.values(p); U < M.length; U++)
          for (var H = M[U], x = 0, F = Object.values(H); x < F.length; x++) {
            var z = F[x], y = z.indexOf(P);
            y !== -1 && z.splice(y, 1);
          }
        for (var b = 0, V = L; b < V.length; b++) {
          var w = V[b], B = w.type, G = w.id, k = (m = (v = (g = p[B]) != null ? g : p[B] = {})[D = G || "__internal_without_id"]) != null ? m : v[D] = [], K = k.includes(P);
          K || k.push(P);
        }
      });
    }
  }), d = At({
    name: t + "/subscriptions",
    initialState: rn,
    reducers: {
      updateSubscriptionOptions: function(R, p) {
      },
      unsubscribeQueryResult: function(R, p) {
      },
      internal_probeSubscription: function(R, p) {
      }
    }
  }), T = At({
    name: t + "/internalSubscriptions",
    initialState: rn,
    reducers: {
      subscriptionsUpdated: {
        reducer: function(R, p) {
          return ha(R, p.payload);
        },
        prepare: Qr()
      }
    }
  }), O = At({
    name: t + "/config",
    initialState: Se({
      online: JY(),
      focused: ej(),
      middlewareRegistered: !1
    }, E),
    reducers: {
      middlewareRegistered: function(R, p) {
        var A = p.payload;
        R.middlewareRegistered = R.middlewareRegistered === "conflict" || a !== A ? "conflict" : !0;
      }
    },
    extraReducers: function(R) {
      R.addCase(hi, function(p) {
        p.online = !0;
      }).addCase(jc, function(p) {
        p.online = !1;
      }).addCase(pi, function(p) {
        p.focused = !0;
      }).addCase(Yc, function(p) {
        p.focused = !1;
      }).addMatcher(c, function(p) {
        return Se({}, p);
      });
    }
  }), h = Pc({
    queries: f.reducer,
    mutations: _.reducer,
    provided: S.reducer,
    subscriptions: T.reducer,
    config: O.reducer
  }), N = function(R, p) {
    return h(l.match(p) ? void 0 : R, p);
  }, I = ke(Se(Se(Se(Se(Se({}, O.actions), f.actions), d.actions), T.actions), _.actions), {
    unsubscribeMutationResult: _.actions.removeMutationResult,
    resetApiState: l
  });
  return { reducer: N, actions: I };
}
var Dt = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), Qc = {
  status: le.uninitialized
}, za = /* @__PURE__ */ An(Qc, function() {
}), Ya = /* @__PURE__ */ An(Qc, function() {
});
function uj(e) {
  var t = e.serializeQueryArgs, n = e.reducerPath, r = function(E) {
    return za;
  }, o = function(E) {
    return Ya;
  };
  return { buildQuerySelector: s, buildMutationSelector: c, selectInvalidatedBy: u };
  function i(E) {
    return Se(Se({}, E), jY(E.status));
  }
  function a(E) {
    var l = E[n];
    if (process.env.NODE_ENV !== "production" && !l) {
      if (a.triggered)
        return l;
      a.triggered = !0, console.error("Error: No data found at `state." + n + "`. Did you forget to add the reducer to the store?");
    }
    return l;
  }
  function s(E, l) {
    return function(f) {
      var _ = t({
        queryArgs: f,
        endpointDefinition: l,
        endpointName: E
      }), S = function(T) {
        var O, h, N;
        return (N = (h = (O = a(T)) == null ? void 0 : O.queries) == null ? void 0 : h[_]) != null ? N : za;
      }, d = f === Dt ? r : S;
      return ln(d, i);
    };
  }
  function c() {
    return function(E) {
      var l, f;
      typeof E == "object" ? f = (l = In(E)) != null ? l : Dt : f = E;
      var _ = function(d) {
        var T, O, h;
        return (h = (O = (T = a(d)) == null ? void 0 : T.mutations) == null ? void 0 : O[f]) != null ? h : Ya;
      }, S = f === Dt ? o : _;
      return ln(S, i);
    };
  }
  function u(E, l) {
    for (var f, _ = E[n], S = /* @__PURE__ */ new Set(), d = 0, T = l.map(ko); d < T.length; d++) {
      var O = T[d], h = _.provided[O.type];
      if (h)
        for (var N = (f = O.id !== void 0 ? h[O.id] : Ba(Object.values(h))) != null ? f : [], I = 0, R = N; I < R.length; I++) {
          var p = R[I];
          S.add(p);
        }
    }
    return Ba(Array.from(S.values()).map(function(A) {
      var g = _.queries[A];
      return g ? [
        {
          queryCacheKey: A,
          endpointName: g.endpointName,
          originalArgs: g.originalArgs
        }
      ] : [];
    }));
  }
}
var Pn = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, ja = function(e) {
  var t = e.endpointName, n = e.queryArgs, r = "", o = Pn == null ? void 0 : Pn.get(n);
  if (typeof o == "string")
    r = o;
  else {
    var i = JSON.stringify(n, function(a, s) {
      return Je(s) ? Object.keys(s).sort().reduce(function(c, u) {
        return c[u] = s[u], c;
      }, {}) : s;
    });
    Je(n) && (Pn == null || Pn.set(n, i)), r = i;
  }
  return t + "(" + r + ")";
};
function Ej() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(r) {
    var o = $o(function(E) {
      var l, f;
      return (f = r.extractRehydrationInfo) == null ? void 0 : f.call(r, E, {
        reducerPath: (l = r.reducerPath) != null ? l : "api"
      });
    }), i = ke(Se({
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1
    }, r), {
      extractRehydrationInfo: o,
      serializeQueryArgs: function(E) {
        var l = ja;
        if ("serializeQueryArgs" in E.endpointDefinition) {
          var f = E.endpointDefinition.serializeQueryArgs;
          l = function(_) {
            var S = f(_);
            return typeof S == "string" ? S : ja(ke(Se({}, _), {
              queryArgs: S
            }));
          };
        } else
          r.serializeQueryArgs && (l = r.serializeQueryArgs);
        return l(E);
      },
      tagTypes: lr([], r.tagTypes || [])
    }), a = {
      endpointDefinitions: {},
      batch: function(E) {
        E();
      },
      apiUid: Gc(),
      extractRehydrationInfo: o,
      hasRehydrationInfo: $o(function(E) {
        return o(E) != null;
      })
    }, s = {
      injectEndpoints: u,
      enhanceEndpoints: function(E) {
        var l = E.addTagTypes, f = E.endpoints;
        if (l)
          for (var _ = 0, S = l; _ < S.length; _++) {
            var d = S[_];
            i.tagTypes.includes(d) || i.tagTypes.push(d);
          }
        if (f)
          for (var T = 0, O = Object.entries(f); T < O.length; T++) {
            var h = O[T], N = h[0], I = h[1];
            typeof I == "function" ? I(a.endpointDefinitions[N]) : Object.assign(a.endpointDefinitions[N] || {}, I);
          }
        return s;
      }
    }, c = e.map(function(E) {
      return E.init(s, i, a);
    });
    function u(E) {
      for (var l = E.endpoints({
        query: function(I) {
          return ke(Se({}, I), { type: Ke.query });
        },
        mutation: function(I) {
          return ke(Se({}, I), { type: Ke.mutation });
        }
      }), f = 0, _ = Object.entries(l); f < _.length; f++) {
        var S = _[f], d = S[0], T = S[1];
        if (!E.overrideExisting && d in a.endpointDefinitions) {
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error("called `injectEndpoints` to override already-existing endpointName " + d + " without specifying `overrideExisting: true`");
          continue;
        }
        a.endpointDefinitions[d] = T;
        for (var O = 0, h = c; O < h.length; O++) {
          var N = h[O];
          N.injectEndpoint(d, T);
        }
      }
      return s;
    }
    return s.injectEndpoints({ endpoints: r.endpoints });
  };
}
function lj(e) {
  for (var t in e)
    return !1;
  return !0;
}
var _j = 2147483647 / 1e3 - 1, dj = function(e) {
  var t = e.reducerPath, n = e.api, r = e.context, o = e.internalState, i = n.internalActions, a = i.removeQueryResult, s = i.unsubscribeQueryResult;
  function c(f) {
    var _ = o.currentSubscriptions[f];
    return !!_ && !lj(_);
  }
  var u = {}, E = function(f, _, S) {
    var d;
    if (s.match(f)) {
      var T = _.getState()[t], O = f.payload.queryCacheKey;
      l(O, (d = T.queries[O]) == null ? void 0 : d.endpointName, _, T.config);
    }
    if (n.util.resetApiState.match(f))
      for (var h = 0, N = Object.entries(u); h < N.length; h++) {
        var I = N[h], R = I[0], p = I[1];
        p && clearTimeout(p), delete u[R];
      }
    if (r.hasRehydrationInfo(f))
      for (var T = _.getState()[t], A = r.extractRehydrationInfo(f).queries, g = 0, v = Object.entries(A); g < v.length; g++) {
        var D = v[g], O = D[0], m = D[1];
        l(O, m == null ? void 0 : m.endpointName, _, T.config);
      }
  };
  function l(f, _, S, d) {
    var T, O = r.endpointDefinitions[_], h = (T = O == null ? void 0 : O.keepUnusedDataFor) != null ? T : d.keepUnusedDataFor;
    if (h !== 1 / 0) {
      var N = Math.max(0, Math.min(h, _j));
      if (!c(f)) {
        var I = u[f];
        I && clearTimeout(I), u[f] = setTimeout(function() {
          c(f) || S.dispatch(a({ queryCacheKey: f })), delete u[f];
        }, N * 1e3);
      }
    }
  }
  return E;
}, Tj = function(e) {
  var t = e.reducerPath, n = e.context, r = e.context.endpointDefinitions, o = e.mutationThunk, i = e.api, a = e.assertTagType, s = e.refetchQuery, c = i.internalActions.removeQueryResult, u = qt(yt(o), Lr(o)), E = function(f, _) {
    u(f) && l(qc(f, "invalidatesTags", r, a), _), i.util.invalidateTags.match(f) && l(Xc(f.payload, void 0, void 0, void 0, void 0, a), _);
  };
  function l(f, _) {
    var S = _.getState(), d = S[t], T = i.util.selectInvalidatedBy(S, f);
    n.batch(function() {
      for (var O, h = Array.from(T.values()), N = 0, I = h; N < I.length; N++) {
        var R = I[N].queryCacheKey, p = d.queries[R], A = (O = d.subscriptions[R]) != null ? O : {};
        p && (Object.keys(A).length === 0 ? _.dispatch(c({
          queryCacheKey: R
        })) : p.status !== le.uninitialized && _.dispatch(s(p, R)));
      }
    });
  }
  return E;
}, fj = function(e) {
  var t = e.reducerPath, n = e.queryThunk, r = e.api, o = e.refetchQuery, i = e.internalState, a = {}, s = function(_, S) {
    (r.internalActions.updateSubscriptionOptions.match(_) || r.internalActions.unsubscribeQueryResult.match(_)) && u(_.payload, S), (n.pending.match(_) || n.rejected.match(_) && _.meta.condition) && u(_.meta.arg, S), (n.fulfilled.match(_) || n.rejected.match(_) && !_.meta.condition) && c(_.meta.arg, S), r.util.resetApiState.match(_) && l();
  };
  function c(_, S) {
    var d = _.queryCacheKey, T = S.getState()[t], O = T.queries[d], h = i.currentSubscriptions[d];
    if (!(!O || O.status === le.uninitialized)) {
      var N = f(h);
      if (Number.isFinite(N)) {
        var I = a[d];
        I != null && I.timeout && (clearTimeout(I.timeout), I.timeout = void 0);
        var R = Date.now() + N, p = a[d] = {
          nextPollTimestamp: R,
          pollingInterval: N,
          timeout: setTimeout(function() {
            p.timeout = void 0, S.dispatch(o(O, d));
          }, N)
        };
      }
    }
  }
  function u(_, S) {
    var d = _.queryCacheKey, T = S.getState()[t], O = T.queries[d], h = i.currentSubscriptions[d];
    if (!(!O || O.status === le.uninitialized)) {
      var N = f(h);
      if (!Number.isFinite(N)) {
        E(d);
        return;
      }
      var I = a[d], R = Date.now() + N;
      (!I || R < I.nextPollTimestamp) && c({ queryCacheKey: d }, S);
    }
  }
  function E(_) {
    var S = a[_];
    S != null && S.timeout && clearTimeout(S.timeout), delete a[_];
  }
  function l() {
    for (var _ = 0, S = Object.keys(a); _ < S.length; _++) {
      var d = S[_];
      E(d);
    }
  }
  function f(_) {
    _ === void 0 && (_ = {});
    var S = Number.POSITIVE_INFINITY;
    for (var d in _)
      _[d].pollingInterval && (S = Math.min(_[d].pollingInterval, S));
    return S;
  }
  return s;
}, Sj = function(e) {
  var t = e.reducerPath, n = e.context, r = e.api, o = e.refetchQuery, i = e.internalState, a = r.internalActions.removeQueryResult, s = function(u, E) {
    pi.match(u) && c(E, "refetchOnFocus"), hi.match(u) && c(E, "refetchOnReconnect");
  };
  function c(u, E) {
    var l = u.getState()[t], f = l.queries, _ = i.currentSubscriptions;
    n.batch(function() {
      for (var S = 0, d = Object.keys(_); S < d.length; S++) {
        var T = d[S], O = f[T], h = _[T];
        if (!(!h || !O)) {
          var N = Object.values(h).some(function(I) {
            return I[E] === !0;
          }) || Object.values(h).every(function(I) {
            return I[E] === void 0;
          }) && l.config[E];
          N && (Object.keys(h).length === 0 ? u.dispatch(a({
            queryCacheKey: T
          })) : O.status !== le.uninitialized && u.dispatch(o(O, T)));
        }
      }
    });
  }
  return s;
}, Za = new Error("Promise never resolved before cacheEntryRemoved."), Rj = function(e) {
  var t = e.api, n = e.reducerPath, r = e.context, o = e.queryThunk, i = e.mutationThunk;
  e.internalState;
  var a = Bo(o), s = Bo(i), c = yt(o, i), u = {}, E = function(_, S, d) {
    var T = l(_);
    if (o.pending.match(_)) {
      var O = d[n].queries[T], h = S.getState()[n].queries[T];
      !O && h && f(_.meta.arg.endpointName, _.meta.arg.originalArgs, T, S, _.meta.requestId);
    } else if (i.pending.match(_)) {
      var h = S.getState()[n].mutations[T];
      h && f(_.meta.arg.endpointName, _.meta.arg.originalArgs, T, S, _.meta.requestId);
    } else if (c(_)) {
      var N = u[T];
      N != null && N.valueResolved && (N.valueResolved({
        data: _.payload,
        meta: _.meta.baseQueryMeta
      }), delete N.valueResolved);
    } else if (t.internalActions.removeQueryResult.match(_) || t.internalActions.removeMutationResult.match(_)) {
      var N = u[T];
      N && (delete u[T], N.cacheEntryRemoved());
    } else if (t.util.resetApiState.match(_))
      for (var I = 0, R = Object.entries(u); I < R.length; I++) {
        var p = R[I], A = p[0], N = p[1];
        delete u[A], N.cacheEntryRemoved();
      }
  };
  function l(_) {
    return a(_) ? _.meta.arg.queryCacheKey : s(_) ? _.meta.requestId : t.internalActions.removeQueryResult.match(_) ? _.payload.queryCacheKey : t.internalActions.removeMutationResult.match(_) ? In(_.payload) : "";
  }
  function f(_, S, d, T, O) {
    var h = r.endpointDefinitions[_], N = h == null ? void 0 : h.onCacheEntryAdded;
    if (N) {
      var I = {}, R = new Promise(function(m) {
        I.cacheEntryRemoved = m;
      }), p = Promise.race([
        new Promise(function(m) {
          I.valueResolved = m;
        }),
        R.then(function() {
          throw Za;
        })
      ]);
      p.catch(function() {
      }), u[d] = I;
      var A = t.endpoints[_].select(h.type === Ke.query ? S : d), g = T.dispatch(function(m, L, P) {
        return P;
      }), v = ke(Se({}, T), {
        getCacheEntry: function() {
          return A(T.getState());
        },
        requestId: O,
        extra: g,
        updateCachedData: h.type === Ke.query ? function(m) {
          return T.dispatch(t.util.updateQueryData(_, S, m));
        } : void 0,
        cacheDataLoaded: p,
        cacheEntryRemoved: R
      }), D = N(S, v);
      Promise.resolve(D).catch(function(m) {
        if (m !== Za)
          throw m;
      });
    }
  }
  return E;
}, Nj = function(e) {
  var t = e.api, n = e.context, r = e.queryThunk, o = e.mutationThunk, i = Ni(r, o), a = Nn(r, o), s = yt(r, o), c = {}, u = function(E, l) {
    var f, _, S;
    if (i(E)) {
      var d = E.meta, T = d.requestId, O = d.arg, h = O.endpointName, N = O.originalArgs, I = n.endpointDefinitions[h], R = I == null ? void 0 : I.onQueryStarted;
      if (R) {
        var p = {}, A = new Promise(function(M, H) {
          p.resolve = M, p.reject = H;
        });
        A.catch(function() {
        }), c[T] = p;
        var g = t.endpoints[h].select(I.type === Ke.query ? N : T), v = l.dispatch(function(M, H, x) {
          return x;
        }), D = ke(Se({}, l), {
          getCacheEntry: function() {
            return g(l.getState());
          },
          requestId: T,
          extra: v,
          updateCachedData: I.type === Ke.query ? function(M) {
            return l.dispatch(t.util.updateQueryData(h, N, M));
          } : void 0,
          queryFulfilled: A
        });
        R(N, D);
      }
    } else if (s(E)) {
      var m = E.meta, T = m.requestId, L = m.baseQueryMeta;
      (f = c[T]) == null || f.resolve({
        data: E.payload,
        meta: L
      }), delete c[T];
    } else if (a(E)) {
      var P = E.meta, T = P.requestId, U = P.rejectedWithValue, L = P.baseQueryMeta;
      (S = c[T]) == null || S.reject({
        error: (_ = E.payload) != null ? _ : E.error,
        isUnhandledError: !U,
        meta: L
      }), delete c[T];
    }
  };
  return u;
}, Oj = function(e) {
  var t = e.api, n = e.context.apiUid, r = e.reducerPath;
  return function(o, i) {
    var a, s;
    t.util.resetApiState.match(o) && i.dispatch(t.internalActions.middlewareRegistered(n)), typeof process < "u" && process.env.NODE_ENV === "development" && t.internalActions.middlewareRegistered.match(o) && o.payload === n && ((s = (a = i.getState()[r]) == null ? void 0 : a.config) == null ? void 0 : s.middlewareRegistered) === "conflict" && console.warn('There is a mismatch between slice and middleware for the reducerPath "' + r + `".
You can only have one api per reducer path, this will lead to crashes in various situations!` + (r === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""));
  };
}, Xa, Ij = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis) : function(e) {
  return (Xa || (Xa = Promise.resolve())).then(e).catch(function(t) {
    return setTimeout(function() {
      throw t;
    }, 0);
  });
}, pj = function(e) {
  var t = e.api, n = e.queryThunk, r = e.internalState, o = t.reducerPath + "/subscriptions", i = null, a = !1, s = t.internalActions, c = s.updateSubscriptionOptions, u = s.unsubscribeQueryResult, E = function(l, f) {
    var _, S, d, T, O, h, N, I, R;
    if (c.match(f)) {
      var p = f.payload, A = p.queryCacheKey, g = p.requestId, v = p.options;
      return (_ = l == null ? void 0 : l[A]) != null && _[g] && (l[A][g] = v), !0;
    }
    if (u.match(f)) {
      var D = f.payload, A = D.queryCacheKey, g = D.requestId;
      return l[A] && delete l[A][g], !0;
    }
    if (t.internalActions.removeQueryResult.match(f))
      return delete l[f.payload.queryCacheKey], !0;
    if (n.pending.match(f)) {
      var m = f.meta, L = m.arg, g = m.requestId;
      if (L.subscribe) {
        var P = (d = l[S = L.queryCacheKey]) != null ? d : l[S] = {};
        return P[g] = (O = (T = L.subscriptionOptions) != null ? T : P[g]) != null ? O : {}, !0;
      }
    }
    if (n.rejected.match(f)) {
      var U = f.meta, M = U.condition, L = U.arg, g = U.requestId;
      if (M && L.subscribe) {
        var P = (N = l[h = L.queryCacheKey]) != null ? N : l[h] = {};
        return P[g] = (R = (I = L.subscriptionOptions) != null ? I : P[g]) != null ? R : {}, !0;
      }
    }
    return !1;
  };
  return function(l, f) {
    var _, S;
    if (i || (i = JSON.parse(JSON.stringify(r.currentSubscriptions))), t.util.resetApiState.match(l))
      return i = r.currentSubscriptions = {}, [!0, !1];
    if (t.internalActions.internal_probeSubscription.match(l)) {
      var d = l.payload, T = d.queryCacheKey, O = d.requestId, h = !!((_ = r.currentSubscriptions[T]) != null && _[O]);
      return [!1, h];
    }
    var N = E(r.currentSubscriptions, l);
    if (N) {
      a || (Ij(function() {
        var A = JSON.parse(JSON.stringify(r.currentSubscriptions)), g = mc(i, function() {
          return A;
        }), v = g[1];
        f.next(t.internalActions.subscriptionsUpdated(v)), i = A, a = !1;
      }), a = !0);
      var I = !!((S = l.type) != null && S.startsWith(o)), R = n.rejected.match(l) && l.meta.condition && !!l.meta.arg.subscribe, p = !I && !R;
      return [p, !1];
    }
    return [!0, !1];
  };
};
function hj(e) {
  var t = e.reducerPath, n = e.queryThunk, r = e.api, o = e.context, i = o.apiUid, a = {
    invalidateTags: he(t + "/invalidateTags")
  }, s = function(l) {
    return !!l && typeof l.type == "string" && l.type.startsWith(t + "/");
  }, c = [
    Oj,
    dj,
    Tj,
    fj,
    Rj,
    Nj
  ], u = function(l) {
    var f = !1, _ = {
      currentSubscriptions: {}
    }, S = ke(Se({}, e), {
      internalState: _,
      refetchQuery: E
    }), d = c.map(function(h) {
      return h(S);
    }), T = pj(S), O = Sj(S);
    return function(h) {
      return function(N) {
        f || (f = !0, l.dispatch(r.internalActions.middlewareRegistered(i)));
        var I = ke(Se({}, l), { next: h }), R = l.getState(), p = T(N, I, R), A = p[0], g = p[1], v;
        if (A ? v = h(N) : v = g, l.getState()[t] && (O(N, I, R), s(N) || o.hasRehydrationInfo(N)))
          for (var D = 0, m = d; D < m.length; D++) {
            var L = m[D];
            L(N, I, R);
          }
        return v;
      };
    };
  };
  return { middleware: u, actions: a };
  function E(l, f, _) {
    return _ === void 0 && (_ = {}), n(Se({
      type: "query",
      endpointName: l.endpointName,
      originalArgs: l.originalArgs,
      subscribe: !1,
      forceRefetch: !0,
      queryCacheKey: f
    }, _));
  }
}
function nt(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  Object.assign.apply(Object, lr([e], t));
}
var qa = /* @__PURE__ */ Symbol(), Aj = function() {
  return {
    name: qa,
    init: function(e, t, n) {
      var r = t.baseQuery, o = t.tagTypes, i = t.reducerPath, a = t.serializeQueryArgs, s = t.keepUnusedDataFor, c = t.refetchOnMountOrArgChange, u = t.refetchOnFocus, E = t.refetchOnReconnect;
      Wz();
      var l = function(w) {
        return typeof process < "u" && process.env.NODE_ENV === "development" && (o.includes(w.type) || console.error("Tag type '" + w.type + "' was used, but not specified in `tagTypes`!")), w;
      };
      Object.assign(e, {
        reducerPath: i,
        endpoints: {},
        internalActions: {
          onOnline: hi,
          onOffline: jc,
          onFocus: pi,
          onFocusLost: Yc
        },
        util: {}
      });
      var f = sj({
        baseQuery: r,
        reducerPath: i,
        context: n,
        api: e,
        serializeQueryArgs: a
      }), _ = f.queryThunk, S = f.mutationThunk, d = f.patchQueryData, T = f.updateQueryData, O = f.upsertQueryData, h = f.prefetch, N = f.buildMatchThunkActions, I = cj({
        context: n,
        queryThunk: _,
        mutationThunk: S,
        reducerPath: i,
        assertTagType: l,
        config: {
          refetchOnFocus: u,
          refetchOnReconnect: E,
          refetchOnMountOrArgChange: c,
          keepUnusedDataFor: s,
          reducerPath: i
        }
      }), R = I.reducer, p = I.actions;
      nt(e.util, {
        patchQueryData: d,
        updateQueryData: T,
        upsertQueryData: O,
        prefetch: h,
        resetApiState: p.resetApiState
      }), nt(e.internalActions, p);
      var A = hj({
        reducerPath: i,
        context: n,
        queryThunk: _,
        mutationThunk: S,
        api: e,
        assertTagType: l
      }), g = A.middleware, v = A.actions;
      nt(e.util, v), nt(e, { reducer: R, middleware: g });
      var D = uj({
        serializeQueryArgs: a,
        reducerPath: i
      }), m = D.buildQuerySelector, L = D.buildMutationSelector, P = D.selectInvalidatedBy;
      nt(e.util, { selectInvalidatedBy: P });
      var U = aj({
        queryThunk: _,
        mutationThunk: S,
        api: e,
        serializeQueryArgs: a,
        context: n
      }), M = U.buildInitiateQuery, H = U.buildInitiateMutation, x = U.getRunningMutationThunk, F = U.getRunningMutationsThunk, z = U.getRunningQueriesThunk, y = U.getRunningQueryThunk, b = U.getRunningOperationPromises, V = U.removalWarning;
      return nt(e.util, {
        getRunningOperationPromises: b,
        getRunningOperationPromise: V,
        getRunningMutationThunk: x,
        getRunningMutationsThunk: F,
        getRunningQueryThunk: y,
        getRunningQueriesThunk: z
      }), {
        name: qa,
        injectEndpoint: function(w, B) {
          var G, k, K = e;
          (k = (G = K.endpoints)[w]) != null || (G[w] = {}), Zc(B) ? nt(K.endpoints[w], {
            name: w,
            select: m(w, B),
            initiate: M(w, B)
          }, N(_, w)) : oj(B) && nt(K.endpoints[w], {
            name: w,
            select: L(),
            initiate: H(w)
          }, N(S, w));
        }
      };
    }
  };
}, gj = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, o = e.length; n < r; n++, o++)
    e[o] = t[n];
  return e;
}, vj = Object.defineProperty, Dj = Object.defineProperties, mj = Object.getOwnPropertyDescriptors, Qa = Object.getOwnPropertySymbols, Lj = Object.prototype.hasOwnProperty, Cj = Object.prototype.propertyIsEnumerable, Ja = function(e, t, n) {
  return t in e ? vj(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, je = function(e, t) {
  for (var n in t || (t = {}))
    Lj.call(t, n) && Ja(e, n, t[n]);
  if (Qa)
    for (var r = 0, o = Qa(t); r < o.length; r++) {
      var n = o[r];
      Cj.call(t, n) && Ja(e, n, t[n]);
    }
  return e;
}, Kn = function(e, t) {
  return Dj(e, mj(t));
};
function es(e, t, n, r) {
  var o = Oe(function() {
    return {
      queryArgs: e,
      serialized: typeof e == "object" ? t({ queryArgs: e, endpointDefinition: n, endpointName: r }) : e
    };
  }, [e, t, n, r]), i = ee(o);
  return te(function() {
    i.current.serialized !== o.serialized && (i.current = o);
  }, [o]), i.current.serialized === o.serialized ? i.current.queryArgs : e;
}
var eo = Symbol();
function to(e) {
  var t = ee(e);
  return te(function() {
    qn(t.current, e) || (t.current = e);
  }, [e]), qn(t.current, e) ? t.current : e;
}
var yn = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, Pj = function(e) {
  var t = e.endpointName, n = e.queryArgs, r = "", o = yn == null ? void 0 : yn.get(n);
  if (typeof o == "string")
    r = o;
  else {
    var i = JSON.stringify(n, function(a, s) {
      return Je(s) ? Object.keys(s).sort().reduce(function(c, u) {
        return c[u] = s[u], c;
      }, {}) : s;
    });
    Je(n) && (yn == null || yn.set(n, i)), r = i;
  }
  return t + "(" + r + ")";
}, yj = typeof window < "u" && window.document && window.document.createElement ? Sr : te, Uj = function(e) {
  return e;
}, bj = function(e) {
  return e.isUninitialized ? Kn(je({}, e), {
    isUninitialized: !1,
    isFetching: !0,
    isLoading: e.data === void 0,
    status: le.pending
  }) : e;
};
function Mj(e) {
  var t = e.api, n = e.moduleOptions, r = n.batch, o = n.useDispatch, i = n.useSelector, a = n.useStore, s = n.unstable__sideEffectsInRender, c = e.serializeQueryArgs, u = e.context, E = s ? function(d) {
    return d();
  } : te;
  return { buildQueryHooks: _, buildMutationHook: S, usePrefetch: f };
  function l(d, T, O) {
    if (T != null && T.endpointName && d.isUninitialized) {
      var h = T.endpointName, N = u.endpointDefinitions[h];
      c({
        queryArgs: T.originalArgs,
        endpointDefinition: N,
        endpointName: h
      }) === c({
        queryArgs: O,
        endpointDefinition: N,
        endpointName: h
      }) && (T = void 0);
    }
    var I = d.isSuccess ? d.data : T == null ? void 0 : T.data;
    I === void 0 && (I = d.data);
    var R = I !== void 0, p = d.isLoading, A = !R && p, g = d.isSuccess || p && R;
    return Kn(je({}, d), {
      data: I,
      currentData: d.data,
      isFetching: p,
      isLoading: A,
      isSuccess: g
    });
  }
  function f(d, T) {
    var O = o(), h = to(T);
    return ve(function(N, I) {
      return O(t.util.prefetch(d, N, je(je({}, h), I)));
    }, [d, O, h]);
  }
  function _(d) {
    var T = function(N, I) {
      var R = I === void 0 ? {} : I, p = R.refetchOnReconnect, A = R.refetchOnFocus, g = R.refetchOnMountOrArgChange, v = R.skip, D = v === void 0 ? !1 : v, m = R.pollingInterval, L = m === void 0 ? 0 : m, P = t.endpoints[d].initiate, U = o(), M = es(D ? Dt : N, Pj, u.endpointDefinitions[d], d), H = to({
        refetchOnReconnect: p,
        refetchOnFocus: A,
        pollingInterval: L
      }), x = ee(!1), F = ee(), z = F.current || {}, y = z.queryCacheKey, b = z.requestId, V = !1;
      if (y && b) {
        var w = U(t.internalActions.internal_probeSubscription({
          queryCacheKey: y,
          requestId: b
        }));
        if (process.env.NODE_ENV !== "production" && typeof w != "boolean")
          throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + t.reducerPath + `" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
        V = !!w;
      }
      var B = !V && x.current;
      return E(function() {
        x.current = V;
      }), E(function() {
        B && (F.current = void 0);
      }, [B]), E(function() {
        var G, k = F.current;
        if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(B), M === Dt) {
          k == null || k.unsubscribe(), F.current = void 0;
          return;
        }
        var K = (G = F.current) == null ? void 0 : G.subscriptionOptions;
        if (!k || k.arg !== M) {
          k == null || k.unsubscribe();
          var X = U(P(M, {
            subscriptionOptions: H,
            forceRefetch: g
          }));
          F.current = X;
        } else
          H !== K && k.updateSubscriptionOptions(H);
      }, [
        U,
        P,
        g,
        M,
        H,
        B
      ]), te(function() {
        return function() {
          var G;
          (G = F.current) == null || G.unsubscribe(), F.current = void 0;
        };
      }, []), Oe(function() {
        return {
          refetch: function() {
            var G;
            if (!F.current)
              throw new Error("Cannot refetch a query that has not been started yet.");
            return (G = F.current) == null ? void 0 : G.refetch();
          }
        };
      }, []);
    }, O = function(N) {
      var I = N === void 0 ? {} : N, R = I.refetchOnReconnect, p = I.refetchOnFocus, A = I.pollingInterval, g = A === void 0 ? 0 : A, v = t.endpoints[d].initiate, D = o(), m = Re(eo), L = m[0], P = m[1], U = ee(), M = to({
        refetchOnReconnect: R,
        refetchOnFocus: p,
        pollingInterval: g
      });
      E(function() {
        var F, z, y = (F = U.current) == null ? void 0 : F.subscriptionOptions;
        M !== y && ((z = U.current) == null || z.updateSubscriptionOptions(M));
      }, [M]);
      var H = ee(M);
      E(function() {
        H.current = M;
      }, [M]);
      var x = ve(function(F, z) {
        z === void 0 && (z = !1);
        var y;
        return r(function() {
          var b;
          (b = U.current) == null || b.unsubscribe(), U.current = y = D(v(F, {
            subscriptionOptions: H.current,
            forceRefetch: !z
          })), P(F);
        }), y;
      }, [D, v]);
      return te(function() {
        return function() {
          var F;
          (F = U == null ? void 0 : U.current) == null || F.unsubscribe();
        };
      }, []), te(function() {
        L !== eo && !U.current && x(L, !0);
      }, [L, x]), Oe(function() {
        return [x, L];
      }, [x, L]);
    }, h = function(N, I) {
      var R = I === void 0 ? {} : I, p = R.skip, A = p === void 0 ? !1 : p, g = R.selectFromResult, v = t.endpoints[d].select, D = es(A ? Dt : N, c, u.endpointDefinitions[d], d), m = ee(), L = Oe(function() {
        return ln([
          v(D),
          function(x, F) {
            return F;
          },
          function(x) {
            return D;
          }
        ], l);
      }, [v, D]), P = Oe(function() {
        return g ? ln([L], g) : L;
      }, [L, g]), U = i(function(x) {
        return P(x, m.current);
      }, qn), M = a(), H = L(M.getState(), m.current);
      return yj(function() {
        m.current = H;
      }, [H]), U;
    };
    return {
      useQueryState: h,
      useQuerySubscription: T,
      useLazyQuerySubscription: O,
      useLazyQuery: function(N) {
        var I = O(N), R = I[0], p = I[1], A = h(p, Kn(je({}, N), {
          skip: p === eo
        })), g = Oe(function() {
          return { lastArg: p };
        }, [p]);
        return Oe(function() {
          return [R, A, g];
        }, [R, A, g]);
      },
      useQuery: function(N, I) {
        var R = T(N, I), p = h(N, je({
          selectFromResult: N === Dt || I != null && I.skip ? void 0 : bj
        }, I)), A = p.data, g = p.status, v = p.isLoading, D = p.isSuccess, m = p.isError, L = p.error;
        return Oo({ data: A, status: g, isLoading: v, isSuccess: D, isError: m, error: L }), Oe(function() {
          return je(je({}, p), R);
        }, [p, R]);
      }
    };
  }
  function S(d) {
    return function(T) {
      var O = T === void 0 ? {} : T, h = O.selectFromResult, N = h === void 0 ? Uj : h, I = O.fixedCacheKey, R = t.endpoints[d], p = R.select, A = R.initiate, g = o(), v = Re(), D = v[0], m = v[1];
      te(function() {
        return function() {
          D != null && D.arg.fixedCacheKey || D == null || D.reset();
        };
      }, [D]);
      var L = ve(function(k) {
        var K = g(A(k, { fixedCacheKey: I }));
        return m(K), K;
      }, [g, A, I]), P = (D || {}).requestId, U = Oe(function() {
        return ln([p({ fixedCacheKey: I, requestId: D == null ? void 0 : D.requestId })], N);
      }, [p, D, N, I]), M = i(U, qn), H = I == null ? D == null ? void 0 : D.arg.originalArgs : void 0, x = ve(function() {
        r(function() {
          D && m(void 0), I && g(t.internalActions.removeMutationResult({
            requestId: P,
            fixedCacheKey: I
          }));
        });
      }, [g, I, D, P]), F = M.endpointName, z = M.data, y = M.status, b = M.isLoading, V = M.isSuccess, w = M.isError, B = M.error;
      Oo({
        endpointName: F,
        data: z,
        status: y,
        isLoading: b,
        isSuccess: V,
        isError: w,
        error: B
      });
      var G = Oe(function() {
        return Kn(je({}, M), { originalArgs: H, reset: x });
      }, [M, H, x]);
      return Oe(function() {
        return [L, G];
      }, [L, G]);
    };
  }
}
var Tr;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(Tr || (Tr = {}));
function wj(e) {
  return e.type === Tr.query;
}
function $j(e) {
  return e.type === Tr.mutation;
}
function no(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
function Un(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  Object.assign.apply(Object, gj([e], t));
}
var Hj = /* @__PURE__ */ Symbol(), Vj = function(e) {
  var t = e === void 0 ? {} : e, n = t.batch, r = n === void 0 ? ps : n, o = t.useDispatch, i = o === void 0 ? Hs : o, a = t.useSelector, s = a === void 0 ? Us : a, c = t.useStore, u = c === void 0 ? $s : c, E = t.unstable__sideEffectsInRender, l = E === void 0 ? !1 : E;
  return {
    name: Hj,
    init: function(f, _, S) {
      var d = _.serializeQueryArgs, T = f, O = Mj({
        api: f,
        moduleOptions: {
          batch: r,
          useDispatch: i,
          useSelector: s,
          useStore: u,
          unstable__sideEffectsInRender: l
        },
        serializeQueryArgs: d,
        context: S
      }), h = O.buildQueryHooks, N = O.buildMutationHook, I = O.usePrefetch;
      return Un(T, { usePrefetch: I }), Un(S, { batch: r }), {
        injectEndpoint: function(R, p) {
          if (wj(p)) {
            var A = h(R), g = A.useQuery, v = A.useLazyQuery, D = A.useLazyQuerySubscription, m = A.useQueryState, L = A.useQuerySubscription;
            Un(T.endpoints[R], {
              useQuery: g,
              useLazyQuery: v,
              useLazyQuerySubscription: D,
              useQueryState: m,
              useQuerySubscription: L
            }), f["use" + no(R) + "Query"] = g, f["useLazy" + no(R) + "Query"] = v;
          } else if ($j(p)) {
            var P = N(R);
            Un(T.endpoints[R], {
              useMutation: P
            }), f["use" + no(R) + "Mutation"] = P;
          }
        }
      };
    }
  };
}, Bj = /* @__PURE__ */ Ej(Aj(), Vj());
const ro = rj({
  baseUrl: "https://api.trunkrs.app/v2",
  // TODO: setup env later
  prepareHeaders: (e) => {
    const t = localStorage.getItem("accessToken");
    return t && e.set("Authorization", `Bearer ${t}`), e;
  }
}), Gj = async (e, t, n) => {
  let r = await ro(e, t, n);
  const o = localStorage.getItem("refreshToken");
  if (r.error && [401, 403, "FETCH_ERROR"].includes(r.error.status)) {
    const i = await ro(
      {
        url: "/auth/functions/refresh-credentials",
        method: "POST",
        body: {
          refresh_token: o
        }
      },
      t,
      n
    );
    if (i.data) {
      const { AccessToken: a } = i.data.AuthenticationResult;
      localStorage.setItem("accessToken", a);
    }
    r = await ro(e, t, n);
  }
  return r;
}, Bt = Bj({
  reducerPath: "api",
  baseQuery: Gj,
  endpoints: () => ({}),
  tagTypes: ["MorningScanResult", "ShipmentsForReturn"]
}), kj = Bt.injectEndpoints({
  endpoints: (e) => ({
    scan: e.mutation({
      query: (t) => ({
        url: "/delivery/functions/morning-scan",
        method: "POST",
        body: {
          subcoId: t.subcoId,
          trunkrsNrOrBarcode: t.trunkrsNrOrBarcode
        }
      }),
      invalidatesTags: ["MorningScanResult"]
    }),
    getMorningScanResult: e.query({
      query: (t) => ({
        url: "/delivery/functions/shipments/morning-scan/v2",
        params: {
          date: WY(),
          subcoId: t
        }
      }),
      providesTags: ["MorningScanResult"]
    })
  })
}), { useGetMorningScanResultQuery: xj, useScanMutation: Cr } = kj, Fj = Bt.injectEndpoints({
  endpoints: (e) => ({
    setShipmentAsReturn: e.mutation({
      query: (t) => ({
        url: "/collection/functions/returns",
        method: "POST",
        body: {
          shipmentId: t.shipmentId,
          optimizationTourId: t.optimizationTourId
        }
      }),
      invalidatesTags: ["ShipmentsForReturn"]
    }),
    getReturnShipmentRequests: e.query({
      query: (t) => ({
        url: "/collection/functions/returns/fetch-requests",
        method: "POST",
        body: t
      }),
      providesTags: ["ShipmentsForReturn"]
    })
  })
}), { useGetReturnShipmentRequestsQuery: Wj, useSetShipmentAsReturnMutation: Kj } = Fj, zj = Y["useId".toString()] || (() => {
});
let Yj = 0;
function oo(e) {
  const [t, n] = Y.useState(zj());
  return Ft(() => {
    e || n(
      (r) => r ?? String(Yj++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const io = "focusScope.autoFocusOnMount", ao = "focusScope.autoFocusOnUnmount", ts = {
  bubbles: !1,
  cancelable: !0
}, jj = /* @__PURE__ */ Te((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [s, c] = Re(null), u = Tt(o), E = Tt(i), l = ee(null), f = It(
    t,
    (d) => c(d)
  ), _ = ee({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  te(() => {
    if (r) {
      let d = function(N) {
        if (_.paused || !s)
          return;
        const I = N.target;
        s.contains(I) ? l.current = I : rt(l.current, {
          select: !0
        });
      }, T = function(N) {
        if (_.paused || !s)
          return;
        const I = N.relatedTarget;
        I !== null && (s.contains(I) || rt(l.current, {
          select: !0
        }));
      }, O = function(N) {
        const I = document.activeElement;
        for (const R of N)
          R.removedNodes.length > 0 && (s != null && s.contains(I) || rt(s));
      };
      document.addEventListener("focusin", d), document.addEventListener("focusout", T);
      const h = new MutationObserver(O);
      return s && h.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", d), document.removeEventListener("focusout", T), h.disconnect();
      };
    }
  }, [
    r,
    s,
    _.paused
  ]), te(() => {
    if (s) {
      rs.add(_);
      const d = document.activeElement;
      if (!s.contains(d)) {
        const O = new CustomEvent(io, ts);
        s.addEventListener(io, u), s.dispatchEvent(O), O.defaultPrevented || (Zj(e8(Jc(s)), {
          select: !0
        }), document.activeElement === d && rt(s));
      }
      return () => {
        s.removeEventListener(io, u), setTimeout(() => {
          const O = new CustomEvent(ao, ts);
          s.addEventListener(ao, E), s.dispatchEvent(O), O.defaultPrevented || rt(d ?? document.body, {
            select: !0
          }), s.removeEventListener(ao, E), rs.remove(_);
        }, 0);
      };
    }
  }, [
    s,
    u,
    E,
    _
  ]);
  const S = ve((d) => {
    if (!n && !r || _.paused)
      return;
    const T = d.key === "Tab" && !d.altKey && !d.ctrlKey && !d.metaKey, O = document.activeElement;
    if (T && O) {
      const h = d.currentTarget, [N, I] = Xj(h);
      N && I ? !d.shiftKey && O === I ? (d.preventDefault(), n && rt(N, {
        select: !0
      })) : d.shiftKey && O === N && (d.preventDefault(), n && rt(I, {
        select: !0
      })) : O === h && d.preventDefault();
    }
  }, [
    n,
    r,
    _.paused
  ]);
  return /* @__PURE__ */ Z($e.div, ce({
    tabIndex: -1
  }, a, {
    ref: f,
    onKeyDown: S
  }));
});
function Zj(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (rt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Xj(e) {
  const t = Jc(e), n = ns(t, e), r = ns(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Jc(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function ns(e, t) {
  for (const n of e)
    if (!qj(n, {
      upTo: t
    }))
      return n;
}
function qj(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Qj(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function rt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Qj(e) && t && e.select();
  }
}
const rs = Jj();
function Jj() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = os(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = os(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function os(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function e8(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
let so = 0;
function t8() {
  te(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : is()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : is()), so++, () => {
      so === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), so--;
    };
  }, []);
}
function is() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var zn = "right-scroll-bar-position", Yn = "width-before-scroll-bar", n8 = "with-scroll-bars-hidden", r8 = "--removed-body-scroll-bar-size";
function o8(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function i8(e, t) {
  var n = Re(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function a8(e, t) {
  return i8(t || null, function(n) {
    return e.forEach(function(r) {
      return o8(r, n);
    });
  });
}
function s8(e) {
  return e;
}
function c8(e, t) {
  t === void 0 && (t = s8);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var c = function() {
        var E = a;
        a = [], E.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(E) {
          a.push(E), u();
        },
        filter: function(E) {
          return a = a.filter(E), n;
        }
      };
    }
  };
  return o;
}
function u8(e) {
  e === void 0 && (e = {});
  var t = c8(null);
  return t.options = Ge({ async: !0, ssr: !1 }, e), t;
}
var eu = function(e) {
  var t = e.sideCar, n = Gs(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Y.createElement(r, Ge({}, n));
};
eu.isSideCarExport = !0;
function E8(e, t) {
  return e.useMedium(t), eu;
}
var tu = u8(), co = function() {
}, Pr = Y.forwardRef(function(e, t) {
  var n = Y.useRef(null), r = Y.useState({
    onScrollCapture: co,
    onWheelCapture: co,
    onTouchMoveCapture: co
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, E = e.enabled, l = e.shards, f = e.sideCar, _ = e.noIsolation, S = e.inert, d = e.allowPinchZoom, T = e.as, O = T === void 0 ? "div" : T, h = Gs(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), N = f, I = a8([n, t]), R = Ge(Ge({}, h), o);
  return Y.createElement(
    Y.Fragment,
    null,
    E && Y.createElement(N, { sideCar: tu, removeScrollBar: u, shards: l, noIsolation: _, inert: S, setCallbacks: i, allowPinchZoom: !!d, lockRef: n }),
    a ? Y.cloneElement(Y.Children.only(s), Ge(Ge({}, R), { ref: I })) : Y.createElement(O, Ge({}, R, { className: c, ref: I }), s)
  );
});
Pr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Pr.classNames = {
  fullWidth: Yn,
  zeroRight: zn
};
var as, l8 = function() {
  if (as)
    return as;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function _8() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = l8();
  return t && e.setAttribute("nonce", t), e;
}
function d8(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function T8(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var f8 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = _8()) && (d8(t, n), T8(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, S8 = function() {
  var e = f8();
  return function(t, n) {
    Y.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, nu = function() {
  var e = S8(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, R8 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, uo = function(e) {
  return parseInt(e || "", 10) || 0;
}, N8 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [uo(n), uo(r), uo(o)];
}, O8 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return R8;
  var t = N8(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, I8 = nu(), p8 = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(n8, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }

  .`).concat(zn, ` {
    right: `).concat(s, "px ").concat(r, `;
  }

  .`).concat(Yn, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }

  .`).concat(zn, " .").concat(zn, ` {
    right: 0 `).concat(r, `;
  }

  .`).concat(Yn, " .").concat(Yn, ` {
    margin-right: 0 `).concat(r, `;
  }

  body {
    `).concat(r8, ": ").concat(s, `px;
  }
`);
}, h8 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, i = Y.useMemo(function() {
    return O8(o);
  }, [o]);
  return Y.createElement(I8, { styles: p8(i, !t, o, n ? "" : "!important") });
}, Fo = !1;
if (typeof window < "u")
  try {
    var bn = Object.defineProperty({}, "passive", {
      get: function() {
        return Fo = !0, !0;
      }
    });
    window.addEventListener("test", bn, bn), window.removeEventListener("test", bn, bn);
  } catch {
    Fo = !1;
  }
var bt = Fo ? { passive: !1 } : !1, A8 = function(e) {
  return e.tagName === "TEXTAREA";
}, ru = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !A8(e) && n[t] === "visible")
  );
}, g8 = function(e) {
  return ru(e, "overflowY");
}, v8 = function(e) {
  return ru(e, "overflowX");
}, ss = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = ou(e, n);
    if (r) {
      var o = iu(e, n), i = o[1], a = o[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, D8 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, m8 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ou = function(e, t) {
  return e === "v" ? g8(t) : v8(t);
}, iu = function(e, t) {
  return e === "v" ? D8(t) : m8(t);
}, L8 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, C8 = function(e, t, n, r, o) {
  var i = L8(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, c = t.contains(s), u = !1, E = a > 0, l = 0, f = 0;
  do {
    var _ = iu(e, s), S = _[0], d = _[1], T = _[2], O = d - T - i * S;
    (S || O) && ou(e, s) && (l += O, f += S), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (E && (o && l === 0 || !o && a > l) || !E && (o && f === 0 || !o && -a > f)) && (u = !0), u;
}, Mn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, cs = function(e) {
  return [e.deltaX, e.deltaY];
}, us = function(e) {
  return e && "current" in e ? e.current : e;
}, P8 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, y8 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, U8 = 0, Mt = [];
function b8(e) {
  var t = Y.useRef([]), n = Y.useRef([0, 0]), r = Y.useRef(), o = Y.useState(U8++)[0], i = Y.useState(function() {
    return nu();
  })[0], a = Y.useRef(e);
  Y.useEffect(function() {
    a.current = e;
  }, [e]), Y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var d = i3([e.lockRef.current], (e.shards || []).map(us), !0).filter(Boolean);
      return d.forEach(function(T) {
        return T.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), d.forEach(function(T) {
          return T.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = Y.useCallback(function(d, T) {
    if ("touches" in d && d.touches.length === 2)
      return !a.current.allowPinchZoom;
    var O = Mn(d), h = n.current, N = "deltaX" in d ? d.deltaX : h[0] - O[0], I = "deltaY" in d ? d.deltaY : h[1] - O[1], R, p = d.target, A = Math.abs(N) > Math.abs(I) ? "h" : "v";
    if ("touches" in d && A === "h" && p.type === "range")
      return !1;
    var g = ss(A, p);
    if (!g)
      return !0;
    if (g ? R = A : (R = A === "v" ? "h" : "v", g = ss(A, p)), !g)
      return !1;
    if (!r.current && "changedTouches" in d && (N || I) && (r.current = R), !R)
      return !0;
    var v = r.current || R;
    return C8(v, T, d, v === "h" ? N : I, !0);
  }, []), c = Y.useCallback(function(d) {
    var T = d;
    if (!(!Mt.length || Mt[Mt.length - 1] !== i)) {
      var O = "deltaY" in T ? cs(T) : Mn(T), h = t.current.filter(function(R) {
        return R.name === T.type && R.target === T.target && P8(R.delta, O);
      })[0];
      if (h && h.should) {
        T.cancelable && T.preventDefault();
        return;
      }
      if (!h) {
        var N = (a.current.shards || []).map(us).filter(Boolean).filter(function(R) {
          return R.contains(T.target);
        }), I = N.length > 0 ? s(T, N[0]) : !a.current.noIsolation;
        I && T.cancelable && T.preventDefault();
      }
    }
  }, []), u = Y.useCallback(function(d, T, O, h) {
    var N = { name: d, delta: T, target: O, should: h };
    t.current.push(N), setTimeout(function() {
      t.current = t.current.filter(function(I) {
        return I !== N;
      });
    }, 1);
  }, []), E = Y.useCallback(function(d) {
    n.current = Mn(d), r.current = void 0;
  }, []), l = Y.useCallback(function(d) {
    u(d.type, cs(d), d.target, s(d, e.lockRef.current));
  }, []), f = Y.useCallback(function(d) {
    u(d.type, Mn(d), d.target, s(d, e.lockRef.current));
  }, []);
  Y.useEffect(function() {
    return Mt.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, bt), document.addEventListener("touchmove", c, bt), document.addEventListener("touchstart", E, bt), function() {
      Mt = Mt.filter(function(d) {
        return d !== i;
      }), document.removeEventListener("wheel", c, bt), document.removeEventListener("touchmove", c, bt), document.removeEventListener("touchstart", E, bt);
    };
  }, []);
  var _ = e.removeScrollBar, S = e.inert;
  return Y.createElement(
    Y.Fragment,
    null,
    S ? Y.createElement(i, { styles: y8(o) }) : null,
    _ ? Y.createElement(h8, { gapMode: "margin" }) : null
  );
}
const M8 = E8(tu, b8);
var au = Y.forwardRef(function(e, t) {
  return Y.createElement(Pr, Ge({}, e, { ref: t, sideCar: M8 }));
});
au.classNames = Pr.classNames;
const w8 = au;
var $8 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, wt = /* @__PURE__ */ new WeakMap(), wn = /* @__PURE__ */ new WeakMap(), $n = {}, Eo = 0, su = function(e) {
  return e && (e.host || su(e.parentNode));
}, H8 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = su(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, V8 = function(e, t, n, r) {
  var o = H8(t, Array.isArray(e) ? e : [e]);
  $n[n] || ($n[n] = /* @__PURE__ */ new WeakMap());
  var i = $n[n], a = [], s = /* @__PURE__ */ new Set(), c = new Set(o), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  o.forEach(u);
  var E = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(f) {
      if (s.has(f))
        E(f);
      else {
        var _ = f.getAttribute(r), S = _ !== null && _ !== "false", d = (wt.get(f) || 0) + 1, T = (i.get(f) || 0) + 1;
        wt.set(f, d), i.set(f, T), a.push(f), d === 1 && S && wn.set(f, !0), T === 1 && f.setAttribute(n, "true"), S || f.setAttribute(r, "true");
      }
    });
  };
  return E(t), s.clear(), Eo++, function() {
    a.forEach(function(l) {
      var f = wt.get(l) - 1, _ = i.get(l) - 1;
      wt.set(l, f), i.set(l, _), f || (wn.has(l) || l.removeAttribute(r), wn.delete(l)), _ || l.removeAttribute(n);
    }), Eo--, Eo || (wt = /* @__PURE__ */ new WeakMap(), wt = /* @__PURE__ */ new WeakMap(), wn = /* @__PURE__ */ new WeakMap(), $n = {});
  };
}, B8 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || $8(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), V8(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
const cu = "Dialog", [uu, F6] = Qo(cu), [G8, ze] = uu(cu), k8 = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: a = !0 } = e, s = ee(null), c = ee(null), [u = !1, E] = js({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Z(G8, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: oo(),
    titleId: oo(),
    descriptionId: oo(),
    open: u,
    onOpenChange: E,
    onOpenToggle: ve(
      () => E(
        (l) => !l
      ),
      [
        E
      ]
    ),
    modal: a
  }, n);
}, Eu = "DialogPortal", [x8, lu] = uu(Eu, {
  forceMount: void 0
}), F8 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = ze(Eu, t);
  return /* @__PURE__ */ Z(x8, {
    scope: t,
    forceMount: n
  }, st.map(
    r,
    (a) => /* @__PURE__ */ Z(Xt, {
      present: n || i.open
    }, /* @__PURE__ */ Z(lc, {
      asChild: !0,
      container: o
    }, a))
  ));
}, Wo = "DialogOverlay", W8 = /* @__PURE__ */ Te((e, t) => {
  const n = lu(Wo, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ze(Wo, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Z(Xt, {
    present: r || i.open
  }, /* @__PURE__ */ Z(K8, ce({}, o, {
    ref: t
  }))) : null;
}), K8 = /* @__PURE__ */ Te((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ze(Wo, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Z(w8, {
      as: ii,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ Z($e.div, ce({
      "data-state": du(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), pn = "DialogContent", z8 = /* @__PURE__ */ Te((e, t) => {
  const n = lu(pn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ze(pn, e.__scopeDialog);
  return /* @__PURE__ */ Z(Xt, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Z(Y8, ce({}, o, {
    ref: t
  })) : /* @__PURE__ */ Z(j8, ce({}, o, {
    ref: t
  })));
}), Y8 = /* @__PURE__ */ Te((e, t) => {
  const n = ze(pn, e.__scopeDialog), r = ee(null), o = It(t, n.contentRef, r);
  return te(() => {
    const i = r.current;
    if (i)
      return B8(i);
  }, []), /* @__PURE__ */ Z(_u, ce({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: pe(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: pe(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && i.preventDefault();
    }),
    onFocusOutside: pe(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), j8 = /* @__PURE__ */ Te((e, t) => {
  const n = ze(pn, e.__scopeDialog), r = ee(!1), o = ee(!1);
  return /* @__PURE__ */ Z(_u, ce({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), _u = /* @__PURE__ */ Te((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = ze(pn, n), c = ee(null), u = It(t, c);
  return t8(), /* @__PURE__ */ Z(Os, null, /* @__PURE__ */ Z(jj, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Z(_c, ce({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": du(s.open)
  }, a, {
    ref: u,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Z8 = "DialogTitle", X8 = /* @__PURE__ */ Te((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ze(Z8, n);
  return /* @__PURE__ */ Z($e.h2, ce({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), q8 = "DialogDescription", Q8 = /* @__PURE__ */ Te((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ze(q8, n);
  return /* @__PURE__ */ Z($e.p, ce({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), J8 = "DialogClose", e6 = /* @__PURE__ */ Te((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ze(J8, n);
  return /* @__PURE__ */ Z($e.button, ce({
    type: "button"
  }, r, {
    ref: t,
    onClick: pe(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function du(e) {
  return e ? "open" : "closed";
}
const yr = k8, Ur = F8, br = W8, Mr = z8, Tu = X8, t6 = Q8, Ai = e6, gi = () => /* @__PURE__ */ C("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94289 7.99998L13.8048 3.13808L12.862 2.19527L8.00008 7.05717L3.13818 2.19527L2.19537 3.13808L7.05727 7.99998L2.19531 12.8619L3.13812 13.8047L8.00008 8.94278L12.862 13.8047L13.8049 12.8619L8.94289 7.99998Z",
    fill: "#220C4A"
  }
) }), n6 = ({
  onConfirm: e
}) => {
  const { t } = Le(), n = gr(), { showReturnAcknowledement: r } = _i(Ii), o = () => {
    n(Go(!1));
  };
  return /* @__PURE__ */ C(yr, { open: r, children: /* @__PURE__ */ j(Ur, { children: [
    /* @__PURE__ */ C(
      br,
      {
        onClick: o,
        className: "fixed inset-0 bg-indigo-scrim opacity-60"
      }
    ),
    /* @__PURE__ */ j(Mr, { className: "fixed inset-0 m-auto h-fit w-fit max-w-[584px] animate-fade-up rounded-md bg-white p-6 shadow-elevation-2", children: [
      /* @__PURE__ */ C(
        Ai,
        {
          onClick: o,
          className: "absolute right-4 top-4 outline-1 hover:bg-gray-34 focus:outline-indigo-50",
          children: /* @__PURE__ */ C(gi, {})
        }
      ),
      /* @__PURE__ */ C(Tu, { className: "mb-4 font-heading text-h3", children: t("RETURNS_SCAN.ACKNOWLEDGEMENT.TITLE") }),
      /* @__PURE__ */ C(t6, { className: "font-body text-md", children: t("RETURNS_SCAN.ACKNOWLEDGEMENT.DESCRIPTION") }),
      /* @__PURE__ */ j("div", { className: "mt-11 flex w-full flex-row justify-end gap-4", children: [
        /* @__PURE__ */ C(Do, { primary: !0, onClick: e, children: t("RETURNS_SCAN.ACKNOWLEDGEMENT.CONFIRM") }),
        /* @__PURE__ */ C(Do, { flat: !0, onClick: o, children: t("RETURNS_SCAN.ACKNOWLEDGEMENT.BACK") })
      ] })
    ] })
  ] }) });
}, r6 = () => {
  const { t: e } = Le(), [, { isLoading: t }] = Cr({
    fixedCacheKey: "scan"
  });
  return /* @__PURE__ */ C(yr, { open: t, modal: !1, children: /* @__PURE__ */ j(Ur, { children: [
    /* @__PURE__ */ C(br, { className: "fixed inset-0 bg-indigo-scrim opacity-60 transition-colors" }),
    /* @__PURE__ */ C(Mr, { className: "fixed inset-0 m-auto h-fit w-fit animate-fade-up rounded-md bg-white p-4 font-body text-h1 text-indigo-50 shadow-elevation-2", children: /* @__PURE__ */ C("span", { className: "animate-pulse animate-infinite", children: e("RETURNS_SCAN.LOADING") }) })
  ] }) });
}, fu = ({ country: e, address: t, postalCode: n, city: r }) => /* @__PURE__ */ j("div", { className: "flex flex-row items-center justify-center gap-2 text-indigo-50", children: [
  /* @__PURE__ */ C("span", { className: "flex h-6 w-6 flex-row items-center justify-center rounded border border-gray-42 text-center font-heading text-xs", children: e }),
  /* @__PURE__ */ j("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ C("span", { className: "font-body text-sm", children: t }),
    /* @__PURE__ */ C("span", { className: "font-body text-xs text-gray-90", children: `${n}, ${r}` })
  ] })
] }), on = ({ label: e, children: t }) => /* @__PURE__ */ j("div", { className: "flex h-14 flex-row items-center gap-4 text-indigo-50", children: [
  /* @__PURE__ */ C("span", { className: "w-[307px] font-heading text-md", children: e }),
  /* @__PURE__ */ C("span", { className: typeof t == "string" ? "font-body text-sm" : "", children: t })
] }), Ae = {
  DATA_PROCESSED: "DATA_PROCESSED",
  SHIPMENT_SORTED: "SHIPMENT_SORTED",
  SHIPMENT_SORTED_AT_SUB_DEPOT: "SHIPMENT_SORTED_AT_SUB_DEPOT",
  SHIPMENT_ACCEPTED_BY_DRIVER: "SHIPMENT_ACCEPTED_BY_DRIVER",
  SHIPMENT_DELIVERED: "SHIPMENT_DELIVERED",
  SHIPMENT_DELIVERED_TO_NEIGHBOR: "SHIPMENT_DELIVERED_TO_NEIGHBOR",
  SHIPMENT_NOT_DELIVERED: "SHIPMENT_NOT_DELIVERED",
  RETURN_SHIPMENT_TO_SENDER: "RETURN_SHIPMENT_TO_SENDER",
  EXCEPTION_SHIPMENT_NOT_ARRIVED: "EXCEPTION_SHIPMENT_NOT_ARRIVED",
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER: "EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER",
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER: "EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER",
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS: "EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS",
  EXCEPTION_SHIPMENT_INVESTIGATE: "EXCEPTION_SHIPMENT_INVESTIGATE"
}, o6 = {
  [Ae.SHIPMENT_ACCEPTED_BY_DRIVER]: "onItsWay",
  [Ae.SHIPMENT_SORTED]: "atCentralHub",
  [Ae.SHIPMENT_SORTED_AT_SUB_DEPOT]: "atRegionalHub",
  [Ae.EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS]: "cancelled",
  [Ae.EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER]: "cancelled",
  [Ae.SHIPMENT_DELIVERED]: "delivered",
  [Ae.SHIPMENT_DELIVERED_TO_NEIGHBOR]: "deliveredToNeighbour",
  [Ae.SHIPMENT_NOT_DELIVERED]: "notDelivered",
  [Ae.EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER]: "notDelivered",
  [Ae.EXCEPTION_SHIPMENT_NOT_ARRIVED]: "expected",
  [Ae.DATA_PROCESSED]: "expected",
  [Ae.EXCEPTION_SHIPMENT_INVESTIGATE]: "notDelivered",
  [Ae.RETURN_SHIPMENT_TO_SENDER]: "returned"
}, i6 = ({ status: e }) => {
  const { t } = Le();
  return /* @__PURE__ */ j("div", { className: "flex w-fit flex-row items-center gap-1 rounded-2xl bg-gray-34 pl-1 pr-[6px]", children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: kt("h-[10px] w-[10px] rounded-full", o6[e] || "defaultColor")
      }
    ),
    /* @__PURE__ */ C("span", { className: "font-body text-sm", children: t(`SHIPMENT_STATES.${e}`) })
  ] });
}, a6 = (e) => {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), r = String(e.getDate()).padStart(2, "0"), o = String(e.getHours()).padStart(2, "0"), i = String(e.getMinutes()).padStart(2, "0"), a = String(e.getSeconds()).padStart(2, "0");
  return `${t}-${n}-${r} | ${o}:${i}:${a}`;
}, s6 = () => {
  const { t: e } = Le(), t = gr(), { activeShipmentDetails: n } = _i(Ii), r = () => {
    t(Fc(void 0));
  };
  return /* @__PURE__ */ C(yr, { open: !!n, children: /* @__PURE__ */ j(Ur, { children: [
    /* @__PURE__ */ C(
      br,
      {
        onClick: r,
        className: "fixed inset-0 bg-indigo-scrim opacity-60"
      }
    ),
    /* @__PURE__ */ j(Mr, { className: "fixed inset-0 m-auto h-[400px] w-[600px] animate-fade-up rounded-md bg-white px-8 py-4 text-indigo-50 shadow-elevation-2", children: [
      /* @__PURE__ */ C(Tu, { className: "mb-8 font-heading text-h3", children: e("RETURNS_SCAN.DETAILS.SHIPMENT_DETAILS") }),
      /* @__PURE__ */ C(
        Ai,
        {
          onClick: r,
          className: "absolute right-4 top-4 outline-1 hover:bg-gray-34 focus:outline-indigo-50",
          children: /* @__PURE__ */ C(gi, {})
        }
      ),
      n && /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C(on, { label: e("RETURNS_SCAN.TRUNKRS_NR"), children: n.trunkrsNr }),
        /* @__PURE__ */ C(on, { label: e("RETURNS_SCAN.ADDRESS"), children: /* @__PURE__ */ C(
          fu,
          {
            address: n.address,
            city: n.city,
            country: n.country,
            postalCode: n.postalCode
          }
        ) }),
        /* @__PURE__ */ C(on, { label: e("RETURNS_SCAN.DETAILS.INTENDED_DELIVERY_DATE"), children: n.intendedDeliveryDate }),
        /* @__PURE__ */ C(on, { label: e("IN_SINCE"), children: a6(new Date(n.inSince)) }),
        /* @__PURE__ */ C(on, { label: e("HUB_INVENTORY.STATUS"), children: /* @__PURE__ */ C(i6, { status: n.latestState }) })
      ] })
    ] })
  ] }) });
};
var Ko = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var lo, Es;
function c6() {
  if (Es)
    return lo;
  Es = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(E) {
        return a[E];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(E) {
        u[E] = E;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return lo = o() ? Object.assign : function(i, a) {
    for (var s, c = r(i), u, E = 1; E < arguments.length; E++) {
      s = Object(arguments[E]);
      for (var l in s)
        t.call(s, l) && (c[l] = s[l]);
      if (e) {
        u = e(s);
        for (var f = 0; f < u.length; f++)
          n.call(s, u[f]) && (c[u[f]] = s[u[f]]);
      }
    }
    return c;
  }, lo;
}
var _o, ls;
function vi() {
  if (ls)
    return _o;
  ls = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _o = e, _o;
}
var To, _s;
function Su() {
  return _s || (_s = 1, To = Function.call.bind(Object.prototype.hasOwnProperty)), To;
}
var fo, ds;
function u6() {
  if (ds)
    return fo;
  ds = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = vi(), n = {}, r = Su();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in i)
        if (r(i, E)) {
          var l;
          try {
            if (typeof i[E] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            l = i[E](a, E, c, s, null, t);
          } catch (S) {
            l = S;
          }
          if (l && !(l instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in n)) {
            n[l.message] = !0;
            var _ = u ? u() : "";
            e(
              "Failed " + s + " type: " + l.message + (_ ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, fo = o, fo;
}
var So, Ts;
function E6() {
  if (Ts)
    return So;
  Ts = 1;
  var e = Zo, t = c6(), n = vi(), r = Su(), o = u6(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return So = function(s, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, E = "@@iterator";
    function l(y) {
      var b = y && (u && y[u] || y[E]);
      if (typeof b == "function")
        return b;
    }
    var f = "<<anonymous>>", _ = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: h(),
      arrayOf: N,
      element: I(),
      elementType: R(),
      instanceOf: p,
      node: D(),
      objectOf: g,
      oneOf: A,
      oneOfType: v,
      shape: L,
      exact: P
    };
    function S(y, b) {
      return y === b ? y !== 0 || 1 / y === 1 / b : y !== y && b !== b;
    }
    function d(y, b) {
      this.message = y, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    d.prototype = Error.prototype;
    function T(y) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, V = 0;
      function w(G, k, K, X, Q, q, ae) {
        if (X = X || f, q = q || K, ae !== n) {
          if (c) {
            var $ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw $.name = "Invariant Violation", $;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var se = X + ":" + K;
            !b[se] && // Avoid spamming the console because they are often not actionable except for lib authors
            V < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + q + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[se] = !0, V++);
          }
        }
        return k[K] == null ? G ? k[K] === null ? new d("The " + Q + " `" + q + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new d("The " + Q + " `" + q + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : y(k, K, X, Q, q);
      }
      var B = w.bind(null, !1);
      return B.isRequired = w.bind(null, !0), B;
    }
    function O(y) {
      function b(V, w, B, G, k, K) {
        var X = V[w], Q = H(X);
        if (Q !== y) {
          var q = x(X);
          return new d(
            "Invalid " + G + " `" + k + "` of type " + ("`" + q + "` supplied to `" + B + "`, expected ") + ("`" + y + "`."),
            { expectedType: y }
          );
        }
        return null;
      }
      return T(b);
    }
    function h() {
      return T(a);
    }
    function N(y) {
      function b(V, w, B, G, k) {
        if (typeof y != "function")
          return new d("Property `" + k + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var K = V[w];
        if (!Array.isArray(K)) {
          var X = H(K);
          return new d("Invalid " + G + " `" + k + "` of type " + ("`" + X + "` supplied to `" + B + "`, expected an array."));
        }
        for (var Q = 0; Q < K.length; Q++) {
          var q = y(K, Q, B, G, k + "[" + Q + "]", n);
          if (q instanceof Error)
            return q;
        }
        return null;
      }
      return T(b);
    }
    function I() {
      function y(b, V, w, B, G) {
        var k = b[V];
        if (!s(k)) {
          var K = H(k);
          return new d("Invalid " + B + " `" + G + "` of type " + ("`" + K + "` supplied to `" + w + "`, expected a single ReactElement."));
        }
        return null;
      }
      return T(y);
    }
    function R() {
      function y(b, V, w, B, G) {
        var k = b[V];
        if (!e.isValidElementType(k)) {
          var K = H(k);
          return new d("Invalid " + B + " `" + G + "` of type " + ("`" + K + "` supplied to `" + w + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return T(y);
    }
    function p(y) {
      function b(V, w, B, G, k) {
        if (!(V[w] instanceof y)) {
          var K = y.name || f, X = z(V[w]);
          return new d("Invalid " + G + " `" + k + "` of type " + ("`" + X + "` supplied to `" + B + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return T(b);
    }
    function A(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function b(V, w, B, G, k) {
        for (var K = V[w], X = 0; X < y.length; X++)
          if (S(K, y[X]))
            return null;
        var Q = JSON.stringify(y, function(ae, $) {
          var se = x($);
          return se === "symbol" ? String($) : $;
        });
        return new d("Invalid " + G + " `" + k + "` of value `" + String(K) + "` " + ("supplied to `" + B + "`, expected one of " + Q + "."));
      }
      return T(b);
    }
    function g(y) {
      function b(V, w, B, G, k) {
        if (typeof y != "function")
          return new d("Property `" + k + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var K = V[w], X = H(K);
        if (X !== "object")
          return new d("Invalid " + G + " `" + k + "` of type " + ("`" + X + "` supplied to `" + B + "`, expected an object."));
        for (var Q in K)
          if (r(K, Q)) {
            var q = y(K, Q, B, G, k + "." + Q, n);
            if (q instanceof Error)
              return q;
          }
        return null;
      }
      return T(b);
    }
    function v(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var b = 0; b < y.length; b++) {
        var V = y[b];
        if (typeof V != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(V) + " at index " + b + "."
          ), a;
      }
      function w(B, G, k, K, X) {
        for (var Q = [], q = 0; q < y.length; q++) {
          var ae = y[q], $ = ae(B, G, k, K, X, n);
          if ($ == null)
            return null;
          $.data && r($.data, "expectedType") && Q.push($.data.expectedType);
        }
        var se = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new d("Invalid " + K + " `" + X + "` supplied to " + ("`" + k + "`" + se + "."));
      }
      return T(w);
    }
    function D() {
      function y(b, V, w, B, G) {
        return U(b[V]) ? null : new d("Invalid " + B + " `" + G + "` supplied to " + ("`" + w + "`, expected a ReactNode."));
      }
      return T(y);
    }
    function m(y, b, V, w, B) {
      return new d(
        (y || "React class") + ": " + b + " type `" + V + "." + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function L(y) {
      function b(V, w, B, G, k) {
        var K = V[w], X = H(K);
        if (X !== "object")
          return new d("Invalid " + G + " `" + k + "` of type `" + X + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var Q in y) {
          var q = y[Q];
          if (typeof q != "function")
            return m(B, G, k, Q, x(q));
          var ae = q(K, Q, B, G, k + "." + Q, n);
          if (ae)
            return ae;
        }
        return null;
      }
      return T(b);
    }
    function P(y) {
      function b(V, w, B, G, k) {
        var K = V[w], X = H(K);
        if (X !== "object")
          return new d("Invalid " + G + " `" + k + "` of type `" + X + "` " + ("supplied to `" + B + "`, expected `object`."));
        var Q = t({}, V[w], y);
        for (var q in Q) {
          var ae = y[q];
          if (r(y, q) && typeof ae != "function")
            return m(B, G, k, q, x(ae));
          if (!ae)
            return new d(
              "Invalid " + G + " `" + k + "` key `" + q + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(V[w], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(y), null, "  ")
            );
          var $ = ae(K, q, B, G, k + "." + q, n);
          if ($)
            return $;
        }
        return null;
      }
      return T(b);
    }
    function U(y) {
      switch (typeof y) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !y;
        case "object":
          if (Array.isArray(y))
            return y.every(U);
          if (y === null || s(y))
            return !0;
          var b = l(y);
          if (b) {
            var V = b.call(y), w;
            if (b !== y.entries) {
              for (; !(w = V.next()).done; )
                if (!U(w.value))
                  return !1;
            } else
              for (; !(w = V.next()).done; ) {
                var B = w.value;
                if (B && !U(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(y, b) {
      return y === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function H(y) {
      var b = typeof y;
      return Array.isArray(y) ? "array" : y instanceof RegExp ? "object" : M(b, y) ? "symbol" : b;
    }
    function x(y) {
      if (typeof y > "u" || y === null)
        return "" + y;
      var b = H(y);
      if (b === "object") {
        if (y instanceof Date)
          return "date";
        if (y instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function F(y) {
      var b = x(y);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function z(y) {
      return !y.constructor || !y.constructor.name ? f : y.constructor.name;
    }
    return _.checkPropTypes = o, _.resetWarningCache = o.resetWarningCache, _.PropTypes = _, _;
  }, So;
}
var Ro, fs;
function l6() {
  if (fs)
    return Ro;
  fs = 1;
  var e = vi();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Ro = function() {
    function r(a, s, c, u, E, l) {
      if (l !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Ro;
}
if (process.env.NODE_ENV !== "production") {
  var _6 = Zo, d6 = !0;
  Ko.exports = E6()(_6.isElement, d6);
} else
  Ko.exports = l6()();
var de = Ko.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var zo = function(e, t) {
  return zo = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      r.hasOwnProperty(o) && (n[o] = r[o]);
  }, zo(e, t);
};
function T6(e, t) {
  zo(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var at = function() {
  return at = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, at.apply(this, arguments);
};
function f6(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && (n[r[o]] = e[r[o]]);
  return n;
}
var xe;
(function(e) {
  e.AUTO = "auto", e.START = "start", e.CENTER = "center", e.END = "end";
})(xe || (xe = {}));
var fe;
(function(e) {
  e.HORIZONTAL = "horizontal", e.VERTICAL = "vertical";
})(fe || (fe = {}));
var gt;
(function(e) {
  e.OBSERVED = "observed", e.REQUESTED = "requested";
})(gt || (gt = {}));
var Ss = (Hn = {}, Hn[fe.VERTICAL] = "scrollTop", Hn[fe.HORIZONTAL] = "scrollLeft", Hn), an = (Vn = {}, Vn[fe.VERTICAL] = "height", Vn[fe.HORIZONTAL] = "width", Vn), S6 = (Bn = {}, Bn[fe.VERTICAL] = "top", Bn[fe.HORIZONTAL] = "left", Bn), R6 = (Gn = {}, Gn[fe.VERTICAL] = "marginTop", Gn[fe.HORIZONTAL] = "marginLeft", Gn), N6 = (kn = {}, kn[fe.VERTICAL] = "marginBottom", kn[fe.HORIZONTAL] = "marginRight", kn), Hn, Vn, Bn, Gn, kn, O6 = (
  /** @class */
  function() {
    function e(t) {
      var n = t.itemCount, r = t.itemSizeGetter, o = t.estimatedItemSize;
      this.itemSizeGetter = r, this.itemCount = n, this.estimatedItemSize = o, this.itemSizeAndPositionData = {}, this.lastMeasuredIndex = -1;
    }
    return e.prototype.updateConfig = function(t) {
      var n = t.itemCount, r = t.itemSizeGetter, o = t.estimatedItemSize;
      n != null && (this.itemCount = n), o != null && (this.estimatedItemSize = o), r != null && (this.itemSizeGetter = r);
    }, e.prototype.getLastMeasuredIndex = function() {
      return this.lastMeasuredIndex;
    }, e.prototype.getSizeAndPositionForIndex = function(t) {
      if (t < 0 || t >= this.itemCount)
        throw Error("Requested index " + t + " is outside of range 0.." + this.itemCount);
      if (t > this.lastMeasuredIndex) {
        for (var n = this.getSizeAndPositionOfLastMeasuredItem(), r = n.offset + n.size, o = this.lastMeasuredIndex + 1; o <= t; o++) {
          var i = this.itemSizeGetter(o);
          if (i == null || isNaN(i))
            throw Error("Invalid size returned for index " + o + " of value " + i);
          this.itemSizeAndPositionData[o] = {
            offset: r,
            size: i
          }, r += i;
        }
        this.lastMeasuredIndex = t;
      }
      return this.itemSizeAndPositionData[t];
    }, e.prototype.getSizeAndPositionOfLastMeasuredItem = function() {
      return this.lastMeasuredIndex >= 0 ? this.itemSizeAndPositionData[this.lastMeasuredIndex] : { offset: 0, size: 0 };
    }, e.prototype.getTotalSize = function() {
      var t = this.getSizeAndPositionOfLastMeasuredItem();
      return t.offset + t.size + (this.itemCount - this.lastMeasuredIndex - 1) * this.estimatedItemSize;
    }, e.prototype.getUpdatedOffsetForIndex = function(t) {
      var n = t.align, r = n === void 0 ? xe.START : n, o = t.containerSize, i = t.currentOffset, a = t.targetIndex;
      if (o <= 0)
        return 0;
      var s = this.getSizeAndPositionForIndex(a), c = s.offset, u = c - o + s.size, E;
      switch (r) {
        case xe.END:
          E = u;
          break;
        case xe.CENTER:
          E = c - (o - s.size) / 2;
          break;
        case xe.START:
          E = c;
          break;
        default:
          E = Math.max(u, Math.min(c, i));
      }
      var l = this.getTotalSize();
      return Math.max(0, Math.min(l - o, E));
    }, e.prototype.getVisibleRange = function(t) {
      var n = t.containerSize, r = t.offset, o = t.overscanCount, i = this.getTotalSize();
      if (i === 0)
        return {};
      var a = r + n, s = this.findNearestItem(r);
      if (typeof s > "u")
        throw Error("Invalid offset " + r + " specified");
      var c = this.getSizeAndPositionForIndex(s);
      r = c.offset + c.size;
      for (var u = s; r < a && u < this.itemCount - 1; )
        u++, r += this.getSizeAndPositionForIndex(u).size;
      return o && (s = Math.max(0, s - o), u = Math.min(u + o, this.itemCount - 1)), {
        start: s,
        stop: u
      };
    }, e.prototype.resetItem = function(t) {
      this.lastMeasuredIndex = Math.min(this.lastMeasuredIndex, t - 1);
    }, e.prototype.findNearestItem = function(t) {
      if (isNaN(t))
        throw Error("Invalid offset " + t + " specified");
      t = Math.max(0, t);
      var n = this.getSizeAndPositionOfLastMeasuredItem(), r = Math.max(0, this.lastMeasuredIndex);
      return n.offset >= t ? this.binarySearch({
        high: r,
        low: 0,
        offset: t
      }) : this.exponentialSearch({
        index: r,
        offset: t
      });
    }, e.prototype.binarySearch = function(t) {
      for (var n = t.low, r = t.high, o = t.offset, i = 0, a = 0; n <= r; ) {
        if (i = n + Math.floor((r - n) / 2), a = this.getSizeAndPositionForIndex(i).offset, a === o)
          return i;
        a < o ? n = i + 1 : a > o && (r = i - 1);
      }
      return n > 0 ? n - 1 : 0;
    }, e.prototype.exponentialSearch = function(t) {
      for (var n = t.index, r = t.offset, o = 1; n < this.itemCount && this.getSizeAndPositionForIndex(n).offset < r; )
        n += o, o *= 2;
      return this.binarySearch({
        high: Math.min(n, this.itemCount - 1),
        low: Math.floor(n / 2),
        offset: r
      });
    }, e;
  }()
), I6 = {
  overflow: "auto",
  willChange: "transform",
  WebkitOverflowScrolling: "touch"
}, p6 = {
  position: "relative",
  width: "100%",
  minHeight: "100%"
}, Ru = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%"
}, h6 = at({}, Ru, { position: "sticky" }), A6 = (
  /** @class */
  function(e) {
    T6(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.itemSizeGetter = function(r) {
        return function(o) {
          return n.getSize(o, r);
        };
      }, n.sizeAndPositionManager = new O6({
        itemCount: n.props.itemCount,
        itemSizeGetter: n.itemSizeGetter(n.props.itemSize),
        estimatedItemSize: n.getEstimatedItemSize()
      }), n.state = {
        offset: n.props.scrollOffset || n.props.scrollToIndex != null && n.getOffsetForIndex(n.props.scrollToIndex) || 0,
        scrollChangeReason: gt.REQUESTED
      }, n.styleCache = {}, n.getRef = function(r) {
        n.rootNode = r;
      }, n.handleScroll = function(r) {
        var o = n.props.onScroll, i = n.getNodeOffset();
        i < 0 || n.state.offset === i || r.target !== n.rootNode || (n.setState({
          offset: i,
          scrollChangeReason: gt.OBSERVED
        }), typeof o == "function" && o(i, r));
      }, n;
    }
    return t.prototype.componentDidMount = function() {
      var n = this.props, r = n.scrollOffset, o = n.scrollToIndex;
      this.rootNode.addEventListener("scroll", this.handleScroll, {
        passive: !0
      }), r != null ? this.scrollTo(r) : o != null && this.scrollTo(this.getOffsetForIndex(o));
    }, t.prototype.componentWillReceiveProps = function(n) {
      var r = this.props, o = r.estimatedItemSize, i = r.itemCount, a = r.itemSize, s = r.scrollOffset, c = r.scrollToAlignment, u = r.scrollToIndex, E = n.scrollToIndex !== u || n.scrollToAlignment !== c, l = n.itemCount !== i || n.itemSize !== a || n.estimatedItemSize !== o;
      n.itemSize !== a && this.sizeAndPositionManager.updateConfig({
        itemSizeGetter: this.itemSizeGetter(n.itemSize)
      }), (n.itemCount !== i || n.estimatedItemSize !== o) && this.sizeAndPositionManager.updateConfig({
        itemCount: n.itemCount,
        estimatedItemSize: this.getEstimatedItemSize(n)
      }), l && this.recomputeSizes(), n.scrollOffset !== s ? this.setState({
        offset: n.scrollOffset || 0,
        scrollChangeReason: gt.REQUESTED
      }) : typeof n.scrollToIndex == "number" && (E || l) && this.setState({
        offset: this.getOffsetForIndex(n.scrollToIndex, n.scrollToAlignment, n.itemCount),
        scrollChangeReason: gt.REQUESTED
      });
    }, t.prototype.componentDidUpdate = function(n, r) {
      var o = this.state, i = o.offset, a = o.scrollChangeReason;
      r.offset !== i && a === gt.REQUESTED && this.scrollTo(i);
    }, t.prototype.componentWillUnmount = function() {
      this.rootNode.removeEventListener("scroll", this.handleScroll);
    }, t.prototype.scrollTo = function(n) {
      var r = this.props.scrollDirection, o = r === void 0 ? fe.VERTICAL : r;
      this.rootNode[Ss[o]] = n;
    }, t.prototype.getOffsetForIndex = function(n, r, o) {
      r === void 0 && (r = this.props.scrollToAlignment), o === void 0 && (o = this.props.itemCount);
      var i = this.props.scrollDirection, a = i === void 0 ? fe.VERTICAL : i;
      return (n < 0 || n >= o) && (n = 0), this.sizeAndPositionManager.getUpdatedOffsetForIndex({
        align: r,
        containerSize: this.props[an[a]],
        currentOffset: this.state && this.state.offset || 0,
        targetIndex: n
      });
    }, t.prototype.recomputeSizes = function(n) {
      n === void 0 && (n = 0), this.styleCache = {}, this.sizeAndPositionManager.resetItem(n);
    }, t.prototype.render = function() {
      var n = this, r = this.props;
      r.estimatedItemSize;
      var o = r.height, i = r.overscanCount, a = i === void 0 ? 3 : i, s = r.renderItem;
      r.itemCount, r.itemSize;
      var c = r.onItemsRendered;
      r.onScroll;
      var u = r.scrollDirection, E = u === void 0 ? fe.VERTICAL : u;
      r.scrollOffset, r.scrollToIndex, r.scrollToAlignment;
      var l = r.stickyIndices, f = r.style, _ = r.width, S = f6(r, ["estimatedItemSize", "height", "overscanCount", "renderItem", "itemCount", "itemSize", "onItemsRendered", "onScroll", "scrollDirection", "scrollOffset", "scrollToIndex", "scrollToAlignment", "stickyIndices", "style", "width"]), d = this.state.offset, T = this.sizeAndPositionManager.getVisibleRange({
        containerSize: this.props[an[E]] || 0,
        offset: d,
        overscanCount: a
      }), O = T.start, h = T.stop, N = [], I = at({}, I6, f, { height: o, width: _ }), R = at({}, p6, (A = {}, A[an[E]] = this.sizeAndPositionManager.getTotalSize(), A));
      if (l != null && l.length !== 0 && (l.forEach(function(g) {
        return N.push(s({
          index: g,
          style: n.getStyle(g, !0)
        }));
      }), E === fe.HORIZONTAL && (R.display = "flex")), typeof O < "u" && typeof h < "u") {
        for (var p = O; p <= h; p++)
          l != null && l.includes(p) || N.push(s({
            index: p,
            style: this.getStyle(p, !1)
          }));
        typeof c == "function" && c({
          startIndex: O,
          stopIndex: h
        });
      }
      return Z("div", at({ ref: this.getRef }, S, { style: I }), Z("div", { style: R }, N));
      var A;
    }, t.prototype.getNodeOffset = function() {
      var n = this.props.scrollDirection, r = n === void 0 ? fe.VERTICAL : n;
      return this.rootNode[Ss[r]];
    }, t.prototype.getEstimatedItemSize = function(n) {
      return n === void 0 && (n = this.props), n.estimatedItemSize || typeof n.itemSize == "number" && n.itemSize || 50;
    }, t.prototype.getSize = function(n, r) {
      return typeof r == "function" ? r(n) : Array.isArray(r) ? r[n] : r;
    }, t.prototype.getStyle = function(n, r) {
      var o = this.styleCache[n];
      if (o)
        return o;
      var i = this.props.scrollDirection, a = i === void 0 ? fe.VERTICAL : i, s = this.sizeAndPositionManager.getSizeAndPositionForIndex(n), c = s.size, u = s.offset;
      return this.styleCache[n] = r ? at({}, h6, (E = {}, E[an[a]] = c, E[R6[a]] = u, E[N6[a]] = -(u + c), E.zIndex = 1, E)) : at({}, Ru, (l = {}, l[an[a]] = c, l[S6[a]] = u, l));
      var E, l;
    }, t.defaultProps = {
      overscanCount: 3,
      scrollDirection: fe.VERTICAL,
      width: "100%"
    }, t.propTypes = {
      estimatedItemSize: de.number,
      height: de.oneOfType([de.number, de.string]).isRequired,
      itemCount: de.number.isRequired,
      itemSize: de.oneOfType([de.number, de.array, de.func]).isRequired,
      onScroll: de.func,
      onItemsRendered: de.func,
      overscanCount: de.number,
      renderItem: de.func.isRequired,
      scrollOffset: de.number,
      scrollToIndex: de.number,
      scrollToAlignment: de.oneOf([xe.AUTO, xe.START, xe.CENTER, xe.END]),
      scrollDirection: de.oneOf([fe.HORIZONTAL, fe.VERTICAL]),
      stickyIndices: de.arrayOf(de.number),
      style: de.object,
      width: de.oneOfType([de.number, de.string])
    }, t;
  }(Iu)
);
const Nu = (e) => {
  const t = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"], n = (/* @__PURE__ */ new Date()).getDay(), r = t[n];
  return e.toLowerCase() === r;
}, fr = ({ small: e }) => e ? /* @__PURE__ */ C(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99984 0.667969L0.666504 14.0013H15.3332L7.99984 0.667969ZM7.99984 3.43469L2.92153 12.668H13.0781L7.99984 3.43469ZM8.6665 10.668V12.0013H7.33317V10.668H8.6665ZM8.6665 10.0013V6.0013H7.33317V10.0013H8.6665Z",
        fill: "#FF6C2B"
      }
    )
  }
) : /* @__PURE__ */ C("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1L1 21H23L12 1ZM12 5.15008L4.38254 19H19.6175L12 5.15008ZM13 16V18H11V16H13ZM13 15V9H11V15H13Z",
    fill: "#FF7D44"
  }
) }), g6 = ({
  onClick: e,
  returnInfo: t,
  merchantName: n
}) => {
  const { t: r, trans: o } = Le();
  return /* @__PURE__ */ j(ai, { openDelay: 200, closeDelay: 0, children: [
    /* @__PURE__ */ C(si, { asChild: !0, children: /* @__PURE__ */ C(
      "a",
      {
        onClick: e,
        className: "flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-sm hover:bg-gray-34",
        children: /* @__PURE__ */ C(fr, { small: !0 })
      }
    ) }),
    /* @__PURE__ */ C(ci, { children: /* @__PURE__ */ j(
      ui,
      {
        align: "start",
        side: "right",
        className: "rounded-[4px] bg-white p-2 shadow-elevation-2",
        children: [
          /* @__PURE__ */ j("div", { className: "flex flex-row gap-2 rounded-[4px] bg-yellow-light-fade px-4 py-2", children: [
            /* @__PURE__ */ C(fr, {}),
            Nu(t.day) ? /* @__PURE__ */ j("div", { className: "flex flex-col font-body text-md text-indigo-50", children: [
              /* @__PURE__ */ j("div", { className: "flex flex-row gap-1", children: [
                r("RETURNS_SCAN.RETURN_TODAY_TO"),
                /* @__PURE__ */ C("span", { className: "font-heading", children: n })
              ] }),
              /* @__PURE__ */ j("div", { className: "flex flex-row gap-1", children: [
                r("RETURNS_SCAN.COLLECTION_OPT_ID"),
                /* @__PURE__ */ C("span", { className: "font-heading", children: t.optimizationTourId })
              ] }),
              /* @__PURE__ */ j("div", { className: "flex flex-row gap-1", children: [
                r("RETURNS_SCAN.COLLECTION_TOUR_TAG"),
                /* @__PURE__ */ C("span", { className: "font-heading", children: t.tourTag })
              ] })
            ] }) : /* @__PURE__ */ C("div", { className: "max-w-[394px] font-body text-md text-indigo-40", children: /* @__PURE__ */ C(
              o,
              {
                t: r,
                i18nKey: "RETURNS_SCAN.NO_COLLECTION_TODAY",
                values: {
                  merchantName: n,
                  day: t.day,
                  optimizationId: t.optimizationTourId,
                  tourTag: t.tourTag
                },
                components: {
                  b: /* @__PURE__ */ C("span", { className: "font-heading" })
                }
              }
            ) })
          ] }),
          /* @__PURE__ */ C(Ei, { className: "fill-white stroke-gray-42" })
        ]
      }
    ) })
  ] });
}, v6 = () => /* @__PURE__ */ j("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6667 3.33333H3.33333V12.6667H12.6667V3.33333ZM2 2V14H14V2H2Z",
      fill: "#220C4A"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.66683 4.66667L8.66683 5.91667L7.3335 5.91667L7.3335 4.66667L8.66683 4.66667ZM8.66683 7.16667L8.66683 11.3333L7.3335 11.3333L7.3335 7.16667L8.66683 7.16667Z",
      fill: "#220C4A"
    }
  )
] }), D6 = ({ onClick: e }) => {
  const { t } = Le();
  return /* @__PURE__ */ j(ai, { openDelay: 200, closeDelay: 0, children: [
    /* @__PURE__ */ C(si, { asChild: !0, children: /* @__PURE__ */ C(
      "a",
      {
        onClick: e,
        className: "flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-sm hover:bg-gray-34",
        children: /* @__PURE__ */ C(v6, {})
      }
    ) }),
    /* @__PURE__ */ C(ci, { children: /* @__PURE__ */ j(
      ui,
      {
        side: "right",
        className: "rounded-sm bg-indigo-50 p-2 font-body text-xs text-white shadow-elevation-2",
        children: [
          t("RETURNS_SCAN.MORE_DETAILS"),
          /* @__PURE__ */ C(Ei, { className: "fill-indigo-50" })
        ]
      }
    ) })
  ] });
}, m6 = () => /* @__PURE__ */ C("svg", { width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12C20.5 16.4182 16.9183 20 12.5 20C8.08172 20 4.5 16.4182 4.5 12C4.5 7.58169 8.08172 3.99997 12.5 3.99997C16.9183 3.99997 20.5 7.58169 20.5 12ZM22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47712 6.97715 1.99997 12.5 1.99997C18.0228 1.99997 22.5 6.47712 22.5 12ZM13.5 8.87497V6.99997H11.5V8.87497H13.5ZM13.5 17V10.75H11.5V17H13.5Z",
    fill: "#220C4A"
  }
) }), Rs = ({
  data: e = [],
  width: t,
  height: n,
  forReturns: r
}) => {
  const { t: o } = Le(), { activeShipmentDetails: i } = _i(Ii), a = gr(), s = (u) => {
    a(Fc(u));
  }, c = (u) => r == null ? void 0 : r.find((E) => u.shipmentId === E.shipmentId);
  return /* @__PURE__ */ j("div", { className: "flex w-fit flex-col", children: [
    /* @__PURE__ */ j("div", { className: "flex h-10 w-full flex-row items-center justify-between px-4 font-heading text-xs text-indigo-50", children: [
      /* @__PURE__ */ C("span", { children: o("RETURNS_SCAN.ADDRESS") }),
      /* @__PURE__ */ C("span", { className: "mr-2", children: o("RETURNS_SCAN.ACTIONS") })
    ] }),
    e.length ? /* @__PURE__ */ C(
      A6,
      {
        width: t,
        height: n,
        itemSize: 56,
        itemCount: e.length,
        className: "rounded-lg bg-white shadow-elevation-1",
        renderItem: ({ index: u, style: E }) => {
          const { address: l, city: f, country: _, postalCode: S, shipmentId: d, merchantName: T } = e[u], O = d === (i == null ? void 0 : i.shipmentId), h = c(e[u]), N = u === e.length - 1;
          return /* @__PURE__ */ j(
            "div",
            {
              style: E,
              className: Xo("relative px-4 pt-[10px]", O && "bg-gray-34"),
              children: [
                O && /* @__PURE__ */ C("div", { className: "absolute left-0 top-0 h-full w-[2px] bg-green-50" }),
                /* @__PURE__ */ j(
                  "div",
                  {
                    className: kt(
                      "flex flex-row justify-between border-b border-gray-42 pb-[10px]",
                      N && "border-0"
                    ),
                    children: [
                      /* @__PURE__ */ C(
                        fu,
                        {
                          address: l,
                          city: f,
                          country: _,
                          postalCode: S
                        }
                      ),
                      h ? /* @__PURE__ */ C(
                        g6,
                        {
                          onClick: () => s(e[u]),
                          merchantName: T,
                          returnInfo: h
                        }
                      ) : /* @__PURE__ */ C(D6, { onClick: () => s(e[u]) })
                    ]
                  }
                )
              ]
            },
            u
          );
        }
      }
    ) : /* @__PURE__ */ C(
      "div",
      {
        style: { height: n, width: t },
        className: "flex w-auto flex-col items-center rounded-lg bg-white px-3 pt-5 shadow-elevation-1",
        children: /* @__PURE__ */ C(Rc, { icon: /* @__PURE__ */ C(m6, {}), children: o("RETURNS_SCAN.KEEP_ON_HUB_PLACEHOLDER") })
      }
    )
  ] });
}, L6 = ({
  subcoId: e,
  onBatchHubOut: t,
  isBatchHubOutDone: n
}) => {
  const { t: r } = Le(), { data: o } = xj(e), i = gr(), a = o == null ? void 0 : o.keepInRegion.map((d) => d.shipmentId), { data: s } = Wj(a || [], {
    skip: !(a != null && a.length)
  }), [c, { width: u, height: E }] = E3(), l = () => {
    i(Go(!0));
  }, f = u / 2 - 8, _ = E - 85, S = async () => {
    try {
      const d = o == null ? void 0 : o.backToTrunkrs.reduce(
        (T, O) => (T.push({ shipmentId: O.shipmentId, subcoId: e }), T),
        []
      );
      if (!d)
        return;
      console.log("lib:", d), await t({ payload: d, inventoryScanCompleted: !0 });
    } catch {
      throw new Error("BatchHubOut error");
    } finally {
      i(Go(!1));
    }
  };
  return /* @__PURE__ */ j(Is, { children: [
    /* @__PURE__ */ j("div", { className: "flex h-full w-full flex-row justify-evenly gap-4", ref: c, children: [
      /* @__PURE__ */ j("div", { className: "flex w-full flex-col", children: [
        /* @__PURE__ */ C(ea, { className: "bg-orange-60", count: (o == null ? void 0 : o.keepInRegion.length) || 0, children: r("RETURNS_SCAN.KEEP_IN_REGION") }),
        /* @__PURE__ */ C(
          Rs,
          {
            width: f,
            height: _,
            data: o == null ? void 0 : o.keepInRegion,
            forReturns: s
          }
        )
      ] }),
      /* @__PURE__ */ j("div", { className: "flex w-full flex-col", children: [
        /* @__PURE__ */ j("div", { className: "flex max-h-9 w-full flex-row justify-between", children: [
          /* @__PURE__ */ C(ea, { className: "text-white", count: (o == null ? void 0 : o.backToTrunkrs.length) || 0, children: r("RETURNS_SCAN.BACK_TO_TRUNKRS") }),
          n ? /* @__PURE__ */ C(fz, {}) : /* @__PURE__ */ C(Do, { onClick: l, disabled: !(o != null && o.backToTrunkrs.length), children: r("RETURNS_SCAN.BUTTON_CONFIRM_RETURNS") })
        ] }),
        /* @__PURE__ */ C(Rs, { width: f, height: _, data: o == null ? void 0 : o.backToTrunkrs })
      ] })
    ] }),
    /* @__PURE__ */ C(s6, {}),
    /* @__PURE__ */ C(n6, { onConfirm: S }),
    /* @__PURE__ */ C(r6, {})
  ] });
}, C6 = () => /* @__PURE__ */ C("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2H6.5V4H3V7.5H1V2ZM5.5 16.5L5.5 7.5H7.5L7.5 16.5H5.5ZM16.5 16.5V7.5H18.5V16.5H16.5ZM11 7.5V16.5H13V7.5H11ZM1 16.5V22H6.5L6.5 20H3L3 16.5H1ZM23 22H17.5V20H21V16.5L23 16.5V22ZM23 7.5V2H17.5V4L21 4V7.5L23 7.5Z",
    fill: "#666666"
  }
) }), P6 = Bt.injectEndpoints({
  endpoints: (e) => ({
    getDriverInfo: e.query({
      query: (t) => ({
        url: `/delivery/functions/fetch-driver-info/${t}`
      })
    })
  })
}), { useGetDriverInfoQuery: y6 } = P6, No = {
  BACK_TO_TRUNKRS: "BACK_TO_TRUNKRS",
  KEEP_IN_REGION: "KEEP_IN_REGION",
  ERROR: "ERROR",
  UNSCANNABLE: "UNSCANNABLE"
}, U6 = ({
  lastDriver: e,
  address: t,
  postalCode: n,
  city: r,
  tel: o,
  sender: i
}) => {
  const { t: a } = Le();
  return /* @__PURE__ */ j("div", { className: "flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white shadow-elevation-2", children: [
    /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-center justify-center gap-4 bg-orange-50", children: /* @__PURE__ */ C("span", { className: "text-center font-heading text-[40px] text-indigo-50", children: a("RETURN_TO_TRUNKRS") }) }),
    /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-start p-10 text-indigo-50", children: /* @__PURE__ */ j("div", { className: "flex flex-col gap-7 font-body text-md", children: [
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.LAST_DRIVER") }),
        /* @__PURE__ */ C("span", { children: e })
      ] }),
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.ADDRESS") }),
        /* @__PURE__ */ C("span", { children: `T: +${o}` }),
        /* @__PURE__ */ C("span", { children: t }),
        /* @__PURE__ */ C("span", { children: `${n} ${r}` })
      ] }),
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.SENDER") }),
        /* @__PURE__ */ C("span", { children: i })
      ] })
    ] }) })
  ] });
}, b6 = () => /* @__PURE__ */ C(
  "svg",
  {
    width: "320",
    height: "320",
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M178.856 160.003L276.096 62.7637L257.24 43.9075L160 141.147L62.7605 43.9075L43.9043 62.7637L141.144 160.003L43.9063 257.241L62.7625 276.097L160 178.859L257.238 276.097L276.094 257.241L178.856 160.003Z",
        fill: "white"
      }
    )
  }
), Ns = () => {
  const { t: e } = Le();
  return /* @__PURE__ */ j("div", { className: "flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white shadow-elevation-2", children: [
    /* @__PURE__ */ j("div", { className: "flex w-1/2 flex-col items-center justify-center gap-4 bg-gray-90", children: [
      /* @__PURE__ */ C(b6, {}),
      /* @__PURE__ */ C("span", { className: "text-center font-heading text-[40px] text-white", children: e("RETURNS_SCAN.ERROR") })
    ] }),
    /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-start px-6 pt-32 text-indigo-50", children: /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ C("span", { className: "text-center font-heading text-h3", children: e("RETURNS_SCAN.SCAN_ERROR_TITLE") }),
      /* @__PURE__ */ C("span", { className: "text-center font-body text-md", children: e("RETURNS_SCAN.SCAN_ERROR_DETAILS") })
    ] }) })
  ] });
}, M6 = ({
  lastDriver: e,
  address: t,
  postalCode: n,
  city: r,
  tel: o,
  sender: i
}) => {
  const { t: a } = Le();
  return /* @__PURE__ */ j("div", { className: "flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white shadow-elevation-2", children: [
    /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-center justify-center gap-4 bg-green-50", children: /* @__PURE__ */ C("span", { className: "font-heading text-[40px] text-indigo-50", children: a("RETURNS_SCAN.KEEP_IN_REGION").toUpperCase() }) }),
    /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-start p-10 text-indigo-50", children: /* @__PURE__ */ j("div", { className: "flex flex-col gap-7 font-body text-md", children: [
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.LAST_DRIVER") }),
        /* @__PURE__ */ C("span", { children: e })
      ] }),
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.ADDRESS") }),
        /* @__PURE__ */ C("span", { children: `T: +${o}` }),
        /* @__PURE__ */ C("span", { children: t }),
        /* @__PURE__ */ C("span", { children: `${n} ${r}` })
      ] }),
      /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ C("span", { className: "font-heading", children: a("RETURNS_SCAN.SENDER") }),
        /* @__PURE__ */ C("span", { children: i })
      ] })
    ] }) })
  ] });
}, w6 = ({
  shipmentId: e,
  merchantName: t,
  optimizationId: n,
  tourTag: r,
  day: o
}) => {
  const { t: i, trans: a } = Le(), [s] = Kj();
  return te(() => {
    s({
      optimizationTourId: n,
      shipmentId: e
    });
  }, [n, s, e]), /* @__PURE__ */ j("div", { className: "flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white shadow-elevation-2", children: [
    /* @__PURE__ */ j("div", { className: "flex w-1/2 flex-col items-center justify-center gap-4 bg-light-violet-40", children: [
      /* @__PURE__ */ C("span", { className: "font-heading text-[40px] text-indigo-50", children: i("RETURNS_SCAN.KEEP_IN_REGION").toUpperCase() }),
      /* @__PURE__ */ C("span", { className: "rounded-md bg-gray-34 px-5 py-2 font-body text-md", children: i("RETURNS_SCAN.FOR_RETURN_TO_SENDER") })
    ] }),
    Nu(o) ? /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-center pt-16 text-indigo-50", children: /* @__PURE__ */ j("div", { className: "flex w-[332px] flex-row gap-2 rounded-[4px] bg-yellow-light-fade px-4 py-2", children: [
      /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(fr, {}) }),
      /* @__PURE__ */ j("div", { className: "flex flex-col gap-7 font-heading text-md", children: [
        /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ C("span", { className: "font-body", children: i("RETURNS_SCAN.RETURN_TODAY_TO") }),
          /* @__PURE__ */ C("span", { children: t })
        ] }),
        /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ C("span", { className: "font-body", children: i("RETURNS_SCAN.COLLECTION_OPT_ID") }),
          /* @__PURE__ */ C("span", { children: n })
        ] }),
        /* @__PURE__ */ j("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ C("span", { className: "font-body", children: i("RETURNS_SCAN.COLLECTION_TOUR_TAG") }),
          /* @__PURE__ */ C("span", { children: r })
        ] })
      ] })
    ] }) }) : /* @__PURE__ */ C("div", { className: "flex w-1/2 flex-col items-center pt-16 text-indigo-50", children: /* @__PURE__ */ j("div", { className: "flex w-[332px] flex-row gap-2 rounded-[4px] bg-yellow-light-fade px-4 py-2", children: [
      /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(fr, {}) }),
      /* @__PURE__ */ C("div", { className: "font-body text-md text-indigo-50", children: /* @__PURE__ */ C(
        a,
        {
          t: i,
          i18nKey: "RETURNS_SCAN.NO_COLLECTION_TODAY",
          values: {
            merchantName: t,
            day: o,
            optimizationId: n,
            tourTag: r
          },
          components: {
            b: /* @__PURE__ */ C("span", { className: "font-heading" })
          }
        }
      ) })
    ] }) })
  ] });
}, sn = ({ children: e }) => {
  const [, { data: t, error: n, reset: r }] = Cr({
    fixedCacheKey: "scan"
  });
  return /* @__PURE__ */ C(yr, { open: !!(t || n), modal: !1, children: /* @__PURE__ */ j(Ur, { children: [
    /* @__PURE__ */ C(
      br,
      {
        onClick: r,
        className: "fixed inset-0 bg-indigo-scrim opacity-60 transition-colors"
      }
    ),
    /* @__PURE__ */ j(Mr, { className: "fixed inset-0 m-auto h-fit w-fit animate-fade-up rounded-md shadow-elevation-2", children: [
      /* @__PURE__ */ C(
        Ai,
        {
          onClick: r,
          className: "absolute right-4 top-4 outline-1 hover:bg-gray-34 focus:outline-indigo-50",
          children: /* @__PURE__ */ C(gi, {})
        }
      ),
      e
    ] })
  ] }) });
}, $6 = () => {
  var o, i, a;
  const [, { data: e, isLoading: t }] = Cr({
    fixedCacheKey: "scan"
  }), n = e != null && e.shipmentData ? e.shipmentData.lastDriver : void 0, { data: r } = y6(n || 0, {
    skip: n === void 0
  });
  return t ? null : e != null && e.shipmentData ? e != null && e.returnInformation && (e == null ? void 0 : e.type) === No.KEEP_IN_REGION ? /* @__PURE__ */ C(sn, { children: /* @__PURE__ */ C(
    w6,
    {
      shipmentId: e.shipmentData.shipmentId,
      day: (o = e == null ? void 0 : e.returnInformation) == null ? void 0 : o.nextCollectionDay,
      merchantName: e == null ? void 0 : e.shipmentData.sender,
      optimizationId: (i = e == null ? void 0 : e.returnInformation) == null ? void 0 : i.availableTours[0].optimizationTourId,
      tourTag: (a = e == null ? void 0 : e.returnInformation) == null ? void 0 : a.availableTours[0].tourTag
    }
  ) }) : (e == null ? void 0 : e.type) === No.KEEP_IN_REGION ? /* @__PURE__ */ C(sn, { children: /* @__PURE__ */ C(
    M6,
    {
      address: e.shipmentData.address,
      city: e.shipmentData.city,
      postalCode: e.shipmentData.postalCode,
      sender: e.shipmentData.sender,
      tel: e.shipmentData.phoneNumber,
      lastDriver: (r == null ? void 0 : r.name) || "--"
    }
  ) }) : (e == null ? void 0 : e.type) === No.BACK_TO_TRUNKRS ? /* @__PURE__ */ C(sn, { children: /* @__PURE__ */ C(
    U6,
    {
      address: e.shipmentData.address,
      city: e.shipmentData.city,
      postalCode: e.shipmentData.postalCode,
      sender: e.shipmentData.sender,
      tel: e.shipmentData.phoneNumber,
      lastDriver: (r == null ? void 0 : r.name) || "--"
    }
  ) }) : /* @__PURE__ */ C(sn, { children: /* @__PURE__ */ C(Ns, {}) }) : /* @__PURE__ */ C(sn, { children: /* @__PURE__ */ C(Ns, {}) });
}, H6 = ({ subcoId: e }) => {
  const { t } = Le(), n = ee(null), [r, { isLoading: o }] = Cr({
    fixedCacheKey: "scan"
  }), [i, a] = Re(""), s = (u) => {
    a(u.currentTarget.value.trim());
  }, c = (u) => {
    u.key === "Enter" && (r({
      subcoId: e,
      trunkrsNrOrBarcode: i
    }).unwrap().then((E) => {
      E.shipmentData || r({
        subcoId: e,
        trunkrsNrOrBarcode: i
      });
    }), a(""));
  };
  return te(() => {
    i === "" && setTimeout(() => {
      var u;
      (u = n.current) == null || u.focus();
    }, 1e3);
  }, [i, o]), /* @__PURE__ */ j(Is, { children: [
    /* @__PURE__ */ j("div", { className: "flex w-full flex-row items-center gap-2 rounded-lg border border-gray-50 bg-white px-4 shadow-elevation-2 focus-within:border-violet-50 hover:border-violet-50", children: [
      /* @__PURE__ */ C(C6, {}),
      /* @__PURE__ */ C(
        "input",
        {
          ref: n,
          value: i,
          disabled: o,
          autoFocus: !0,
          onChange: s,
          className: "h-14 w-full font-body text-lg text-gray-90 outline-none disabled:bg-white",
          placeholder: t(o ? "RETURNS_SCAN.LOADING" : "RETURNS_SCAN.SCAN_INPUT_PLACEHOLDER"),
          onKeyDown: c
        }
      )
    ] }),
    /* @__PURE__ */ C($6, {})
  ] });
}, V6 = yY({
  reducer: {
    morningScan: xY,
    [Bt.reducerPath]: Bt.reducer
  },
  devTools: !0,
  middleware: (e) => e().concat(Bt.middleware)
}), W6 = ({
  t: e,
  trans: t,
  subcoId: n,
  className: r,
  onBatchHubOut: o,
  isBatchHubOutDone: i
}) => /* @__PURE__ */ C(Bs.Provider, { value: { t: e, trans: t }, children: /* @__PURE__ */ C(r3, { store: V6, children: /* @__PURE__ */ j("div", { className: Xo("flex flex-col gap-8", r), children: [
  /* @__PURE__ */ C(H6, { subcoId: n }),
  /* @__PURE__ */ C(
    L6,
    {
      subcoId: n,
      onBatchHubOut: o,
      isBatchHubOutDone: i
    }
  )
] }) }) });
export {
  W6 as InventoryScan
};
